export default {
  translation: {


    // App
    'apartment_system': 'سیستەمی بەڕێوەبردنی ئەپارتمان',
    'apartment_management': 'بەڕێوەبردنی ئەپارتمان',
    'building_management': 'بەڕێوەبردنی بیناکان',

    // Navigation - updated
    'dashboard': 'داشبۆرد',
    'user_management': 'بەڕێوەبردنی بەکارهێنەران',
    'building_management': 'بەڕێوەبردنی بیناکان',
    'apartment_management': 'بەڕێوەبردنی ئەپارتمان',
    'owner_management': 'بەڕێوەبردنی خاوەنەکان',
    'tenant_management': 'بەڕێوەبردنی کرێکارەکان',
    'payment_management': 'بەڕێوەبردنی پارەدانەکان',
    'service_management': 'بەڕێوەبردنی خزمەتگوزاریەکان',
    'report_management': 'ڕاپۆرت و شیکاری',
    'log_management': 'تۆمارەکانی چالاکی',

    // Buildings
    'buildings': 'بیناکان',
    'building_list': 'لیستی بیناکان',
    'switch_building': 'بیناکانی چاککردن',
    'add_building': 'زیادکردنی بینا',
    'edit_building': 'دەستکاری بینا',
    'building_details': 'وردەکاری بینا',
    'building_name': 'ناوی بینا',
    'building_address': 'ناونیشان',
    'total_floors': 'کۆی گشتی نهۆمەکان',
    'total_apartments': 'کۆی گشتی ئەپارتمانەکان',
    'building_view': 'بینینی بینا',
    'showing_all_apartments': 'نمایشکردنی هەموو ئەپارتمانەکان',
    'expand_all_floors': 'کردنەوەی هەموو نهۆمەکان',
    'collapse_all_floors': 'داخستنی هەموو نهۆمەکان',

    // Apartments (renamed from Properties)
    'apartments': 'ئەپارتمانەکان',
    'apartment_list': 'لیستی ئەپارتمانەکان',
    'add_apartment': 'زیادکردنی ئەپارتمان',
    'edit_apartment': 'دەستکاری ئەپارتمان',
    'apartment_details': 'وردەکاری ئەپارتمان',
    'apartment_number': 'ژمارەی ئەپارتمان',
    'apartment_display': 'ژوورە ژمارە {{number}}',
    'floor_number': 'ژمارەی نهۆم',
    'floor_display': 'نهۆمی {{number}}',
    'monthly_rent': 'کرێی مانگانە',
    'apartment_status': 'بار',
    'vacant': 'بەتاڵ',
    'under_maintenance': 'لەژێر چاککردن',
    'key_status': 'حاڵەتی کلیل',
    'at_office': 'لە ئۆفیسە',
    'with_tenant': 'لای کرێچییە',
    'with_maintenance': 'لای چاککردنەوەیە',
    'lost': 'ونبووە',
    'key_handover': 'ڕادەستکردنی کلیل',
    'give_out_keys': 'ڕادەستکردنی کلیل',
    'return_keys': 'وەرگرتنەوەی کلیل',
    'keys': 'کلیلەکان',
    'remotes': 'کۆنتڕۆڵ',
    'fobs': 'فۆب',
    'possession_date': 'بەرواری ڕادەستکردن',
    'key_details': 'وردەکاری کلیل',
    'key_history': 'مێژووی کلیل',
    'record_handover': 'تۆمارکردنی ڕادەستکردن',
    'confirm_and_record': 'دڵنیابوونەوە و تۆمارکردن',
    'add_notes': 'تێبینی زیاتر لێرە زیاد بکە...',
    'no_key_history': 'هیچ مێژوویەکی تەسلیمکردنی کلیل نەدۆزرایەوە.',
    'loading_history': 'بارکردنی مێژوو...',
    'by': 'لە لایەن',
    'warning_handover_no_tenant': 'تۆمارکردنی ڕادەستکردن بەبێ کرێچییەکی پەیوەندیدار.',
    'key_handover_success': 'ڕادەستکردنی کلیل بە سەرکەوتوویی تۆمارکرا',
    'failed_to_record_handover': 'تۆمارکردنی ڕادەستکردنی کلیل سەرکەوتوو نەبوو',
    'failed_to_load_history': 'بارکردنی مێژووی کلیل سەرکەوتوو نەبوو',
    'key_management': 'بەڕێوەبردنی کلیل',
    'manage_keys': 'بەڕێوەبردنی کلیل',
    'total_handovers': 'کۆی گشتی ئەنجامەکان',
    'given_out': 'دراوە',
    'returned': 'گەڕاوەتەوە',
    'currently_out': 'ئێستا دەرەوەیە',
    'documents': 'دۆکیومێنتەکان',

    // AI Intelligence & Sidebar
    'ai_intelligence': 'ژیریی دەستکرد',
    'rent_pricing_ai': 'نرخاندنی کرێ بە ژیری دەستکرد',
    'churn_prediction': 'پێشبینی جێهێشتنی کرێگرتە',
    'showings': 'پیشاندانی یەکەکان',
    'tenant_surveys': 'ڕاپرسی کرێگرتەکان',
    'insurance': 'دڵنیایی (تأمين)',
    'vendor_1099': 'دابینکەر 1099',
    'rent_roll': 'تۆماری کرێکان',
    'ar_aging': 'کۆنی حیسابەکان',
    'webhooks': 'Webhooks',

    // AI Rent Pricing Page
    'ai_rent_pricing': 'نرخاندنی کرێ بە ژیری دەستکرد',
    'ai_rent_pricing_desc': 'پێشنیارەکانی نرخی کرێی بازاڕ وەربگرە بە پشتیوانی ژیری دەستکرد لەسەر بنەمای یەکە هاوشێوەکان، ڕێژەی داگیرکردن و ڕەوتەکانی نوێکردنەوە',
    'select_unit_to_analyze': 'یەکەیەک هەڵبژێرە بۆ شیکردنەوە',
    'choose_an_apartment': 'شوقەیەک هەڵبژێرە...',
    'analyze': 'شیکردنەوە',
    'analyzing': 'خەریکی شیکردنەوەیە...',
    'ai_recommended_rent': 'کرێی پێشنیارکراوی ژیری دەستکرد',
    'range': 'مەودا',
    'high_confidence': 'بەرز',
    'medium_confidence': 'ناوەند',
    'low_confidence': 'نزم',
    'confidence_suffix': 'متمانە',
    'comparable_units_found': 'یەکە هاوشێوەکان ({{count}} دۆزرایەوە)',
    'avg_comparable_rent': 'تێکڕا: {{amount}}/مانگانە',
    'vs_suggestion': 'بەرامبەر پێشنیار',
    'select_unit_analyze_desc': 'یەکەیەک هەڵبژێرە و کلیک لەسەر شیکردنەوە بکە',
    'claude_analyze_desc': 'ژیری دەستکرد شیکردنەوە بۆ یەکە هاوشێوەکان، ڕێژەی داگیرکردن و ڕەوتەکانی نوێکردنەوە دەکات بۆ پێشنیارکردنی باشترین کرێ',

    // Churn Prediction Page
    'churn_prediction_desc': 'ئەگەری نوێکردنەوە بە ژیری دەستکرد بۆ هەموو کرێگرتە چالاکەکان',
    'run_ai_scoring': 'بەگەڕخستنی هەڵسەنگاندنی ژیری دەستکرد',
    'running': 'خەریکی کارکردنە...',
    'high_churn_risk': 'مەترسی بەرزی جێهێشتن',
    'medium_risk': 'مەترسی ناوەند',
    'likely_to_renew': 'ئەگەری نوێکردنەوەی هەیە',
    'no_churn_scores': 'هێشتا هیچ هەڵسەنگاندنێک نییە',
    'run_scoring_desc': 'کلیک لەسەر "بەگەڕخستنی هەڵسەنگاندنی ژیری دەستکرد" بکە بۆ شیکردنەوەی هەموو کرێگرتە چالاکەکان',
    'run_scoring_now': 'ئێستا هەڵسەنگاندن بکە',
    'renewal_score': 'نمرەی نوێکردنەوە',
    'risk_level': 'ئاستی مەترسی',
    'lease_ends': 'گرێبەست کۆتایی دێت',
    'key_factors': 'هۆکارە سەرەکییەکان',
    'send_offer': 'ناردنی پێشنیار',
    'late_payments_6m': '{{count}} پارەدانی درەنگ',
    'current_balance_factor': '${{amount}} قەرز',
    'prior_renewals_factor': '{{count}} نوێکردنەوەی پێشوو',

    // Showings Page
    'showings_desc': 'خشتەبەندی و بەدواداچوونی پیشاندانی یەکەکان بۆ کرێگرتە ئەگەرییەکان',
    'schedule_showing': 'خشتەبەندی پیشاندان',
    'upcoming': 'داهاتوو',
    'today': 'ئەمڕۆ',
    'no_shows': 'ئامادەنەبوو',
    'all': 'هەموو',
    'no_showings_found': 'هیچ پیشاندانێک نەدۆزرایەوە',
    'schedule_first_showing': 'خشتەبەندی یەکەم پیشاندان',
    'prospect': 'کڕیاری ئەگەری',
    'unit': 'یەکە',
    'date_and_time': 'بەروار و کات',
    'scheduled': 'خشتەبەندی کراوە',
    'completed': 'تەواو بوو',
    'cancelled': 'هەڵوەشایەوە',
    'no_show': 'ئامادەنەبوو',
    'edit_showing': 'دەستکاری پیشاندان',
    'prospect_name': 'ناوی کڕیاری ئەگەری',
    'prospect_phone': 'تەلەفۆن',
    'prospect_email': 'ئیمەیڵ',
    'start_time': 'کاتی دەستپێکردن',
    'end_time': 'کاتی کۆتایی',
    'assigned_to': 'سپێردراوە بە',
    'notes': 'تێبینییەکان',

    // Insurance Page
    'insurance_tracking': 'بەدواداچوونی دڵنیایی (تأمين)',
    'insurance_desc': 'بەڕێوەبردنی پالیسیەکانی دڵنیایی کرێگرتە، خاوەن و باڵەخانە',
    'add_policy': 'زیادکردنی پالیسیەک',
    'expiring_30d': 'لە ٣٠ رۆژدا بەسەردەچێت',
    'total_coverage': 'کۆی داپۆشین',
    'all_status': 'هەموو بارودۆخەکان',
    'all_types': 'هەموو جۆرەکان',
    'no_policies_found': 'هیچ پالیسیەک نەدۆزرایەوە',
    'add_first_policy': 'زیادکردنی یەکەم پالیسیەک',
    'entity': 'لایەن',
    'insurer': 'کۆمپانیای دڵنیایی',
    'policy_type': 'جۆری پالیسی',
    'coverage': 'داپۆشین (تغطية)',
    'expiry': 'بەسەرچوون',
    'expired_days_ago': 'بەرلە {{days}} رۆژ بەسەرچوو',
    'days_left': '{{days}} رۆژ ماوە',
    'edit_policy': 'دەستکاری پالیسیەک',
    'entity_type': 'جۆری لایەن',
    'policy_number': 'ژمارەی پالیسی',
    'coverage_amount': 'بڕی داپۆشین',
    'annual_premium': 'پشکی ساڵانە',
    'start_date': 'بەرواری دەستپێکردن',
    'expiry_date': 'بەرواری بەسەرچوون',
    'document_url': 'لینکی دۆکیومێنت (COI)',

    // Survey Results Page
    'tenant_surveys_desc': 'نمرەکانی ڕەزامەندی و فیدباکی کرێگرتەکان',
    'overall_rating': 'نمرەی گشتی',
    'distribution': 'دابەشبوون',
    'by_category': 'بەپێی جۆر',
    'no_surveys_yet': 'هێشتا هیچ ڕاپرسییەک نییە',
    'tenants_submit_feedback_desc': 'کرێگرتەکان دەتوانن فیدباک بنێرن لە ڕێگەی پۆرتاڵەکەیانەوە',

    // Services
    'services': 'خزمەتگوزاریەکان',
    'service_payments': 'پارەدانی خزمەتگوزاری',
    'generate_services': 'دروستکردنی پارەدانی خزمەتگوزاری',
    'service_statistics': 'ئاماری خزمەتگوزاری',
    'service_type': 'جۆری خزمەتگوزاری',
    'service_amount': 'بڕ',
    'service_date': 'بەرواری خزمەتگوزاری',
    'service_status': 'باری پارەدان',
    'service_paid': 'پارەدراو',
    'service_unpaid': 'پارەنەدراو',

    // Reports - updated
    'revenue_report': 'ڕاپۆرتی داهات',
    'payment_logs': 'تۆماری پارەدانەکان',
    'occupancy_report': 'ڕاپۆرتی گیرانی',
    'monthly_payments_report': 'ڕاپۆرتی پارەدانی مانگانە',
    'monthly_payments_subtitle': 'بینینی گشتی پارەدانی کرێکاران و خزمەتگوزاریەکان',
    'all_paid': 'هەموو پارەدراوە',
    'try_adjusting_filters': 'هەوڵبدە مانگ، ساڵ، یان فلتەرەکان بگۆڕیت',
    'pending': 'چاوەڕوان',
    'total': 'کۆی گشتی',
    'print_receipt': 'چاپکردنی وەرگرت',
    'monthly_revenue': 'داهاتی مانگانە',
    'building_revenue': 'داهاتی بینا',
    'owner_revenue': 'داهاتی خاوەن',
    'paid_until': 'دراوە تا',
    'tenant_payments': 'باری پارەدانی کرێکار',
    'next_billing_date': 'بەرواری پارەدانی داهاتوو',
    'current_tenant': 'کرێکاری ئێستا',
    'total_owners': 'خاوەنەکان',
    'urgent_action': 'ڕێکاری بەپەلە',
    'future_tenant_upcoming': 'کرێکاری داهاتوو',

    // Logs
    'activity_logs': 'تۆماری چالاکیەکان',
    'all_user_activities': 'هەموو چالاکیەکانی بەکارهێنەر',
    'all_user_activities_desc': 'بینینی هەموو چالاکیەکان و گۆڕانکارییەکانی بەکارهێنەر',
    'tenant_logs': 'مێژووی کرێکارەکان',
    'tenant_activity_desc': 'بینینی هەموو چالاکیە پەیوەندیدارەکان بە کرێکارەکان',
    'revenue_by_user': 'داهات بەپێی بەکارهێنەر',
    'monthly_revenue_by_user': 'داهاتی مانگانە بەپێی بەکارهێنەر',
    'revenue_breakdown_desc': 'بینینی وردەکاری داهات بەپێی بەکارهێنەر بۆ مانگێکی دیاریکراو',
    'time': 'کات',
    'entity': 'بوار',
    'details': 'وردەکارییەکان',
    'amount': 'بڕ',
    'search_logs': 'گەڕان لە تۆمارەکان...',
    'filter_activities': 'پاڵاوتنی چالاکیەکان',
    'action_type': 'جۆری ڕێکار',
    'entity_type': 'جۆری بوار',
    'apply_filter': 'جێبەجێکردنی پاڵاوتن',
    'entries': 'مداخل',
    'no_logs_matching_search': 'هیچ تۆمارێک نەدۆزرایەوە کە لەگەڵ گەڕانەکەت بگونجێت',
    'no_logs_available': 'هیچ تۆمارێکی چالاکی بەردەست نییە',
    'showing_range': 'پیشاندانی {{start}} بۆ {{end}} لە کۆی {{total}} داخلکراو',
    'select_month': 'مانگ هەڵبژێرە',
    'payment_count': 'ژمارەی پارەدانەکان',
    'total_amount': 'کۆی گشتی بڕەکە',
    'percentage': 'ڕێژەی سەدی',
    'no_revenue_data': 'هیچ داتایەکی داهات بۆ ئەم مانگە بەردەست نییە',
    'january': 'کانوونی دووەم',
    'february': 'شوبات',
    'march': 'ئازار',
    'april': 'نیسان',
    'may': 'ئایار',
    'june': 'حوزەیران',
    'july': 'تەممووز',
    'august': 'ئاب',
    'september': 'ئەیلوول',
    'october': 'تشرینی یەکەم',
    'november': 'تشرینی دووەم',
    'december': 'کانوونی یەکەم',
    'notification_log': 'سجلی ئاگادارییەکان',
    'all_notifications': 'هەموو ئاگادارییەکان',
    'all_channels': 'هەموو کەناڵەکان',
    'all_statuses': 'هەموو بارودۆخەکان',
    'all_recipients': 'هەموو وەرگرەکان',
    'sent_at': 'نێردرا لە',
    'template_subject': 'نموونە / بابەت',
    'email_templates': 'نموونەکانی ئیمەیڵ',
    'active_templates_count_one': 'یەک نموونەی چالاک',
    'active_templates_count_other': '{{count}} نموونەی چالاک',
    'new_template': 'نموونەی نوێ',
    'test_email_placeholder': 'ناونیشانی ئیمەیڵی تاقیکردنەوە (بۆ هەموو دوگمەکانی تاقیکردنەوە بەکاردێت)',
    'no_email_templates': 'هێشتا هیچ نموونەیەکی ئیمەیڵ نییە',
    'create_first_template': 'یەکەم نموونە دروست بکە',
    'rent_due': 'کاتی کرێ',
    'late_payment': 'پارەدانی دواکەوتوو',
    'lease_renewal': 'نوێکردنەوەی گرێبەست',
    'lease_expiry': 'کۆتایی هاتنی گرێبەست',
    'move_in': 'هاتنە ناوەوە',
    'move_out': 'چوونە دەرەوە',
    'violation': 'سەرپێچی',
    'maintenance': 'چاککردنەوە',
    'inspection': 'پشکنین',
    'owner_payout': 'پارەدانی خاوەن موڵک',
    'email_template_form_desc': 'ئیمەیڵی ئۆتۆماتیکی بۆ کرێچی و خاوەن موڵکەکانت دیزاین بکە',
    'update_template': 'نوێکردنەوەی نموونە',
    'create_template': 'دروستکردنی نموونە',
    'visual': 'بینراو',
    'html': 'HTML',
    'live_preview': 'پێشبینینی ڕاستەوخۆ',
    'subject_line': 'بابەتی نامە',
    'email_content': 'ناوەرۆکی ئیمەیڵ',
    'event_trigger': 'هۆکاری ناردن',
    'internal_name': 'ناوی ناوخۆیی',
    'dynamic_tags': 'تاگە دینامیکییەکان',
    'starter_templates': 'نموونە سەرەتاییەکان',
    'starter_templates_desc': 'یەکێک هەڵبژێرە بۆ ئەوەی خێراتر دیزاین بکەیت',
    'apply_design': 'جێبەجێکردنی دیزاین',
    'payment_settings': 'إعدادات الدفع',
    'accept_online_payments': 'قبول المدفوعات عبر الإنترنت',
    'stripe_connect_desc': 'قم بتوصيل حساب Stripe الخاص بك لتمكين المستأجرين من دفع الإيجار مباشرة من خلال البوابة. يتم إيداع الأموال مباشرة في حسابك المصرفي، ويقوم نظامنا بتتبع كل شيء تلقائياً.',
    'why_stripe_connect': 'لماذا تستخدم Stripe Connect؟',
    'stripe_benefit_1': 'تحصيل الإيجار وتتبعه آلياً',
    'stripe_benefit_2': 'إيداعات مباشرة في حسابك المصرفي',
    'stripe_benefit_3': 'معالجة آمنة ومتوافقة مع PCI',
    'stripe_benefit_4': 'دعم تقسيم رسوم المنصة',
    'start_stripe_onboarding': 'بدأ الربط مع Stripe',
    'stripe_account_status': 'حالة حساب Stripe',
    'active_verified': 'نشط وموثق',
    'pending_onboarding': 'مطلوب اتخاذ إجراء: انتظار إكمال البيانات',
    'complete_setup': 'إكمال الإعداد',
    'payments_enabled': 'تم تمكين المدفوعات',
    'payouts_enabled': 'تم تمكين السحب',
    'account_id': 'معرف الحساب',
    'payment_configuration': 'تكوين الدفع',
    'platform_fee_type': 'نوع رسوم المنصة',
    'no_fee_direct': 'بدون رسوم (دفع مباشر)',
    'percentage_soon': 'نسبة مئوية (قريباً)',
    'fixed_soon': 'مبلغ ثابت (قريباً)',
    'platform_fee_disabled': 'رسوم منصة QuadCores معطلة حالياً لمنظمتك.',
    'yes': 'به‌ڵێ',
    'no': 'نه‌خێر',
    'general_settings': 'ڕێکخستنە گشتییەکان',
    'enable_whatsapp_notifications': 'چالاککردنی ئاگادارکردنەوەکانی واتسئەپ',
    'whatsapp_enable_desc': 'هەموو نامە ئۆتۆماتیکییەکانی واتسئەپ کارا بکە یاخود بکوژێنەوە',
    'default_country_code': 'کۆدی وڵاتی بنەڕەتی',
    'default_message_language': 'زمانی بنەڕەتی نامەکان',
    'rent_reminder': 'بیرخستنەوەی کرێ',
    'enable_rent_reminders': 'چالاککردنی بیرخستنەوەی کرێ',
    'rent_reminders_desc': 'ناردن بۆ ئەو کرێچییانەی کرێی دواکەوتوو یان داهاتوویان هەیە',
    'days_before_due': 'ڕۆژ پێش وادەی سەرەکی',
    'service_fee_reminder': 'بیرخستنەوەی پارەی خزمەتگوزاری',
    'enable_service_fee_reminders': 'چالاککردنی بیرخستنەوەی پارەی خزمەتگوزاری',
    'service_fee_reminders_desc': 'ئاگادارکردنەوەی کرێچی و خاوەن ماڵەکان دەربارەی پارەی خزمەتگوزاری نەدراو',
    'owner_reminder': 'بیرخستنەوەی خاوەن موڵک',
    'enable_owner_reminders': 'چالاککردنی بیرخستنەوەی خاوەن موڵک',
    'owner_reminders_desc': 'ئاگادارکردنەوەی خاوەن موڵکەکان کاتێک کرێچییەکانیان پارەیان دواکەوتووە',
    'payment_confirmation': 'تەئکیدکردنەوەی پارەدان',
    'send_payment_confirmation': 'ناردنی تەئکیدکردنەوەی پارەدان',
    'payment_confirmation_desc': 'ئاگادارکردنەوەی ئۆتۆماتیکی کرێچی لە ڕێگەی واتسئەپ کاتێک پارەیەک تۆمار دەکرێت',
    'sms_twilio': 'SMS (Twilio)',
    'enable_sms_notifications': 'چالاککردنی ئاگادارکردنەوەکانی SMS (Twilio)',
    'sms_enable_desc': 'هەموو نامە ئۆتۆماتیکییەکانی SMS کارا بکە یاخود بکوژێنەوە',
    'sender': 'نێرەر',
    'send_test_sms': 'ناردنی نامەی SMSی تاقیکاری',
    'test_sms_desc': 'دڵنیابەوە لە کارکردنی Twilio بە ناردنی نامەیەکی تاقیکاری بۆ هەر ژمارەیەکی مۆبایل.',
    'phone_number': 'ژمارەی مۆبایل',
    'send_test': 'ناردنی تاقیکاری',
    'preview_reminders': 'پێشبینینی بیرخستنەوەکان',
    'confirm_send_all': 'تەئکیدکردن و ناردنی هەمووی',
    'notification_settings': 'ڕێکخستنەکانی ئاگادارکردنەوە',
    'notification_settings_desc': 'ڕێکخستنی بیرخستنەوەکانی واتسئەپ و SMS بۆ کرێچی و خاوەن موڵکەکان',
    'preview_send': 'پێشبینین و ناردن',
    'save_settings': 'پاراستنی ڕێکخستنەکان',
    'failed_load_notification_settings': 'بارکردنی ڕێکخستنەکان شکستی هێنا',
    'settings_saved': 'ڕێکخستنەکان پاشەکەوت کران',
    'settings_save_failed': 'پاشەکەوتکردن شکستی هێنا',
    'preview_failed': 'پێشبینین شکستی هێنا',
    'reminders_sent': 'بیرخستنەوەکان نێردران',
    'no_pending_reminders': 'هیچ بیرخستنەوەیەکی هەڵپەسێردراو نییە لە ئێستادا.',
    'recipient_pending': 'وەرگری چاوەڕوانکراو',
    'confirm_replace_content': 'ئەمە دەبێتە هۆی گۆڕینی ناوەڕۆکی ئێستا. دەتەوێت بەردەوام بیت؟',
    'applied_template': 'نموونەی {{name}} جێبەجێ کرا',
    'webhooks': 'Webhooks',
    'webhooks_desc': 'ناردنی ڕووداوەکان بۆ سیستمەکانت کاتێک گۆڕانکاری لە APS ڕوو دەدات',
    'add_endpoint': 'زیادکردنی خاڵی کۆتایی',
    'failed_load_webhooks': 'بارکردنی Webhooks شکستی هێنا',
    'failed_load_deliveries': 'بارکردنی گەیاندنەکان شکستی هێنا',
    'failed_update': 'نوێکردنەوە شکستی هێنا',
    'failed_delete': 'سڕینەوە شکستی هێنا',
    'deleted': 'سڕایەوە',
    'rotate_secret_confirm': 'گۆڕینی نهێنی؟ پێویستە کڕیارەکەت لۆژیکی پشتڕاستکردنەوەی نوێ بکاتەوە.',
    'secret_rotated': 'نهێنی گۆڕدرا - ئێستا پاشەکەوتی بکە، چونکە جارێکی تر پیشان نادرێتەوە',
    'failed_rotate': 'گۆڕین شکستی هێنا',
    'copied_to_clipboard': 'کۆپی کرا بۆ حافظە',
    'no_webhooks_yet': 'هێشتا هیچ خاڵێکی کۆتایی Webhook نییە',
    'no_webhooks_desc': 'دانەیەک زیاد بکە بۆ دەستپێکردنی وەرگرتنی ڕووداوەکان.',
    'failures': 'شکستەکان',
    'recent_deliveries': 'گەیاندنە نوێیەکان',
    'no_deliveries_yet': 'هێشتا هیچ گەیاندنێک نییە.',
    'event': 'ڕووداو',
    'http': 'HTTP',
    'duration': 'ماوە',
    'sent_at': 'نێردرا لە',
    'delete_webhook_confirm': 'سڕینەوەی Webhook بۆ {{url}}؟',
    'rotate_secret': 'گۆڕینی نهێنی',
    'disable': 'ناچالاککردن',
    'enable': 'چالاککردن',
    'ok_200': '200 OK',
    'failed': 'شکستی هێنا',
    'uploading': 'خەریکی بارکردنە...',
    'save_changes': 'پاراستنی گۆڕانکارییەکان',
    'contact_email': 'ئیمەیڵی پەیوەندی',
    'contact_phone': 'مۆبایلی پەیوەندی',
    'office_address': 'ناونیشانی ئۆفیس',
    'organization_logo': 'لۆگۆی ڕێکخراو',
    'failed_to_load_system_data': 'بارکردنی داتاکانی سیستم شکستی هێنا',
    'logo_upload_success': 'لۆگۆ بە سەرکەوتوویی بارکرا',
    'error_uploading_logo': 'هەڵە لە بارکردنی لۆگۆ',
    'error_updating_system_settings': 'هەڵە لە نوێکردنەوەی ڕێکخستنەکانی سیستم',
    'manage_your_subscription_and_billing': 'بەڕێوەبردنی بەشداری و فۆتۆکانت',
    'previous': 'پێشوو',
    'next': 'دواتر',
    'recent_transactions': 'مامەڵە نوێیەکان',
    'alerts_notifications': 'ئاگاداری و ئاگادارکردنەوەکان',
    'active_properties': 'عەقاراتی چالاک',
    'occupancy_rate_desc': '{{rate}}% ڕێژەی نیشتەجێبوون',
    'vs_last_month': 'بەراورد بە مانگی ڕابردوو',
    'overdue_amount': '{{amount}} دواکەوتوو',
    'payment_desc': 'پارەدانی {{type}} - شوقەی {{number}}',
    'overdue_payments': 'پارەدانی دواکەوتوو',
    'overdue_payments_msg': '{{count}} کرێنشین پارەی هەڵپەسێردراویان هەیە بە کۆی {{amount}}',
    'view_details': 'بینینی وردەکارییەکان',
    'lease_expiring_soon': 'گرێبەست بەسەردەچێت بەم زووانە',
    'lease_expiring_msg': '{{count}} گرێبەستی بەکرێدان لە ماوەی ٣٠ ڕۆژدا بەسەردەچن',
    'review_leases': 'پێداچوونەوەی گرێبەستەکان',
    'trial_ending_soon': 'ماوەی تاقیکاری بەسەردەچێت بەم زووانە',
    'trial_ending_msg': 'ماوەی تاقیکاریت لە دوای {{days}} ڕۆژ بەسەردەچێت. تکایە بەشداری بکە بۆ ئەوەی خزمەتگوزارییەکەت نەپچڕێت.',
    'upgrade_plan': 'بەرزکردنەوەی پلان',
    'last_7_days': '٧ ڕۆژی ڕابردوو',
    'last_30_days': '٣٠ ڕۆژی ڕابردوو',
    'last_3_months': '٣ مانگی ڕابردوو',
    'last_year': 'ساڵی ڕابردوو',
    'error_loading_dashboard': 'هەڵە لە بارکردنی داشبۆرد',
    'reports_dashboard': 'داشبۆردی ڕاپۆرتەکان',
    'overview_of_financial_performance': 'تێڕوانینێکی گشتی بۆ ئەدای دارایی و ئامارەکانی عەقارات',
    'view_all_reports': 'بینینی هەموو ڕاپۆرتەکان',
    'total_revenue': 'کۆی داهات',
    'total_payments_count': '{{count}} پارەدان',
    'total_tenants': 'کۆی کرێنشینان',
    'new_tenants_this_year': '{{count}} نوێ لەم ساڵەدا',
    'total_buildings_count': '{{count}} باڵەخانە',
    'total_owners': 'کۆی خاوەن موڵکەکان',
    'ended_contracts_count': '{{count}} گرێبەستی تەواوبوو',
    'monthly_revenue_year': 'داهاتی مانگانە - {{year}}',
    'occupancy_rate': 'ڕێژەی نیشتەجێبوون',
    'quick_reports': 'ڕاپۆرتە خێراکان',
    'annual_revenue': 'داهاتی ساڵانە',
    'yearly_breakdown': 'تێڕوانینی ساڵانە بۆ هەموو داهاتەکان',
    'building_revenue': 'داهاتی باڵەخانە',
    'revenue_by_building': 'وردەکاری داهات بەپێی باڵەخانە',
    'owner_revenue': 'داهاتی خاوەن موڵک',
    'revenue_by_owner': 'وردەکاری داهات بەپێی خاوەن موڵک',
    'detailed_payment_history': 'مێژووی وردی پارەدان و تۆمارەکان',
    'occupied': 'تەواو بووە',
    'vacant': 'بەتاڵ',
    'maintenance': 'چاودێری',
    'excellent': 'ناوازە',
    'good': 'باش',
    'needs_improvement': 'پێویستی بە باشترکردنە',
    'rent': 'کرێ',
    'service': 'خزمەتگوزاری',
    'deposit': 'بارمتە',
    'commission': 'کۆمسیۆن',
    'insurance': 'دڵنیایی',
    'total': 'کۆی گشتی',
    'no_recent_payments': 'هیچ پارەدانێکی نوێ نەدۆزرایەوە',
    'no_overdue_payments': 'هیچ پارەدانێکی دواکەوتوو نەدۆزرایەوە',
    'overdue': 'دواکەوتوو',
    'partial': 'بەشێکی',
    'expired': 'بەسەرچوو',
    'pending': 'چاوەڕوانکراو',
    'paid': 'دراوە',
    'apt': 'شوقە',
    'days_overdue': 'ڕۆژ دواکەوتووە',
    'owner_payments': 'مدفوعات المالک',
    'all_months': 'هەموو مانگەکان',
    'more_overdue_tenants': 'کرێنشینی تری دواکەوتوو',
    'error_fetching_occupancy': 'هەڵە لە هێنانی زانیارییەکانی نیشتەجێبوون',
    'failed_load_occupancy': 'بارکردنی ئامارەکانی نیشتەجێبوون سەرکەوتوو نەبوو',
    'error_fetching_payments': 'هەڵە لە هێنانی پارەدانە نوێیەکان',
    'failed_load_payments': 'بارکردنی پارەدانە نوێیەکان سەرکەوتوو نەبوو',
    'error_fetching_tenant_status': 'هەڵە لە هێنانی دۆخی پارەدانی کرێنشین',
    'failed_load_tenant_status': 'بارکردنی دۆخی پارەدانی کرێنشین سەرکەوتوو نەبوو',
    'failed_to_load_report_data': 'بارکردنی زانیارییەکانی ڕاپۆرت سەرکەوتوو نەبوو',
    'mgmt_fee_collected': 'کرێی بەڕێوەبردن کۆکراوەتەوە (YTD)',
    'mgmt_fee_outstanding': 'کرێی بەڕێوەبردنی مانەوە',
    'active_tenant_arrears': 'لووتپڕی کرێنشینانی چالاک',
    'all_accounts_settled': 'هەموو هەژمارەکان چارەسەر کراون',

    "floor_number": "جهازی ژمارە {{number}}",
    "apartment_number": "ژوورە ژمارە {{number}}",

    // Common
    'loading': 'بارکردن...',
    'save': 'پاشەکەوت',
    'cancel': 'پاشگەزبوونەوە',
    'edit': 'دەستکاری',
    'delete': 'سڕینەوە',
    'add': 'زیادکردن',
    'view': 'بینین',
    'search': 'گەڕان',
    'filter': 'پاڵاوتن',
    'actions': 'کردارەکان',
    'status': 'بار',
    'active': 'چالاک',
    'inactive': 'نەچالاک',
    'yes': 'بەڵێ',
    'no': 'نەخێر',
    'confirm': 'دڵنیاکردنەوە',
    'success': 'سەرکەوتن',
    'error': 'هەڵە',
    'warning': 'ئاگاداری',
    'info': 'زانیاری',

    // App
    'apartment_system': 'سیستەمی ئەپارتمان',
    'apartment_management': 'بەڕێوەبردنی ئەپارتمان',

    // Authentication
    'login': 'چوونەژوورەوە',
    'logout': 'چوونەدەرەوە',
    'username': 'ناوی بەکارهێنەر',
    'password': 'وشەی نهێنی',
    'email': 'ئیمەیل',
    'remember_me': 'لەبیرم بێت',
    'forgot_password': 'وشەی نهێنیت لەبیرچووە؟',
    'forgot_password_instructions': 'ناوی بەکارهێنەر یان ئیمەیلەکەت بنووسە بۆ وەرگرتنی کۆدی پشتڕاستکردنەوە',
    'send_code': 'ناردنی کۆدی پشتڕاستکردنەوە',
    'reset_password': 'دانانەوەی وشەی نهێنی',
    'password_reset_success': 'وشەی نهێنیت بە سەرکەوتوویی دانرایەوە',
    'password_min_length': 'وشەی نهێنی دەبێت لانی کەم ٨ پیت بێت',
    'login_failed': 'چوونەژوورەوە سەرنەکەوت',
    'invalid_credentials': 'زانیاریەکان هەڵەن',
    'security_verification': 'پشتڕاستکردنەوەی ئەمنیەت',
    'verification_code_sent': 'کۆدی پشتڕاستکردنەوە بۆ ئامێرەکەت ناردرا.',
    'enter_valid_otp': 'تکایە کۆدی پشتڕاستکردنەوەی دروست بنووسە',
    'verification_failed': 'پشتڕاستکردنەوە شکستی هێنا',
    'code_resent_success': 'کۆدی پشتڕاستکردنەوە بە سەرکەوتوویی دووبارە ناردرا.',
    'too_many_attempts': 'زۆر هەوڵ هاتوو. تکایە دواتر هەوڵ بدەرەوە.',
    'check_device_for_code': 'ئامێرەکەت بپشکنە بۆ کۆدەکە',
    'verifying': 'پشتڕاستکردنەوەدا...',

    // Navigation
    'dashboard': 'داشبۆرد',
    'core': 'سەرەکی',
    "accounting": "ژمێریاری",
    'user_management': 'بەڕێوەبردنی بەکارهێنەران',
    'property_management': 'بەڕێوەبردنی موڵک',
    'maintenance_operations': 'چاککردن و کارگێڕی',
    'financial_management': 'بەڕێوەبردنی دارایی',
    'financial_payments': 'پارەدانەکان',
    'financial_accounting': 'ژمێریاری',
    'financial_portfolio': 'پۆرتفۆلیۆ و KPIکان',
    'portfolio_kpis': 'پۆرتفۆلیۆ و نیشاندەرەکان',
    'reports_analytics': 'ڕاپۆرت و شیکاری',
    'logs_audit': 'تۆمار و وردبینی',
    'all_activities': 'هەموو چالاکیەکان',
    'tenant_activities': 'چالاکیەکانی کرێکار',
    'system': 'سیستەم',
    'bookings': 'حیجزەکان',
    'booking_list': 'لیستی حیجزەکان',
    'new_booking': 'حیجزی نوێ',
    'booking_calendar': 'ڕۆژژمێری حیجزەکان',
    'waitlist': 'لیستی چاوەڕوانی',
    'analytics': 'شیکارییەکان',
    'subscription': 'بەشداری',
    'whatsapp': 'واتسئەپ',
    'manage_services': 'بەڕێوەبردنی خزمەتگوزارییەکان',
    'generate_payments': 'دروستکردنی پارەدانەکان',
    'reports_dashboard': 'داشبۆردی ڕاپۆرتەکان',

    // Users
    'system_users': 'بەکارهێنەرانی سیستەم',
    'user_list': 'لیستی بەکارهێنەران',
    'add_user': 'زیادکردنی بەکارهێنەر',
    'edit_user': 'دەستکاری بەکارهێنەر',
    'user_profile': 'پرۆفایلی بەکارهێنەر',
    'first_name': 'ناوی یەکەم',
    'last_name': 'ناوی کۆتایی',
    'phone_number': 'ژمارەی مۆبایل',
    'role': 'ڕۆڵ',
    'administrator': 'بەڕێوەبەر',
    'front_desk': 'پێشەوەی میز',
    'created_at': 'دروستکراوە لە',
    'last_login': 'کۆتا چوونەژوورەوە',
    'never': 'هەرگیز',

    // Properties
    'properties': 'موڵکەکان',
    'property_list': 'لیستی موڵک',
    'add_property': 'زیادکردنی موڵک',
    'property_owners': 'خاوەنەکانی موڵک',
    'owner_list': 'لیستی خاوەنەکان',
    'add_owner': 'زیادکردنی خاوەن',
    'owners': 'خاوەنەکان',

    // Tenants
    'tenants': 'کرێکارەکان',
    'tenant_list': 'لیستی کرێکارەکان',
    'add_tenant': 'زیادکردنی کرێکار',
    'overdue_rent': 'کرێی دواکەوتوو',

    // Payments
    'payments': 'پارەدانەکان',
    'all_payments': 'هەموو پارەدانەکان',
    'record_payment': 'تۆمارکردنی پارەدان',
    'overdue_payments': 'پارەدانەکان درەنگکراوەکان',
    'receipts': 'وەرگرتەکان',

    // Reports
    'reports': 'ڕاپۆرتەکان',
    'all_reports': 'هەموو ڕاپۆرتەکان',
    'financial_reports': 'ڕاپۆرتە داراییەکان',
    'payment_reports': 'ڕاپۆرتە پارەدانەکان',
    'property_reports': 'ڕاپۆرتە موڵکەکان',
    'reports_1099_desc': 'ڕاپۆرتی IRS 1099-MISC بۆ دابەشکردنی موڵکەکان بۆ خاوەنەکان',
    'vendor_1099_nec': 'دابینکەر 1099-NEC',
    'vendor_1099_desc': 'ڕاپۆرتی ساڵانەی IRS – دابینکەرانی پارەدراو ≥ $600 وەک قەرەبووی غەیرە فەرمانبەر',
    'rent_roll_desc': 'وێنەی هەموو یەکەکان، باری نیشتەجێبوون، کرێ و وردەکارییەکانی گرێبەست',
    'ar_aging_desc': 'قەرزە هەڵپەسێردراوەکانی کرێکاران کۆکراوەتەوە بەپێی کات (0, 1-30, 31-60, 61-90, 90+)',
    'total_vendors': 'کۆی دابینکەران',
    'require_1099': '1099 پێویستە',
    'total_reportable': 'کۆی گشتی شایەنی ڕاپۆرتکردن',
    '1099_required': '1099 پێویستە',
    'below_threshold': 'لەژێر ئاستی پێویست',
    'occupancy_rate': 'ڕێژەی نیشتەجێبوون',
    'scheduled_rent': 'کرێی دیاریکراو',
    'aging_breakdown': 'وردەکاری قەرزە کۆنەکان',

    // Settings
    'settings': 'ڕێکخستنەکان',
    'profile_settings': 'ڕێکخستنەکانی پرۆفایل',
    'system_settings': 'ڕێکخستنەکانی سیستەم',
    'profile': 'پرۆفایل',
    'personal_details': 'وردەکارییە کەسییەکان',
    'security_settings': 'ڕێکخستنەکانی ئاسایش',
    'change_password': 'گۆڕینی وشەی نهێنی',
    'current_password': 'وشەی نهێنی ئێستا',
    'new_password': 'وشەی نهێنی نوێ',
    'confirm_new_password': 'دڵنیابوونەوە لە وشەی نهێنی نوێ',
    'organization_settings': 'ڕێکخستنەکانی ڕێکخراو',
    'organization_name': 'ناوی ڕێکخراو',
    'timezone': 'کاتژمێری ناوچەکە',
    'subscription_plan': 'پلانی بەشداری',
    'trial_period': 'ماوەی تاقیکردنەوە',
    'days_left': '{{days}} ڕۆژ ماوە',
    'subscription_required': 'بەشداری پێویستە',
    'subscription_expired_message': 'دەستگەیشتن بە ڕووبەری کارەکەت ئێستا داخراوە. بەشدارییەکەت نوێ بکەرەوە بۆ بەردەوامبوون لە بەڕێوەبردنی موڵکەکانت.',
    'premium_experience_notice': 'ڕووبەری کاری نایاب پێویستە',
    'feature_locked_message': 'ئەم تایبەتمەندییە لە پلانی ئێستاتدا بەردەست نییە. تکایە بۆ دەستگەیشتن بەرزکردنەوەی پلان بکە.',
    'renew_subscription': 'نوێکردنەوەی بەشداری',
    'update_profile_success': 'پرۆفایل بە سەرکەوتوویی نوێکرایەوە',
    'update_password_success': 'وشەی نهێنی بە سەرکەوتوویی گۆڕدرا',
    'update_system_success': 'ڕێکخستنەکانی سیستەم بە سەرکەوتوویی نوێکرایەوە',

    // Notifications
    'notifications': 'ئاگاداریەکان',
    'view_all_notifications': 'بینینی هەموو ئاگاداریەکان',

    // Forms
    'personal_information': 'زانیاری کەسی',
    'account_information': 'زانیاری هەژمار',
    'security': 'ئاسایش',
    'enter_first_name': 'ناوی یەکەم بنوسە',
    'enter_last_name': 'ناوی کۆتایی بنوسە',
    'enter_email': 'ئیمەیل بنوسە',
    'enter_username': 'ناوی بەکارهێنەر بنوسە',
    'enter_password': 'وشەی نهێنی بنوسە',
    'enter_phone_number': 'ژمارەی مۆبایل بنوسە',
    'confirm_password': 'دڵنیابوونەوە لە وشەی نهێنی',
    'leave_blank_to_keep_current': 'بەتاڵی بەجێبهێڵە بۆ پاراستنی وشەی نهێنی ئێستا',

    // Validation
    'first_name_required': 'ناوی یەکەم پێویستە',
    'last_name_required': 'ناوی کۆتایی پێویستە',
    'email_required': 'ئیمەیل پێویستە',
    'invalid_email': 'تکایە ئیمەیلی دروست بنوسە',
    'username_required': 'ناوی بەکارهێنەر پێویستە',
    'username_too_short': 'ناوی بەکارهێنەر دەبێت لانی کەم ٣ پیت بێت',
    'password_required': 'وشەی نهێنی پێویستە',
    'password_too_short': 'وشەی نهێنی دەبێت لانی کەم ٦ پیت بێت',
    'passwords_do_not_match': 'وشەی نهێنیەکان یەک ناگرێتەوە',
    'phone_invalid_format': 'تکایە ژمارەی مۆبایلی دروست بنوسە',

    // Actions
    'saving': 'پاشەکەوت دەکرێت...',
    'deleting': 'سڕینەوە دەکرێت...',
    'loading_users': 'بارکردنی بەکارهێنەران...',
    'loading_user_data': 'بارکردنی زانیاری بەکارهێنەر...',
    'update': 'نوێکردنەوە',
    'activate': 'چالاککردن',
    'deactivate': 'ناچالاککردن',
    'show_all': 'نیشانی هەموو',
    'hide_inactive': 'شاردنەوەی نەچالاک',
    'all_roles': 'هەموو ڕۆڵەکان',
    'retry': 'هەوڵدانەوە',

    // Messages
    'no_users_found': 'هیچ بەکارهێنەرێک نەدۆزرایەوە',
    'user_created_successfully': 'بەکارهێنەر بە سەرکەوتوویی دروستکرا',
    'user_updated_successfully': 'بەکارهێنەر بە سەرکەوتوویی نوێکرایەوە',
    'user_deleted_successfully': 'بەکارهێنەر بە سەرکەوتوویی سڕایەوە',
    'confirm_deletion': 'دڵنیابوونەوە لە سڕینەوە',
    'delete_user_confirmation': 'ئایا دڵنیایت لە سڕینەوەی {{name}}? ئەم کردارە ناتوانرێت گەڕێندرێتەوە.',

    // Dashboard
    'welcome_back': 'بەخێربێیتەوە',
    'dashboard_subtitle': 'لێرە دەبینیت چی ڕوودەدات لەگەڵ موڵکەکانتدا ئەمڕۆ.',
    'total_properties': 'کۆی گشتی موڵک',
    'active_tenants': 'کرێکارە چالاکەکان',
    'monthly_revenue': 'داھاتی مانگانە',
    'pending_payments': 'پارەدانە چاوەڕوانکراوەکان',
    'recent_activity': 'چالاکیەکانی دوایی',
    'quick_actions': 'کردارە خێراکان',
    'showing': 'پیشاندان',
    'of': 'لە',
    'users': 'بەکارهێنەران',
    'contact': 'پەیوەندی',
    'user': 'بەکارهێنەر',

    // Sidebar specific translations
    'core': 'سەرەکی',
    'user_management': 'بەڕێوەبردنی بەکارهێنەران',
    'property_management': 'بەڕێوەبردنی موڵک',
    'maintenance_operations': 'چاککردن و کارگێڕی',
    'financial_management': 'بەڕێوەبردنی دارایی',
    'financial_payments': 'پارەدانەکان',
    'financial_accounting': 'ژمێریاری',
    'financial_portfolio': 'پۆرتفۆلیۆ و KPIکان',
    'reports_analytics': 'ڕاپۆرت و شیکاری',
    'logs_audit': 'تۆمار و پشکنین',
    'system': 'سیستەم',

    'system_users': 'بەکارهێنەرانی سیستەم',
    'user_list': 'لیستی بەکارهێنەران',
    'add_user': 'زیادکردنی بەکارهێنەر',

    'buildings': 'بیناکان',
    'building_list': 'لیستی بیناکان',
    'add_building': 'زیادکردنی بینا',

    'apartments': 'ئەپارتمانەکان',
    'apartment_list': 'لیستی ئەپارتمانەکان',
    'add_apartment': 'زیادکردنی ئەپارتمان',

    'owners': 'خاوەنەکان',
    'owner_list': 'لیستی خاوەنەکان',
    'add_owner': 'زیادکردنی خاوەن',

    'tenants': 'کرێکارەکان',
    'tenant_list': 'لیستی کرێکارەکان',
    'add_tenant': 'زیادکردنی کرێکار',
    'owner_living': 'نیشتەجێبوونی خاوەن',
    'future_tenant': 'کرێکاری داهاتوو',
    'overdue_rent': 'کرێی درەنگکراو',

    'payments': 'پارەدانەکان',
    'all_payments': 'هەموو پارەدانەکان',
    'record_payment': 'تۆمارکردنی پارەدان',
    'payment_stats': 'ئاماری پارەدان',

    'service_payments': 'پارەدانی خزمەتگوزاری',
    'manage_services': 'بەڕێوەبردنی خزمەتگوزاری',
    'generate_payments': 'دروستکردنی پارەدان',
    'service_statistics': 'ئاماری خزمەتگوزاری',

    'reports': 'ڕاپۆرتەکان',
    'reports_dashboard': 'داشبۆردی ڕاپۆرتەکان',
    'revenue_report': 'ڕاپۆرتی داهات',
    'payment_logs': 'تۆماری پارەدانەکان',
    'occupancy_report': 'ڕاپۆرتی گیرانی',
    'tenant_payments': 'پارەدانی کرێکارەکان',
    'building_revenue': 'داهاتی بینا',
    'owner_revenue': 'داهاتی خاوەن',

    'activity_logs': 'تۆماری چالاکیەکان',
    'all_activities': 'هەموو چالاکیەکان',
    'tenant_activities': 'چالاکیەکانی کرێکار',
    'monthly_revenue': 'داهاتی مانگانە',

    'settings': 'ڕێکخستنەکان',
    'profile_settings': 'ڕێکخستنەکانی پرۆفایل',
    'system_settings': 'ڕێکخستنەکانی سیستەم',

    'logout': 'چوونەدەرەوە',

    // Apartment Detail View
    'loading_apartment_details': 'وردەکاری ئەپارتمان بار دەکرێت...',
    'error_loading_apartment': 'هەڵە لە بارکردنی وردەکاری ئەپارتمان',
    'try_again': 'هەوڵبدەرەوە',
    'back_to_apartments': 'گەڕانەوە بۆ ئەپارتمانەکان',
    'apartment_not_found': 'ئەپارتمان نەدۆزرایەوە',
    'apartment_not_found_message': 'ئەپارتمانەکە کە بۆی دەگەڕێی بوونی نییە یان سڕایەوە.',

    'building_and_location': 'بینا و شوێن',
    'building': 'بینا',
    'floor': 'نهۆم',
    'address': 'ناونیشان',

    'apartment_details': 'وردەکاری ئەپارتمان',
    'apartment_type': 'جۆر',
    'size': 'قەبارە',
    'furnished': 'فرۆشراو',

    'owner_information': 'زانیاری خاوەن',
    'owner_name': 'ناو',
    'owner_contact': 'پەیوەندی',

    'additional_information': 'زانیاری زیاتر',
    'created_at': 'دروستکراوە لە',
    'updated_at': 'دوایین نوێکردنەوە',

    'status_management': 'بەڕێوەبردنی بار',
    'status_vacant': 'بەتاڵ',
    'status_occupied': 'گیراو',
    'status_maintenance': 'لەژێر چاککردن',
    'status_vacant_description': 'بەردەستە بۆ کرێ یان خراپە',
    'status_occupied_description': 'لەلایەن کرێکارەوە گیراوە',
    'status_maintenance_description': 'لەژێر چاککردن یان نوێکردنەوە',
    'status_sold_description': 'ئەم یەکەیە فرۆشراوە',
    'change_status': 'گۆڕینی بار بۆ',

    'quick_actions': 'کردارە خێراکان',
    'create_lease': 'دروستکردنی گرێبەست',
    'view_tenant_info': 'بینینی زانیاری کرێکار',
    'mark_maintenance_complete': 'نیشانەکردنی چاککردن وەک تەواو',
    'view_building': 'بینینی بینا',
    'edit_apartment': 'دەستکاری ئەپارتمان',

    'same_building_apartments': 'هەمان بینا',
    'view_all_apartments_in_building': 'بینینی هەموو ئەپارتمانەکانی بینا',
    'view_vacant_apartments': 'بینینی ئەپارتمانە بەتاڵەکان',

    // Delete confirmation
    'delete_apartment_confirmation': 'ئایا دڵنیایت لە سڕینەوەی ئەپارتمان "{{name}}"? ناتوانرێت ئەم کردارە گەڕێندرێتەوە.',

    // Apartment Form
    'loading_apartment_data': 'بارکردنی زانیاری ئەپارتمان...',
    'edit_apartment': 'دەستکاری ئەپارتمان',
    'add_new_apartment': 'زیادکردنی ئەپارتمانی نوێ',

    'basic_information': 'زانیاری بنەڕەتی',
    'apartment_number': 'ژمارەی ئەپارتمان',
    'enter_apartment_number': 'ژمارەی ئەپارتمان بنوسە',
    'floor_number': 'ژمارەی نهۆم',
    'enter_floor_number': 'ژمارەی نهۆم بنوسە',
    'size_sqm': 'قەبارە (م²)',
    'enter_size': 'قەبارە بنوسە بە مەتر چوارگۆشە',
    'apartment_type': 'جۆری ئەپارتمان',
    'select_apartment_type': 'جۆری ئەپارتمان هەڵبژێرە',
    'select_building': 'بینا هەڵبژێرە',
    'furnished': 'فرۆشراو',

    // Validation messages
    'floor_required': 'ژمارەی نهۆم پێویستە',
    'apartment_number_required': 'ژمارەی ئەپارتمان پێویستە',
    'size_required': 'قەبارە پێویستە',
    'type_required': 'جۆری ئەپارتمان پێویستە',
    'building_required': 'بینا پێویستە',
    'invalid_size': 'قەبارە دەبێت گەورەتر بێت لە صفر',

    // Form actions
    'update': 'نوێکردنەوە',
    'save': 'پاشەکەوت',
    'saving': 'پاشەکەوت دەکرێت...',


    // Apartment List
    'apartments': 'ئەپارتمانەکان',
    'search_apartments': 'گەڕان بۆ ئەپارتمان...',
    'filter': 'پاڵاوتن',
    'grid_view': 'تۆڕ',
    'list_view': 'لیست',
    'add_apartment': 'زیادکردنی ئەپارتمان',
    'all_buildings': 'هەموو بیناکان',
    'all_types': 'هەموو جۆرەکان',
    'all_statuses': 'هەموو بارەکان',
    'all': 'هەمووی',
    'vacant_apartments': 'ئەپارتمانە بەتاڵەکان',
    'occupied_apartments': 'ئەپارتمانە گیراوەکان',
    'maintenance_apartments': 'لەژێر چاککردن',
    'loading_apartments': 'ئەپارتمانەکان بار دەکرێن...',
    'error_loading_apartments': 'هەڵە لە بارکردنی ئەپارتمانەکان',
    'no_apartments_found': 'هیچ ئەپارتمانێک نەدۆزرایەوە',
    'no_apartments_message': 'هیچ ئەپارتمانێک لە سیستەمەکە نییە تاکو ئێستا.',
    'create_first_apartment': 'دروستکردنی یەکەم ئەپارتمان',
    'showing_filtered_results': 'پیشاندانی {{showing}} لە {{total}} ئەپارتمان',

    // Statuses
    'vacant': 'بەتاڵ',
    'occupied': 'گیراو',
    'maintenance': 'لەژێر چاککردن',

    // Apartment card
    'furnished': 'فرۆشراو',

    // Delete confirmation
    'delete_apartment_confirmation': 'ئایا دڵنیایت لە سڕینەوەی ئەپارتمان "{{name}}"? ناتوانرێت ئەم کردارە گەڕێندرێتەوە.',
    'deleting': 'سڕینەوە دەکرێت...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'دروستکردنی ئەپارتمان بە گشتی',
    'preview': 'پێشبینین',
    'apartment_number_format': 'شێوازی ژمارەی ئەپارتمان',
    'format_pattern': 'شێوازی فۆرمات',
    'format_pattern_help': 'بەکارهێنانی {floor} بۆ ژمارەی نهۆم و {unit} بۆ ژمارەی یەکە. نموونە: {floor}{unit} = 0201',
    'preview_example': 'نموونەی پێشبینین',
    'floor_plans': 'پلانی نهۆمەکان',
    'add_floor_plan': 'زیادکردنی پلانی نهۆم',
    'floor_plan_number': 'پلانی نهۆمی {number}',
    'floors_comma_separated': 'نهۆمەکان (بە فاریزە جیاکراوە)',
    'unit_types': 'جۆرەکانی یەکە',
    'add_unit_type': 'زیادکردنی جۆری یەکە',
    'unit_type_number': 'جۆری یەکە {number}',
    'name': 'ناو',
    'quantity': 'ژمارە',
    'type': 'جۆر',
    'area_sqm': 'قەبارە (م²)',
    'furnished': 'فرۆشراو',
    'apartment_preview_count': 'پێشبینینی ئەپارتمان ({count} یەکە)',
    'floor_unit_type': 'نهۆمی {floor} • {type}',
    'close': 'داخستن',
    'create_apartments': 'دروستکردنی ئەپارتمان',
    'create_apartments_count': 'دروستکردنی {count} ئەپارتمان',
    'creating_apartments': 'دروستکردنی ئەپارتمان...',
    'add_at_least_one_floor_plan': 'تکایە بەلایەنی کەم یەک پلانی نهۆم زیاد بکە',
    'no_apartments_to_create': 'هیچ ئەپارتمانێک نییە بۆ دروستکردن',


    'building_name_required': 'ناوی بینا پێویستە',
    'building_address_required': 'ناونیشانی بینا پێویستە',
    'invalid_floors': 'پێویستە کۆی نهۆمەکان کەمتر نەبێت لە ١',
    'invalid_apartments': 'پێویستە کۆی شوقەکان کەمتر نەبێت لە ٠',
    'loading_building_data': 'زانیارییەکانی بینا بار دەکرێت...',
    'edit_building': 'دەستکاریکردنی بینا',
    'add_new_building': 'بینایەکی نوێ زیاد بکە',
    'basic_information': 'زانیارییە بنەڕەتییەکان',
    'building_name': 'ناوی بینا',
    'enter_building_name': 'ناوی بینا بنوسە',
    'total_floors': 'کۆی نهۆمەکان',
    'number_of_floors': 'ژمارەی نهۆمەکان',
    'total_apartments': 'کۆی شوقەکان',
    'number_of_apartments': 'ژمارەی شوقەکان',
    'address': 'ناونیشان',
    'enter_complete_building_address': 'ناونیشانی تەواوی بینا بنوسە',
    'cancel': 'پاشگەزبوونەوە',
    'saving': 'لە پاشەکەوتکردندایە...',
    'update': 'نوێکردنەوە',
    'save': 'پاشەکەوتکردن',


    'buildings': 'بیناکان',
    'search_buildings': 'گەڕان بەناو بیناکاندا...',
    'bulk_add_apartments': 'زیادکردنی شوقە بە گشتی',
    'add_building': 'بینایەک زیاد بکە',
    'loading_buildings': 'بیناکان بار دەکرێن...',
    'error_loading_buildings': 'هەڵە لە بارکردنی بیناکان',
    'try_again': 'هەوڵبدەرەوە',
    'no_buildings_found': 'هیچ بینایەک نەدۆزرایەوە',
    'no_buildings_yet': 'هێشتا بینایەک نییە',
    'no_buildings_match_search': 'هیچ بینایەک نەدۆزرایەوە کە بگونجێت لەگەڵ "{{search}}"',
    'no_buildings_message': 'هێشتا هیچ بینایەک نییە لە سیستمەکەدا. یەکەم بینات زیاد بکە بۆ دەستپێکردن.',
    'create_first_building': 'یەکەم بینا دروست بکە',
    'showing_filtered_results': 'پیشاندانی {{showing}} لە {{total}} بیناکان',
    'floors': 'نهۆمەکان',
    'apartments': 'شوقەکان',
    'occupancy': 'پڕی',
    'vacant': 'بەتاڵ',
    'occupied': 'پڕە',
    'no_apartments_yet': 'هێشتا شوقە نییە',
    'add_apartments': '+ زیادکردنی شوقە',
    'confirm_deletion': 'دڵنیابوونەوە لە سڕینەوە',
    'delete_building_confirmation': 'دڵنیایت لە سڕینەوەی بینای "{{name}}"? ناتوانیت ئەم کارە بگەڕێنیتەوە.',
    'cancel': 'پاشگەزبوونەوە',
    'deleting': 'لە سڕینەوەدایە...',
    'delete': 'سڕینەوە',
    'create_building_first': 'تکایە یەکەم بینات دروست بکە',
    'create': 'دروستکردنی شوقە',
    'unnamed_building': 'بینای بێ ناو',
    'no_address_provided': 'ناونیشان نەدراوە',

    'select_building_for_bulk_creation': 'بینا هەڵبژێرە بۆ زیادکردنی شوقە بە گشتی',

    'loading_building_details': 'زانیارییەکانی بینا بار دەکرێت...',
    'error_loading_building': 'هەڵە لە بارکردنی بینا',
    'try_again': 'هەوڵبدەرەوە',
    'back_to_buildings': 'گەڕانەوە بۆ بیناکان',
    'building_not_found': 'بینا نەدۆزرایەوە',
    'building_not_found_message': 'بیناکە کە بۆی دەگەڕێی بوونی نییە یان سڕایەوە.',
    'add_apartment': 'شوقەیەک زیاد بکە',
    'edit_building': 'دەستکاریکردنی بینا',
    'generate_reports': 'ڕاپۆرت دروست بکە',
    'total_apartments': 'کۆی شوقەکان',
    'units': 'یەکە',
    'across_floors': 'بەدرێژایی {{floors}} نهۆمە',
    'vacant_apartments': 'بەتاڵ',
    'available_for_rent': 'بۆ کرێ بەردەستە',
    'no_vacancies': 'هیچ شوقەیەک بەتاڵ نییە',
    'occupancy_rate': 'ڕێژەی پڕی',
    'occupied_units': 'یەکەی پڕ',
    'maintenance_apartments': 'چاککردن',
    'needs_attention': 'پێویستی بە سەرنجە',
    'average_apartment_size': 'ناوەندەی قەبارە',
    'furnished_apartments': 'فرۆشراو',
    'utility_status': 'دۆخی خزمەتگوزاریەکان',
    'water': 'ئاو',
    'electricity': 'کارەبا',
    'internet': 'ئینتەرنێت',
    'hide_details': 'شاردنەوەی زانیاری',
    'show_details': 'پیشاندانی زانیاری',
    'search_apartments': 'گەڕان بۆ شوقە، خاوەن، کرێکار...',
    'all_statuses': 'هەموو دۆخەکان',
    'vacant': 'بەتاڵ',
    'occupied': 'پڕە',
    'maintenance': 'چاککردن',
    'top_floor_first': 'نهۆمی سەرەوە یەکەم',
    'ground_floor_first': 'نهۆمی خوارەوە یەکەم',
    'showing_results': 'پیشاندانی {{count}} لە {{total}} شوقە',
    'matching': 'گونجاندن',
    'with_status': 'بە دۆخی',
    'no_apartments_found': 'هیچ شوقەیەک نەدۆزرایەوە',
    'no_apartments_match_filters': 'هیچ شوقەیەک نەدۆزرایەوە کە گونجاو بیت لەگەڵ فلتەرەکانی ئێستا.',
    'clear_filters': 'پاککردنەوەی فلتەرەکان',
    'floor_number': 'نهۆمی {{number}}',
    'apartments': 'شوقە',
    'owner': 'خاوەن',
    'status': 'دۆخ',
    'vacant_status': 'بەردەستە',
    'maintenance_status': 'لەژێر چاککردندا',
    'furnished': 'فرۆشراو',
    'unfurnished': 'فرۆشنەکراو',
    'no_matching_apartments_on_floor': 'هیچ شوقەیەک لە نهۆمی {{floor}} نەدۆزرایەوە کە گونجاو بیت لەگەڵ فلتەرەکانی ئێستا.',
    'construction_year': 'ساڵی دروستکردن: {{year}}',

    'activity_logs': 'تۆمارەکانی چالاکی',
    'track_all_system_activities': 'بەدواداچوونی هەموو چالاکی و گۆڕانکارییەکانی سیستم',
    'filter': 'فلتەر',
    'export_to_excel': 'هەناردن بۆ ئێکسێل',
    'exporting': 'لە هەنارداندایە...',
    'filter_logs': 'فلتەرکردنی تۆمارەکان',
    'action_type': 'جۆری کردار',
    'all_actions': 'هەموو کردارەکان',
    'entity_type': 'جۆری ناوک',
    'all_entities': 'هەموو ناوکەکان',
    'entries_per_page': 'ژمارەی تۆمار بۆ هەر پەڕەیەک',
    'start_date': 'بەرواری دەستپێکردن',
    'end_date': 'بەرواری کۆتایی',
    'reset': 'دووبارەکردنەوە',
    'apply_filter': 'جێبەجێکردنی فلتەر',
    'previous': 'پێشوو',
    'next': 'دواتر',
    'tenant_activity_logs': 'تۆمارەکانی چالاکی کرێکاران',
    'payment_activity_logs': 'تۆمارەکانی چالاکی پارەدانەکان',
    'building_activity_logs': 'تۆمارەکانی چالاکی بیناکان',
    'apartment_activity_logs': 'تۆمارەکانی چالاکی شوقەکان',
    'owner_activity_logs': 'تۆمارەکانی چالاکی خاوەنەکان',
    'user_activity_logs': 'تۆمارەکانی چالاکی بەکارهێنەران',
    'system_activity_logs': 'تۆمارەکانی چالاکی سیستم',

    'monthly_revenue_by_user': 'داھاتمانگەی مانگانە بەپێی بەکارهێنەر',
    'export_to_excel': 'هەناردن بۆ ئێکسێل',
    'exporting': 'لە هەنارداندایە...',
    'total_revenue': 'کۆی داھات',
    'total_payments': 'کۆی پارەدانەکان',
    'recorded_by': 'تۆمارکراوە لەلایەن',
    'average_payment': 'ناوەندی پارەدان',
    'per_transaction': 'بۆ هەر مامەڵەیەک',
    'revenue_by_user': 'داھات بەپێی بەکارهێنەر',
    'no_revenue_data': 'هیچ زانیاری داھات نییە',
    'no_revenue_data_message': 'هیچ تۆمارێکی پارەدان نەدۆزرایەوە بۆ {{month}} {{year}}. هەوڵبدە مانگ یان ساڵێکی جیاواز هەڵبژێریت.',

    'loading_owner_data': 'زانیارییەکانی خاوەن بار دەکرێت...',
    'error_loading_owner': 'هەڵە لە بارکردنی خاوەن',
    'back_to_owners': 'گەڕانەوە بۆ خاوەنەکان',
    'send_reminder': 'ناردنی ئاگادارکردنەوە',
    'edit': 'دەستکاری',
    'overview': 'بینینێکی گشتی',
    'properties': 'شوقەکان',
    'payments': 'پارەدانەکان',
    'outstanding': 'قەرزەکان',
    'contact_information': 'زانیارییەکانی پەیوەندی',
    'property_overview': 'بینینێکی گشتی لە شوقەکان',
    'add_apartment': 'شوقەیەک زیاد بکە',
    'no_properties': 'هیچ شوقەیەک نییە',
    'no_properties_message': 'ئەم خاوەنە هیچ شوقەیەکی نییە تاکو ئێستا.',
    'add_first_property': 'یەکەم شوقە زیاد بکە',
    'view_details': 'بینینی وردەکاری',
    'payment_history': 'مێژووی پارەدانەکان',
    'no_payments': 'هیچ پارەدانێک نییە',
    'no_payments_message': 'تا ئێستا هیچ پارەدانێک تۆمار نەکراوە.',
    'outstanding_fees': 'پارەی قەرزکراو',
    'no_outstanding_fees': 'هیچ پارەی قەرزکراو نییە',
    'all_fees_paid': 'هەموو پارەکان نوێکراوەتەوە.',
    'total_outstanding': 'کۆی پارەی قەرزکراو',
    'add_payment': 'پارەدان زیاد بکە',
    'property': 'شوقە',
    'select_property': 'شوقە هەڵبژێرە',
    'amount': 'بڕی پارە',
    'payment_date': 'بەرواری پارەدان',
    'payment_method': 'شێوازی پارەدان',
    'cash': 'پارە',
    'bank_transfer': 'گوازینەوەی بانکی',
    'check': 'چێک',
    'credit_card': 'کارتی بانکی',
    'online_payment': 'پارەدانی ئۆنلاین',
    'reference_number': 'ژمارەی سەرچاوە',
    'notes': 'تێبینییەکان',
    'cancel': 'پاشگەزبوونەوە',


    'owner_information': 'زانیارییەکانی خاوەن',
    'name': 'ناو',
    'phone': 'ژمارەی مۆبایل',
    'owner_lives_property': 'خاوەن لە شوقەکە دەژی',
    'select_apartments': 'شوقەکان هەڵبژێرە',
    'available_apartments': 'شوقەی بەردەست',
    'no_apartments_available': 'هیچ شوقەیەک بەردەست نییە. هەموو شوقەکان خاوەنیان هەیە.',
    'apartment_number': 'شوقەی ژمارە {{number}}',
    'floor': 'نهۆم',
    'size': 'قەبارە',
    'type': 'جۆر',
    'status': 'دۆخ',
    'cancel': 'پاشگەزبوونەوە',
    'saving': 'لە پاشەکەوتکردندایە...',
    'update_owner': 'نوێکردنەوەی خاوەن',
    'create_owner': 'دروستکردنی خاوەن',
    'edit_property_owner': 'دەستکاریکردنی خاوەنی شوقە',
    'add_property_owner': 'زیادکردنی خاوەنی شوقە',


    'property_owners': 'خاوەن موڵک',
    'add_owner': 'خاوەن زیاد بکە',
    'search_owners': 'گەڕان بۆ خاوەنەکان...',
    'filter': 'پاڵاوتن',
    'list_view': 'لیست',
    'grid_view': 'تۆڕ',
    'export': 'هەناردن',
    'exporting': 'هەناردن...',
    'living_status': 'دۆخی نیشتەجێبوون',
    'all': 'هەمووی',
    'living_on_property': 'نیشتەجێبوون لە موڵک',
    'not_living_on_property': 'نەنیشتەجێبوون لە موڵک',
    'country': 'وڵات',
    'all_countries': 'هەموو وڵاتەکان',
    'apartment_status': 'دۆخی شوقە',
    'all_statuses': 'هەموو دۆخەکان',
    'with_vacant': 'بە شوقەی بەتاڵ',
    'fully_occupied': 'تەواو داگیرکراو',
    'with_maintenance': 'بە چاککردنەوە',
    'min_apartments': 'کەمترین شوقە',
    'max_apartments': 'زۆرترین شوقە',
    'min_occupancy_rate': 'کەمترین ڕێژەی داگیرکردن (%)',
    'clear_filters': 'پاککردنەوەی پاڵاوتن',
    'apply_filters': 'جێبەجێکردنی پاڵاوتن',
    'total_owners': 'کۆی گشتی خاوەنەکان',
    'resident_owners': 'خاوەنە نیشتەجێبووەکان',
    'with_apartments': 'بە شوقە',
    'without_apartments': 'بێ شوقە',
    'loading_owners': 'بارکردنی خاوەنەکان...',
    'error_loading_owners': 'هەڵە لە بارکردنی خاوەنەکان',
    'try_again': 'هەوڵبدەرەوە',
    'no_owners_found': 'هیچ خاوەنی موڵک نەدۆزرایەوە',
    'no_owners_message': 'هیچ خاوەنی موڵک نییە لە سیستمەکەدا. کرتە لەسەر دوگمەی \'خاوەن زیاد بکە\' بۆ دروستکردنی یەکەم خاوەن.',
    'create_first_owner': 'یەکەم خاوەن دروست بکە',
    'showing_filtered_results': 'پیشاندانی {showing} لە {total} خاوەن',
    'confirm_deletion': 'دڵنیابوونەوە لە سڕینەوە',
    'delete_owner_confirmation': 'دڵنیایت دەتەوێت خاوەن "{name}" بسڕیتەوە؟ ناتوانیت ئەم کردارە بگەڕێنیتەوە.',
    'cancel': 'پاشگەزبوونەوە',
    'delete': 'سڕینەوە',
    'deleting': 'سڕینەوە...',
    "loading": "باركردن...",
    "edit_property_owner": "دەستکاری خاوەنی موڵک",
    "add_property_owner": "زیادکردنی خاوەنی موڵک",
    "owner_information": "زانیاری خاوەن",
    "name": "ناو",
    "phone": "ژمارەی تەلەفۆن",
    "owner_lives_on_property": "خاوەن لە موڵکەکەدا دەژی",
    "select_apartments": "هەڵبژاردنی شوقە ({{count}})",
    "available_apartments": "{{count}} شوقەی بەردەست",
    "no_apartments_available": "هیچ شوقەیەک بەردەست نییە. هەموو شوقەکان خاوەنیان هەیە.",
    "floor": "نهۆم",
    "size": "قەبارە",
    "size_unit_sqm": "م²",
    "type": "جۆر",
    "status": "دۆخ",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "update_owner": "نوێکردنەوەی خاوەن",
    "create_owner": "دروستکردنی خاوەن",
    "failed_to_load_data": "سەرکەوتوو نەبوو لە بارکردنی زانیارییەکان",
    "failed_to_save_owner": "سەرکەوتوو نەبوو لە پاشەکەوتکردنی خاوەن",

    "activity_logs": "تۆماری چالاکییەکان",
    "tenant_activity_logs": "تۆماری چالاکی کرێچییەکان",
    "payment_activity_logs": "تۆماری چالاکی پارەدانەکان",
    "building_activity_logs": "تۆماری چالاکی بیناکان",
    "apartment_activity_logs": "تۆماری چالاکی شوققەکان",
    "owner_activity_logs": "تۆماری چالاکی خاوەنەکان",
    "user_activity_logs": "تۆماری چالاکی بەکارهێنەران",
    "system_activity_logs": "تۆماری چالاکی سیستەم",
    "track_all_system_activities": "بەدواداچوونی هەموو چالاکی و گۆڕانکارییەکانی سیستەم",
    "filter": "فلتەر",
    "export_to_excel": "هەناردەکردن بۆ ئێکسێل",
    "exporting": "خەریکی هەناردەکردنە...",
    "search_logs_placeholder": "گەڕان لە تۆمارەکان بەپێی ناو، بەکارهێنەر یان وردەکاری...",
    "showing_entries": "پیشاندانی {{showing}} لە {{total}} تۆمار",
    "filter_logs": "فلتەرکردنی تۆمارەکان",
    "action_type": "جۆری کردار",
    "all_actions": "هەموو کردارەکان",
    "entity_type": "جۆری ڕەگەز",
    "all_entities": "هەموو ڕەگەزەکان",
    "entries_per_page": "تۆمار لە هەر لاپەڕەیەک",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "reset": "ڕێکخستنەوە",
    "apply_filter": "جێبەجێکردنی فلتەر",
    "time": "کات",
    "user": "بەکارهێنەر",
    "action": "کردار",
    "entity": "ڕەگەز",
    "details": "وردەکاری",
    "view": "بینین",
    "system": "سیستەم",
    "view_entity_details": "بینینی وردەکاری {{type}}",
    "no_logs_matching_search": "هیچ تۆمارێکی چالاکی نییە کە لەگەڵ هۆکارەکانی گەڕاندا بگونجێت",
    "no_logs_for_filters": "هیچ تۆمارێکی چالاکی نییە بۆ فلتەرە دیاریکراوەکان",
    "showing_range": "پیشاندانی {{start}} بۆ {{end}} لە {{total}} تۆمار",
    "previous": "پێشوو",
    "next": "داهاتوو",
    "failed_to_load_logs": "بارکردنی تۆماری چالاکییەکان سەرکەوتوو نەبوو",
    "failed_to_export_logs": "هەناردەکردنی تۆمارەکان بۆ ئێکسێل سەرکەوتوو نەبوو",

    "tenant": "کرێچی",
    "payment": "پارەدان",
    "building": "بینا",
    "apartment": "شوققە",
    "owner": "خاوەن",
    "user": "بەکارهێنەر",
    "system": "سیستەم",

    "created": "دروستکرا",
    "updated": "نوێکرایەوە",
    "deleted": "سڕایەوە",
    "viewed": "بینرا",
    "login": "چوونەژوورەوە",
    "logout": "چوونەدەرەوە",
    "payment_made": "پارەدان کرا",
    "payment_received": "پارەدان وەرگیرا",
    "status_changed": "دۆخ گۆڕدرا",
    "approved": "پەسەندکرا",
    "rejected": "ڕەتکرایەوە",
    "maintenance_request": "داواکاری چاککردنەوە",
    "maintenance_completed": "چاککردنەوە تەواو بوو",


    "loading_payment_data": "باركردنی زانیاری پارەدان...",
    "error_loading_payment": "هەڵە لە باركردنی پارەدان",
    "payment_not_found": "پارەدان نەدۆزرایەوە",
    "back_to_payments": "گەڕانەوە بۆ پارەدانەکان",
    "confirm_deletion": "دڵنیابوونەوە لە سڕینەوە",
    "delete_payment_confirmation": "دڵنیایت لە سڕینەوەی ئەم پارەدانە بە بڕی {{amount}}؟ ئەم کردارە ناتوانرێت بگەڕێنرێتەوە.",
    "cancel": "هەڵوەشاندنەوە",
    "deleting": "سڕینەوە...",
    "delete": "سڕینەوە",
    "print_receipt": "چاپکردنی پسوولە",
    "edit": "دەستکاریکردن",
    "tenant": "کرێچی",
    "unknown_tenant": "کرێچی نەناسراو",
    "apartment": "شوقە",
    "apt": "شوقە",
    "none": "هیچ",
    "payment_period": "ماوەی پارەدان",
    "payment_details": "وردەکاریەکانی پارەدان",
    "tenant_information": "زانیاری کرێچی",
    "payment_information": "زانیاری پارەدان",
    "amount": "بڕ",
    "payment_date": "بەرواری پارەدان",
    "payment_type": "جۆری پارەدان",
    "created": "دروستکراوە",
    "last_updated": "دوایین نوێکردنەوە",
    "notes": "تێبینیەکان",
    "view_tenant": "بینینی کرێچی",
    "unknown_period": "ماوەی نەناسراو",
    "to": "بۆ",
    "invalid_period_data": "زانیاری ماوە نادروستە",
    "unknown_type": "جۆری نەناسراو",
    "unknown": "نەناسراو",
    "failed_to_load_payment_data": "سەرکەوتوو نەبوو لە باركردنی زانیاری پارەدان",
    "failed_to_delete_payment": "سەرکەوتوو نەبوو لە سڕینەوەی پارەدان",

    "rent": "کرێ",
    "service": "ڕسوماتی خزمەتگوزاری",
    "deposit": "بارمتە",
    "maintenance": "چاککردنەوە",
    "other": "هیتر",

    "loading": "باركردن...",
    "edit_payment": "دەستکاری پارەدان",
    "record_payment": "تۆمارکردنی پارەدان",
    "payment_information": "زانیاری پارەدان",
    "tenant": "کرێچی",
    "select_tenant": "کرێچی هەڵبژێرە",
    'financial_matrix_subtitle': 'بینینی یەکگرتووی هەموو چالاکییە داراییەکان لە هەموو یەکەکاندا',
    'total_charged': 'کۆی داواکراو',
    'total_collected': 'کۆی کۆکراوەتەوە',
    'overdue_balance': 'باڵانسی دواکەوتوو',
    'partial_balance': 'باڵانسی بەشێکی',
    'all_floors': 'هەموو نهۆمەکان',
    'floor_label': 'نهۆم',
    'legend_paid': 'دراوە',
    'legend_partial': 'بەشێکی دراوە',
    'legend_overdue': 'دواکەوتوو',
    'legend_upcoming': 'داهاتوو',
    'legend_no_charges': 'هیچ ڕسوماتی نییە',
    'table_unit': 'یەکە',
    'table_now': 'ئێستا',
    'view_rent': 'کرێ',
    'view_service': 'خزمەتگوزاری',
    'view_sales': 'فرۆشتن',
    'treasury_quick_pay': 'خەزینە - پارەدان',
    'payment_amount': 'بڕی پارەدان',
    'memo': 'تێبینی',
    'add_a_note_about_this_treasury_event': 'تێبینی دەربارەی ئەم جوڵەیە...',
    'view_owner_file_and_distribution': 'بینینی پەڕگەی خاوەن ماڵ',
    'view_resident_ledger': 'بینینی تۆماری نیشتەجێبوو',
    'processing': 'خەریکە...',
    'confirm_and_record': 'تأکیدکردنەوە و تۆمارکردن',
    'no_entity_found': 'هیچ نیشتەجێبوو یان خاوەن ماڵێک بۆ ئەم یەکەیە نەدۆزرایەوە',
    'owner_view': 'خاوەن ماڵ',
    'tenant_view': 'نیشتەجێبوو',
    'search_owner_unit_building': 'گەڕان بۆ خاوەن، یەکە، یان بینا...',
    'showing_all_installments': 'نیشاندانی هەموو {{count}} قیست',
    'showing_overdue_within_days': 'نیشاندانی دواکەوتووەکان + مستحق لە ماوەی {{days}} ڕۆژ · {{hidden}} قیستی داهاتوو شاردراوەتەوە',
    'hide_future_count': 'شاردنەوەی داهاتووەکان ({{count}})',
    'show_all_future_count': 'نیشاندانی هەموو داهاتووەکان ({{count}})',
    'no_overdue_upcoming_all_clear': 'هیچ پارەدانێکی دواکەوتوو یان داهاتوو نییە — هەموو شتێک ڕاستە!',
    'no_records_match_search': 'هیچ تۆمارێک بە گەڕانەکەت ناگونجێ.',
    'payment_recorded_success': 'پارەدانەکە بە سەرکەوتوویی تۆمارکرا',
    'enter_valid_amount': 'تکایە بڕی دروست بنوسە',

    "apt": "شوقە",
    "no_apartment": "شوقە نییە",
    "amount": "بڕ",
    "payment_date": "بەرواری پارەدان",
    "payment_type": "جۆری پارەدان",
    "payment_period": "ماوەی پارەدان",
    "period_start": "دەستپێکی ماوە",
    "period_end": "کۆتایی ماوە",
    "additional_information": "زانیاری زیاتر",
    "notes": "تێبینییەکان",
    "notes_placeholder": "هەر تێبینییەکی زیاتر سەبارەت بەم پارەدانە...",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "update_payment": "نوێکردنەوەی پارەدان",
    "failed_to_load_tenants_format": "بارکردنی کرێچییەکان سەرکەوتوو نەبوو: فۆرماتی داتا چاوەڕواننەکراو",
    "failed_to_load_tenants": "بارکردنی کرێچییەکان سەرکەوتوو نەبوو. تکایە دووبارە هەوڵ بدەوە.",
    "failed_to_load_payment_data": "بارکردنی زانیاری پارەدان سەرکەوتوو نەبوو",
    "failed_to_save_payment": "پاشەکەوتکردنی پارەدان سەرکەوتوو نەبوو",

    "rent": "کرێ",
    "service": "ڕسوماتی خزمەتگوزاری",
    "deposit": "بارمتە",
    "maintenance": "چاککردنەوە",
    "other": "هیتر",

    "payments": "پارەدانەکان",
    "refresh": "نوێکردنەوە",
    "refresh_payments": "نوێکردنەوەی پارەدانەکان",
    "stats": "ئامار",
    "toggle_statistics": "گۆڕینی بینینی ئامارەکان",
    "search_payments": "گەڕان لە پارەدانەکان...",
    "filter": "پاڵاوتن",
    "record_payment": "تۆمارکردنی پارەدان",
    "confirm_deletion": "دڵنیاکردنەوە لە سڕینەوە",
    "confirm_delete_payment": "ئایا دڵنیایت لە سڕینەوەی پارەدانی {amount} بۆ کرێگر {tenantName}؟ ناتوانیت ئەم کردارە بگەڕێنیتەوە.",
    "cancel": "پاشگەزبوونەوە",
    "deleting": "لە سڕینەوەدایە...",
    "delete": "سڕینەوە",
    "filter_payments": "پاڵاوتنی پارەدانەکان",
    "reset_all": "ڕێکخستنەوەی هەموو",
    "payment_type": "جۆری پارەدان",
    "all_types": "هەموو جۆرەکان",
    "payment_type_rent": "کرێ",
    "payment_type_service": "خزمەتگوزاری",
    "payment_type_deposit": "دانهێنان",
    "payment_type_other": "ئەویتر",

    "payment_type_commission": "کۆمیشن",
    "payment_type_security_deposit": "مەبەستی ئەمنییەت",    "building": "بینین",
    "all_buildings": "هەموو بیناکان",
    "from_date": "لە رۆژی",
    "to_date": "بۆ رۆژی",
    "total_payments": "کۆی گشتی پارەدانەکان",
    "payment": "پارەدان",
    "payments": "پارەدانەکان",
    "recorded": "تۆمارکراو",
    "rent_payments": "پارەدانی کرێ",
    "service_payments": "پارەدانی خزمەتگوزاری",
    "payment_statistics": "ئاماری پارەدانەکان",
    "payments_by_month": "پارەدانەکان بەپێی مانگ",
    "payment_types_distribution": "دابەشبوونی جۆرەکانی پارەدان",
    "recent_activity": "چالاکیەکانی دوایی",
    "close_statistics": "داخستنی ئامارەکان",
    "loading_payments": "بارکردنی پارەدانەکان...",
    "this_may_take_moment": "لەوانەیە کاتێکی کەم بخایەنێت",
    "error_loading_payments": "هەڵە لە بارکردنی پارەدانەکان",
    "try_again": "هەوڵبدەرەوە",
    "no_payments_found": "هیچ پارەدانێک نەدۆزرایەوە",
    "no_payments_match_filters": "هیچ پارەدانێک نەگونجاوە لەگەڵ پاڵاوتنی ئێستا. هەوڵبدە پاڵاوتنی گونجاوتر بکەیت.",
    "no_payments_in_system": "هیچ پارەدانێک نییە لە سیستەمەکەدا. دەستپێبکە بە تۆمارکردنی یەکەم پارەدان.",
    "reset_filters": "ڕێکخستنەوەی پاڵاوتنەکان",
    "record_first_payment": "تۆمارکردنی یەکەم پارەدان",
    "unknown_period": "ماوەی نەزانراو",
    "to": "بۆ",
    "invalid_period_data": "داتای ماوەی نادروست",
    "unknown_type": "جۆری نەزانراو",
    "apt": "ئەپارتمان",
    "print_receipt": "چاپکردنی پێداویستی",
    "view_details": "بینینی وردەکاری",
    "edit_payment": "دەستکاری پارەدان",
    "delete_payment": "سڕینەوەی پارەدان",
    "showing_payments": "نیشاندانی {start}-{end} لە {total} پارەدانەکان",
    "showing_filtered_payments": "نیشاندانی {filtered} لە {total} پارەدانەکان بەپێی گەڕانەکەت",
    "authentication_required": "پێویستی بە ڕاستکردنەوەی ناسنامە هەیە",
    "failed_load_payments": "سەرکەوتوو نەبوو لە بارکردنی داتای پارەدانەکان",
    "auth_failed_login_again": "ڕاستکردنەوەی ناسنامە سەرکەوتوو نەبوو. تکایە جارێکی تر بچۆ ژوورەوە.",
    "access_denied_admin_required": "ڕێگەپێنەدراو. پێویستی بە ڕۆڵی بەڕێوەبەر هەیە.",
    "server_error_check_backend": "هەڵەی ڕاژەکار. تکایە بزانە ئایا ڕاژەکار کاردەکات.",
    "cannot_connect_server": "ناتوانیت پەیوەندی بە ڕاژەکارەوە بکەیت. تکایە بزانە ئایا ڕاژەکار کاردەکات.",
    "error_fetching_payments": "هەڵە لە هێنانی پارەدانەکان",
    "error_deleting_payment": "هەڵە لە سڕینەوەی پارەدان",
    "failed_delete_payment": "سەرکەوتوو نەبوو لە سڕینەوەی پارەدان",

    "occupancy_report": "ڕاپۆرتی ئەشغاڵی",
    "loading": "بارکردن...",
    "refresh": "نوێکردنەوە",
    "back": "گەڕانەوە",
    "error_fetching_occupancy": "هەڵە لە هێنانی داتای ئەشغاڵی",
    "failed_load_occupancy": "سەرکەوتوو نەبوو لە بارکردنی داتای ئەشغاڵی",
    "occupied": "پڕ",
    "vacant": "بەتاڵ",
    "maintenance": "چاککردن",
    "apartments": "ئەپارتمان",
    "occupancy_rate": "ڕێژەی ئەشغاڵی",
    "of": "لە",
    "vacant_apartments": "ئەپارتمانە بەتاڵەکان",
    "of_total": "لە کۆی گشتی",
    "maintenance_apartments": "لە چاککردندا",
    "potential_income": "داهاتی مانگانەی ئەگەری",
    "buildings": "بیناکان",
    "occupancy_distribution": "دابەشبوونی ئەشغاڵی",
    "occupancy_by_building": "ئەشغاڵی بەپێی بینا",
    "building": "بینا",
    "total_apartments": "کۆی ئەپارتمانەکان",
    "print_report": "چاپکردنی ڕاپۆرت",
    "export_report": "هەناردنی ڕاپۆرت",

    "rent": "کرێ",
    "service": "خزمەتگوزاری",
    "commission": "کومیسیۆن",
    "insurance": "دڵنیایی",
    "total": "کۆی گشتی",

    "occupied": "پڕ",
    "vacant": "بەتاڵ",
    "maintenance": "چاککردن",
    "apartments": "ئەپارتمان",
    "of": "لە",
    "excellent": "نایاب",
    "good": "باش",
    "needs_improvement": "پێویستی بە باشترکردن هەیە",
    "error_fetching_occupancy": "هەڵە لە هێنانی داتای ئەشغاڵی",
    "failed_load_occupancy": "سەرکەوتوو نەبوو لە بارکردنی داتای ئەشغاڵی",

    "overdue": "دواکەوتوو",
    "pending": "چاوەڕوان",
    "paid": "پارەدراو",
    "no_overdue_payments": "هیچ پارەدانێکی دواکەوتوو نەدۆزرایەوە",
    "apt": "ئەپارتمان",
    "days_overdue": "رۆژ دواکەوتوو",
    "more_overdue_tenants": "کرێگرانی دواکەوتووی زیاتر...",
    "error_fetching_tenant_status": "هەڵە لە هێنانی دۆخی پارەدانی کرێگر",
    "failed_load_tenant_status": "سەرکەوتوو نەبوو لە بارکردنی دۆخی پارەدانی کرێگر",

    "rent": "کرێ",
    "service": "خزمەتگوزاری",
    "deposit": "دانهێنان",
    "no_recent_payments": "هیچ پارەدانێکی نوێ نەدۆزرایەوە",
    "error_fetching_payments": "هەڵە لە هێنانی پارەدانە نوێیەکان",
    "failed_load_payments": "سەرکەوتوو نەبوو لە بارکردنی پارەدانە نوێیەکان",

    "payment_logs": "تۆماری پارەدانەکان",
    "filter": "فلتەر",
    "back": "گەڕانەوە",
    "search_payment_logs_placeholder": "گەڕان لە تۆماری پارەدانەکان...",
    "showing_entries": "پیشاندانی {{showing}} لە {{total}} تۆمار",
    "filter_payments": "فلتەری پارەدانەکان",
    "time_period": "ماوەی کات",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "payment_type": "جۆری پارەدان",
    "all_types": "هەموو جۆرەکان",
    "entries_per_page": "تۆمار لە هەر لاپەڕەیەک",
    "reset": "ڕێکخستنەوە",
    "apply_filter": "جێبەجێکردنی فلتەر",
    "payment_id": "ناسنامەی پارەدان",
    "date": "بەروار",
    "tenant": "کرێچی",
    "building": "بینا",
    "type": "جۆر",
    "amount": "بڕ",
    "actions": "کردارەکان",
    "print_receipt": "چاپکردنی پسوولە",
    "view_details": "بینینی وردەکاری",
    "no_logs_matching_search": "هیچ تۆمارێکی پارەدان نییە کە لەگەڵ هۆکارەکانی گەڕاندا بگونجێت",
    "no_logs_for_period": "هیچ تۆمارێکی پارەدان بەردەست نییە بۆ ماوەی کاتی دیاریکراو",
    "showing_range": "پیشاندانی {{start}} بۆ {{end}} لە {{total}} تۆمار",
    "previous": "پێشوو",
    "next": "داهاتوو",
    "print_report": "چاپکردنی ڕاپۆرت",
    "export_to_excel": "هەناردەکردن بۆ ئێکسێل",
    "failed_to_load_payment_logs": "بارکردنی تۆماری پارەدانەکان سەرکەوتوو نەبوو",

    "current_month": "مانگی ئێستا",
    "last_month": "مانگی پێشوو",
    "current_quarter": "چارەکی ئێستا",
    "current_year": "ساڵی ئێستا",
    "custom": "ماوەی تایبەت",

    "rent": "کرێ",
    "service": "خزمەتگوزاری",
    "commission": "کومیشن",
    "insurance": "بیمە",
    "other": "هیتر",

    "reports_dashboard": "داشبۆردی ڕاپۆرتەکان",
    "overview_of_financial_performance": "تێڕوانینی گشتی کارایی دارایی و ئاماری موڵک",
    "view_all_reports": "بینینی هەموو ڕاپۆرتەکان",
    "failed_to_load_report_data": "بارکردنی داتای ڕاپۆرت سەرکەوتوو نەبوو",
    "total_revenue": "کۆی داهات",
    "total_payments_count": "{{count}} پارەدان",
    "total_tenants": "کۆی کرێچییەکان",
    "new_tenants_this_year": "{{count}} نوێ لەم ساڵدا",
    "total_properties": "کۆی موڵکەکان",
    "total_buildings_count": "{{count}} بینا",
    "total_owners": "کۆی خاوەنەکان",
    "ended_contracts_count": "{{count}} گرێبەستی کۆتاییهاتوو",
    "monthly_revenue_year": "داهاتی مانگانە - {{year}}",
    "view_details": "بینینی وردەکاری",
    "occupancy_rate": "ڕێژەی داگیرکردن",
    "recent_payments": "پارەدانە نوێیەکان",
    "view_all": "بینینی هەموو",
    "overdue_payments": "پارەدانە دواکەوتووەکان",
    "quick_reports": "ڕاپۆرتە خێراکان",
    "annual_revenue": "داهاتی سالانە",
    "yearly_breakdown": "شیکردنەوەی ساڵانەی هەموو داهاتەکان",
    "building_revenue": "داهاتی بینا",
    "revenue_by_building": "شیکردنەوەی داهات بەپێی بینا",
    "owner_revenue": "داهاتی خاوەن",
    "revenue_by_owner": "شیکردنەوەی داهات بەپێی خاوەنی موڵک",
    "payment_logs": "تۆماری پارەدانەکان",
    "detailed_payment_history": "مێژووی وردی پارەدان",


    "revenue_report": "ڕاپۆرتی داهات",
    "filter": "فلتەر",
    "loading": "باركردن...",
    "refresh": "نوێکردنەوە",
    "back": "گەڕانەوە",
    "filter_report": "فلتەری ڕاپۆرت",
    "time_period": "ماوەی کات",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "cancel": "هەڵوەشاندنەوە",
    "apply_filter": "جێبەجێکردنی فلتەر",
    "failed_to_load_revenue_data": "بارکردنی داتای داهات سەرکەوتوو نەبوو",
    "total_revenue": "کۆی داهات",
    "total_payments_count": "{{count}} پارەدان",
    "rent_revenue": "داهاتی کرێ",
    "percent_of_total": "{{percent}}% لە کۆی گشتی",
    "service_revenue": "داهاتی خزمەتگوزاری",
    "unique_tenants": "کرێچییە تایبەتەکان",
    "avg_per_tenant": "ناوەندی {{amount}} بۆ هەر کرێچییەک",
    "revenue_by_building": "داهات بەپێی بینا",
    "view_details": "بینینی وردەکاری",
    "building": "بینا",
    "tenants": "کرێچییەکان",
    "no_building_revenue_data": "هیچ داتای داهاتی بینا بەردەست نییە",
    "revenue_by_owner": "داهات بەپێی خاوەن",
    "owner": "خاوەن",
    "apartments": "شوقەکان",
    "no_owner_revenue_data": "هیچ داتای داهاتی خاوەن بەردەست نییە",
    "print_report": "چاپکردنی ڕاپۆرت",
    "export_report": "هەناردەکردنی ڕاپۆرت",

    "current_month": "مانگی ئێستا",
    "last_month": "مانگی پێشوو",
    "current_quarter": "چارەکی ئێستا",
    "current_year": "ساڵی ئێستا",
    "custom": "ماوەی تایبەت",

    "service_payments_management": "بەڕێوەبردنی پارەدانی خزمەتگوزاریەکان",
    "refresh": "نوێکردنەوە",
    "back_to_dashboard": "گەڕانەوە بۆ داشبۆرد",
    "building": "بینا",
    "select_building": "هەڵبژاردنی بینا",
    "year": "ساڵ",
    "search": "گەڕان",
    "search_apartments_tenants": "گەڕان بۆ شوقە، کرێچییەکان...",
    "generate_payments": "دروستکردنی پارەدانەکان",
    "view_statistics": "بینینی ئامارەکان",
    "filter_by_status": "فلتەر بەپێی دۆخ",
    "all": "هەموو",
    "paid": "پارەدراو",
    "unpaid": "پارەنەدراو",
    "clear_filters": "سڕینەوەی فلتەرەکان",
    "loading_service_data": "بارکردنی داتای پارەدانی خزمەتگوزاری...",
    "no_building_selected": "هیچ بینایەک هەڵنەبژێردراوە",
    "please_select_building": "تکایە بینایەک هەڵبژێرە بۆ بینینی پارەدانی خزمەتگوزاریەکان.",
    "no_search_results": "هیچ ئەنجامێکی گەڕان نییە",
    "no_matching_apartments": "هیچ شوقە یان کرێچییەک نییە کە لەگەڵ پێوەرەکانی گەڕاندا بگونجێت.",
    "service_payments_for_building_year": "پارەدانی خزمەتگوزاری بۆ {{building}} - {{year}}",
    "floor_number": "نهۆمی {{number}}",
    "apartments": "شوقەکان",
    "rate": "ڕێژە",
    "tenant_owner": "کرێچی/خاوەن",
    "vacant": "بەتاڵ",
    "mark_as_paid": "نیشانە بکە وەک پارەدراو",
    "mark_as_unpaid": "نیشانە بکە وەک پارەنەدراو",
    "view_details": "بینینی وردەکاری",
    "summary": "کورتە",
    "floor_apartment_count": "{{floors}} نهۆم، {{apartments}} شوقە",
    "no_floors_available": "هیچ نهۆمێک بەردەست نییە",
    "no_floors_message": "هیچ نهۆمێک بە شوقە لەم بینایەدا نییە، یان هێشتا هیچ پارەدانێکی خزمەتگوزاری دروست نەکراوە.",
    "failed_to_load_buildings": "بارکردنی بیناکان سەرکەوتوو نەبوو. تکایە دووبارە هەوڵ بدەوە.",
    "failed_to_load_floors": "بارکردنی نهۆمەکان سەرکەوتوو نەبوو",
    "failed_to_load_building_floors": "بارکردنی نهۆمەکانی بینا سەرکەوتوو نەبوو",
    "failed_to_load_floor_data": "بارکردنی داتای نهۆم سەرکەوتوو نەبوو",
    "data_refreshed_successfully": "داتا بە سەرکەوتوویی نوێکرایەوە.",
    "failed_to_refresh_data": "نوێکردنەوەی داتا سەرکەوتوو نەبوو",
    "marked_as_paid_via_service_management": "نیشانە کرا وەک پارەدراو لە ڕێگەی بەڕێوەبردنی خزمەتگوزارییەوە",
    "marked_as_unpaid_via_service_management": "نیشانە کرا وەک پارەنەدراو لە ڕێگەی بەڕێوەبردنی خزمەتگوزارییەوە",
    "payment_marked_as_paid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەدراو.",
    "payment_marked_as_unpaid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەنەدراو.",
    "failed_to_update_payment": "نوێکردنەوەی پارەدان سەرکەوتوو نەبوو",
    "payment_details": "وردەکاری پارەدان",
    "payment_due": "پارەدانی بەسەرچوو",
    "amount": "بڕ",
    "status": "دۆخ",
    "paid_on": "پارەدراو لە",
    "no_apartments_on_floor": "هیچ شوقەیەک لەم نهۆمەدا نەدۆزرایەوە.",

    "month_1": "کانوونی دووەم",
    "month_2": "شوبات",
    "month_3": "ئازار",
    "month_4": "نیسان",
    "month_5": "ئایار",
    "month_6": "حوزەیران",
    "month_7": "تەمموز",
    "month_8": "ئاب",
    "month_9": "ئەیلوول",
    "month_10": "تشرینی یەکەم",
    "month_11": "تشرینی دووەم",
    "month_12": "کانوونی یەکەم",

    "service_payment_details": "وردەکاری پارەدانی خزمەتگوزاری",
    "print_receipt": "چاپکردنی پسوولە",
    "loading": "باركردن...",
    "failed_to_load_payment_details": "بارکردنی وردەکاری پارەدان سەرکەوتوو نەبوو",
    "api_endpoint_missing_message": "ئەم هەڵەیە ئاماژە بە کۆتایی API ونبوو لەسەر سێرڤەری باکگراوند دەکات. بۆ چاککردنی، ڕێگایەک زیاد بکە بۆ GET /api/services/:id لە فایلی serviceRoutes.js.",
    "payment_information": "زانیاری پارەدان",
    "apartment": "شوقە",
    "period": "ماوە",
    "amount": "بڕ",
    "status": "دۆخ",
    "tenant": "کرێچی",
    "owner": "خاوەن",
    "payment_date": "بەرواری پارەدان",
    "paid_by": "پارەدراو لەلایەن",
    "notes": "تێبینییەکان",
    "update_payment": "نوێکردنەوەی پارەدان",
    "mark_as_paid": "نیشانە بکە وەک پارەدراو",
    "currency": "دراو",
    "select_payer": "دانەر هەڵبژێرە",
    "management": "بەڕێوەبردن",
    "other": "هیتر",
    "payment_notes_placeholder": "هەر تێبینییەکی زیاتر سەبارەت بەم پارەدانە دابنێ...",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "payment_history": "مێژووی پارەدان",
    "date": "بەروار",
    "action": "کردار",
    "by": "لەلایەن",
    "paid": "پارەدراو",
    "unpaid": "پارەنەدراو",
    "payment_marked_as_paid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەدراو.",
    "payment_marked_as_unpaid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەنەدراو.",
    "failed_to_update_payment": "نوێکردنەوەی پارەدان سەرکەوتوو نەبوو",
    "service_payment_receipt": "پسوولەی پارەدانی خزمەتگوزاری",
    "property_management": "بەڕێوەبردنی موڵک",
    "receipt_generated": "ئەم پسوولەیە دروستکرا لە {{date}} کاتژمێر {{time}}",
    "automated_receipt_notice": "ئەمە پسوولەیەکی دروستکراوی خۆکارە و پێویستی بە واژۆ نییە.",
    "us_dollar": "دۆلاری ئەمەریکی",
    "iraqi_dinar": "دیناری عێراقی",
    "euro": "یۆرۆ",

    "month_1": "کانوونی دووەم",
    "month_2": "شوبات",
    "month_3": "ئازار",
    "month_4": "نیسان",
    "month_5": "ئایار",
    "month_6": "حوزەیران",
    "month_7": "تەمموز",
    "month_8": "ئاب",
    "month_9": "ئەیلوول",
    "month_10": "تشرینی یەکەم",
    "month_11": "تشرینی دووەم",
    "month_12": "کانوونی یەکەم",

    "tenant": "کرێچی",
    "owner": "خاوەن",
    "management": "بەڕێوەبردن",
    "other": "هیتر",

    "generate_service_payments": "دروستکردنی پارەدانەکانی خزمەتگوزاری",
    "recipients": "وەرگرەکان",
    "entire_building": "هەموو باڵەخانەکە",
    "generate_for_all_apartments": "دروستکردن بۆ هەموو شوقەکان لە باڵەخانەکەدا",
    "specific_tenants": "کرێچییە دیاریکراوەکان",
    "generate_for_selected_tenants": "دروستکردن تەنها بۆ کرێچییە دیاریکراوەکان",
    "specific_owners": "خاوەنە دیاریکراوەکان",
    "generate_for_selected_owners": "دروستکردن تەنها بۆ خاوەنە دیاریکراوەکان",
    "select_building": "باڵەخانە هەڵبژێرە",
    "include_vacant_apartments": "شوقە بەتاڵەکان لەخۆبگرە",
    "selected_tenants": "کرێچییە دیاریکراوەکان",
    "selected_owners": "خاوەنە دیاریکراوەکان",
    "select_tenants": "کرێچییەکان هەڵبژێرە",
    "select_owners": "خاوەنەکان هەڵبژێرە",
    "no_tenants_selected": "هیچ کرێچییەک دیاری نەکراوە",
    "no_owners_selected": "هیچ خاوەنێک دیاری نەکراوە",
    "payment_details": "وردەکاریەکانی پارەدان",
    "amount": "بڕ",
    "currency": "دراو",
    "us_dollar": "دۆلاری ئەمەریکی",
    "iraqi_dinar": "دیناری عێراقی",
    "euro": "یۆرۆ",
    "initial_status": "دۆخی سەرەتایی",
    "unpaid": "نەدراوە",
    "paid": "دراوە",
    "notes": "تێبینیەکان",
    "payment_notes_placeholder": "هەر تێبینیەکی زیادەت هەیە لەسەر ئەم پارەدانانە بینووسە...",
    "time_period": "ماوەی کات",
    "generation_type": "جۆری دروستکردن",
    "single_month": "یەک مانگ",
    "multiple_months": "چەندین مانگ",
    "month_range": "مەودای مانگەکان",
    "year": "ساڵ",
    "month": "مانگ",
    "select_months": "مانگەکان هەڵبژێرە",
    "from": "لە",
    "to": "بۆ",
    "selected_months": "مانگە دیاریکراوەکان",
    "payment_generation_summary": "پوختەی دروستکردنی پارەدان",
    "all_apartments_in": "هەموو شوقەکان لە",
    "selected_building": "باڵەخانەی دیاریکراو",
    "tenants": "کرێچییەکان",
    "owners": "خاوەنەکان",
    "cancel": "هەڵوەشاندنەوە",
    "generating": "دروستکردن...",
    "generate_payments": "دروستکردنی پارەدانەکان",
    "search": "گەڕان",
    "search_by_tenant_name_or_phone": "گەڕان بە ناوی کرێچی، ژمارە تەلەفۆن یان ژمارەی شوقە...",
    "search_by_owner_name_or_phone": "گەڕان بە ناوی خاوەن یان ژمارە تەلەفۆن...",
    "no_results_found": "هیچ ئەنجامێک نەدۆزرایەوە",
    "selected": "دیاریکراو",
    "done": "تەواو",
    "no_tenants_available": "هیچ کرێچییەک بەردەست نییە. تکایە سەرەتا کرێچی زیاد بکە.",
    "no_owners_available": "هیچ خاوەنێک بەردەست نییە. تکایە سەرەتا خاوەن زیاد بکە.",
    "apt": "شوقە",
    "january": "کانوونی دووەم",
    "february": "شوبات",
    "march": "ئازار",
    "april": "نیسان",
    "may": "ئایار",
    "june": "حوزەیران",
    "july": "تەمموز",
    "august": "ئاب",
    "september": "ئەیلوول",
    "october": "تشرینی یەکەم",
    "november": "تشرینی دووەم",
    "december": "کانوونی یەکەم",
    "failed_to_load_buildings": "سەرکەوتوو نەبوو لە بارکردنی باڵەخانەکان. تکایە دووبارە هەوڵ بدەرەوە.",
    "failed_to_load_tenants": "سەرکەوتوو نەبوو لە بارکردنی کرێچییەکان. تکایە دووبارە هەوڵ بدەرەوە.",
    "failed_to_load_owners": "سەرکەوتوو نەبوو لە بارکردنی خاوەنەکان. تکایە دووبارە هەوڵ بدەرەوە.",
    "please_select_building": "تکایە باڵەخانەیەک هەڵبژێرە",
    "please_select_at_least_one_recipient": "تکایە لانی کەم یەک {{recipient}} هەڵبژێرە",
    "please_enter_valid_amount": "تکایە بڕێکی دروست داخل بکە",
    "please_select_month": "تکایە مانگێک هەڵبژێرە",
    "please_select_at_least_one_month": "تکایە لانی کەم یەک مانگ هەڵبژێرە",
    "end_month_must_be_after_start_month": "مانگی کۆتایی دەبێت دوای مانگی دەستپێک بێت",
    "successfully_generated_payments": "بە سەرکەوتوویی {{count}} پارەدانی خزمەتگوزاری دروستکرا بۆ {{months}} مانگ. {{skipped}} پارەدان پێشتر دروستکرابوون.",
    "failed_to_generate_service_payments": "سەرکەوتوو نەبوو لە دروستکردنی پارەدانەکانی خزمەتگوزاری",
    "tenant": "کرێچی",
    "owner": "خاوەن",

    "service_payment_statistics": "ئاماری پارەدانی خزمەتگوزاری",
    "back_to_services": "گەڕانەوە بۆ خزمەتگوزاریەکان",
    "building": "باڵەخانە",
    "year": "ساڵ",
    "loading_statistics": "بارکردنی ئامارەکان...",
    "no_building_selected": "هیچ باڵەخانەیەک دیاری نەکراوە",
    "please_select_building_statistics": "تکایە باڵەخانەیەک دیاری بکە بۆ بینینی ئاماری پارەدانی خزمەتگوزاری.",
    "overall_statistics": "ئاماری گشتی",
    "total_collection": "کۆی کۆکراوە",
    "of": "لە",
    "payment_rate": "ڕێژەی پارەدان",
    "payments": "پارەدانەکان",
    "outstanding_amount": "بڕی ماوە",
    "unpaid_payments": "پارەدانی نەدراو",
    "monthly_statistics": "ئاماری مانگانە",
    "no_monthly_data": "هیچ داتایەکی مانگانە بەردەست نییە بۆ ساڵی دیاریکراو.",
    "month": "مانگ",
    "total_amount": "کۆی بڕ",
    "collected": "کۆکراوە",
    "outstanding": "ماوە",
    "progress": "پێشکەوتن",
    "failed_to_load_service_statistics": "سەرکەوتوو نەبوو لە بارکردنی ئاماری خزمەتگوزاری",

    "loading_tenant_data": "بارکردنی زانیاریەکانی کرێچی...",
    "error_loading_tenant": "هەڵە لە بارکردنی کرێچی",
    "tenant_not_found": "کرێچی نەدۆزرایەوە",
    "back_to_tenants": "گەڕانەوە بۆ کرێچییەکان",
    "record_payment": "تۆمارکردنی پارەدان",
    "edit": "دەستکاری",
    "status_unknown": "دۆخ نەزانراوە",
    "apartment": "شوقە",
    "apt": "شوقە",
    "none": "هیچ",
    "monthly_rent": "کرێی مانگانە",
    "payment_date": "بەرواری پارەدان",
    "overview": "پوختە",
    "leases": "گرێبەستەکان",
    "payments": "پارەدانەکان",
    "contact_information": "زانیاری پەیوەندی",
    "lease_information": "زانیاری گرێبەست",
    "contract_period": "ماوەی گرێبەست",
    "rent": "کرێ",
    "discount": "داشکاندن",
    "rent_after_discount": "کرێ دوای داشکاندن",
    "additional_fees": "پارەدانی زیادە",
    "service_fee": "کرێی خزمەتگوزاری",
    "office_commission": "کومیسیۆنی نووسینگە",
    "insurance": "بیمە",
    "notes": "تێبینییەکان",
    "no_leases": "هیچ گرێبەستێک نییە",
    "no_leases_message": "ئەم کرێچییە هێشتا هیچ شوقەیەکی بۆ دیاری نەکراوە.",
    "active_leases": "گرێبەستە چالاکەکان",
    "inactive_leases": "گرێبەستە ناچالاکەکان",
    "active": "چالاک",
    "ended": "کۆتایی هاتووە",
    "expiring_soon": "بەزوویی کۆتایی دێت",
    "end_lease": "کۆتایی هێنان بە گرێبەست",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "duration": "ماوە",
    "remaining": "ماوەی ماوە",
    "months": "مانگ",
    "security_deposit": "بارمتەی دڵنیایی",
    "total_value": "بەهای گشتی",
    "no_payments": "هیچ پارەدانێک نییە",
    "no_payments_message": "ئەم کرێچییە هێشتا هیچ پارەدانێکی تۆمار نەکراوە.",
    "record_first_payment": "تۆمارکردنی یەکەم پارەدان",
    "payment_period": "ماوەی پارەدان",
    "reference": "ژمارەی پسوولە",
    "payment_type": "جۆری پارەدان",
    "rent_payment": "پارەدانی کرێ",
    "additional_fee": "پارەدانی زیادە",
    "utility_payment": "پارەدانی خزمەتگوزاری",
    "other_payment": "پارەدانی تر",
    "start": "دەستپێک",
    "end": "کۆتایی",
    "reference_number": "ژمارەی پسوولە",
    "cancel": "هەڵوەشاندنەوە",
    "unknown_period": "ماوەی نەزانراو",
    "invalid_period_format": "فۆرماتی ماوە نادروستە",
    "to": "بۆ",
    "invalid_period_data": "داتای ماوە نادروستە",
    "please_enter_valid_payment_amount": "تکایە بڕێکی پارەدانی دروست داخل بکە",
    "end_date_must_be_after_start_date": "بەرواری کۆتایی دەبێت دوای بەرواری دەستپێک بێت",
    "failed_to_add_payment": "سەرکەوتوو نەبوو لە زیادکردنی پارەدان",
    "maintenance_requests_not_supported": "داواکاریەکانی چاکسازی لە پێکهاتەی ئێستای داتابەیسدا پشتگیری ناکرێن",
    "failed_to_create_maintenance_request": "سەرکەوتوو نەبوو لە دروستکردنی داواکاری چاکسازی",
    "confirm_end_lease": "دڵنیایت کە دەتەوێت کۆتایی بەم گرێبەستە بهێنیت؟ ئەم کردارە ناتوانرێت پاشگەز بکرێتەوە.",
    "lease_ended_by_administrator": "گرێبەست لەلایەن بەڕێوەبەرەوە کۆتایی پێهێنرا",
    "failed_to_end_lease": "سەرکەوتوو نەبوو لە کۆتایی هێنان بە گرێبەست",
    "failed_to_load_tenant_data": "سەرکەوتوو نەبوو لە بارکردنی زانیاری کرێچی",
    "actual_end_date": "بەرواری کۆتایی ڕاستەقینە",
    "deposit": "بارمتە",


    "edit_tenant": "دەستکاریکردنی کرێچی",
    "add_tenant": "زیادکردنی کرێچی",
    "basic_information": "زانیاری بنەڕەتی",
    "first_name": "ناوی یەکەم",
    "last_name": "ناوی دوایی",
    "email": "ئیمەیل",
    "phone": "تەلەفۆن",
    "apartment": "شوقە",
    "select_apartment": "شوقە هەڵبژێرە",
    "floor": "نهۆم",
    "rent_amount": "بڕی کرێ",
    "discount": "داشکاندن",
    "service_fee": "کرێی خزمەتگوزاری",
    "office_commission": "کومیسیۆنی نووسینگە",
    "insurance": "بیمە",
    "contract_start_date": "بەرواری دەستپێکی گرێبەست",
    "contract_end_date": "بەرواری کۆتایی گرێبەست",
    "payment_date": "بەرواری پارەدان",
    "payment_end_date": "بەرواری کۆتایی پارەدان",
    "rent_status": "دۆخی کرێ",
    "additional_information": "زانیاری زیاتر",
    "notes": "تێبینییەکان",
    "tenant_notes_placeholder": "هەر تێبینییەکی زیادە لەسەر ئەم کرێچییە...",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "update_tenant": "نوێکردنەوەی کرێچی",
    "create_tenant": "دروستکردنی کرێچی",
    "loading": "بارکردن...",
    "failed_to_load_tenant_data": "سەرکەوتوو نەبوو لە بارکردنی زانیاری کرێچی",
    "failed_to_save_tenant": "سەرکەوتوو نەبوو لە پاشەکەوتکردنی کرێچی",
    "pending": "چاوەڕوان",
    "paid": "پارەدراو",
    "late": "درەنگ",
    "overdue": "دواکەوتوو",
    "unpaid": "پارەنەدراو",

    "tenants": "کرێچییەکان",
    "refresh_tenants": "نوێکردنەوەی کرێچییەکان",
    "selected": "هەڵبژێردراو",
    "delete_selected_tenants": "سڕینەوەی کرێچییە هەڵبژێردراوەکان",
    "search_tenants": "گەڕان بۆ کرێچییەکان...",
    "filter": "فلتەرکردن",
    "switch_to_list_view": "گۆڕین بۆ پیشاندانی لیست",
    "switch_to_grid_view": "گۆڕین بۆ پیشاندانی تۆڕ",
    "list_view": "لیست",
    "grid_view": "تۆڕ",
    "hide_inactive_tenants": "شاردنەوەی کرێچییە ناچالاکەکان",
    "show_inactive_tenants": "پیشاندانی کرێچییە ناچالاکەکان",
    "hide_inactive": "شاردنەوەی ناچالاکەکان",
    "show_inactive": "پیشاندانی ناچالاکەکان",
    "add_tenant": "زیادکردنی کرێچی",
    "rent_status": "دۆخی کرێ",
    "all_statuses": "هەموو دۆخەکان",
    "all_buildings": "هەموو باڵەخانەکان",
    "all_apartments": "هەموو شوقەکان",
    "min_rent": "کەمترین کرێ",
    "max_rent": "زۆرترین کرێ",
    "unlimited": "بێ سنوور",
    "contracts_ending_before": "گرێبەستەکان کۆتاییان دێت پێش",
    "clear_filters": "سڕینەوەی فلتەرەکان",
    "apply_filters": "جێبەجێکردنی فلتەرەکان",
    "active_tenants": "کرێچییە چالاکەکان",
    "inactive_tenants": "کرێچییە ناچالاکەکان",
    "with_apartments": "بە شوقەوە",
    "without_apartments": "بێ شوقە",
    "loading_tenants": "بارکردنی کرێچییەکان...",
    "error_loading_tenants": "هەڵە لە بارکردنی کرێچییەکان",
    "try_again": "هەوڵ بدەرەوە",
    "no_tenants_found": "هیچ کرێچییەک نەدۆزرایەوە",
    "no_tenants_message": "هیچ کرێچییەک لە سیستەمدا نییە. کلیک لەسەر دوگمەی 'زیادکردنی کرێچی' بکە بۆ دروستکردنی یەکەم کرێچی.",
    "create_first_tenant": "دروستکردنی یەکەم کرێچی",
    "page": "لاپەڕە",
    "showing_items": "پیشاندان {start}-{end} لە {total}",
    "first_page": "یەکەم لاپەڕە",
    "previous_page": "لاپەڕەی پێشوو",
    "next_page": "لاپەڕەی داهاتوو",
    "last_page": "دوا لاپەڕە",
    "showing_filtered_results": "پیشاندانی {showing} لە {total} کرێچی",
    "confirm_deletion": "دڵنیابوونەوە لە سڕینەوە",
    "delete_tenant_confirmation": "دڵنیایت کە دەتەوێت کرێچی \"{name}\" بسڕیتەوە؟ ئەم کردارە ناتوانرێت پاشەکشە بکرێت.",
    "cancel": "هەڵوەشاندنەوە",
    "deleting": "سڕینەوە...",
    "delete": "سڕینەوە",
    "tenant": "کرێچی",
    "apartment": "شوقە",
    "rent": "کرێ",
    "contract": "گرێبەست",
    "status": "دۆخ",
    "actions": "کردارەکان",
    "apt": "شوقە",
    "unknown_building": "باڵەخانەی نەناسراو",
    "no_apartment_assigned": "هیچ شوقەیەک دیاری نەکراوە",
    "status_unknown": "دۆخی نەناسراو",
    "monthly_rent": "کرێی مانگانە",
    "after_discount": "دوای داشکاندن",
    "payment_date": "بەرواری پارەدان",
    "not_set": "دیاری نەکراوە",
    "contract_start": "دەستپێکی گرێبەست",
    "contract_end": "کۆتایی گرێبەست",
    "service": "خزمەتگوزاری",
    "commission": "کومیسیۆن",
    "insurance": "بیمە",
    "hide_owner_details": "شاردنەوەی وردەکاری خاوەن",
    "show_owner_details": "پیشاندانی وردەکاری خاوەن",
    "apartment_owner": "خاوەنی شوقە",
    "loading_owner_details": "بارکردنی وردەکاری خاوەن...",
    "no_owner_information": "هیچ زانیاریەک لەسەر خاوەن نییە",
    "lives_on_property": "لە موڵکەکەدا دەژی",
    "yes": "بەڵێ",
    "no": "نەخێر",
    "total_apartments": "کۆی شوقەکان",
    "apartment_details": "وردەکاریەکانی شوقە",
    "apartment_number": "ژمارەی شوقە",
    "unknown": "نەزانراو",
    "floor": "نهۆم",
    "apartment_type": "جۆری شوقە",
    "standard": "ستاندارد",
    "furnished": "موبیلیا",
    "view_owner_profile": "بینینی پرۆفایلی خاوەن",
    "mark_as_inactive": "دیاریکردن وەک ناچالاک",
    "mark_as_active": "دیاریکردن وەک چالاک",
    "record_payment": "تۆمارکردنی پارەدان",
    "view_details": "بینینی وردەکاریەکان",
    "edit_tenant": "دەستکاریکردنی کرێچی",
    "delete_tenant": "سڕینەوەی کرێچی",
    "to": "بۆ",
    "payment": "پارەدان",
    "apartment_financial_details": "وردەکاری داراییەکانی شوقە",
    "not_authenticated": "ڕێگەپێدراو نیت. تکایە چوونەژوورەوە تۆمار بکە.",
    "authentication_required": "ناسنامە پێویستە",
    "authentication_failed": "ناسنامە سەرکەوتوو نەبوو. تکایە دووبارە چوونەژوورەوە تۆمار بکە.",
    "access_denied": "ڕێگە نەدراوە. ڕۆڵی بەڕێوبەر پێویستە.",
    "server_error": "هەڵەی سێرڤەر. تکایە بزانە ئایا پشتەوەی سێرڤەر کار دەکات.",
    "cannot_connect_to_server": "ناتوانرێت پەیوەندی بە سێرڤەرەوە بکرێت. تکایە بزانە ئایا پشتەوەی سێرڤەر لەسەر پۆرتی 3000 کار دەکات.",
    "failed_to_load_tenants_data": "سەرکەوتوو نەبوو لە بارکردنی داتای کرێچییەکان",
    "unknown_error": "هەڵەی نەناسراو",
    "failed_to_delete_tenant": "سەرکەوتوو نەبوو لە سڕینەوەی کرێچی",
    "confirm_bulk_delete": "دڵنیایت کە دەتەوێت {count} کرێچی بسڕیتەوە؟ ئەم کردارە ناتوانرێت پاشەکشە بکرێت.",
    "failed_to_delete_tenants": "سەرکەوتوو نەبوو لە سڕینەوەی کرێچییەکان",
    "failed_to_update_tenant_status": "سەرکەوتوو نەبوو لە نوێکردنەوەی دۆخی کرێچی",
    "pending": "چاوەڕوان",
    "paid": "پارەدراو",
    "late": "درەنگ",
    "overdue": "دواکەوتوو",

    'add_new_user': 'بەکارهێنەری نوێ زیاد بکە',
    'search_users': 'گەڕان بەدوای بەکارهێنەران',
    'total_users': 'کۆی گشتی بەکارهێنەران',
    'active_users': 'بەکارهێنەرانی چالاک',
    'inactive_users': 'بەکارهێنەرانی ناچالاک',
    'financial_summary': 'پوختەی دارایی',
    'filters': 'فلتەرەکان',
    'search_tenant_by_name_phone_or_apartment': 'بەدوای کرێچیدا بگەڕێ بە ناوی تەلەفۆن یان شوقە',
    'view_profile': 'بینینی پڕۆفایلی',

    "generate": "زیاد بکە",
    "generated": "دروستکراوە",

    "generate_payment_for": "دروستکردنی پارەدان بۆ",
    "payment_amount": "بڕی پارەدان",
    "enter_amount": "بڕی پارە بنووسە",
    "mark_as_paid_immediately": "دەستبەجێ وەک پارەدراو دیاری بکە",
    "notes": "تێبینیەکان",
    "payment_notes": "تێبینی پارەدان",
    "required_fields": "خانە پێویستەکان",
    "cancel": "هەڵوەشاندنەوە",
    "generate_payment": "دروستکردنی پارەدان",

    // WhatsApp
    "whatsapp_settings": "ڕێکخستنەکانی واتساب",
    "whatsapp_settings_description": "ئاگادارکردنەوەی خۆکاری واتساب بۆ بەکارهێنەران و خاوەنەکان",
    "whatsapp_enable": "چالاككردنی ئاگادارکردنەوەکانی واتساب",
    "whatsapp_enable_sub": "هەموو پەیامە خۆکارییەکانی واتساب دابخە یان ببەستەرەوە",
    "general_settings": "ڕێکخستنە گشتییەکان",
    "default_country_code": "کۆدی وڵاتی بنەڕەت",
    "tenant_rent_reminder": "بیرهێنانەوەی کرێی بەکارهێنەر",
    "tenant_rent_reminder_sub": "ناردنی بیرهێنانەوە بۆ بەکارهێنەران پێش یان دوای ماوەی پارەدان",
    "days_before_due": "ڕۆژ پێش ماوەی سەرکەوتن",
    "reminder_message_template": "نموونەی پەیام",
    "service_fee_reminder": "بیرهێنانەوەی کرێی خزمەتگوزاری",
    "enable_service_fee_reminder": "چالاككردنی بیرهێنانەوەی کرێی خزمەتگوزاری",
    "service_fee_reminder_sub": "ئاگادارکردنەوەی بەکارهێنەران دەربارەی پارەدانی خزمەتگوزاری داهاتوو",
    "owner_reminder": "بیرهێنانەوەی خاوەن",
    "enable_owner_reminders": "چالاككردنی بیرهێنانەوەکانی خاوەن",
    "owner_reminder_sub": "ئاگادارکردنەوەی خاوەنان کاتێک بەکارهێنەرانیان پارەدانی دواخراو هەیە",
    "owner_message_template": "نموونەی پەیامی خاوەن",
    "payment_confirmation": "پشتڕاستکردنەوەی پارەدان",
    "send_on_payment": "ناردنی پشتڕاستکردنەوە کاتێک پارەدان تۆمار دەکرێت",
    "payment_confirmation_sub": "بە خۆکاری دەنێردرێت بۆ بەکارهێنەر کاتێک پارەدان تۆمار دەکرێت",
    "payment_confirmation_template": "نموونەی پەیامی پشتڕاستکردنەوە",
    "whatsapp_test_send": "ناردنی پەیامی تاقیکردنەوە",
    "test_message": "پەیام",
    "send_test_message": "ناردنی پەیامی تاقیکردنەوە",
    "whatsapp_test_sent": "پەیامی تاقیکردنەوە نێردرا!",
    "whatsapp_test_default_message": "پەیامی تاقیکردنەوە لە سیستەمی بەڕێوەبردنی موڵک",
    "send_reminders_now": "ئێستا بیرهێنانەوەکان بنێرە",
    "send_reminders_now_description": "یەکسەر بیرهێنانەوە بنێرە بۆ هەموو بەکارهێنەران و خاوەنانێک کە پێویستیان پێیەتی.",
    "whatsapp_must_be_enabled": "واتساب دەبێت پێشتر چالاک بکرێت",
    "failed_to_load_settings": "شکستی هێنا لە بارکردنی ڕێکخستنەکان",
    "settings_saved": "ڕێکخستنەکان بە سەرکەوتوویی پاشەکەوت کران",
    "failed_to_save": "شکستی هێنا لە پاشەکەوتکردن",
    "failed_to_send": "شکستی هێنا لە ناردن",
    "server_error": "هەڵەی پەیوەندی بە سێرڤەر",
    "sent": "نێردرا",
    "errors": "هەڵەکان",
    "skipped": "تێپەڕاندرا",

    // Bookings
    "bookings": "حجزەکان",
    "booking_management": "بەڕێوەبردنی حجز",
    "new_booking": "حجزی نوێ",
    "create_booking": "دروستکردنی حجز",
    "edit_booking": "دەستکاری حجز",
    "booking_details": "وردەکاری حجز",
    "prospect": "داواکاری ئەگەری",
    "prospect_name": "ناوی داواکار",
    "prospect_name_placeholder": "بۆ نموونە: محمد ئەحمەد",
    "prospect_phone": "ژمارەی مۆبایل",
    "prospect_phone_placeholder": "+964 770 000 0000",
    "prospect_email_placeholder": "john@example.com",
    "prospect_email": "ناونیشانی ئیمەیل",
    "move_in_date": "بەرواری گواستنەوە",
    "move_out_date": "بەرواری چوونەدەرەوە",
    "hold_duration": "ماوەی ڕاگرتن",
    "hold_hours": "کاتژمێرەکانی ڕاگرتن",
    "hold_expiration": "کۆتاییهاتنی ڕاگرتن",
    "internal_notes": "تێبینییە ناوخۆییەکان",
    "check_availability": "پشکنینی بەردەستبوون",
    "checking_availability": "پشکنین بۆ بەردەستبوون دەکرێت...",
    "no_bookings_found": "هیچ حجزێک نەدۆزرایەوە",
    "calendar_view": "بینینی ڕۆژژمێر",
    "waitlist": "لیستی چاوەڕوانی",
    "new_booking_hold": "ڕاگرتنی حجزی نوێ",
    "property_information": "زانیاری موڵک",
    "prospect_details": "وردەکاری داواکار",
    "requested_dates": "بەروارە داواکراوەکان",
    "conflict_detected": "تەنگژە دۆزرایەوە",
    "booking_timeline": "کاتی حجزەکان",
    "monthly_view_holds": "بینینی مانگانەی ڕاگرتنی ئەپارتمانە چالاکەکان",
    "confirmed_hold": "ڕاگرتنی پشتڕاستکراوە",
    "pending_payment": "پارەدانی چاوەڕوانکراو",
    "move_in": "گواستنەوە بۆ ناوەوە",
    "move_out": "گواستنەوە بۆ دەرەوە",
    "convert_to_tenant": "گۆڕین بۆ کرێچی",
    "confirm_booking": "پشتڕاستکردنەوەی حجز",
    "cancel_booking": "هەڵوەشاندنەوەی حجز",
    "at_12_pm": "کاتژمێر 12:00 نیوەڕۆ",
    "extending": "درێژکردنەوه...",
    "renewing": "نوێکردنەوه...",
    "cancel_booking_question": "دڵنیایت لە هەڵوەشاندنەوەی ئەم حجزە؟",
    "yes_cancel": "بەڵێ، هەڵوەشاندنەوە",
    "keep_it": "بمێنێتەوە",
    "cancellation_reason": "هۆکاری هەڵوەشاندنەوه",
    "booking_confirmed": "حجز پشتڕاستکرایەوە",
    "booking_cancelled": "حجز هەڵوەشێنرایەوە",
    "booking_converted": "بە سەرکەوتوویی حجز گۆڕدرا بۆ کرێچی!",
    "process_to_booking": "گۆڕین بۆ حجز",
    "waitlist_management": "بەڕێوەبردنی لیستی چاوەڕوانی",
    "waitlist_empty": "لیستی چاوەڕوانی بەتاڵە",
    "search_waitlist": "گەڕان لە لیستی چاوەڕوانی...",
    "priority": "لەپێشینە",
    "desired_unit": "یەکەی داواکراو",
    "move_in_preference": "بەرواری گونجاوی گواستنەوە",
    "added": "زیادکرا",
    "rank": "پلە",
    "process_waitlist_success": "بە سەرکەوتوویی گۆڕدرا بۆ حجزی چاوەڕوانکراو!",
    "remove_from_waitlist": "ئایا دڵنیایت لە سڕینەوەی ئەم ناوە لە لیستی چاوەڕوانی؟",
    "entry_removed": "ناو سڕایەوە",
    "hold_expires": "کۆتاییهاتنی ڕاگرتن",
    "hours": "کاتژمێر",
    "optional": "ئارەزوومەندانە",
    "apartment_element": "بەشی ئەپارتمان",
    "select_unit": "یەکەیەک هەڵبژێرە",
    "error_loading_data": "بارکردنی زانیارییەکان سەرکەوتوو نەبوو",
    "error_saving_booking": "هەڵە لە پاشەکەوتکردنی حجز",
    "save_changes": "پاشەکەوتکردنی گۆڕانکارییەکان",
    "select_apartment_move_in_date_error": "تکایە ئەپارتمان و بەرواری گواستنەوە هەڵبژێرە بۆ پشکنینی بەردەستبوون",
    "apartment_available": "ئەپارتمان بەردەستە بۆ ئەم بەروارانە!",
    "error_checking_availability": "هەڵە لە پشکنینی بەردەستبوون",
    "confirm_conflict_booking": "تەنگژەی بەروار هەیە. ئایا دڵنیایت لە بەردەوامبوون؟",
    "booking_updated": "حجز بە سەرکەوتوویی نوێکرایەوە",
    "booking_number": "حجز #{{id}}",
    "created_at": "دروستکراوە لە {{date}}",
    "created_by": "لە لایەن {{name}}",
    "system": "سیستەم",
    "confirm": "پشتڕاستکردنەوە",
    "target_property": "موڵکی مەبەست",
    "furnished": "مۆبیلیاتدار",
    "unfurnished": "بێ مۆبیلیات",
    "booking_window": "کات و ماوەی حجز",
    "indefinite": "بێ سنوور",
    "created_source": "دروستکراوە ({{source}})",
    "view_tenant_profile": "بڕوانە پڕۆفایلی کرێگرتە",
    "convert_to_active_tenant": "گۆڕین بۆ کرێنشینی چالاک",
    "lease_details_move_in_instruction": "تەواوکردنی وردەکارییەکانی بەکرێدان بۆ گواستنەوەی {{name}} بۆ ناو یەکەی {{unit}}.",
    "monthly_rent": "کرێی مانگانە",
    "first_payment_date": "بەرواری یەکەم پارەدان",
    "contract_start": "دەستپێکی گرێبەست",
    "contract_end": "کۆتایی گرێبەست",
    "confirm_convert": "پشتڕاستکردنەوە و گۆڕین",
    "confirm_booking_question": "پشتڕاستکردنەوەی حجز: ئایا دڵنیایت لە جێگیرکردنی ئەم حجزە و گرتنی شوێنەکە بۆ ئەم داواکارە؟",
    "reason_optional": "تکایە هۆکارێک بنووسە (ئارەزوومەندانە):",
    "amount": "بڕ",
    "today": "ئەمڕۆ",
    "sun": "یەکشەممە",
    "mon": "دووشەممە",
    "tue": "سێشەممە",
    "wed": "چوارشەممە",
    "thu": "پێنجشەممە",
    "fri": "هەینی",
    "sat": "شەممە",
    "more": "زیاتر",
    "close": "داخستن",
    "hold_expiration": "کۆتاییهاتنی حجز",
    "view_details": "بڕوانە وردەکاریی",
    "waitlist_management": "بەڕێوەبردنی لیستی چاوەڕوانی",
    "search_waitlist": "گەڕان لە لیستی چاوەڕوانی...",
    "waitlist_empty": "لیستی چاوەڕوانی چۆڵە",
    "no_prospective_tenants_waiting": "لە ئێستادا هیچ کرێنشینێکی چاوەڕوانکراو چاوەڕێی بەردەستبوونی شوقە ناکات.",
    "priority": "گرنگی",
    "rank": "پلە: {{priority}}",
    "desired_unit": "یەکەی مەبەست",
    "move_in_preference": "پەسەندکراوی گواستنەوە",
    "process_to_booking": "چارەسەرکردن بۆ حجز",
    "remove": "سڕینەوە",
    "remove_waitlist_confirm": "ئایا دڵنیایت لە سڕینەوەی ئەم پێشنیارە لە لیستی چاوەڕوانی؟",
    "waitlist_processed": "بە سەرکەوتوویی گۆڕدرا بۆ حجزێکی چاوەڕوانکراو!",
    "entry_removed": "پێشنیار سڕایەوە",
    "failed_process_waitlist": "چارەسەرکردنی پێشنیاری لیستی چاوەڕوانی سەرکەوتوو نەبوو",
    "failed_remove_entry": "سڕینەوەی پێشنیار سەرکەوتوو نەبوو",
    "booking_analytics": "ئامارەکانی حجز",
    "track_conversion_and_holds": "بەدواداچوونی ڕێژەی گۆڕین و ماوەی ڕاگرتنەکان",
    "last_7_days": "٧ ڕۆژی ڕابردوو",
    "last_30_days": "٣٠ ڕۆژی ڕابردوو",
    "last_90_days": "٩٠ ڕۆژی ڕابردوو",
    "last_year": "ساڵی ڕابردوو",
    "total_bookings": "کۆی گشتی حجزەکان",
    "in_selected_period": "لە ماوەی دیاریکراودا",
    "conversion_rate": "ڕێژەی گۆڕین",
    "converted_to_tenants": "{{count}} گۆڕدرا بۆ کرێنشین",
    "cancellation_rate": "ڕێژەی هەڵوەشاندنەوە",
    "cancelled_holds": "{{count}} حجزی هەڵوەشاوە",
    "avg_hold_time": "تێکڕای کاتی ڕاگرتن",
    "before_conversion_cancel": "پێش گۆڕین/هەڵوەشاندنەوە",
    "volume_trends": "ئاراستەکانی قەبارە",
    "no_trend_data": "هیچ زانیارییەکی ئاراستە بەردەست نییە",
    "total_holds": "کۆی حجزەکان",
    "status_breakdown": "دابەشبوونی بارودۆخ",
    "no_status_data": "هیچ زانیارییەکی بارودۆخ بەردەست نییە",
    "active_holds": "حجزە چالاکەکان",
    "apartment_unit_display": "شوقەی {{number}} - نهۆمی {{floor}}",
    "pending_move_in": "چاوەڕوانی گواستنەوە",
    "tenant_name": "ناو",
    "tenant_phone": "ژمارەی تەلەفۆن",
    "tenant_email": "ئیمەیل",
    "lease_details": "وردەکارییەکانی گرێبەست",
    "start_date": "بەرواری دەستپێکردن",
    "end_date": "بەرواری کۆتایی هاتن",
    "monthly_pay_date": "بەرواری پارەدانی مانگانە",
    "day_number": "ڕۆژی {{number}}",
    "duration": "ماوە",
    "months": "مانگ",
    "remaining_time": "کاتی ماوە",
    "financial_summary": "پوختەی دارایی",
    "monthly_rent": "کرێی مانگانە",
    "effective_rent": "کرێی ڕاستەقینە",
    "rent_status": "دۆخی کرێ",
    "future_tenant_upcoming_move_in": "کرێچی داهاتوو (گواستنەوەی داهاتوو)",
    "move_in_date": "بەرواری گواستنەوە",
    "contract_end": "کۆتایی گرێبەست",
    "recent_bookings": "حجزە نوێیەکان و ڕاگرتنەکان",
    "new_hold": "ڕاگرتنی نوێ",
    "available_now": "ئێستا بەردەستە",
    "lease_ending_soon": "کرێ بەم زووانە کۆتایی دێت",
    "no_apartments_found": "هیچ شوقەیەکی گونجاو نەدۆزرایەوە",
    "ready": "ئامادەیە",
    "ends_in_days": "کۆتایی دێت لەماوەی {{count}} ڕۆژدا",
    "search_unit": "گەڕان بۆ شوقە...",
    "currently_occupied": "لە ئێستادا داگیرکراوە",
    "occupied": "داگیرکراوە",
    "all_service_payments": "هەموو پارەدانی خزمەتگوزاریەکان",
    'manage_all_service_payments_across_buildings': 'بەڕێوەبردنی هەموو پارەدانی خزمەتگوزاریەکان لە سەرانسەری بیناکاندا',
    'tenants_management': 'بەڕێوەبردنی کرێنشینان',
    'manage_tenants_and_leases': 'بەڕێوەبردنی کرێنشینان و گرێبەستەکان',
    'past_tenants': 'کرێنشینانی پێشوو',
    'lease_ended': 'گرێبەست کۆتایی هاتوە',
    'end_lease_confirm_title': 'پشتڕاستکردنەوەی کۆتایی هاتنی گرێبەست',
    'end_lease_confirm_body': 'دڵنیایت لە کۆتایی هاتنی ئەم گرێبەستە؟',
    'no_past_tenants': 'هیچ کرێنشینێکی پێشوو نییە',
    'status_expired_description': 'ئەم گرێبەستە کۆتایی هاتوە. هیچ پارەیەکی تر ناتوانرێت بۆی جێبەجێ بکرێت.',
    'lease_expired_warning': 'ئەم گرێبەستە کۆتایی هاتوە.',
    'tenant_lease_expired_message': 'هیچ پارەیەکی تر ناتوانرێت بۆی جێبەجێ بکرێت.',
    'expired_on': 'کۆتایی هاتوە لە',
    'manage_tenant': 'بەڕێوەبردنی کرێنشین',
    'move_in_pending': 'گواستنەوەی چاوەڕوانکراو',
    'lease_expired': 'گرێبەست کۆتایی هاتوە',
    'create_hold': 'دروستکردنی ڕاگرتن',
    'billing_subscription': 'بڵینگ و بەشداری',
    'current_plan': 'پلانی ئێستا',
    'subscribe_now': 'سەبسکرایب بکە ئێستا',
    'manage_your_subscription_and_billing': 'بەڕێوەبردنی بەشداری و بڵینگی خۆت',
    'view_payment_logs': 'بینینی تۆماری پارەدانەکان',
    'view_activity_logs': 'بینینی تۆمارەکانی چالاکی',
    'view_revenue_report': 'بینینی ڕاپۆرتی داهات',
    'view_occupancy_report': 'بینینی ڕاپۆرتی نیشتەجێبوون',
    'view_tenant_logs': 'بینینی تۆماری کرێنشینان',
    'login_success': 'چوونەژوورەوە سەرکەوتوو بوو',
    'logout_success': 'چوونەدەرەوە سەرکەوتوو بوو',
    'record_payment': 'تۆمارکردنی پارەدان',
    'occupied_status': 'داگیرکراوە',
    'partial': 'جزئي',
    'scheduled_tenants': 'کرێنشینانی چاوەڕوانکراو',
    'multiple_leases': 'گرێبەستە فرەوانەکان',
    'current_end_date': 'بەرواری کۆتایی هاتنی ئێستا',
    'new_end_date': 'بەرواری کۆتایی هاتنی نوێ',
    'extend': 'درێژکردنەوە',
    'transfer': 'گواستنەوە',
    'transfer_apartment': 'گواستنەوەی شوقە',
    'current_apartment': 'شوقەی ئێستا',
    'select_new_apartment': 'دیاریکردنی شوقەی نوێ',
    'new_monthly_rent': 'کرێی مانگانەی نوێ',
    'transferring': 'گواستنەوە...',
    'failed_to_transfer_tenant': 'گواستنەوەی کرێنشین سەرکەوتوو نەبوو',
    'tenant_transferred_success': 'کرێنشین بەسەرکەوتوویی گواسترایەوە',
    'expired': 'کۆتایی هاتوە',
    'invite_portal': 'دەعوەت بۆ سیستەم',
    'tenant_documents': 'وثائق المستأجر',
    'maintenance_requests': 'طلبات الصيانة',
    'add_request': 'إضافة طلب',
    'reported_on': 'تم الإبلاغ في',
    'send_portal_invitation': 'إرسال دعوة إلى النظام',
    'fully_signed': 'موقع بالكامل',
    'voided': 'ملغى',
    'upgrade_for_analytics': 'لتحليلات',
    'upgrade_analytics_message': 'لتحليلات',
    'view_plans': 'عرض الخطط',
    'choose_a_plan': 'اختر خطط',
    'subscribe_with_stripe': 'اشترك مع stripe',
    'manage_subscription': 'إدارة الاشتراك',
    'subscribe_with_stripe': 'اشترك مع stripe',
    'upgrade': 'ترقية',
    'contact_sales': 'اتصل ببيع',
    'no_payment_history': 'لا يوجد سجل دفع',
    'no_subscription_history': 'لا يوجد سجل اشتراك',

    // ID Documents (Tenant & Owner)
    'id_documents': 'بەڵگەنامەکانی ناسنامە',
    'id_document_front': 'پێشەوە',
    'id_document_back': 'پشتەوە',
    'id_document_type': 'جۆری بەڵگەنامە',
    'id_document_number': 'ژمارەی بەڵگەنامە',
    'id_document_uploaded_at': 'بەرواری بارکردن',
    'select_document_type': 'جۆری بەڵگەنامە هەڵبژێرە',
    'national_id': 'ناسنامەی نیشتیمانی',
    'passport': 'پاسپۆرت',
    'driving_license': 'مۆڵەتی شوفێری',
    'residence_permit': 'مۆڵەتی نیشتەجێبوون',
    'other_document': 'جۆری تر',
    'document_number_placeholder': 'ژمارەی بەڵگەنامە بنوسە (ئارەزووی)',
    'front_side': 'لای پێشەوە',
    'back_side': 'لای پشتەوە',
    'drag_drop_or_click': 'بکێشە و دابنێ یان کلیک بکە بۆ بارکردن',
    'supported_formats': 'پشتیوانی: JPG, PNG, WEBP (زۆرترین 5MB)',
    'upload_id_documents': 'بارکردنی بەڵگەنامەکانی ناسنامە',
    'uploading': 'لە بارکردندایە...',
    'id_documents_uploaded': 'بەڵگەنامەکانی ناسنامە بە سەرکەوتوویی بارکران',
    'id_documents_upload_failed': 'بارکردنی بەڵگەنامەکانی ناسنامە سەرنەکەوت',
    'delete_document_side': 'سڕینەوەی بەڵگەنامەی {{side}}',
    'confirm_delete_document': 'دڵنیایت لە سڕینەوەی ئەم بەڵگەنامەیە؟',
    'document_deleted': 'بەڵگەنامە بە سەرکەوتوویی سڕایەوە',
    'document_delete_failed': 'سڕینەوەی بەڵگەنامە سەرنەکەوت',
    'no_id_documents': 'هیچ بەڵگەنامەی ناسنامەیەک هێشتا بارنەکراوە',
    'view_document': 'بینینی بەڵگەنامە',
    'close_preview': 'داخستنی پێشبینین',
    'save_changes': 'پاشەکەوتکردنی گۆڕانکارییەکان',
    'pending_upload': 'چاوەڕوانی بارکردن',
    'id_documents_tab': 'بەڵگەنامەکانی ناسنامە',
    'tenant_id_documents': 'بەڵگەنامەکانی ناسنامەی کرێکار',
    'owner_id_documents': 'بەڵگەنامەکانی ناسنامەی خاوەن',
    'id_documents_description': 'بارکردن و بەڕێوەبردنی وێنەکانی بەڵگەنامەی ناسنامە',

    'waitlist': 'لیستی چاوەڕوانی',
    'waitlist_management': 'بەڕێوەبردنی لیستی چاوەڕوانی',
    'search_waitlist': 'گەڕان بە ناوی، تەلەفۆن یان یەکەکە...', 
    'waitlist_empty': 'لیستی چاوەڕوانی بەتاڵە',
    'no_prospective_tenants_waiting': 'هیچ کرێکارێکی داهاتوو چاوەڕێی یەکەیەکی تایبەت ناکات.',

    // Waitlist table columns
    'priority': 'پێشینە',
    'prospect': 'چاوەڕوان',
    'desired_unit': 'یەکەی خواستراو',
    'move_in_preference': 'بەرواری چوونە ژوورەوە',
    'added': 'زیادکراوە',
    'rank': '#{{priority}}',
    'process_to_booking': 'کردن بە ڕەزاکردن',
    'remove': 'سڕینەوە',
    'remove_from_waitlist': 'سڕینەوە لە لیستی چاوەڕوانی',
    'remove_waitlist_confirm': 'دڵنیای لە سڕینەوەی ئەم چاوەڕوانە لە لیستی چاوەڕوانی؟ ئەم کارە هەڵناگیرێتەوە.',

    // Waitlist status messages
    'waitlist_processed': 'چاوەڕوان بە سەرکەوتوویی کرایە ڕەزاکردنێکی چاوەڕوانکراو',
    'failed_process_waitlist': 'هەڵە لە کردن بە ڕەزاکردنی ئەم چاوەڕوانە',
    'entry_removed': 'چاوەڕوان سڕایەوە لە لیستی چاوەڕوانی',
    'failed_remove_entry': 'هەڵە لە سڕینەوەی چاوەڕوان لە لیستی چاوەڕوانی',

    // Add to Waitlist Modal
    'add_to_waitlist': 'زیادکردن بۆ لیستی چاوەڕوانی',
    'waitlist_form_subtitle': 'چاوەڕوانەکە بە شێوەیەکی ئۆتۆماتیکی بەرزدەکرێتەوە کاتێک یەکەکە بەردەست دەبێت',
    'desired_unit': 'یەکەی خواستراو',
    'prospect_details': 'زانیاری چاوەڕوان',
    'prospect_name': 'ناوی چاوەڕوان',
    'prospect_phone': 'تەلەفۆنی چاوەڕوان',
    'prospect_email': 'ئیمەیڵی چاوەڕوان',
    'scheduling_priority': 'پلان و پێشینە',
    'preferred_move_in_date': 'بەرواری چوونە ژوورەوە',
    'higher_is_first': 'زیاتر = یەکەم لە ڕیزەکە',
    'priority_hint': 'چاوەڕوانەکان بە پێشینەی بەرزتر پێش دەکەون. پێشینەی بنەڕەتی 0 (FIFO).',
    'priority_range_error': 'پێشینە دەبێت لە نێوان 0 و 10 بێت',
    'loading_apartments': 'لە بارکردنی یەکەکەکان...',
    'field_required': 'ئەم کێڵگەیە پێویستە',
    'adding': 'زیادکردن...',
    'added_to_waitlist': 'چاوەڕوان بە سەرکەوتوویی زیادکرا بۆ لیستی چاوەڕوانی',
    'failed_add_waitlist': 'هەڵە لە زیادکردنی چاوەڕوان بۆ لیستی چاوەڕوانی',
    'waitlist_auto_promote_info': 'کاتێک یەکەی هەڵبژێردراو بەردەست دەبێت، ئەم چاوەڕوانە بە شێوەیەکی ئۆتۆماتیکی دەکرێتە ڕەزاکردنێکی چاوەڕوانکراو بەپێی پێشینە و شوێنی لە ڕیزەکەدا.',
    'waitlist_notes_placeholder': 'داواکاری تایبەت، سەرچاوەی سەرنج، تێبینیەکانی بەڕێوەبەر...',

    // ── Maintenance Hub ───────────────────────────────────────────
    'maintenance_hub': 'سەنتەری چاکسازی و خزمەتگوزاری',
    'track_and_assign_maintenance': 'چاوەڕێی داواکاری کرێکاران بکە و ئەرکەکان بۆ خزمەتگوزارەکان دیاری بکە',
    'search_requests': 'گەڕان بەپێی کێشە، کرێکار یان شوقە...',
    'loading_requests': 'لە بارکردنی داواکارییەکان...',
    'no_maintenance_found': 'هیچ داواکاری چاکسازییەکی نەدۆزییەوە',
    'issue': 'کێشە',
    'location': 'شوێن',
    'tenant': 'کرێکار',
    'assign_vendor': 'خزمەتگوزار دیاری بکە',
    'update_status': 'ڕێژەی کارکردن نوێ بکەوە',
    'status_updated': 'ڕێژەی کارکردن بە سەرکەوتوویی نوێ کرایەوە',
    'error_updating_status': 'هەڵە لە نوێکردنەوەی ڕێژەی کارکردن',
    'error_fetching_data': 'هەڵە لە وەرگرتنی زانیارییەکان',

    // Work Orders
    'create_work_order': 'داواکاری کارکردن دروست بکە',
    'work_order_created': 'داواکاری کارکردن دروست کرا و دیاری کرا',
    'error_creating_work_order': 'هەڵە لە دروستکردنی داواکاری کارکردن',
    'select_vendor': 'خزمەتگوزار هەڵبژێرە',
    'select_a_vendor': 'خزمەتگوزارێک هەڵبژێرە',
    'estimated_cost': 'نرخی پێشبینیکراو',
    'scheduled_date': 'بەرواری دیاریکراو',
    'work_description': 'ڕوونکردنەوەی کارکردن',

    // Maintenance statuses
    'open': 'کرایەوە',
    'in_progress': 'لە کارکردندایە',
    'completed': 'تەواو بوو',
    'cancelled': 'هەڵوەشێنرایەوە',

    // ── Vendor Management ─────────────────────────────────────────
    'vendor_management': 'بەڕێوەبردنی خزمەتگوزارەکان',
    'manage_maintenance_vendors': 'بەڕێوەبردنی کۆمپانیاکانی چاکسازی دەرەکی و خزمەتگوزارەکان',
    'add_vendor': 'خزمەتگوزار زیاد بکە',
    'add_new_vendor': 'خزمەتگوزارێکی نوێ زیاد بکە',
    'edit_vendor': 'خزمەتگوزار دەستکاری بکە',
    'search_vendors': 'گەڕان بەپێی ناوی خزمەتگوزار یان جۆری...',
    'no_vendors_found': 'هیچ خزمەتگوزارێک نەدۆزییەوە',
    'vendor_name': 'ناوی خزمەتگوزار',
    'category': 'جۆری',
    'contact_person': 'کەسی پەیوەندیکردن',
    'vendor_created': 'خزمەتگوزار بە سەرکەوتوویی دروست کرا',
    'vendor_updated': 'خزمەتگوزار بە سەرکەوتوویی نوێ کرایەوە',
    'vendor_deleted': 'خزمەتگوزار بە سەرکەوتوویی سڕایەوە',
    'update_vendor': 'خزمەتگوزار نوێ بکەوە',
    'save_vendor': 'خزمەتگوزار پاشەکەوت بکە',
    'confirm_delete_vendor': 'دڵنیای لە سڕینەوەی ئەم خزمەتگوزارە؟ ئەم کارە هەڵناگیرێتەوە.',
    'error_fetching_vendors': 'هەڵە لە وەرگرتنی خزمەتگوزارەکان',
    'error_saving_vendor': 'هەڵە لە پاشەکەوتکردنی خزمەتگوزار',
    'error_deleting_vendor': 'هەڵە لە سڕینەوەی خزمەتگوزار',
    'confirm_delete_vendor_title': 'سڕینەوەی خزمەتگوزار',
    'vendor_no_email': 'خزمەتگوزار ئیمەیڵی نییە',
    'vendor_invite_saved': 'بانگهێشتەکە پاراستراوە!',
    'vendor_invite_link_copied': 'لینکی ڕێکخستن کۆپی کرا بۆ کلیپبۆرد',
    'vendor_invite_failed': 'ناردنی بانگهێشت سەرکەوتوو نەبوو',
    'vendor_invite_portal': 'بانگهێشت بۆ پۆرتاڵی خزمەتگوزار',
    'vendor_category_placeholder': 'نمونە: بۆرپێچ، IT، کارەبا',
    'vendor_1099_nec': 'خزمەتگوزار 1099-NEC',
    'vendor_1099_desc': 'ڕاپۆرتی ساڵانەی IRS — خزمەتگوزارانی کە ≥ 600$ وەرگرتوون',
    'vendor_1099_disclaimer': 'فۆرمەکانی 1099-NEC پێویستن بۆ هەر خزمەتگوزارێک (ناکارمەندێک) کە ≥ 600$ لە ساڵی کالەندەردا پارەی وەرگرتووە. موعەدی IRS بەمەودایە 31ی ژانویەیە. هەمیشە پشتی پسپۆڕی باجدا ببە پێش پێشکەشکردن.',
    '1099_required': '1099 پێویستە',
    'no_vendor_payments_recorded': 'هیچ پارەدانێکی خزمەتگوزار تۆمارنەکراوە بۆ',

    // ── Contract Templates ────────────────────────────────────────
    'contract_templates': 'نموونەی گرێبەستەکان',
    'manage_legal_templates_desc': 'ڕێنماییە یاساییەکان و ڕێساکانی ئۆتۆماتیکی بۆ گرێبەستەکان بەڕێوەبەرە.',
    'create_template': 'نموونە دروست بکە',
    'search_templates': 'گەڕان بەپێی نموونەکان...',
    'no_templates_found': 'هیچ نموونەیەک نەدۆزییەوە',
    'create_first_template_desc': 'دەست بکە بە دروستکردنی یەکەم نموونەی یاسایی گرێبەستت.',
    'no_description_provided': 'هیچ ڕوونکردنەوەیەک نەدراوە.',
    'default_rules': 'ڕێساکانی بنەڕەتی',
    'failed_to_load_templates': 'هەڵە لە بارکردنی نموونەکان',
    'template_deleted_successfully': 'نموونە بە سەرکەوتوویی سڕایەوە',
    'failed_to_delete_template': 'هەڵە لە سڕینەوەی نموونە',
    'confirm_delete_template': 'دڵنیای لە سڕینەوەی ئەم نموونەیە؟ ئەم کارە هەڵناگیرێتەوە.',

    // Contract Template Form
    'edit_template': 'دەستکاری نموونە',
    'create_new_template': 'نموونەیەکی نوێ دروست بکە',
    'template_details': 'وردەکارییەکانی نموونە',
    'template_name': 'ناوی نموونە',
    'is_active': 'نموونەی چالاک',
    'legal_text': 'دەقی یاسایی',
    'default_variable_rules': 'ڕێساکانی گۆڕاوەی بنەڕەتی',
    'default_rules_desc': 'گۆڕاوە بنەڕەتییەکان (وەک commission_rate) دیاری بکە کە دروستکەر بەکاری دەهێنێت.',
    'add_rule': 'ڕێسایەک زیاد بکە',
    'no_default_rules': 'هیچ ڕێسایەکی بنەڕەتی دیاریکراو نییە.',
    'variable_name_placeholder': 'ناوی گۆڕاوە (نموونە: commission_rate)',
    'default_value_placeholder': 'نرخی بنەڕەتی (نموونە: 8)',
    'archive_template': 'نموونە ئەرشیف بکە',
    'archive_template_confirm': 'دڵنیای لە ئەرشیفکردنی ئەم نموونەیە؟ بۆ گرێبەستە نوێیەکان بەردەست نابێت.',
    'archive': 'ئەرشیف بکە',
    'template_archived_successfully': 'نموونە بە سەرکەوتوویی ئەرشیف کرا',
    'failed_to_archive_template': 'هەڵە لە ئەرشیفکردنی نموونە',
    'template_updated_successfully': 'نموونە بە سەرکەوتوویی نوێ کرایەوە',
    'template_created_successfully': 'نموونە بە سەرکەوتوویی دروست کرا',
    'failed_to_save_template': 'هەڵە لە پاشەکەوتکردنی نموونە',
    'failed_to_load_template': 'هەڵە لە بارکردنی نموونە',

    // Contract types
    'management': 'بەڕێوەبردن',
    'lease': 'بەکرێدان',
    'sale': 'فرۆشتن',
    'lease_progress': 'پێشکەوتنی گرێبەست',
    'status_open': 'کراوة',
    'status_in_progress': 'لە کاردایە',
    'status_completed': 'تەواوەتە',
    'status_cancelled': 'ڕەتخراوە',
    'priority_low': 'کەم',
    'priority_medium': 'نێوانی',
    'priority_high': 'بەرز',
    'priority_urgent': 'بهستە',
    'priority_emergency': 'ئەفرێن',
    'estimated_cost': 'كۆلفی خەمین',
    'tenant_portal_submissions': 'نێردانیەکانی درگەی خوزمەدان',
    'portal_submission_note': 'فەیلەکانی کە کرێدار بە رێگەی درگەی خویندەوەری کەلستووەکانییە نێردانییان',
    'tenant_proof_document': 'ناونەی ناسنامە / بەلگەنامە',
    'tenant_insurance_document': 'بێمە / بەلگەنامە',
    'not_submitted': 'نێردرانەکراوە',
    'saved': 'چاوەندراوە',
    'payment_method': 'شێوازی پارەدان',
    'tenant_ledger': 'دەفتەری گشتی کرێدار',
    'ledger_description': 'تۆماری نەگۆڕی هەموو کرێ و پارەدانەکان. کرێدیت زیاد بکە بۆ سەرەستکردنەوەی هەڵەکان.',
    'ledger_generate_monthly': 'مانگانە دروستبکە',
    'ledger_add_charge': 'کرێ زیاددەکە',
    'ledger_add_credit': 'کرێدیت زیادبکە',
    'ledger_apply_late_fee': 'تاوانی دواکەوتن جێبەجێبکە',
    'ledger_late_fee': 'تاوانی دواکەوتن',
    'ledger_charge': 'کرێ',
    'ledger_deposit': 'پارەی بەپێچ',
    'ledger_payment': 'پارەدان',
    'ledger_credit': 'کرێدیت',
    'ledger_charge_rent_fee': 'کرێ (بەکرێدان / تێچوو)',
    'ledger_description_placeholder': 'نموونە: تێچووی چاکسازی',
    'outstanding_balance': 'ماوەی نەدراو',
    'ledger_balance_note': 'لەسەر بنەمای هەموو تۆمارەکانی دەفتەری گشتی',
    'ledger_total_entries': 'کۆی تۆمارەکان',
    'ledger_no_entries': 'هیچ تۆمارێک لە دەفتەری گشتیدا نییە',
    'ledger_no_entries_hint': 'یەکەمین کرێی مانگانە دروستبکە یان دەستکاری کرێ لە سەرەوە.',
    'ledger_balance_after': 'ماوە پاشان',
    'ledger_charge_added': 'کرێ زیادکرا بۆ دەفتەری گشتی',
    'ledger_charge_failed': 'شکستی هێنا لە زیادکردنی کرێ',
    'ledger_credit_added': 'کرێدیت زیادکرا بۆ دەفتەری گشتی',
    'ledger_credit_failed': 'شکستی هێنا لە زیادکردنی کرێدیت',
    'ledger_late_fee_applied': 'تاوانی دواکەوتن جێبەجێکرا',
    'ledger_late_fee_failed': 'شکستی هێنا لە جێبەجێکردنی تاوان',
    'ledger_monthly_generated': 'کرێی مانگانە دروستکرا',
    'ledger_monthly_failed': 'شکستی هێنا لە دروستکردنی کرێ',
    'ledger_load_failed': 'شکستی هێنا لە بارکردنی دەفتەری گشتی',
    'created_by': 'دروستکراوە لەلایەن',
    'expired': 'بەسەرچووە',
    'expiring_soon': 'بەم زووانەی بەسەر دەچێت',
    'email': 'ئیمەیل',

    // ── Layout / Sidebar / Header ─────────────────────────────────────────────
    'welcome_user': 'خەرھاتبێیتەوە، {{name}}؟',
    'owner_portal': 'دەرگەی خاوەن',
    'tenant_portal': 'دەرگەی کرێکار',
    'owner': 'خاوەن',
    'tenant': 'کرێکار',
    'properties_&_contracts': 'شوقەکان و گرێبەستەکان',
    'financial': 'دارایی',
    'financial_&_lease': 'دارایی و کرێ',
    'Dashboard': 'داشبۆڕد',
    'Properties': 'شوقەکان',
    'Contracts': 'گرێبەستەکان',
    'Installments': 'قستەکان',
    'Service Charges': 'بیگەی خزمەتگوزاری',
    'Financials': 'دارایی',
    'Maintenance': 'چاککردن',
    'Payments': 'پاڕەدانەکان',
    'Lease Details': 'وردەکاریی گرێبەست',
    'Inspections': 'پشکنینەکان',
    'Profile': 'پڕۆفایل',
    'documents': 'دۆکۆمەنتەکان',
    'announcements': 'ڕادەبێذییەکان',
    'messages': 'نامەکان',
    'Messages': 'نامەکان',
    'maintenance_subtitle': 'وەرخوازیی چاککردنمان بسپێنه و بەدواداچوونیییان لە یەک یەکهێوه.',
    'new_request': 'وەرخوازیی نوێ',
    'report_an_issue': 'ڕاپۆرتaی کێشەیەک',
    'issue_summary': 'کۆتاییی کێشەکە',
    'issue_summary_placeholder': 'نموونە: تراکیتی ئاو لە دهوێوەکە',
    'urgency_level': 'ڕێژەی ،هیێتی',
    'low_urgency': 'کەم - ھەناکارنییە',
    'normal_urgency': 'ناوەندی - پێویستی بە سەرنجە',
    'high_urgency': 'بەرز - کەژاو لەسەر ژیانی ڕۆژییە',
    'emergency_urgency': 'ڕۆکاری - کردەوەری فۆری',
    'describe_the_problem': 'کێشەکە وێنە بە',
    'describe_problem_placeholder': 'تکایە کێشەکە بە زۆرترین وردەکارییەک وینە بە...',
    'upload_photo_optional': 'بارکردنی پۆكەرە (دابیخوێ)',
    'add_photo': 'پۆكەرە زیادبکە',
    'photo_upload_tip': 'پۆكەرە یاردەدەژمان دا کێشەکەت بە ھەنگامتر چاڕەسەربکەین.',
    'photo_upload_specs': 'JPG، PNG یان WEBP. ژمارەی زۆرتر 5 مەگابایت.',
    'emergency_contact_warning': 'بۆ ڕۆکارییەکانی ھەبشێدانە، تکایە ئەگەری ڕۆکاریی بکەیت. ەمە وەرخوازییەش بە بالاترین ئەولەوییەتییە رەفتار دەکەین.',
    'processing': 'پەڕەژەکردن...',
    'submit_request': 'نێردانی وەرخواز',
    'ongoing_past_requests': 'وەرخوازە جارییەکان و کۆنییەکان',
    'submitted': 'نێردرا',
    'in_progress': 'لە ڕێگەی ئەنجامداندا',
    'completed': 'تەواوبوو',
    'request_cancelled': 'وەرخواز هەستکرا',
    'all_clear': 'ھەموو بەخێرە!',
    'no_maintenance_on_record': 'ھیچ وەرخوازیی چاککردن تۆمار نەکراوە. ھەموو باشە!',
    'resolved_on': 'چاڕەسەربوو لە {{date}}',
    'failed_to_load_maintenance_requests': 'بارکردنی وەرخوازەکانی چاککردن سەرکەوتوو نەبوو',
    'failed_to_submit_request': 'نێردانی وەرخواز سەرکەوتوو نەبوو',
    'photo_size_limit_error': 'پۆكەرەکە دەبێت كەمتر بێت لە 5 مەگابایت',
    'request_submitted_success': 'وەرخواز بە سەرکەوتوویی نێردرا',
    'low': 'کەم',
    'normal': 'ناوەندی',
    'high': 'بەرز',
    'emergency': 'ڕۆکاری',
    'id': 'ID',
    'announcements_subtitle': 'لەگەڵ نوێترین هەواڵ و نوێکارییەکانی بەڕێوەبردنی بینا ئاگادار بە.',
    'no_announcements_title': 'هیچ ڕادەبێذییەک نییە',
    'no_announcements_subtitle': 'دواتر سەری بدەرەوە بۆ نوێکارییەکان.',
    'posted_by': 'بڵاوکراوەتەوە لەلایەن {{name}}',
    'failed_to_load_announcements': 'بارکردنی ڕادەبێذییەکان سەرکەوتوو نەبوو',
    'documents_verification': 'بەڵگەنامەکان و پشکنین',
    'documents_verification_subtitle': 'بەڵگەنامەکانی پێویستت بار بکە و بەڕێوەبە.',
    'supported_formats_specs': 'فۆرماتی پەسەندکراو: PDF، JPG، JPEG، PNG. زۆرترین قەبارە 5 مەگابایت.',
    'identification_proof': 'پشتگیری ناسنامە',
    'identification_proof_desc': 'ناسنامەی فەرمی وەک پاسپۆرت، ناسنامەی نیشتیمانی یان مۆڵەتی شوفێری.',
    'renters_insurance': 'بیمەی کرێنشین',
    'renters_insurance_desc': 'بەڵگەنامەی بیمەی بەردەست کە یەکەکەت داگیردەکات.',
    'verified': 'پشکنراوە',
    'missing': 'نییە',
    'pdf_document': 'بەڵگەنامەی PDF',
    'view_full_size': 'بینینی قەبارەی تەواو',
    'replace': 'جێگرتنەوە',
    'upload_file': 'بارکردنی فایل',
    'need_help_verification': 'پێویستی بە یارمەتی هەیت؟',
    'need_help_verification_subtitle': 'ئەگەر کێشەت هەبوو بە بارکردنی بەڵگەنامەکان، پەیوەندی بکە بە تیمی پشتگیریمان.',
    'contact_support': 'پەیوەندی بە پشتگیری',
    'failed_to_load_document_status': 'دۆخی بەڵگەنامەکان بارکرانەوە نەبوو',
    'file_size_large_error': 'فایل زۆر گەورەیە. زۆرترین 5 مەگابایت.',
    'document_uploaded_success': 'بەڵگەنامە بە سەرکەوتوویی بارکرا',
    'failed_to_upload_document': 'بارکردنی بەڵگەنامە سەرکەوتوو نەبوو',
    'my_inspections': 'پشکنینەکانم',
    'my_inspections_subtitle': 'هەموو پشکنینەکانی موڵک پەیوەست بە کرێکارییەکەت ببینە.',
    'no_inspections_yet': 'تاکو ئێستا هیچ پشکنینێک نییە',
    'no_inspections_subtitle': 'تۆمارەکانی پشکنینی موڵکەکەت ئێرەدا دەردەکەون دوای تەواوبوون.',
    'failed_to_load_inspections': 'بارکردنی پشکنینەکان سەرکەوتوو نەبوو',
    'inspection_type_move_in': 'کۆچکردنەوە',
    'inspection_type_move_out': 'کۆچکردن',
    'inspection_type_periodic': 'سەردانی دووری',
    'inspection_type_maintenance': 'چاککردن',
    'inspection_status_completed': 'تەواوبوو',
    'inspection_status_signed': 'واژووکراو',
    'inspection_status_draft': 'بیانووی پێشوو',
    'unit_prefix': 'یەکە',
    'items_checked': '{{done}} / {{total}} بەند پشکنراوە',
    'inspection_items': 'بەندەکانی پشکنین',
    'general_notes': 'تێبینییە گشتییەکان',
    'management_team': 'تیمی بەڕێوەبردن',
    'management_team_subtitle': 'هێڵی ڕاستەوخۆ بۆ بەڕێوەبردنی بینا',
    'message_empty_state': 'هێشتا هیچ نامەیەک نییە. گفتوگۆ دەستپێبکە!',
    'failed_to_load_messages': 'بارکردنی نامەکان سەرکەوتوو نەبوو',
    'failed_to_send_message': 'ناردنی نامە سەرکەوتوو نەبوو',
    'message_placeholder': 'نامەیەک بنووسە...',
    'lease_details_subtitle': 'گرێبەستی کرێکارییەکەت، دۆخی پارەدان و واژووی دیجیتاڵ پێداچوونەوە بکە.',
    'lease_not_found': 'هیچ گرێبەستێک نەدۆزرایەوە',
    'contact_management_error': 'تکایە پەیوەندی بە بەڕێوەبردنی بینا بکە.',
    'lease_signed': 'واژووکراو',
    'download_your_lease': 'گرێبەستەکەت بە PDF دابگرە',
    'generating': 'دروستکردن...',
    'download_pdf': 'PDF دابگرە',
    'sign_lease_now': 'ئێستا واژوو بکە',
    'contract_term': 'ماوەی گرێبەست',
    'property_information': 'موڵک و خاوەن',
    'landlord_owner': 'خاوەن موڵک',
    'payment_status': 'دۆخی پارەدان',
    'current_balance': 'ماندە سەرجەم',
    'payment_required': 'پارەدان پێویستە',
    'account_good_standing': 'هەژمار لە دۆخی باشدایە',
    'lease_signed_success': 'گرێبەست بە سەرکەوتوویی واژووکرا!',
    'failed_to_sign_lease': 'واژووکردنی گرێبەست سەرکەوتوو نەبوو',
    'lease_pdf_download_success': 'PDF بە سەرکەوتوویی داگیرا',
    'lease_pdf_download_failed': 'داگیرکردنی PDF سەرکەوتوو نەبوو',
    'e_signature_recorded': 'واژووی ئەلیکترۆنی تۆمارکرا',
    'signed_on': 'واژووکراو لە',
    'ip_trace': 'IP',
    'integrity_hash': 'Hash',
    'signature_graphic': 'واژووەکەت',
    'legal_disclosure': 'ئاشکراکردنی یاساییی',
    'legal_disclosure_text': 'ئەم گرێبەستە کرێکارییە بەلگەنامەیەکی یاسایی ئەلزامییە. بە واژووکردنی ئەلیکترۆنی موافقەتی هەموو مەرج و حاڵەکانت دەکەیت.',
    'payments_billing': 'پارەدان و فاتورەکان',
    'payments_billing_subtitle': 'پارەدانەکانی کرێ، بیگەی خزمەتگوزاری و هەژمارەکەت بەدواداچوو بکە.',
    'download_statement': 'دابگرتنی پێداچوونەوەی هەژمار',
    'current_amount_due': 'بڕی ئێستای دەستبەسەر',
    'due_on': 'کاتی دەستبەسەر',
    'view_ledger_hint': 'مێژووی تەواوی مامەڵەکانت ببینە لە',
    'view_your_ledger': 'دەفتەری هەژمار',
    'all_paid_up': 'هەموو دراوە!',
    'tab_rent_payments': 'پارەدانەکانی کرێ',
    'tab_service_charges': 'بیگەی خزمەتگوزاری',
    'tab_service_charges_due': 'بیگەی خزمەتگوزاری ({{count}} دەستبەسەر)',
    'tab_account_ledger': 'دەفتەری هەژمار',
    'transaction_history': 'مێژووی مامەڵەکان',
    'no_transactions': 'تاکو ئێستا هیچ مامەڵەیەک نییە',
    'no_transactions_subtitle': 'مێژووی پارەدانی کرێکەت ئێرەدا دەردەکەوێت.',
    'outstanding_service_charges': 'بیگەکانی خزمەتگوزاری دەرکەوتوو',
    'service_charge_default': 'بیگەی خزمەتگوزاری',
    'paid_service_history': 'مێژووی خزمەتگوزارییە دراوەکان',
    'paid_badge': 'دراوە',
    'no_service_charges': 'هیچ بیگەی خزمەتگوزارییەک نییە',
    'no_service_charges_subtitle': 'هیچ بیگەیەک بە هەژمارەکەت نەکراوەتەوە.',
    'account_balance': 'ماندەی هەژمار',
    'ledger_calculated_from': 'حسابکراوە لە {{count}} مامەڵە',
    'full_account_statement': 'پێداچوونەوەی تەواوی هەژمار',
    'full_account_statement_subtitle': 'هەموو بیگە و پارەدانەکانی هەژمارەکەت',
    'no_ledger_entries': 'هیچ تۆمارێک نییە',
    'no_ledger_entries_subtitle': 'چالاکیی هەژمارەکەت ئێرەدا دەردەکەوێت.',
    'balance_after_col': 'ماندە پاشت',
    'ledger_type_charge': 'بیگە',
    'ledger_type_late_fee': 'بیگەی دواکەوتن',
    'ledger_type_deposit': 'مانە',
    'ledger_type_payment': 'پارەدان',
    'ledger_type_credit': 'قەرز',
    'payment_success_stripe': 'پارەدان سەرکەوتوو بوو! هەژمارەکەت نوێ کراوەتەوە.',
    'payment_cancelled_stripe': 'پارەدان هەستکرا. هیچ بیگەیەک نەکراوەتەوە.',
    'online_payments_not_enabled': 'پارەدانی ئۆنلاین بۆ هەژمارەکەت چالاک نەکراوە.',
    'failed_to_initiate_payment': 'دەستپێکردنی پارەدان سەرکەوتوو نەبوو',
    'failed_to_load_payment_data': 'بارکردنی داتای پارەدان سەرکەوتوو نەبوو',
    'my_profile': 'پرۆفایلەکەم',
    'my_profile_subtitle': 'زانیارییە کەسییەکانت و ئەمنیەتی هەژمارەکەت بەڕێوەبە.',
    'personal_information': 'زانیارییە کەسییەکان',
    'full_name': 'ناوی تەواو',
    'your_full_name_placeholder': 'ناوی تەواوەکەت',
    'phone_placeholder': '7XX XXX XXXX',
    'email_placeholder': 'you@example.com',
    'saving': 'پاشکەوتکردن...',
    'save_changes': 'پاشکەوتکردنی گۆڕانکارییەکان',
    'change_password': 'گۆڕینی تێپەڕەوشە',
    'current_password': 'تێپەڕەوشەی ئێستا',
    'new_password': 'تێپەڕەوشەی نوێ',
    'confirm_new_password': 'دوبارەکردنەوەی تێپەڕەوشەی نوێ',
    'min_8_chars': 'کەمترین 8 پیت',
    'repeat_new_password': 'تێپەڕەوشەی نوێ دووبارە بکەرەوە',
    'passwords_do_not_match': 'تێپەڕەوشەکان دەگونجێن نین',
    'updating': 'نوێکردنەوە...',
    'update_password': 'نوێکردنەوەی تێپەڕەوشە',
    'account_id': 'ID هەژمار',
    'tenant_since': 'کرێکار لە',
    'failed_to_load_profile': 'بارکردنی پرۆفایل سەرکەوتوو نەبوو',
    'profile_updated': 'پرۆفایل بە سەرکەوتوویی نوێکراوەتەوە',
    'failed_to_update_profile': 'نوێکردنەوەی پرۆفایل سەرکەوتوو نەبوو',
    'password_changed': 'تێپەڕەوشە بە سەرکەوتوویی گۆڕدرا',
    'failed_to_change_password': 'گۆڕینی تێپەڕەوشە سەرکەوتوو نەبوو',
    'password_min_8': 'تێپەڕەوشە دەبێت کەمترین 8 پیت بێت',
    'service_charges_title': 'بیگەکانی خزمەتگوزاری',
    'service_charges_subtitle': 'بیگەکانی خزمەتگوزاریت ببینە و بیدەرەوە.',
    'total_charges': 'کۆی بیگەکان',
    'outstanding_balance_label': 'دەرکەوتوو',
    'service_charges_year': 'بیگەی خزمەتگوزاری — {{year}}',
    'no_service_charges_year': 'هیچ بیگەی خزمەتگوزارییەک نییە بۆ {{year}}',
    'no_service_charges_year_hint': 'تەمەن کردن بە هەڵبژاردنی ساڵێکی تر.',
    'paid_on_date': 'دراوە لە {{date}}',
    'unpaid_label': 'نەدراوە',
    'pay_online': 'پارەدانی ئۆنلاین',
    'service_paid_success': 'بیگەی خزمەتگوزاری بە سەرکەوتوویی دراوە!',
    'payment_canceled': 'پارەدان هەستکرا.',
    'failed_to_load_service_charges': 'بارکردنی بیگەکانی خزمەتگوزاری سەرکەوتوو نەبوو',
    'portfolio_summary': 'کورتەی بوشکۆی موڵک',
    'portfolio_subtitle': 'بەخێربێی دوایتر، {{name}}. ئێرەدا کورتەی بوشکۆی موڵکەکەتە.',
    'portfolio_statement': 'پێداچوونەوەی بوشکۆ',
    'total_units': 'کۆی یەکەکان',
    'occupancy_rate': 'ڕێژەی هەبوون',
    'active_leases': '{{count}} گرێبەستی کرێکارییە چالاک',
    'monthly_revenue': 'داهاتی مانگانە',
    'vacant_units': 'یەکە بەتاڵەکان',
    'installment_summary': 'کورتەی قیستەکان',
    'view_detailed_ledger': 'بینینی دەفتەری وردەکاری',
    'outstanding': 'دەرکەوتوو',
    'across_installments': 'لەسەر {{count}} قیست',
    'overdue': 'دواکەوتوو',
    'actions_required': '{{count}} کارو پێویستە',
    'proceed_to_payments': 'بڕۆ بۆ پارەدانەکان',
    'revenue_performance': 'ئەدای داهات',
    'no_revenue_data': 'هیچ داتای داهاتێک بەردەست نییە',
    'portfolio_distribution': 'دابەشکردنی بوشکۆ',
    'no_building_data': 'هیچ داتای بینایەک بەردەست نییە',
    'occupied_label': 'دانیشتوو',
    'ready_to_scale': 'ئامادەی بەڕێوەبردنی بوشکۆکەتیت؟',
    'ready_to_scale_subtitle': 'دەستگهێشتن بە ئامرازە سەرەکییەکان بۆ موڵکەکانت',
    'failed_to_load_dashboard_data': 'بارکردنی داتای داشبۆرد سەرکەوتوو نەبوو',
    'failed_to_download_statement': 'داگیرکردنی پێداچوونەوەکە سەرکەوتوو نەبوو',
    'owner_messages_title': 'نامەکان',
    'owner_messages_subtitle': 'پەیوەندیی ڕاستەوخۆ بە بەڕێوەبردنی بینا',
    'my_properties': 'موڵکەکانم',
    'my_properties_subtitle': 'هەموو شوقەکان و یەکەکانی بوشکۆکەت ببینە.',
    'portfolio_empty': 'هیچ موڵکێک نەدۆزراوەتەوە',
    'portfolio_empty_subtitle': 'تاکو ئێستا هیچ شوقەیەک بە بوشکۆکەتدا دیاری نەکراوە. پەیوەندی بە بەڕێوەبەرت بکە.',
    'floor_prefix': 'نۆبەر',
    'sqm': 'م²',
    'current_rent': 'کرێی ئێستا',
    'per_month_short': '/مانگ',
    'failed_to_load_properties': 'بارکردنی موڵکەکان سەرکەوتوو نەبوو',
    'maintenance_approvals': 'موافەقەتەکانی چاکسازی',
    'maintenance_approvals_subtitle': 'داواکارییەکانی چاکسازیی کرێکاران بپشکنە و ڕازی بو یان ڕەتیبکەرەوە.',
    'failed_to_load_maintenance': 'بارکردنی داواکارییەکانی چاکسازی سەرکەوتوو نەبوو',
    'request_status_updated': 'دۆخی داواکاری بە سەرکەوتوویی نوێکراوەتەوە',
    'failed_to_update_request': 'نوێکردنەوەی داواکارییەکەی چاکسازی سەرکەوتوو نەبوو',
    'pending_approval': 'چاوەڕوانی موافەقەت',
    'approved_in_progress': 'موافەقەتکراوە / لە ئەنجامدانداییە',
    'rejected_cancelled': 'ڕەتکراوەتەوە / هەستکراوە',
    'above_threshold': 'سەروی سنوور (${{amount}})',
    'no_maintenance_requests': 'هیچ داواکارییەکی چاکسازی نییە',
    'no_maintenance_subtitle': 'داواکارییەکانی چاکسازیی کرێکاران کە موافەقەتت پێویستە ئێرەدا دەردەکەون.',
    'financial_overview': 'پێداچوونەوەی دارایی',
    'financial_subtitle': 'داهاتی جەنگاوی کرێکارانت لەسەر هەموو موڵکەکان بەدواداچوو بکە.',
    'no_financial_data': 'هیچ داتای دارایییەک نییە',
    'no_payments_message': 'تاکو ئێستا هیچ پارەدانێکی تۆماركراو بۆ بوشکۆکەت نییە.',
    'recent_payments': 'پارەدانەکانی دوایین',
    'property_tenant': 'موڵک / کرێکار',
    'gross_amount': 'بڕی كۆ',
    'commission': 'کۆمیسیۆن',
    'net_amount': 'بڕی خاڵص',
    'overdue_payments': 'پارەدانەکانی دواکەوتوو',
    'failed_to_load_financials': 'بارکردنی داتای دارایی سەرکەوتوو نەبوو',
    'statement_downloaded': 'پێداچوونەوەی {{month}} {{year}} داگیرا',
    'management_commission': 'کۆمیسیۆنی بەڕێوەبردن',
    'unit_display': 'یەکە {{number}}',
    'since': 'لە',
    'amount_owed': 'بڕی دەستبەسەر',
    'financial_ledger': 'دەفتەری دارایی',
    'ledger_subtitle': 'هەموو پارەدانەکانی قیست لەسەر گرێبەستەکانی موڵکت.',
    'total_outstanding': 'کۆی دەرکەوتوو',
    'installment': 'قیست',
    'due_date': 'کاتی دەستبەسەر',
    'action': 'کردار',
    'partial': 'بەشداری',
    'owner_contract': 'گرێبەستی خاوەن موڵک',
    'pay_amount': 'پارەدانی {{amount}}',
    'settled': 'دانپاوانکراو',
    'no_installments': 'هیچ قیستێک نەدۆزراوەتەوە.',
    'failed_to_load_installments': 'بارکردنی قیستەکان سەرکەوتوو نەبوو',
    'payment_success_msg': 'پارەدان سەرکەوتوو بوو! سپاس.',
    'payment_canceled_msg': 'پارەدان هەستکرا.',
    'error_connecting_payment': 'هەڵە لە پەیوەندیکردن بە سیستەمی پارەدان',
    'owner_service_charges': 'بیگەکانی خزمەتگوزاری',
    'owner_service_charges_subtitle': 'بیگەکانی خزمەتگوزاری فاکتوورکراو بۆ موڵکەکانت ببینە و بیدەرەوە.',
    'owner_service_info': 'بیگەکانی خزمەتگوزاری لەلایەن بەڕێوەبردنی بینادا دەدرێن. تکایە بڕەکانی دەرکەوتوو بەکاتی بدەرەوە بۆ ئەوەی قەتعکردنی خزمەتگوزاری ڕوونەدات.',
    'outstanding_balance': 'ماندەی دەرکەوتوو',
    'service_charge_paid': 'بیگەی خزمەتگوزاری بە سەرکەوتوویی دراوە!',
    'paid_on': 'دراوە لە {{date}}',
    'unpaid': 'نەدراوە',
    'my_agreements': 'گرێبەستەکانم',
    'agreements_subtitle': 'گرێبەستەکانی بەڕێوەبردنی موڵکەکانت پێشترببینە و واژوو بکە.',
    'no_active_agreements': 'هیچ گرێبەستێک نەدۆزراوەتەوە',
    'no_contracts_message': 'ئێستا هیچ گرێبەستێکی تۆمارکراوت نییە. پەیوەندی بە بەڕێوەبەرە بینایەکەت بکە.',
    'management_agreement': 'گرێبەستی بەڕێوەبردن',
    'total_value': 'نرخی کۆ',
    'remaining': 'ئەوەی ماوە',
    'failed_to_load_agreements': 'بارکردنی گرێبەستەکان سەرکەوتوو نەبوو',
    'rent': 'کرێی شوقە',
    'download_pdf': 'داگیرکردنی PDF',
    'generating': 'دروستکردن...',
    'announcements_manager': 'ڕاگەیاندنەکان',
    'announcements_manager_subtitle': 'بڵاوکردنەوە و بەڕێوەبردنی ڕاگەیاندنەکان بۆ بەکارهێنەران، خاوەنانی موڵک، یان بیناکانی دیاریکراو.',
    'new_announcement': 'ڕاگەیاندنی نوێ',
    'publish_announcement': 'بڵاوکردنەوە',
    'publishing': 'بڵاودەکرێتەوە…',
    'all_announcements': 'هەموو ڕاگەیاندنەکان',
    'announcement_created': 'ڕاگەیاندن بە سەرکەوتوویی بڵاوکرایەوە!',
    'announcement_create_failed': 'بڵاوکردنەوە سەرکەوتوو نەبوو.',
    'announcement_deleted': 'ڕاگەیاندن سڕایەوە.',
    'announcement_delete_failed': 'سڕینەوە سەرکەوتوو نەبوو.',
    'announcement_delete_confirm': 'ئەم ڕاگەیاندنە بسڕیتەوە؟ ئەم کردارە گەڕاندنەوەی نییە.',
    'announcement_fields_required': 'سەردێڕ و ناوەڕۆک پێویستن.',
    'announcement_building_required': 'تکایە بینایەک هەڵبژێرە.',
    'announcement_title_placeholder': 'وەک: چاکسازی ئاوی مەودادراو لە دووشەممە',
    'announcement_content_placeholder': 'پەیامەکەت لێرە بنووسە…',
    'target_audience': 'کۆمەڵی ئامانج',
    'audience_all': 'هەموو',
    'audience_tenants': 'تەنها بەکارهێنەران',
    'audience_owners': 'تەنها خاوەنانی موڵک',
    'audience_building': 'بینایەکی دیاریکراو',
    'select_building': 'بینایەک هەڵبژێرە',
    'select_building_placeholder': '— بینایەک هەڵبژێرە —',
    'no_announcements_yet': 'هێشتا هیچ ڕاگەیاندنێک نییە',
    'no_announcements_yet_subtitle': 'کلیک لەسەر "ڕاگەیاندنی نوێ" بکە بۆ ناردنی یەکەمین پەیام.',
    'announcements_owner_subtitle': 'دوایین هەواڵ و نوێکارییەکانی بەڕێوەبەری موڵکەکەت بخوێنەوە.',
    'announcements_check_back': 'دواتر بیسەرەوە بۆ هەواڵ و نوێکارییەکانی بەڕێوەبەرەکەت.',
    'posted_by': 'بڵاوکرایەوە لەلایەن {{name}}',

    // ── ڕاپۆرتی مووچەی بەڕێوەبردن ────────────────────────────────────────────
    'management_fee_report': 'ڕاپۆرتی مووچەی بەڕێوەبردن',
    'management_fee_report_subtitle': 'شوێنکەوتنی وەرگرتنی قیستەکانی خاوەنان و شیکردنەوەی دواکەوتن',
    'ledger_activity_report': 'ڕاپۆرتی چالاکی دەفتەری',
    'ledger_activity_report_subtitle': 'هەموو تۆماری دەفتەری — داواکاری، پارەدان، سزای دواکەوتن، قەرزبخشین و پێشەکی',
    'ledger_type_charge':   'داواکاری',
    'ledger_type_late_fee': 'سزای دواکەوتن',
    'ledger_type_deposit':  'پێشەکی',
    'ledger_type_payment':  'پارەدان',
    'ledger_type_credit':   'قەرزبخشین',
    'ledger_net_balance':   'باڵانسی پێویست',
    'feature_locked': 'تایبەتمەندی قفڵکراوە',
    'mgmt_fee_analytics_required': 'ڕاپۆرتەکانی مووچەی بەڕێوەبردن پلانی ئەنالیتیکسی پێویستە.',
    'upgrade': 'بەرزبکرەوە',
    'year': 'ساڵ',
    'month': 'مانگ',
    'all_months': 'هەموو مانگەکان',
    'all_owners': 'هەموو خاوەنەکان',
    'all_statuses': 'هەموو دۆخەکان',
    'status_paid': 'دراوە',
    'status_pending_upcoming': 'چاوەڕوان (داهاتوو)',
    'status_overdue': 'دواکەوتوو',
    'status_partial': 'بەشداری',
    'status_cancelled_label': 'هەستکراوە',
    'clear_filters': 'فلتەرەکان پاک بکەرەوە',
    'print_pdf': 'چاپ / PDF',
    'export_csv': 'CSV دەرببە',
    'exporting': 'دەردەچێت…',
    'total_expected': 'کۆی چاوەڕوانکراو',
    'total_collected': 'کۆی کۆکراوەتەوە',
    'overdue_balance': 'ماندەی دواکەوتوو',
    'collection_rate': 'ڕێژەی کۆکردنەوە',
    'n_installments': '{{count}} قیست',
    'n_paid': '{{count}} دراوە',
    'n_overdue_installments': '{{count}} قیستی دواکەوتوو',
    'n_upcoming': '{{count}} داهاتوو',
    'monthly_breakdown': 'دابەشکردنی مانگانە — {{year}}',
    'monthly_breakdown_filtered': 'دابەشکردنی مانگانە — {{year}} (فلتەرکراو بۆ {{month}})',
    'chart_expected': 'چاوەڕوانکراو',
    'chart_collected': 'کۆکراوەتەوە',
    'chart_overdue': 'دواکەوتوو',
    'no_installment_data_year': 'هیچ داتایەکی قیستێک بۆ {{year}} نییە',
    'tooltip_expected': 'چاوەڕوانکراو:',
    'tooltip_collected': 'کۆکراوەتەوە:',
    'tooltip_overdue': 'دواکەوتوو:',
    'all_installments': 'هەموو قیستەکان',
    'n_records': '{{count}} تۆمار',
    'n_records_plural': '{{count}} تۆمار',
    'page_of': 'لاپەڕە {{page}}/{{total}}',
    'no_installments_found': 'هیچ قیستێک نەدۆزرایەوە',
    'try_adjusting_filters': 'تکایە فلتەرەکانت بگۆڕە.',
    'col_owner': 'خاوەن',
    'col_apt': 'شوقە',
    'col_building': 'بینا',
    'col_due_date': 'بەرواری دەستبەسەر',
    'col_amount': 'بڕ',
    'col_paid': 'دراوە',
    'col_balance': 'ماندە',
    'col_status': 'دۆخ',
    'col_days_late': 'ڕۆژەکانی دواکەوتن',
    'totals_all_pages': 'کۆی گشتی (هەموو لاپەڕەکان):',
    'previous': '← پێشوو',
    'next': 'دواتر →',
    'page_x_of_y': 'لاپەڕە {{page}} لە {{total}} ({{count}} کۆی گشتی)',
    'overdue_aging_title': 'قیستە دواکەوتوەکان — شیکردنەوەی موددە',
    'col_aging': 'موددەی دواکەوتن',
    'all_installments_up_to_date': 'هەموو قیستەکان نوێیەتەوەن!',
    'no_overdue_found': 'هیچ قیستێکی مووچەی بەڕێوەبردنی دواکەوتوو نەدۆزرایەوە.',
    'total_overdue': 'کۆی دواکەوتوو:',
    'n_days': '{{count}} ڕۆژ',
    'aging_1_30': '١–٣٠ ڕۆژ',
    'aging_31_60': '٣١–٦٠ ڕۆژ',
    'aging_61_90': '٦١–٩٠ ڕۆژ',
    'aging_90_plus': '+٩٠ ڕۆژ',
    'badge_paid': 'دراوە',
    'badge_partial': 'بەشداری',
    'badge_pending': 'چاوەڕوان',
    'badge_overdue': 'دواکەوتوو',
    'badge_cancelled': 'هەستکراوە',
    'failed_to_load_mgmt_fee_report': 'بارکردنی ڕاپۆرتی مووچەی بەڕێوەبردن سەرکەوتوو نەبوو',
    'export_failed': 'دەرچوون شکستی هێنا',
    'export_downloaded_label': 'داونلۆدکرا: {{label}}',

    // Report Templates
    'report_templates': 'ڕێنماییەکانی ڕاپۆرت',
    'report_templates_subtitle': 'ڕێکخستنەکانی ڕاپۆرت کە دەتوانرێتەوە بەکاربهێنرێت دروست بکە و بەڕێوەبەرە.',
    'create_template': 'ڕێنمایی نوێ',
    'create_first_template': 'ڕێنمایی یەکەم دروست بکە',
    'template_name': 'ناوی ڕێنمایی',
    'template_description': 'پێناسە',
    'template_config': 'ڕێکخستن (JSON)',
    'no_templates': 'هیچ ڕێنماییەکی ڕاپۆرت نییە',
    'no_templates_message': 'ڕێکخستنەکانی ڕاپۆرت کە زۆر بەکاردەهێنرێت وەک ڕێنماییەکی بەکارهێنراو ڕزگار بکە.',
    'template_created': 'ڕێنمایی بە سەرکەوتوویی دروست کرا',
    'template_updated': 'ڕێنمایی بە سەرکەوتوویی نوێکراوەتەوە',
    'template_deleted': 'ڕێنمایی سڕایەوە',
    'delete_template_title': 'ڕێنمایی بسڕەوە',
    'delete_template_message': 'دڵنیای لە سڕینەوەی "{{name}}"؟ ئەم کردارە گەڕاندنەوەی نییە.',


    'issue_utility_bill': 'دەرکردنی پسوڵەی خزمەتگوزاری',
    'tenant_billing_assignment': 'دیاریکردنی کرێنشین و پسوڵە',
    'select_tenant': 'هەڵبژاردنی کرێنشین',
    'search_tenant_placeholder': 'گەڕان بەپێی ناو یان ژمارەی شوقە...',
    'utility_details': 'وردەکارییەکانی خزمەتگوزاری',
    'period_month': 'مانگ',
    'period_year': 'ساڵ',
    'due_date': 'ڕێکەوتی کۆتایی',
    'posting_options': 'هەڵبژاردەکانی تۆمارکردن',
    'charge_immediately': 'تۆمارکردنی بڕی پارەکە لە هەمان کاتدا',
    'charge_immediately_desc_on': 'بڕە پارەکە ڕاستەوخۆ دوای پاشەکەوتکردن بۆ هەژماری کرێنشینەکە زیاد دەکرێت.',
    'charge_immediately_desc_off': 'پسوڵەکە وەک "هەڵپەسێردراو" پاشەکەوت دەکرێت و دەبێت دواتر بە دەستی تۆماری بکەیت.',
    'processing': 'خەریکە ئەنجام دەدرێت...',
    'issue_and_charge': 'دەرکردن و تۆمارکردن',
    'issue_bill': 'دەرکردنی پسوڵە',
    'meter_identity_provider': 'ناسنامەی پێوەر و دابینکەر',
    'account_number': 'ژمارەی هەژمار',
    'meter_number': 'ژمارەی پێوەر',
    'shared_meter_rubs': 'پێوەری هاوبەش (دابەشکردنی RUBS)',
    'pricing_unit_measurement': 'نرخ و یەکەی پێوانە',
    'rate_per_unit': 'نرخی هەر یەکەیەک ($)',
    'unit_of_measure': 'یەکەی پێوانە',
    'billing_day_monthly': 'ڕۆژی پسوڵە (مانگانە)',
    'internal_notes': 'تێبینییە ناوخۆییەکان',

    // Utility — edit / void / mark-paid
    'edit_utility_account': 'دەستکاریکردنی ئەکاونتی خزمەتگوزاری',
    'void_bill': 'پووچەڵکردنی پسوڵە',
    'void_reason': 'هۆکار (دەسەڵاتی نییە)',
    'void_reason_placeholder': 'بۆ نموونە: هەڵەی پسوڵەکردن، دووبارەبوون...',
    'confirm_void_bill': 'ئەم پسوڵەیە پووچەڵ دەبێت و ناتوانرێت کرێ لێ وەربگیرێت.',
    'confirm_void_bill_sent': 'ئەم پسوڵەیە پێشتر کرێ لێ وەرگیراوە. تومارێکی کرێدیت دەردەچێت بۆ گەڕاندنەوەی ئەو کرێیە.',
    'bill_voided': 'پسوڵەکە پووچەڵکرا',
    'bill_marked_paid': 'پسوڵەکە وەک پارەدراو نیشانەکرا',
    'confirm_mark_paid': 'ئایا دەتەوێت ئەم پسوڵەیە وەک پارەدراو نیشانە بکەیت (پارەدانی دەرەکی)؟',
    'deactivate_utility_account': 'ئەکاونتەکە ناچالاک بکە',
    'confirm_deactivate_utility_account': 'دڵنیایت کە دەتەوێت ئەم ئەکاونتی خزمەتگوزارییە ناچالاک بکەیت؟',
    'post_utility_charge': 'تۆمارکردنی کرێی خزمەتگوزاری',
    'account_updated': 'ئەکاونتەکە بە سەرکەوتوویی نوێکرایەوە',
    'utility_bill': 'پسووڵەی خزمەتگوزاری',
    'tenant_info': 'بەرێوەبراو',
    'tenant_name_5': 'ناو',
    'email_15': 'ئیمەیڵ',
    'reading_history': 'مێژووی خوێندنەوە',
    'usage_breakdown': 'وردەکاریی بەکارهێنان',
    'previous_reading': 'خوێندنەوەی پێشوو',
    'current_reading': 'خوێندنەوەی ئێستا',
    'view_account': 'بینینی ئەکاونتی خزمەتگوزاری',

    // Currency
    'currency_selector_label': 'دراوی ڕێکخراو',
    'currency_stripe_warning': 'پارەدانی ئەلیکترۆنی لە ڕێگەی Stripe بۆ ئەم دراوە بەردەست نییە. کرێچییەکان دەبێت بە دەستەوە بپارەدەن.',
    'online_payment_unavailable': 'پارەدانی ئەلیکترۆنی بۆ دراوەکەت بەردەست نییە. تکایە بە دەستەوە بپارەدە.',

    // Buildings / Bulk creator
    'units_per_floor': 'یەکەکان بۆ هەر نهۆم',
    'QTY_PER_FLOOR': 'بڕ / نهۆم',
    'qty_per_floor': 'بڕ / نهۆم',
    'SIZE': 'قەبارە',
    'SELECT_FLOORS': 'نهۆمەکان هەڵبژێرە',
    'select_floors': 'نهۆمەکان هەڵبژێرە',
    'BULK_ADD': 'زیادکردنی کۆمەڵانە',
    'bulk_add': 'زیادکردنی کۆمەڵانە',
    'avg_occupancy': 'تێکڕای ناوبژی',
    'total_buildings': 'کۆی بیناکان',

    // Dashboard & Risk Widgets
    'payment_risk': 'مەترسی پارەدان',
    'ai_scored_late_payment': 'ئەگەری دواکەوتنی پارەدان بەپێی زیرەکی دەستکرد',
    'high_risk': 'مەترسی بەرز',
    'medium': 'مامناوەند',
    'low_risk': 'مەترسی نزم',
    'no_scores_yet': 'هێشتا هیچ هەڵسەنگاندنێک نییە. کرتە بکە بۆ نوێکردنەوە.',
    'owed': 'قەرزدارە',
    'view_all_risk_scores': 'بینینی هەموو مەترسییەکان',
    'renewal_risk': 'مەترسی نوێکردنەوە',
    'leases_expiring_90d': 'ئەو گرێبەستانەی لە ٩٠ ڕۆژدا کۆتایی دێن',
    'exp_in_30d': 'کۆتایی دێت لە ٣٠ ڕۆژدا',
    'exp_in_90d': 'کۆتایی دێت لە ٩٠ ڕۆژدا',
    'no_leases_expiring_90d': 'هیچ گرێبەستێک نییە لە ٩٠ ڕۆژی داهاتوودا کۆتایی بێت.',
    'left': 'ماوە',
    'view_all_renewal_risks': 'بینینی هەموو مەترسییەکانی نوێکردنەوە',
    're_run_ai_scoring': 'دووبارە هەڵسەنگاندن بکەوە',

    // User Form
    'invitation_only_onboarding': 'دروستکردنی هەژمار تەنها بە بانگهێشت',
    'invitation_only_onboarding_desc': 'لەبەر هۆکاری ئاسایشی، وشەی تێپەڕ لەلایەن بەڕێوەبەرانەوە دانانرێت. بانگهێشتێکی پارێزراو دەنێردرێت بۆ ئیمەیڵی بەکارهێنەر بۆ ئەوەی خۆیان هەژمار و وشەی تێپەڕیان دابنێن.',
    'user_created_email_failed': 'هەژمار دروستکرا بۆ ',
    'user_created_email_failed_2': '، بەڵام ',
    'invitation_email_could_not_be_sent': 'نەتوانرا ئیمەیڵی بانگهێشت بنێردرێت',
    'user_created_email_failed_3': ' بەهۆی کێشەی سێرڤەرەوە.',
    'manual_onboarding_link': 'بەستەری دروستکردنی هەژمار',
    'manual_onboarding_desc': 'تکایە ئەم بەستەرە کۆپی بکە و بینێرە بۆ بەکارهێنەر بۆ ئەوەی وشەی تێپەڕیان دابنێن:',
    'link_copied_to_clipboard': 'بەستەر کۆپیکرا!',
    'copy_link': 'کۆپیکردنی بەستەر',
    'done': 'تەواو',
    'add_another_user': 'زیادکردنی بەکارهێنەری تر',

    // Apartment List
    'furnished_apartment': 'شوقەی مۆبیلیاتدار',
    'multiple_leases': 'چەندین گرێبەستی کرێ',
    'manage': 'بەڕێوەبردن',
    'delete_apartment': 'سڕینەوەی شوقە',

    // --- HIGH-QUALITY MANUAL TRANSLATIONS ---
    'total_properties': 'کۆی موڵکەکان',
    'active_properties': 'موڵکە چالاکەکان',
    'active_tenants': 'کرێچییە چالاکەکان',
    'monthly_revenue': 'داهاتی مانگانە',
    'pending_payments': 'پارەدانە هەڵپەسێردراوەکان',
    'lease_expiring_soon': 'ئەو گرێبەستانەی بەمزوانە کۆتاییان دێت',
    'payment_risk': 'مەترسی پارەدان',
    'ai_scored_late_payment': 'ئەگەری دواکەوتنی پارەدان (بە زیرەکی دەستکرد)',
    'high_risk': 'مەترسی بەرز',
    'medium_risk': 'مەترسی مامناوەند',
    'low_risk': 'مەترسی نزم',
    'no_scores_yet': 'تا ئێستا هیچ هەڵسەنگاندنێک نییە. کرتە بکە بۆ تازەکردنەوە.',
    'renewal_risk': 'مەترسی نوێکردنەوە',
    'leases_expiring_in_90_days': 'ئەو گرێبەستانەی لە ٩٠ ڕۆژدا کۆتاییان دێت',
    'exp_in_30d': 'کۆتایی دێت لە ٣٠ ڕۆژدا',
    'exp_in_90d': 'کۆتایی دێت لە ٩٠ ڕۆژدا',
    'no_leases_expiring_90d': 'هیچ گرێبەستێک لە ٩٠ ڕۆژی داهاتوودا کۆتایی نایەت.',
    'leasing_office': 'ئۆفیسی بەکرێدان',
    'marketing_links': 'بەستەرەکانی بەبازاڕکردن',
    'bulk_import': 'هاوردەکردنی بەکۆمەڵ',
    'evictions': 'دەرکردنەکان',
    'accounting': 'ژمێریاری',
    'payments': 'پارەدانەکان',
    'portfolio_kpis': 'پۆرتفۆلیۆ و نیشاندەرەکان',
    'bulk_comms': 'نامەی بەکۆمەڵ',
    'email_templates': 'قاڵبەکانی ئیمەیڵ',
    'building_view': 'بینینی باڵەخانە',
    'failed_to_load_logs': 'داگرتنی تۆمارەکانی چالاکی سەرکەوتوو نەبوو',
    'export_failed': 'هەناردەکردنی تۆمارەکان سەرکەوتوو نەبوو',
    'all_user_activities_desc': 'چاودێری هەموو کار و ڕووداوەکانی سیستم بکە',
    'search_logs': 'گەڕان لە تۆمارەکان...',
    'entries': 'تۆمار',
    'filter_activities': 'پاڵاوتنی چالاکییەکان',
    'action_type': 'جۆری کردار',
    'all_actions': 'هەموو کردارەکان',
    'entity_type': 'جۆری قەوارە',
    'all_types': 'هەموو جۆرەکان',
    'start_date': 'ڕێکەوتی دەستپێک',
    'end_date': 'ڕێکەوتی کۆتایی',
    'reset': 'ڕێستکردنەوە',
    'apply_filter': 'جێبەجێکردنی پاڵاوتن',
    'time': 'کات',
    'user': 'بەکارهێنەر',
    'action': 'کردار',
    'entity': 'قەوارە',
    'details': 'وردەکارییەکان',
    'amount': 'بڕ',
    'no_logs_matching_search': 'هیچ تۆمارێک هاوتا نییە لەگەڵ گەڕانەکەت.',
    'no_logs_available': 'هیچ تۆمارێکی چالاکی بەردەست نییە.',
    'showing_range': 'پیشاندانی {{start}} بۆ {{end}} لە {{total}}',
    'previous': 'پێشوو',
    'next': 'دواتر',
    'exporting': 'هەناردە دەکرێت...',
    'export': 'هەناردەکردن',
    'filter': 'پاڵاوتن',
    'activity_logs': 'تۆمارەکانی چالاکی',
    'invitation_only_onboarding': 'چوونەژوورەوە تەنها بە بانگهێشتنامە',
    'approve_payment_msg': 'دڵنیایت دەتەوێت ئەم پارەدانە پەسەند بکەیت؟',
    'reject_payment_msg': 'تکایە هۆکارێک بۆ ڕەتکردنەوەی ئەم پارەدانە بنووسە.',
    'errors_serverError': 'هەڵەی ناوخۆیی سێرڤەر',
    'timePeriods_month': 'مانگ',
    'timePeriods_quarter': 'چارەک',
    'timePeriods_year': 'ساڵ',
    'common_startDate': 'ڕێکەوتی دەستپێک',
    'common_endDate': 'ڕێکەوتی کۆتایی',
    'common_type': 'جۆر',
    'common_all': 'هەموو',
    'common_tenant': 'کرێچی',

  
  
  
    // Auto-added translations
    'ai_greeting': 'ئای سڵاو',
    'overdue_tenants_q': 'کرێچییە دواکەوتووەکان پ',
    'revenue_30d_q': 'داهات 30d پ',
    'expenses_month_q': 'مانگی خەرجییەکان پ',
    'utility_pending_q': 'سوودمەندی چاوەڕوانکراو پ',
    'kpi_noi_summary_q': 'Kpi Noi پوختە پ',
    'security_deposits_q': 'پارەی زەمانەت پ',
    'late_fees_q': 'کرێی درەنگ پ',
    'owner_payouts_q': 'پارەدانی خاوەنکار پ',
    'ai_error': 'هەڵەی ئای',
    'ai_assistant': 'یاریدەدەری ئای',
    'analyzing_data': 'شیکردنەوەی داتاکان',
    'ai_placeholder': 'Ai شوێنگرەوە',
    'sales': 'فرۆشتن',
    'sales_management': 'بەڕێوەبردنی فرۆشتن',
    'inspections': 'پشکنینەکان',
    'all_inspections': 'هەموو پشکنینەکان',
    'violations': 'سەرپێچیەکان',
    'notices': 'ئاگادارکردنەوەکان',
    'screening': 'سکرینکردن',
    'lease_applications': 'داواکاری بەکرێدان',
    'lease_renewals': 'نوێکردنەوەی بەکرێدان',
    'amenities_parking': 'خزمەتگوزارییەکان وەستانی ئۆتۆمبێل',
    'building_amenities': 'خزمەتگوزاری بیناسازی',
    'parking_spaces': 'شوێنی وەستانی ئۆتۆمبێل',
    'amenity_bookings': 'حجزکردنی ئاسانکاری',
    'pm_schedules': 'خشتەکانی Pm',
    'work_orders': 'فەرمانی کارکردن',
    'vendors': 'فرۆشیاران',
    'transactions': 'مامەڵەکان',
    'service_charges': 'پارەی خزمەتگوزاری',
    'late_fees': 'کرێی دواکەوتن',
    'security_deposits': 'پارەی زەمانەت',
    'bulk_owner_payout': 'پارەدانی خاوەن بەکۆمەڵ',
    'owner_installments': 'قیستی خاوەنکار',
    'expenses': 'خەرجییەکان',
    'general_ledger': 'کتێبی گشتی',
    'financial_matrix': 'ماتریکسی دارایی',
    'cash_flow_forecast': 'پێشبینی ڕۆیشتنی پارە',
    'receivables': 'قەرزە وەرگیراوەکان',
    'receivables_sub': 'ئەو پارەیەی قەرزتە، بەپێی درەنگی.',
    'no_receivables': 'کەس هیچ قەرزی نییە.',
    'books_need_attention': 'دەفتەرەکان پێویستیان بە سەرنجە',
    'books_tie_out': 'وەرگرتنەکان لەگەڵ دەفتەری گشتیدا دەگونجێن',
    'ar_gl_drift': 'وەرگرتنەکان لەگەڵ دەفتەری گشتیدا ناگونجێن',
    'unmirrored_charges': 'باجەکان',
    'unmirrored_payments': 'پارەدانەکان',
    'not_in_receivables': 'هێشتا لە وەرگرتنەکاندا نین',
    'closed_periods': 'ماوە(کان)ی داخراو',
    'fix_now': 'ئێستا چاکبکە',
    'fixing': 'چاکدەکرێت…',
    'accounting_statement': 'ڕاپۆرتی حساب ←',
    'statement': 'ڕاپۆرتی حساب',
    'open_full_record': 'کردنەوەی تۆمارە تەواوەکە ←',
    'credit_on_account': 'باڵانسی داهات لە حساب',
    'opening_balance': 'باڵانسی کردنەوە',
    'closing_balance': 'باڵانسی داخستن',
    'no_activity': 'هیچ چالاکییەک نییە لەم ماوەیەدا.',
    'charge': 'بڕی داواکراو',
    'kind_rent': 'کرێ',
    'kind_service': 'کرێی خزمەتگوزاری',
    'kind_late_fee': 'کرێی درەنگکەوتن',
    'kind_utility': 'خزمەتگوزارییەکان',
    'kind_parking': 'شوێنی ئۆتۆمبێل',
    'kind_deposit': 'دەپۆزیت',
    'kind_sale_installment': 'قیستی فرۆشتن',
    'kind_management_fee': 'کرێی بەڕێوەبردن',
    'kind_maintenance_fee': 'کرێی چاکسازی',
    'kind_payment': 'پارەدان',
    'utilities': 'خزمەتگوزارییەکان',
    'kpi_dashboard': 'داشبۆردەکەی Kpi',
    'portfolio': 'پۆرتفۆلیۆ',
    'reports_1099': 'ڕاپۆرتەکان 1099',
    'all_messages': 'هەموو پەیامەکان',
    'whatsapp_and_sms': 'واتس ئەپ و Sms',
    'late_fees_org_config': 'درەنگ کرێ Org Config',
    'unpaid_balance': 'باڵانسی نەدراو',
    'lease_period': 'ماوەی بەکرێدان',
    'balance': 'هاوسەنگی',
    'view_record': 'بینینی تۆمار',
    'apartment_created_successfully': 'شوقە بە سەرکەوتوویی دروستکرا',
    'apartment_updated_successfully': 'شوقە بە سەرکەوتوویی نوێکرایەوە',
    'manage_your_properties': 'بەڕێوەبردنی موڵکەکانت',
    'add_your_first_apartment': 'یەکەم شوقەت زیاد بکە',
    'filter_apartments': 'شوقە فلتەرەکان',
    'no_matching_apartments_message': 'هیچ پەیامێکی شوقەی هاوتا نییە',
    'select_at_least_one_floor': 'بەلایەنی کەمەوە یەک نهۆم هەڵبژێرە',
    'add_at_least_one_unit_type': 'بەلایەنی کەمەوە یەک جۆری یەکە زیاد بکە',
    'apartments_created': 'شوقە دروستکراوە',
    'skipped_duplicates': 'دووبارەبووەکانی بەجێهێشتووە',
    'apartments_created_successfully': 'شوقە بە سەرکەوتوویی دروستکرا',
    'error_creating_apartments': 'هەڵە لە دروستکردنی شوقە',
    'clear': 'ڕوونە',
    'select_floors_and_types': 'نهۆم و جۆرەکان هەڵبژێرە',
    'future_tenant_only': 'تەنها کرێچی داهاتوو',
    'converted': 'گۆڕاو',
    'confirmed': 'پشتڕاستکراوەتەوە',
    'hold': 'ڕاگرتن',
    'failed_confirm_booking': 'شکستی هێنا پشتڕاستکردنەوەی حجزکردن',
    'failed_cancel_booking': 'شکستی هێنا هەڵوەشاندنەوەی حجزکردن',
    'failed_convert_tenant': 'گۆڕینی کرێچی شکستی هێنا',
    'converted_to_tenant': 'گۆڕاوە بۆ کرێچی',
    'hold_expired': 'ڕاگرتن بەسەرچووە',
    'booking_created': 'حجزکردن دروستکراوە',
    'failed_save_booking': 'شکستی هێنا پاشەکەوتکردنی حجزکردن',
    'failed_load_bookings': 'شکستی هێنا بارکردنی حجزەکان',
    'building_created_successfully': 'بینا بە سەرکەوتوویی دروستکراوە',
    'building_updated_successfully': 'بینا بە سەرکەوتوویی نوێکرایەوە',
    'current': 'ئێستا',
    'financial_status': 'دۆخی دارایی',
    'occupancy_physical': 'داگیرکردن فیزیکی',
    'unit_indicators': 'نیشاندەری یەکە',
    'furnished_unit': 'یەکەی مۆبیلیات',
    'expired_label': 'لیبێڵی بەسەرچوو',
    'lease_expired_short': 'بەکرێدان بە کورتی بەسەرچوو',
    'building_has_no_apartments': 'بینایەک شوقەی نییە',
    'add_apartments_hint': 'زیادکردنی شوقە ئاماژە',
    'due': 'بەهۆی...',
    'contract_type': 'جۆری گرێبەست',
    'description': 'وەسف',
    'cash_flow_subtitle': 'ژێرنووسی ڕۆیشتنی پارە',
    'next_7_days': '٧ ڕۆژی داهاتوو',
    'next_14_days': '١٤ ڕۆژی داهاتوو',
    'next_30_days': '٣٠ ڕۆژی داهاتوو',
    'expected_this_period': 'چاوەڕوانکراو ئەم ماوەیە',
    'total_overdue_balance': 'کۆی گشتی باڵانسی دواکەوتوو',
    'collected_today': 'ئەمڕۆ کۆکراوەتەوە',
    'no_upcoming_payments': 'هیچ پارەیەکی داهاتوو نییە',
    'overdue_label': 'لەیبڵی دواکەوتوو',
    'expected_label': 'لیبێڵی چاوەڕوانکراو',
    'view_arrow': 'بینینی تیر',
    'jan_short': 'یان شۆرت',
    'feb_short': 'شوبات کورت',
    'mar_short': 'مار شۆرت',
    'apr_short': 'نیسان کورتە',
    'may_short': 'مای شۆرت',
    'jun_short': 'جون شۆرت',
    'jul_short': 'Jul شۆرت',
    'aug_short': 'ئاب کورتە',
    'sep_short': 'سێپ شۆرت',
    'oct_short': 'ئۆکتۆبەر کورتە',
    'nov_short': 'نۆڤەمبەر کورت',
    'dec_short': 'دیس شۆرت',
    'search_unit_tenant': 'گەڕان بە کرێچی یەکەی',
    'no_results_for_filters': 'هیچ ئەنجامێک بۆ فلتەرەکان نییە',
    'no_apartments_found_building': 'هیچ شوقەیەک نەدۆزراوەتە��ە بینا',
    'quick_pay': 'Quick Pay',
    'charged': 'بارگاوی کراوە',
    'method': 'شێواز',
    'bank': 'بانک',
    'cheque': 'پشکنین بکە',
    'stripe': 'هێڵکاری',
    'failed_to_load_revenue': 'شکستی هێنا لە بارکردنی داهات',
    'no_tenant_logs': 'هیچ لۆگێکی کرێچی نییە',
    'payment_record_error': 'هەڵەی تۆماری پارەدان',
    'contract_not_found': 'گرێبەست نەدۆزراوەتەوە',
    'back_to_owner': 'گەڕانەوە بۆ خاوەنەکەی',
    'contract_details': 'وردەکاری گرێبەستەکە',
    'contract_id': 'ناسنامەی گرێبەست',
    'summary_info': 'زانیاری پوخ��ە',
    'n_a': 'ن ئەی',
    'paid_progress': 'پێشکەوتنی پارەدار',
    'total_installments': 'کۆی گشتی قیستەکان',
    'paid_installments': 'قیستی پارەدار',
    'pending_installments': 'قیستی چاوەڕوانکراو',
    'legal_document': 'بەڵگەنامەی یاسایی',
    'signatures': 'واژۆکردن',
    'owner_signature': 'واژۆی خاوەنکار',
    'awaiting_owner_signature': 'چاوەڕوانی واژۆی خاوەنکارە',
    'admin_signature': 'واژۆی بەڕێوەبەر',
    'awaiting_admin_signature': 'چاوەڕوانی واژۆی ئەدمین',
    'installment_schedule': 'خشتەی قیست',
    'paid_amount': 'بڕی پارە دراو',
    'save_payment': 'پاشەکەوتکردنی پارەدان',
    'add_contract': 'گرێبەست زیاد بکە',
    'language': 'زمان',
    'exportPDF': 'هەناردەکردنی PDF',
    'print': 'چاپ',
    'receiptNo': 'پسوڵەی ژمارە 10',
    'contractDetails': 'وردەکاری گرێبەستەکە',
    'contractNo': 'گرێبەستی ژمارە 10',
    'contractType': 'جۆری گرێبەست',
    'startDate': 'بەرواری دەستپێکردن',
    'endDate': 'بەرواری کۆتایی',
    'openEnded': 'کۆتایی کراوە',
    'financialSummary': 'پوختەی دارایی',
    'totalValue': 'بەهای کۆی گشتی',
    'totalPaid': 'کۆی گشتی پارەدار',
    'balanceDue': 'باڵانس Due',
    'installments': 'قیستەکان',
    'installmentSchedule': 'خشتەی قیست',
    'dueDate': 'بەرواری کۆتایی هاتنی',
    'paidAmt': 'پارەدار Amt',
    'paymentDate': 'بەرواری پارەدان',
    'paidWatermark': 'واتەرمارکی پارەدار',
    'paymentDetails': 'وردەکاری پارەدان',
    'installmentNo': 'قیستی ژمارە 10',
    'amountDue': 'بڕی پارە کە دەبێ بدرێت',
    'amountPaid': 'بڕی دراو',
    'paymentStatus': 'دۆخی پارەدان',
    'paymentConfirmed': 'پارەدان پشتڕاست کراوەتەوە',
    'awaitingPayment': 'چاوەڕوانی پارەدان',
    'balanceRemaining': 'هاوسەنگی ماوەتەوە',
    'authorizedSig': 'ڕێگەپێدراو سیگ',
    'ownerSig': 'خاوەنی سیگ',
    'generatedBy': 'دروستکراوە لەلایەن',
    'informationalOnly': 'تەنها زانیاری',
    'failed_to_load_owner_data': 'شکستی هێنا لە بارکردنی داتای خاوەنەکەی',
    'sending': 'ناردن',
    'payment_reminder_message': 'پەیامی بیرخستنەوەی پارەدان',
    'reminder_sent_success': 'بیرخستنەوە سەرکەوتنی نێردراوە',
    'failed_to_send_reminder': 'شکستی هێنا لە ناردنی بیرخستنەوە',
    'owner_has_no_email': 'خاوەنەکەی هیچ ئیمەیڵێکی نییە',
    'portal_invitation_sent_successfully': 'بانگهێشتی پۆرتاڵ بە سەرکەوتوویی نێردراوە',
    'failed_to_send_portal_invite': 'شکستی هێنا لە ناردنی بانگهێشتی پۆرتاڵ',
    'owner_not_found': 'خاوەنەکەی نەدۆزراوەتەوە',
    'resident_owner': 'خاوەنی نیشتەجێ',
    'total_income': 'کۆی گشتی داهات',
    'contracts': 'گرێبەستەکان',
    'residence': 'شوێنی نیشتەجێبوون',
    'does_not_live_on_property': 'لەسەر موڵک و ماڵی ناژی',
    'outstanding_fees_note': 'تێبینی کرێی نەدراو',
    'owner_contracts': 'گرێبەستی خاوەنکار',
    'no_contracts_found': 'هیچ گرێبەستێک نەدۆزراوەتەوە',
    'pending_signature': 'چاوەڕوانی واژۆکردن',
    'fully_executed': 'بە تەواوی جێبەجێ کراوە',
    'draft': 'ڕەشنووسی',
    'error_loading_financials': 'هەڵە لە بارکردنی داراییەکان',
    'due_soon': 'بەم زووانە بڕیارە',
    'management_fees': 'کرێی بەڕێوەبردن',
    'owner_updated_successfully': 'خاوەنەکەی بە سەرکەوتوویی نوێکرایەوە',
    'invitation_sent': 'بانگهێشتنامە نێردراوە',
    'invitation_failed': 'بانگهێشتنامە شکستی هێنا',
    'owner_created_successfully': 'خاوەنەکەی بە سەرکەوتوویی دروستکراوە',
    'preferred_language': 'زمانی پەسەندکراو',
    'english': 'ئینگلیزی',
    'arabic': 'عەرەبی',
    'kurdish': 'کوردی',
    'drop_here': 'لێرە دابەزێنە',
    'failed_to_load_owners_data': 'شکستی هێنا لە بارکردنی داتای خاوەنەکان',
    'connection_error': 'هەڵەی پەیوەندیکردن',
    'failed_to_delete_owner': 'شکستی هێنا لە سڕینەوەی خاوەنەکەی',
    'failed_to_delete_owners': 'شکستی هێنا لە سڕینەوەی خاوەنەکان',
    'hide_apartments': 'شوقە شاردنەوە',
    'show_apartments': 'شوقەکان پیشان بدە',
    'apartments_count': 'ژمارەی شوقەکان',
    'edit_owner': 'دەستکاری خاوەنی',
    'delete_owner': 'خاوەنی بسڕەوە',
    'occupied_lowercase': 'پیتی بچووکی داگیرکراو',
    'confirm_bulk_delete_title': 'ناونیشانی سڕینەوەی بەکۆمەڵ پشتڕاست ��کەرەوە',
    'refresh_owners': 'خاوەنەکانی نوێ بکەرەوە',
    'delete_selected_owners': 'خاوەن هەڵبژێردراوەکان بسڕەوە',
    'export_to_pdf': 'هەناردەکردن بۆ Pdf',
    'print_owners': 'خاوەن چاپەکان',
    'min_zero': 'کەمترین سفر',
    'count_formatted': 'ژمارە فۆرمات کراوە',
    'most_popular': 'زۆرترین باو',
    'trial': 'دادگاییکردن',
    'past_due': 'کات بەسەرچوو',
    'canceled': 'هەڵوەشایەوە',
    'invalid_plan_selected': 'پلانی نادروست هەڵبژێردرا',
    'could_not_start_checkout': 'نەتوانرا دەست بە کۆکردنەوە بکات',
    'checkout_failed': 'کۆتایی هاتنی پارە شکستی هێنا',
    'could_not_open_portal': 'نەتوانرا پۆرتاڵ بکرێتەوە',
    'failed_to_open_portal': 'شکستی هێنا لە کردنەوەی پۆرتاڵ',
    'payment_approved_success': 'سەرکەوتنی پەسەندکراوی پارەدان',
    'failed_to_approve_payment': 'شکستی هێنا لە پەسەندکردنی پارەدان',
    'provide_rejection_reason': 'هۆکاری ڕەتکردنەوە دابین بکە',
    'payment_rejected': 'پارەدان ڕەتکرایەوە',
    'failed_to_reject_payment': 'شکستی هێنا لە ڕەتکردنەوەی پارەدان',
    'stripe_connected': 'شریت پەیوەست کراوە',
    'yr': 'Yr',
    'mo': 'مۆ',
    'expires': 'بەسەر دەچێت',
    'renews': 'نوێ دەکاتەوە',
    'opening': 'کردنەوەی',
    'stripe_portal_title': 'ناونیشانی پۆرتاڵی ستڕایپ',
    'stripe_portal_desc': 'Stripe Portal Desc',
    'monthly': 'مانگانە',
    'annual': 'ساڵانە',
    'redirecting': 'ئاڕاستەکردنەوە',
    'stripe_secure_notice': 'ئاگاداری پارێزراوی ستڕایپ',
    'organization': 'ڕێکخستن',
    'approve_payment': 'پەسەندکردنی پارەدان',
    'approve': 'پەسەند بکە',
    'reject_payment': 'ڕەتکردنەوەی پارەدان',
    'reject': 'ڕەتکردنەوە',
    'errors.serverError': 'هەڵەی سێرڤەر',
    'export_excel': 'هەناردەکردنی ئێکسڵ',
    'timePeriods.month': 'مانگ',
    'timePeriods.quarter': 'چارەکێک',
    'timePeriods.year': 'ساڵ',
    'common.startDate': 'بەرواری دەستپێکردن',
    'common.endDate': 'بەرواری کۆتایی',
    'common.type': 'جۆر',
    'common.all': 'هەموو...',
    'common.tenant': 'کرێچی',
    'common.searchTenant': 'گەڕان بە کرێچی',
    'ledgerReport.netBalance': 'باڵانسی پاک',
    'ledgerReport.entries': 'بەشدارییەکان',
    'common.noData': 'بێ داتا',
    'common.date': 'بەروار',
    'common.building': 'بینا',
    'common.apartment': 'شوقە',
    'common.description': 'وەسف',
    'common.amount': 'بڕی',
    'ledgerReport.balanceAfter': 'هاوسەنگی دوای...',
    'ledgerReport.createdBy': 'دروستکراوە لەلایەن...',
    'common.page': 'پەیج',
    'metric': 'میتریک',
    'value': 'بەها',
    'failed_to_export': 'شکستی هێنا لە هەناردەکردن',
    'select_date_range': 'مەودای بەروار هەڵبژێرە',
    'revenue_deep_dive_restricted': 'داهات Deep Dive سنووردارە',
    'showing_building_revenue': 'پیشاندانی داهاتی بیناسازی',
    'showing_owner_revenue': 'پیشاندانی داهاتی خاوەنکار',
    'showing_monthly_revenue': 'پیشاندانی داهاتی مانگانە',
    'receiptTitle': 'ناونیشانی پسوڵە',
    'receiptDate': 'بەرواری وەرگرتن',
    'residentName': 'ناوی نیشتەجێ',
    'servicePeriod': 'ماوەی خزمەتگوزاری',
    'signature': 'واژۆ',
    'responsible': 'بەرپرسیار',
    'thankYou': 'سوپاس بۆ ئێوەی بەڕێز',
    'invalid_amount': 'بڕی نادروست',
    'payment_generated_successfully': 'پارەدان بە سەرکەوتوویی دروست بووە',
    'failed_to_generate_payment': 'شکستی هێنا لە دروستکردنی پارەدان',
    'no_owner': 'بێ خاوەن',
    'rented': 'بەکرێ گیراوە',
    'payer': 'پارەدەر',
    'failed_to_load_service_data': 'شکستی هێنا لە بارکردنی داتاکانی خزمەتگوزاری',
    'records': 'تۆمارەکان',
    'no_matching_payments_found': 'هیچ پارەیەکی هاوتا نەدۆزراوەتەوە',
    'paid_count': 'ژمارەی پارەدار',
    'unpaid_count': 'ژمارەی بێ مووچە',
    'no_data_to_export': 'هیچ داتایەک نییە بۆ هەناردەکردن',
    'export_successful': 'هەناردەکردن سەرکەوتوو بوو',
    'months_with_data': 'مانگەکان بە داتا',
    'data_refreshed_successfully': 'داتاکان بە سەرکەوتوویی نوێ کرایەوە',
    'payment_marked_as_paid': 'پارەدان بە سەرکەوتوویی وەک دراو نیشانەکرا',
    'payment_marked_as_unpaid': 'پارەدان بە سەرکەوتوویی وەک نەدراو نیشانەکرا',
    'rented': 'کرێدراو',
    'service_charge_deleted': 'کرێی خزمەتگوزاری بە سەرکەوتوویی سڕایەوە',
    'failed_to_delete_service_charge': 'سڕینەوەی کرێی خزمەتگوزاری شکستی هێنا',
    'service_payment_note_default': 'پارەدانی خزمەتگوزاری بۆ {{month}} {{year}}',
    'failed_init_stripe': 'Init Stripe شکستی هێنا',
    'refresh_status': 'دۆخی نوێکردنەوە',
    'failed_to_load_user_data': 'شکستی هێنا لە بارکردنی داتای بەکارهێنەر',
    'error_updating_profile': 'هەڵە لە نوێکردنەوەی پڕۆفایلی',
    'error_updating_password': 'هەڵە لە نوێکردنەوەی وشەی نهێنی',
    'manage_your_account_and_system_preferences': 'بەڕێوەبردنی ئەکاونتەکەت و هەڵبژاردەکانی سیستەمەکەت',
    'error_from_server': 'هەڵە لە سێرڤەرەوە',
    'nameLabel': 'ناو لیبێڵ',
    'floorPre': 'نهۆمی پێش',
    'aptPre': 'Apt Pre',
    'periodLabel': 'ناوی ماوەی',
    'officeCommission': 'کۆمیسیۆنی فەرمانگە',
    'invalid_date': 'بەرواری نادروست',
    'tenant_has_no_email': 'کرێچی هیچ ئیمەیڵێکی نییە',
    'portal_invitation_failed': 'بانگهێشتی پۆرتاڵ شکستی هێنا',
    'lease_extended_success': 'سەرکەوتنی درێژکراوەی بەکرێدان',
    'failed_to_extend_lease': 'شکستی هێنا لە درێژکردنەوەی بەکرێدان',
    'lease_renewed_success': 'سەرکەوتنی نوێبوونەوەی بەکرێدان',
    'failed_to_renew_lease': 'شکستی هێنا لە نوێکردنەوەی بەکرێدان',
    'ending_lease': 'کۆتایی هێنان بە بەکرێدان',
    'extend_lease': 'درێژکردنەوەی بەکرێدان',
    'renew_lease': 'نوێکردنەوەی بەکرێدان',
    'french': 'فەرەنسی',
    'german': 'ئەڵمانی',
    'italian': 'ئیتاڵی',
    'no_additional_fees': 'بێ هیچ پارەیەکی زیادە',
    'electronic_signature': 'واژۆی ئەلیکترۆنی',
    'no_maintenance_requests_message': 'هیچ پەیامێکی داواکاری چاککردنەوە نییە',
    'add_first_request': 'داواکاری یەکەم زیاد بکە',
    'select_option': 'Option هەڵبژێرە',
    'tenant_updated_successfully': 'کرێچی بە سەرکەوتوویی نوێکرایەوە',
    'tenant_created_successfully': 'کرێچی بە سەرکەوتوویی دروست کراوە',
    'no_phone': 'بێ مۆبایل',
    'not_assigned': 'تەرخان نەکراوە',
    'financial_details': 'وردەکاری دارایی',
    'search_tenants_by_name_phone_or_apartment': 'گەڕان بە کرێچیەکان بە ناو تەلەفۆن یان شوقە',
    'more_info': 'زانیاری زیاتر',
    'apartment_specs': 'تایبەتمەندی شوقە',
    'hide_inactive_users': 'شاردنەوەی بەکارهێنەرانی ناچالاک',
    'show_inactive_users': 'بەکارهێنەرانی ناچالاک پیشان بدە',
    'error_loading_users': 'هەڵە لە بارکردنی بەکارهێنەران',
    'no_users_message': 'هیچ پەیامێکی بەکارهێنەران نییە',
    'create_first_user': 'یەکەم بەکارهێنەر دروست بکە',
    'spanish': 'ئیسپانی',
    'sms_sent_to': 'Sms Sent To',
    'sms_failed': 'کورتەنامە شکستی هێنا',
    'request_failed': 'داواکاری شکستی هێنا',
    'via_twilio': 'لە ڕێگەی تویلیۆوە',
    'no_recipients_match': 'هیچ یەکسانبوونی وەرگرەکان',
    'on': 'لەسەر',
    'off': 'کوژاوەتەوە',
    'loading_units': 'یەکەکانی بارکردن',
    'listed_rent': 'کرێی ڕیزبەندی',
    'portfolio_occupancy': 'داگیرکردنی پۆرتفۆلیۆ',
    'avg_renewal_increase': 'زیادبوونی تێکڕای نوێکردنەوە',
    'title': 'ناونیشان',
    'content': 'ناوەڕۆک',
    'marketing_links_desc': 'بەستەرەکانی بازاڕکردن Desc',
    'days': 'ڕۆژان',
    'download_failed': 'داگرتن شکستی هێنا',
    'run_report': 'ڕاپۆرتی بەڕێوەبردن',
    'downloading': 'دابەزاندن',
    'total_ar': 'کۆی گشتی Ar',
    'total_balance': 'کۆی گشتی باڵانس',
    'no_outstanding_balances_found': 'هیچ باڵانسێکی نەدۆزراوەتەوە',
    'totals': 'کۆی گشتی',
    'subject_body_required': 'جەستەی بابەت پێویستە',
    'no_active_tenants': 'بێ کرێچی چالاک',
    'confirm_send_bulk': 'پشتڕاستکردنەوەی ناردنی بەکۆمەڵ',
    'message_sent_to_tenants': 'پەیامێک بۆ کرێچییەکان نێردراوە',
    'bulk_communications': 'پەیوەندییە بەکۆمەڵەکان',
    'message_sent_successfully': 'پەیامێک بە سەرکەوتوویی نێردراوە',
    'in_app_announcement': 'لە ڕاگەیاندنی ئەپدا',
    'dismiss': 'دەرکردن',
    'target_building': 'بینای ئامانج',
    'all_buildings_count': 'هەموو بیناکان ژمارە',
    'compose_message': 'پێکهێنانی پەیام',
    'subject': 'بابەت',
    'message_body': 'جەستەی پەیام',
    'markdown_hint': 'ئاماژەی مارکداون',
    'characters': 'کارەکتەرەکان',
    'delivery_channels': 'کەناڵەکانی گەیاندن',
    'email_blast': 'تەقینەوەی ئیمەیڵ',
    'send_to_tenants': 'بنێرە بۆ کرێچییەکان',
    'bulk_guidelines': 'ڕێنماییەکانی بەکۆمەڵ',
    'in_app_announcements': 'لە ڕاگەیاندنەکانی ئەپدا',
    'in_app_desc': 'لە App Desc',
    'email_blasts': 'تەقینەوەی ئیمەیڵ',
    'email_blast_desc': 'ئیمەیڵ تەقینەوە Desc',
    'send_immediate_desc': 'ناردنی دەستبەجێ Desc',
    'professional_desc': 'پیشەیی Desc',
    'failed_to_load_owner_balances': 'شکستی هێنا لە بارکردنی باڵانسی خاوەنکار',
    'bulk_payout_success': 'سەرکەوتنی پارەدانی بەکۆمەڵ',
    'bulk_payout_failed': 'پارەدانی بەکۆمەڵ شکستی هێنا',
    'select_at_least_one_owner': 'بەلایەنی کەمەوە یەک خاوەن هەڵبژێرە',
    'bulk_payout_subtitle': 'ژێرنووسی پارەدانی بەکۆمەڵ',
    'total_owed_all': 'کۆی گشتی قەرزدار هەموو',
    'owners_with_balance': 'خاوەنەکان لەگەڵ باڵانس',
    'selected_to_pay': 'ه��ڵبژێردرا بۆ پارەدان',
    'owner_balances': 'باڵانسی خاوەنکار',
    'deselect_all': 'All هەڵبژێرە',
    'select_all': 'هەموو هەڵبژێرە',
    'balance_owed': 'باڵانسی قەرزدار',
    'last_payout': 'دوا پارەدان',
    'notes_optional': 'تێبینیەکان ئیختیارییە',
    'payout_notes_placeholder': 'تێبینییەکانی پارەدان شوێنگر',
    'pay_owners_btn': 'Pay Owners Btn',
    'last_batch_results': 'ئەنجامی کۆتا وەجبە',
    'confirm_bulk_payout_title': 'پشتڕاستکردنەوەی پارەدانی بەکۆمەڵ',
    'confirm_bulk_payout': 'پشتڕاستکردنەوەی پارەدانی بەکۆمەڵ',
    'pay': 'پارە بدە',
    'error_loading_churn_data': 'هەڵە لە بارکردنی داتاکانی Churn',
    'running_scoring': 'ڕاکردن گۆڵکردن',
    'scored_tenants': 'کرێچییە نمرەکان',
    'scoring_failed': 'گۆڵکردن شکستی هێنا',
    'vendor_dashboard_subtitle': 'ژێرنووسی داشبۆردەکەی فرۆشیار',
    'view_your_work_orders': 'بینینی فەرمانەکانی کارەکانت',
    'et_failed_load': 'Et بارکردنی شکستخواردوو',
    'et_fields_required': 'Et مەیدانەکان پێویستن',
    'et_updated': 'Et نوێکراوەتەوە',
    'et_created': 'Et دروستکراوە',
    'et_save_failed': 'Et Save شکستی هێنا',
    'et_edit_title': 'Et دەستکاری ناونیشان',
    'et_new_title': 'Et ناونیشانی نوێ',
    'templates': 'قاڵبەکان',
    'editor': 'سەرنوسەر',
    'desktop': 'سەر مێز',
    'mobile': 'مۆبایل',
    'realistic_sample_data': 'داتای نمونەیی واقیعی',
    'template_logic': 'لۆژیکی قاڵب',
    'event_trigger_desc': 'ئیڤێنت تریگەر Desc',
    'admin_only': 'تەنها ئەدمین',
    'click_to_insert': 'کلیک لە To Insert بکە',
    'body': 'جەستە',
    'template_deactivated': 'قاڵبەکە ناچالاک کراوە',
    'failed_to_deactivate': 'شکستی هێنا لە ناچالاککردن',
    'enter_test_email': 'ئیمەیڵی تاقیکردنەوە داخڵ بکە',
    'test_email_sent_to': 'ئیمەیڵی تاقیکردنەوە کە نێردراوە بۆ',
    'failed_to_send_test': 'شکستی هێنا لە ناردنی تاقیکردنەوە',
    'active_templates_count': 'ژمارەی قاڵبە چالاکەکان',
    'send_test_email': 'ناردنی ئیمەیڵی تاقیکردنەوە',
    'expense_created': 'خەرجی دروست کراوە',
    'new_expense': 'خەرجی نوێ',
    'select_category': 'پۆل هەڵبژێرە',
    'invoice_number': 'ژمارەی فاکتورە',
    'charge_to_owner': 'بارگاویکردنەوە بۆ خاوەنەکەی',
    'create_expense': 'دروستکردنی خەرجی',
    'status_approved': 'دۆخی پەسەندکراوە',
    'status_pending_approval': 'دۆخەکە لە چاوەڕوانی پەسەندکردندایە',
    'status_voided': 'دۆخەکە پووچەڵکراوەتەوە',
    'status_rejected': 'دۆخی ڕەتکراوەتەوە',
    'failed_to_load_expenses': 'شکستی هێنا لە بارکردنی خەرجییەکان',
    'expense_rejected': 'خەرجییەکە ڕەتکراوەتەوە',
    'confirm_reject': 'ئەم خەرجییە ڕەت بکەیتەوە؟ ناتوانرێت وەکوو پێشووەبکرێتەوە.',
    'date_from': 'لە بەروار',
    'date_to': 'بۆ بەروار',
    'failed_to_load': 'شکستی هێنا لە بارکردنی داتا',
    'assign_failed': 'دیاریکردن شکستی هێنا',
    'unavailable': 'بەردەست نییە',
    'filtered_by': 'فلتەر بەپێی:',
    'calendar': 'ڕۆژژمێر',
    'notes_placeholder': 'تێبینییە زیادەکان…',
    'no_amenities_match_filter': 'هیچ ئامادەکارییەک لەگەڵ فلتەری هەڵبژێردراو ناکۆکی نییە.',
    'all_amenities': 'هەموو ئامادەکارییەکان',
    'no_bookings_on_day': 'هیچ بووکینگێک لەم ڕۆژەدا نییە.',
    'parking_assigned': 'پارکینگ دیاریکرا',
    'parking_unassigned': 'دیاریکردنی پارکینگ لابرا',
    'parking_space_deleted': 'شوێنی پارکینگ سڕایەوە',
    'parking_space_created': 'شوێنی پارکینگ دروستکرا',
    'parking_space_updated': 'شوێنی پارکینگ نوێکرایەوە',
    'parking_spaces_generated': 'شوێنە پارکینگەکان بە کۆمەڵ دروستکران',
    'booking_deleted': 'بووکینگەکە سڕایەوە',
    'parking_layout_hint': 'ڕیزەکان دیاری بکە لە ڕێگەی دەستکاریکردنی شوێن بۆ ڕێکخستنی نەخشەی پارکینگ',
    'delete_amenity_title': 'سڕینەوەی ئامادەکاری',
    'confirm_delete_amenity': 'دڵنیایتە لە سڕینەوەی ئەم ئامادەکارییە؟ ناتوانرێت وەکوو پێشووبکرێتەوە.',
    'delete_parking_space_title': 'سڕینەوەی شوێنی پارکینگ',
    'confirm_delete_parking': 'دڵنیایتە لە سڕینەوەی ئەم شوێنی پارکینگە؟ ناتوانرێت وەکوو پێشووبکرێتەوە.',
    'delete_booking_title': 'سڕینەوەی بووکینگ',
    'confirm_delete_booking': 'دڵنیایتە لە سڕینەوەی ئەم بووکینگە؟ ناتوانرێت وەکوو پێشووبکرێتەوە.',
    'unassign_parking_title': 'لابردنی دیاریکردنی پارکینگ',
    'confirm_unassign_parking': 'دڵنیایتە لە لابردنی دیاریکردنی ئەم شوێنی پارکینگە؟',
    'start_end_required': 'ژمارەی دەستپێک و کۆتایی پێویستن',
    'space_number_required': 'ژمارەی شوێن پێویستە',
    'row_zone': 'ڕیز / زۆن',
    'row_zone_hint': 'بۆ نەخشەی پارکینگ',
    'expense_approved': 'خەرجییەکان پەسەندکراون',
    'confirm_void': 'پشتڕاستکردنەوەی پووچەڵ',
    'expense_voided': 'خەرجییەکان پووچەڵکرانەوە',
    'expenses_title': 'ناونیشانی خەرجییەکان',
    'expenses_subtitle': 'خەرجییەکان ژێرنووس',
    'total_expenses': 'کۆی خەرجییەکان',
    'approved_amount': 'بڕی پەسەندکراو',
    'item_singular': 'بابەتی تاک',
    'items_plural': 'بابەتەکان فرەیی',
    'how_it_works': 'چۆن کاردەکات',
    'expense_hint1': 'ئامۆژگاری خەرجییەکان1',
    'expense_hint2': 'ئامۆژگاری خەرجییەکان2',
    'expense_hint3': 'ئاماژەی خەرجییەکان3',
    'expense_hint4': 'ئامۆژگاری خەرجییەکان4',
    'search_expenses': 'خەرجییەکانی گەڕان',
    'expense_records': 'تۆمارەکانی خەرجییەکان',
    'no_expenses_found': 'هیچ خەرجیەک نەدۆزراوەتەوە',

    // Storage / Inventory
    'storage_title': 'کۆگا',
    'storage_subtitle': 'شوێنکەوتنی کاڵاکان لە کۆگا و ناردنیان بۆ شوقەکان — بەخۆکار وەک خەرجی تۆمار دەکرێت',
    'add_stock': 'زیادکردنی کاڵا',
    'stock_value': 'بەهای کاڵاکان',
    'items_in_storage': 'کاڵاکان لە کۆگا',
    'total_issued': 'کۆی ناردراو',
    'stock_on_hand': 'کاڵای بەردەست',
    'issuance_history': 'مێژووی ناردن',
    'quantity_on_hand': 'بەردەست',
    'issue_to_apartment': 'ناردن بۆ شوقە',
    'issue': 'ناردن',
    'storage_hint1': 'سەرەتا کاڵاکان لە کۆگا تۆمار بکە: دەرگا، پەنجەرە، ئامێرەکان، هتد — پێویست بە شوقە نییە هێشتا',
    'storage_hint2': '"ناردن بۆ شوقە" کاڵا دەگوازێتەوە بۆ یەکەیەک و بەخۆکار تێچووەکە تۆمار دەکات',
    'storage_hint3': 'تێچووی ناردراو وەک خەرجی چاوەڕوانی پەسەندکردن تۆمار دەکرێت',
    'storage_hint4': 'پوختەی خەرجی بەپێی شوقە کۆی تێچوو بۆ هەر یەکەیەک نیشان دەدات، بەپێی ئەوەی بەڕاستی ناردراوە',
    'search_materials': 'گەڕان بەپێی کاڵا، شوقە، دابینکەر...',
    'no_materials_found': 'هێشتا هیچ شتێک لێرە نییە',
    'spend_by_apartment': 'خەرجی بەپێی شوقە',
    'apartment_label': 'شوقە',
    'item_name': 'کاڵا',
    'item_name_placeholder': 'وەک نموونە: دەرگای ناوەوە، پەنجەرەی دووچینی',
    'items_logged': 'کاڵاکان',
    'quantity': 'ژمارە',
    'quantity_required': 'ژمارە پێویستە',
    'quantity_exceeds_stock': 'تەنها {{available}} بەردەستە لە کۆگا',
    'available_short': '{{qty}} بەردەستە',
    'unit_cost': 'تێچووی یەکە',
    'total_cost': 'کۆی تێچوو',
    'select_apartment': 'شوقە هەڵبژێرە',
    'stock_added': 'کاڵا زیادکرا بۆ کۆگا',
    'material_issued': 'نێردرا بۆ شوقە و وەک خەرجی تۆمارکرا',
    'failed_to_load_materials': 'بارکردنی زانیاری کۆگا سەرکەوتوو نەبوو',
    'failed_to_load_apartments': 'بارکردنی شوقەکان سەرکەوتوو نەبوو — پەیوەندییەکەت بپشکنە و دووبارە هەوڵ بدەرەوە',

    'owner_label': 'ناوی خاوەنەکەی',
    'void': 'پووچەڵ',
    'error_loading_accounts': 'هەڵە لە بارکردنی ئەکاونتەکان',
    'error_loading_journal_entries': 'هەڵە لە بارکردنی نووسراوەکانی گۆڤار',
    'error_loading_trial_balance': 'هەڵە لە بارکردنی باڵانسی تاقیکردنەوە',
    'error_loading_pnl': 'هەڵە لە بارکردنی Pnl',
    'gl_account_required_fields': 'Gl ئەکاونتی پێویست مەیدانەکان',
    'account_created': 'ئەکاونت دروست کراوە',
    'save_failed': 'پاشەکەوتکردن شکستی هێنا',
    'description_required': 'وەسف پێویستە',
    'journal_min_lines_error': 'هەڵەی هێڵەکانی کەمترین گۆڤار',
    'entry_out_of_balance_error': 'هەڵەی چوونە ژوورەوە لە دەرەوەی باڵانس',
    'journal_account_required_error': 'هەڵەی پێویستی ئەژمێری جۆرناڵ',
    'journal_entry_posted': 'نووسینی گۆڤار پۆست کراوە',
    'post_failed': 'پۆستەکە شکستی هێنا',
    'entry_reversed': 'هاتنە ژوورەوە پێچەوانە بووە',
    'reversal_failed': 'پێچەوانەکردنەوە شکستی هێنا',
    'chart_of_accounts': 'چارت ئۆف ئەکاونتەکان',
    'journal_entries': 'نووسینەکانی گۆڤار',
    'trial_balance': 'هاوسەنگی تاقیکردنەوە',
    'pnl_statement': 'بەیاننامەی Pnl',
    'gl_subtitle': 'ژێرنووسی Gl',
    'add_account': 'زیادکردنی ئەکاونت',
    'new_gl_account': 'ئەکاونتی نوێی Gl',
    'code': 'کۆد',
    'create_account': 'دروستکردنی ئەکاونت',
    'normal_balance': 'هاوسەنگی ئاسایی',
    'no_accounts_found': 'هیچ ئەکاونتێک نەدۆزراوەتەوە',
    'all_sources': 'هەموو سەرچاوەکان',
    'apply': 'داواکاری پێشکەش بکە',
    'new_entry': 'هاتنە ژوورەوەی نوێ',
    'new_journal_entry': 'هاتنە ژوورەوەی گۆڤاری نوێ',
    'source': 'سەرچاوە',
    'account': 'ئەکاونت',
    'debit': 'خەرجکردن',
    'credit': 'کریدت',
    'select_account': 'ئەکاونت هەڵبژێرە',
    'line_description_placeholder': 'وەسفکردنی هێڵ شوێنگر',
    'balanced_msg': 'هاوسەنگ Msg',
    'out_of_balance_amount': 'بڕی دەرەوەی باڵانس',
    'posting': 'پۆستکردن',
    'post_entry': 'پۆست ئینتری',
    'no_journal_entries_found': 'هیچ زانیارییەکی گۆڤار نەدۆزراوەتەوە',
    'lines': 'هێڵەکان',
    'reversed': 'پێچەوانە کراوەتەوە',
    'posted': 'پۆست کراوە',
    'lines_count': 'ژمارەی هێڵەکان',
    'hide': 'شاردنەوە',
    'reverse': 'پێچەوانە',
    'as_of_date': 'As Of Date',
    'run': 'ڕاکردن',
    'out_of_balance': 'لە دەرەوەی باڵانس',
    'total_debits': 'کۆی گشتی خەرجییەکان',
    'total_credits': 'کۆی گشتی کرێدتەکان',
    'net_income': 'داهاتی پاک',
    'revenue': 'داهات',
    'no_revenue_entries': 'بێ هاتنە ژوورەوەی داهات',
    'no_expense_entries': 'بێ هاتنە ژوورەوەی خەرجییەکان',
    'select_date_range_run_msg': 'مەودای بەروار هەڵبژێرە Run Msg',
    'journal_entry': 'نووسینی گۆڤار',
    'reason_for_reversal_prompt': 'هۆکاری پێشنیاری پێچەوانەکردنەوە',
    'error_loading_kpi_data': 'هەڵە لە بارکردنی داتاکانی Kpi',
    'snapshot_complete': 'وێنەی خێرا تەواو',
    'snapshot_failed': 'وێنەیەکی خێرا شکستی هێنا',
    'kpi_subtitle': 'ژێرنووسی Kpi',
    'capturing': 'گرتن',
    'snapshot_now': 'وێنەیەکی خێرا ئێستا',
    'units_occupied_msg': 'یەکەکانی داگیرکراو Msg',
    'annual_gross_rent': 'کرێی گشتی ساڵانە',
    'per_month_suffix': 'پاشگری لە مانگێکدا',
    'portfolio_value': 'بەهای پۆرتفۆلیۆ',
    'equity_label_val': 'ئیکویتی لیبێڵ ڤاڵ',
    'vacant_units_count': 'ژمارەی یەکە بەتاڵەکان',
    'kpi_step1': 'Kpi هەنگاوی یەکەم',
    'kpi_step2': 'Kpi هەنگاوی دووەم',
    'kpi_step3': 'Kpi هەنگاوی3',
    'per_building_metrics': 'هەر پێوەرەکانی بیناسازی',
    'no_snapshots_yet': 'هێشتا وێنەیەکی خێرا نییە',
    'monthly_noi': 'مانگانە نۆی',
    'cap_rate': 'ڕێژەی کاپ',
    'gross_yield': 'بەرهەمی گشتی',
    'overdue_tenants': 'کرێچییە دواکەوتووەکان',
    'building_id_label': 'لیبێڵی ناسنامەی بیناسازی',
    'units_count': 'ژمارەی یەکەکان',
    'investment_summary': 'پوختەی وەبەرهێنان',
    'current_value': 'بەهای ئێستا',
    'purchase_cost': 'تێچووی کڕین',
    'equity': 'یەکسانی',
    'failed_to_load_pending': 'شکستی هێنا لە بارکردن Pending',
    'enter_reason_error': 'هەڵەی هۆکار دابنێ',
    'enter_valid_amount_error': 'هەڵەی بڕی ڕەوا دابنێ',
    'fee_waived': 'کرێی لێخۆشبوو',
    'failed_to_waive': 'شکستی هێنا لە دەستبەرداربوون',
    'confirm_manual_assess': 'هەڵسەنگاندنی دەستی پشتڕاست بکەرەوە',
    'late_fee_assessed': 'کرێی درەنگ هەڵسەنگێندرا',
    'of_rent': 'لە کرێ',
    'day_grace': 'ڕۆژی نیعمەت',
    'late_fees_disabled': 'کرێی درەنگ لەکارکەوتووە',
    'late_fee_mgmt': 'بەڕێوەبردنی کرێی درەنگ',
    'late_fees_disabled_hint': 'ئامۆژگاری لەکارخستنی کرێی درەنگ',
    'enable_in_settings': 'لە ڕێکخستنەکاندا چالاک بکە',
    'fee_settings': 'ڕێکخستنەکانی کرێ',
    'pending_charges': 'تۆمەتەکانی چاوەڕوانکراو',
    'history_tab': 'تابی مێژوو',
    'search_late_fees': 'گەڕان بەدوای Late Fees',
    'tenants_due_fee': 'کرێی کرێچییەکان',
    'next_cron_run': 'ڕاکردنی داهاتووی کرۆن',
    'no_pending_late_fees': 'بێ کرێی دواکەوتنی چاوەڕوانکراو',
    'enable_late_fees_hint': 'ئامۆژگاری کرێی درەنگ چالاک بکە',
    'projected_fee': 'کرێی پێشبینیکراو',
    'last_fee': 'دوا کرێ',
    'applying': 'داواکاری پێشکەشکردن',
    'apply_now': 'ئێستا داواکاری پێشکەش بکە',
    'all_late_fee_charges': 'هەموو پارەی درەنگ کرێ',
    'page_info': 'زانیاری پەیج',
    'no_late_fee_records': 'هیچ تۆمارێکی دواکەوتنی کرێ',
    'waive': 'دەستبەرداربوون',
    'auto_label': 'Auto Label',
    'manual_label': 'لیبێڵی دەستی',
    'waive_late_fee': 'دەستبەرداربوون لە کرێی دواکەوتن',
    'waive_confirm_hint': 'ئاماژەی پشتڕاستکردنەوەی دەستبەرداربوون',
    'waive_amount_label': 'ناوی بڕی دەستبەرداربوون',
    'waive_reason_label': 'وازهێنان لە هۆکار',
    'waive_reason_placeholder': 'جێگرەوەی هۆکاری دەستبەرداربوون',
    'waiving': 'دەستب��رداربوون',
    'confirm_waiver': 'پشتڕاستکردنەوەی دەستبەرداربوون',
    'unit_label': 'یەکەی لیبێڵ',
    'failed_to_load_chat_history': 'شکستی هێنا لە بارکردنی مێژووی چات',
    'messages_title': 'ناونیشانی پەیامەکان',
    'tenants_tab': 'تابی کرێچییەکان',
    'owners_tab': 'تابی خاوەنەکان',
    'no_conversations': 'هیچ گفتوگۆیەک نییە',
    'you_label': 'تۆ لایبەل',
    'no_messages_yet': 'هێشتا هیچ پەیامێک نییە',
    'type_message_placeholder': 'شوێنی Message Placeholder بنووسە',
    'your_inbox': 'ئیمەیڵەکەت',
    'select_conversation_hint': 'ئامۆژگاری گفتوگۆ هەڵبژێرە',
    'failed_to_load_notification_log': 'شکستی هێنا لە بارکردنی لۆگی ئاگادارکردنەوە',
    'notification_log_desc': 'لۆگی ئاگادارکردنەوە Desc',
    'total_sent': 'کۆی گشتی نێردراو',
    'failed_bounced': 'شکستی هێنا Bounced',
    'no_notifications_found': 'هیچ ئاگادارکردنەوەیەک نەدۆزراوەتەوە',
    'channel': 'کەناڵ',
    'recipient': 'وەرگر',
    'flat_amount': 'بڕی تەخت',
    'org_settings_desc': 'ڕێکخستنەکانی Org Desc',
    'late_fee_configuration': 'ڕێکخستنی کرێی درەنگ',
    'enabled': 'چالاک کراوە',
    'disabled': 'لەکارکەوتووە',
    'legal_note_late_fees': 'تێبینی یاسایی کرێی دواکەوتن',
    'grace_period_days': 'ڕۆژانی ماوەی گرەیس',
    'fee_type': 'جۆری کرێ',
    'percent_of_rent': 'لەسەدا لە کرێ',
    'late_fee_summary': 'پوختەی کرێی درەنگ',
    'applied_after': 'Applied دوای...',
    'error_loading_portfolio_data': 'هەڵە لە بارکردنی داتاکانی پۆرتفۆلیۆ',
    'investment_portfolio': 'پۆرتفۆلیۆی وەبەرهێنان',
    'investment': 'وەبەرهێنان',
    'record_valuation': 'بەهادان بە تۆمارکردن',
    'total_portfolio_value': 'کۆی بەهای پۆرتفۆلیۆ',
    'annualized_amount': 'بڕی ساڵانە',
    'avg_cap_rate': 'تێکڕای ڕێژەی کاپ',
    'annualized': 'ساڵانە',
    'avg_gross_yield': 'تێکڕای بەرهەمی گشتی',
    'gross_rent_on_value': 'کۆی گشتی کرێ لەسەر بەها',
    'portfolio_step1': 'پۆرتفۆلیۆ هەنگاوی یەکەم',
    'portfolio_step2': 'پۆرتفۆلیۆ هەنگاوی دووەم',
    'portfolio_step3': 'پۆرتفۆلیۆ هەنگاوی سێیەم',
    'portfolio_step4': 'پۆرتفۆلیۆ هەنگاوی چوارەم',
    'per_building_breakdown': 'بۆ هەر بینایەک تێکچوون',
    'no_portfolio_data': 'هیچ داتایەکی پۆرتفۆلیۆ نییە',
    'last_valuation': 'دوا بەهادان',
    'occupied_short': 'داگیرکراو شۆرت',
    'no_valuation': 'بێ بەهادان',
    'update_value': 'بەهای نوێکردنەوە',
    'discount_rent': 'داشکاندنی کرێ',
    'lease_start': 'دەستپێکردنی بەکرێدان',
    'lease_end': 'کۆتایی بەکرێدان',
    'next_bill': 'پڕۆژە یاسای داهاتوو',
    'no_units_found': 'هیچ یەکەیەک نەدۆزراوەتەوە',
    'csv_download_failed': 'داگرتنی Csv شکستی هێنا',
    'all_1099_downloaded': 'هەموو 1099 دابەزێنراون',
    'no_reportable_owners': 'هیچ خاوەنێکی ڕاپۆرتکراو نییە',
    'pdf_download_failed': 'داگرتنی Pdf شکستی هێنا',
    'pdf_generation_failed': 'نەوەی Pdf شکستی هێنا',
    'generating_pdfs': 'دروستکردنی Pdfs',
    'download_all_pdfs': 'داگرتنی هەموو Pdfs',
    'important': 'گرنگە',
    'irs_1099_disclaimer': 'Irs 1099 ڕەتکردنەوەی بەرپرسیاریەتی',
    'owner_payment_summary': 'پوختەی پارەدانی خاوەنکار',
    'irs_threshold': 'Irs Threshold',
    'total_paid': 'کۆی گشتی پارەدار',
    'form': 'فۆڕم',
    'file_form': 'فۆڕمی فایل',
    'no_owner_payments_found': 'هیچ پارەیەکی خاوەن ماڵ نەدۆزراوەتەوە',
    'error_loading_deposits': 'هەڵە لە بارکردنی پارە دانراوەکان',
    'deposit_collected': 'پارەی پێشەکی کۆکراوەتەوە',
    'deposit_returned': 'پارەی پێشەکی گەڕاوەتەوە',
    'security_deposits_subtitle': 'ژێرنووسی پارەی زەمانەت',
    'total_held': 'کۆی گشتی بەڕێوەچوو',
    'active_deposits': 'وەبەرهێنانی چالاک',
    'deposits_returned': 'وەبەرهێنانەکان گەڕاونەتەوە',
    'all_tenants_deposit_status': 'دۆخی دانانی پارەی هەموو کرێچییەکان',
    'no_deposits_found': 'هیچ پارەیەکی پێشەکی نەدۆزراوەتەوە',
    'deposit_amount': 'بڕی پارەی پێشەکی',
    'deductions': 'لێبڕینەکان',
    'collect': 'کۆکردنەوە',
    'return': 'گەڕانەوە',
    'status_returned': 'دۆخ گەڕاوەتەوە',
    'collect_security_deposit': 'کۆکردنەوەی پارەی زەمانەت',
    'return_security_deposit': 'گەڕانەوەی پارەی زەمانەت',
    'damages_unpaid_rent': 'زیانەکانی کرێی نەدراو',
    'optional_notes': 'تێبینی ئیختیاری',
    'record_collection': 'کۆکردنەوەی تۆمارەکان',
    'record_return': 'گەڕانەوەی تۆمارکردن',
    'deposit_amount_placeholder': 'نموونه: 1500.00',
    'error_loading_showing': 'هەڵەی ��ارکردن پیشان دەدرێت',
    'required_fields_error': 'هەڵەی مەیدانی پێویست',
    'showing_updated': 'پیشاندانی نوێکراوە',
    'showing_scheduled': 'پیشاندانی بەرنامە بۆ داڕێژراو',
    'time_conflict_error': 'هەڵەی ململانێی کات',
    'choose_unit': 'یەکە هەڵبژێرە',
    'agent_name_placeholder': 'ناوی بریکار شوێنگر',
    'schedule': 'خشتەی کار',
    'error_loading_showings': 'هەڵە لە بارکردنی پیشاندانی',
    'marked_as': 'بەم شێوەیە نیشانە کراوە',
    'update_failed': 'نوێکردنەوە شکستی هێنا',
    'delete_failed': 'سڕینەوە شکستی هێنا',
    'mark_completed': 'مارک تەواو بووە',
    'mark_no_show': 'مارک نۆ شۆ',
    'confirm_delete': 'پشتڕاستکردنەوەی سڕینەوە',
    'confirm_delete_showing': 'پشتڕاستکردنەوەی سڕینەوە پیشاندانی',
    'error_loading_surveys': 'هەڵە لە بارکردنی ڕاپرسییەکان',
    'from_responses': 'لە وەڵامەکانەوە',
    'no_data_yet': 'هێشتا هیچ داتایەک نییە',
    'error_loading_utility_data': 'هەڵە لە بارکردنی داتاکانی سوودمەند',
    'reading_recorded_generate_bills': 'خوێندنەوەی تۆمارکراو دروستکردنی پڕۆژە یاسا',
    'utility_type_required': 'جۆری سوودمەندی پێویستە',
    'failed_to_create_account': 'شکستی هێنا لە دروستک��دنی ئەکاونت',
    'add_utility_account': 'زیادکردنی ئەژمێری سوودمەندی',
    'utility_type': 'جۆری سوودمەندی',
    'provider_name': 'ناوی دابینکەر',
    'provider_placeholder': 'جێگرەوەی دابینکەر',
    'select_tenant_error': 'هەڵەی کرێچی هەڵبژێرە',
    'please_fix_errors': 'تکایە هەڵەکان چاک بکەن',
    'bill_issued_successfully': 'پڕۆژە یاسا بە سەرکەوتوویی دەرچوو',
    'failed_to_issue_bill': 'شکستی هێنا لە دەرکردنی پڕۆژە یاسا',
    'valuation_recorded': 'بەهادان تۆمارکراوە',
    'download_csv': 'داگرتنی Csv',
    'vendor_1099_disclaimer': 'فرۆشیار 1099 ڕەتکردنەوەی بەرپرسیاریەتی',
    'vendor': 'فرۆشیار',
    'first_payment': 'یەکەم پارەدان',
    'last_payment': 'دوا پارەدان',
    'no_vendor_payments_recorded': 'هیچ پارەیەکی فرۆشیار تۆمار نەکراوە',
    'account_deactivated': 'ئەکاونت ناچالاک کراوە',
    'server_no_response': 'سێرڤەر بێ وەڵام',
    'login_to_continue': 'چوونەژوورەوە بۆ بەردەوام بوون',
    'logging_in': 'چوونە ژوورەوە',
    'dont_have_account': 'Dont Have Account',
    'register': 'ناوت تۆمار بکە',
    'company_name_required': 'ناوی کۆمپانیا پێویستە',
    'registration_failed': 'ناو تۆمارکردن شکستی هێنا',
    'sign_up_to_get_started': 'بۆ دەستپێکردن ناوت تۆمار بکە',
    'company_name': 'ناوی کۆمپانیا',
    'enter_company_name': 'ناوی کۆمپانیا بنووسە',
    'already_have_account': 'پێشتر ئەکاونتت هەیە',
    'fully_signed_active': 'بە تەواوی واژۆکراو چالاکە',
    'pending_owner_signature': 'واژۆی خاوەنەکەی لە چاوەڕوانیدایە',
    'pending_admin_signature': 'چاوەڕوانی واژۆی بەڕێوەبەر',
    'terminated': 'کۆتایی هات',
    'back_to_contracts': 'گەڕانەوە بۆ گرێبەستەکان',
    'contract_terms': 'مەرجەکانی گرێبەست',
    'payment_schedule': 'خشتەی پارەدان',
    'no_installments_defined': 'هیچ قیستێک پێناسە نەکراوە',
    'signed_by': 'واژۆ کراوە لەلایەن',
    'sign_now': 'ئێستا واژۆ بکە',
    'awaiting_admin_review': 'چاوەڕوانی پێداچوونەوەی ئەدمین',
    'sign_contract': 'گرێبەست واژۆ بکە',
    'past': 'ڕابردوو',
    'financials': 'دارایی',
    'approvals': 'پەسەندکردنەکان',
    'high_priority': 'ئەولەویەتێکی بەرز',
    'medium_priority': 'ئەولەویەتی مامناوەند',
    'low_priority': 'ئەولەویەتێکی کەم',
    'est_cost': 'Est Cost',
    'member_since': 'ئەندام لە...',
    'expires_today': 'ئەمڕۆ بەسەر دەچێت',
    'pct_elapsed': 'Pct تێپەڕیوە',
    'pay_now': 'ئێستا پارە بدە',
    'view_ledger': 'بینینی کتێبی سەرەکی',
    'welcome_back_user': 'بەخێر بێیت بەکارهێنەر',
    'tenancy_overview': 'تێڕوانینێکی گشتی بۆ کرێچی',
    'action_required': 'کردەوەی پێویستە',
    'due_today': 'Due Today',
    'view_lease_short': 'بینینی کورتە بەکرێدان',
    'need_repairs': 'پێویستی بە چاککردنەوە هەیە',
    'repairs_subtitle': 'چاککردنەوە ژێرنووس',
    'create_request': 'داواکاری دروست بکە',
    'recent_account_activity': 'چالاکیی ئەکاونتی ئەم دواییە',
    'no_ledger_entries_yet': 'هێشتا هیچ نووسینێکی کتێبی سەرەکی نییە',
    'balance_after': 'هاوسەنگی دوای...',
    'active_maintenance': 'چاککردنەوەی چالاک',
    'all_clear_maintenance': 'هەموو چاککردنەوەیەکی ڕوون',
    'maintenance_request_default': 'داواکاری چاککردنەوە بە شێوازی پێشوەختە',
    'building_news': 'هەواڵی بیناسازی',
    'failed_to_load_lease_details': 'شکستی هێنا لە بارکردنی وردەکارییەکانی بەکرێدان',
    'tenant_signin_success': 'سەرکەوتنی چوونەژوورەوەی کرێچی',

    // Auto-added mass translations from ESLint Codemod
    '10': '10 / 10 .',
    '12': '/ 12',
    '16': '-16%',
    '25': '25 / 2019 .',
    '50': '50 /',
    '100': '100 /',
    '600': ': ٦٠٠ دۆلار',
    'ai_assistant_pro_only': 'یاریدەدەری AI — تەنها Pro',
    'ask_questions_about_your_portfolio_in_pl': 'پرسیار دەربارەی پۆرتفۆلیۆکەت بکە بە زمانی ئینگلیزی ساد��. وەڵامی خێرا لەسەر داهات، پارەدانی دواکەوتوو، پۆستە بەتاڵەکان و زۆر شتی تر بەدەستبهێنە.',
    'upgrade_to_pro': 'بەرزکردنەوە بۆ Pro',
    'here_s_what_s_happening_across_your_port': 'لێرەدا ئەوەیە کە ئەمڕۆ لە سەرانسەری پۆرتفۆلیۆکەتدا چی ڕوودەدات.',
    'portfolio_risk': 'مەترسی پۆرتفۆلیۆ',
    'pro_only': 'تەنها پرۆ',
    'pending_collections': 'کۆکردنەوەکانی چاوەڕوانکراو',
    'ask_ai_assistant': 'پرسیار لە یاریدەدەری AI بکە',
    'unlock_ai_assistant_upgrade_to_pro': 'Unlock AI Assistant — بەرزکردنەوە بۆ Pro',
    'download': 'داگرتن',
    'd': 'د',
    'view_details_1': 'بینینی وردەکارییەکان',
    'export_data': 'هەناردەکردنی داتا',
    'refresh_data': 'داتا نوێکردنەوە',
    'property_pulse': 'تایبەتمەندی پەلسی',
    'cash_flow_analysis_for_the_current_fisca': 'شیکاری ڕۆیشتنی پارە بۆ ساڵی دارایی ئێستا',
    'yearly_report': 'ڕاپۆرتی ساڵانە',
    'analytics_pro_required': 'Analytics Pro پێویستە',
    'unlock_deep_financial_insights_and_custo': 'تێگەیشتنە داراییە قووڵەکان و ڕاپۆرتی پێشبینیکردنی تایبەتمەند بکەرەوە.',
    'upgrade_now': 'ئێستا بەرز بکەرەوە',
    'items_requiring_immediate_follow_up': 'ئەو بابەتانەی کە پێویستیان بە بەدواداچوونی دەستبەجێ هەیە',
    'activity_log': 'لۆگی چالاکییەکان',
    'view_history': 'بینینی مێژوو',
    'no_recent_logs_found': 'هیچ لۆگێکی ئەم دواییە نەدۆزراوەتەوە',
    'active_issues': 'پرسە چالاکەکان',
    'pro': 'پرۆ',
    'pro_1': 'پرۆ',
    'sell_unit': 'یەکەی فرۆشتن',
    'floor_1': 'نهۆم',
    'size_1': 'قەبارە',
    'm': 'م2',
    'amenities': 'خزمەتگوزارییەکان',
    'last_updated_today': 'دوایین نوێکردنەوە: ئەمڕۆ',
    'back_to_apartment': 'گەڕانەوە بۆ شوقە',
    'sell_unit_1': 'یەکەی فرۆشتن',
    'floor_2': 'نهۆم',
    'select_buyer': 'کڕیار هەڵبژێرە',
    'existing_owner': 'خاوەنی ئێستا',
    'new_buyer': 'کڕیاری نوێ',
    'no_owners_found_switch_to_new_buyer_to_c': 'هیچ خاو��نێک نەدۆزراوەتەوە — بگۆڕە بۆ "کڕیاری نوێ" بۆ دروستکردنی یەکێک',
    'search_owners_placeholder': 'بگەڕێ بۆ خاوەنەکان بە ناو، تەلەفۆن، یان ئیمەیل...',
    'buyer_name_placeholder': 'بۆ نموونە: ئەحمەد ڕاشیدی',
    'sale_notes_placeholder': 'تێبینیی ئارەزوومەندانە...',
    'edit_1': 'دەستکاریکردن',
    'the_buyer_will_be_created_as_an_owner_an': 'کڕیار وەک خاوەنێک دروست دەکرێت و بە شێوەیەکی ئۆتۆماتیکی بەستراوەتەوە بەم فرۆشتنەوە.',
    'sale_terms': 'مەرجەکانی فرۆشتن',
    'total_sale_price': 'کۆی گشتی نرخی فرۆشتن *',
    'down_payment': 'پارەی پێشەکی',
    'annual_interest_rate': 'ڕێژەی سوودی ساڵانە (%)',
    'term_months': 'ماوەی (مانگەکان) *',
    'yrs': 'ساڵ)',
    'sale_start_date': 'فرۆشتن / بەرواری دەستپێکردن *',
    'quick_preview': 'پێشبینی خێرا',
    'principal': 'بەڕێوەبەری قوتابخانە',
    'down_payment_1': 'پارەی پێشەکی',
    'term': 'وەرزی',
    'months_1': 'مانگ',
    'amortization_schedule': 'خشتەی خەرجکردنی خەرجییەکان',
    'confirm_sale': 'فرۆشتن پشتڕاست بکەرەوە',
    'buyer': 'کڕیار',
    'floor_3': '— نهۆم',
    'financial_terms': 'مەرجە داراییەکان',
    'draft_sale_contract': 'ڕەشنووسی گرێبەستی فرۆشتن',
    'will_be_created_the_apartment_will_be_ma': 'دروست دەبێت. شوقەکە بەم شێوەیە نیشانە دەکرێت',
    'sold': 'فرۆشرا',
    'only_after_both_you_and_the_buyer_digita': 'تەنها دوای ئەوەی هەردوو تۆ و کڕیار بە شێوەیەکی دیجیتاڵی گرێبەستەکە واژۆ بکەن.',
    'sale_finalized': 'فرۆشتن کۆتایی هات!',
    'the_sale_contract_for_unit': 'گرێبەستی فرۆشتن بۆ یونیت',
    'has_been_created_use_the_links_below_to': 'دروست بووە. ئەم بەستەرانەی خوارەوە بەکاربهێن�� بۆ ئەوەی کڕیارەکە بخەیتە ناو ئۆتۆمبێلەکەوە.',
    'public_sign_link': 'لینکی واژۆی گشتی',
    'p_sign_owner': '/p/sign/خاوەن/',
    'portal_invite_link': 'لینکی بانگهێشتکردنی پۆرتاڵ',
    'portal_setup_password_type_owner_id': '/portal/setup-password?جۆر=خاوەن&id=',
    'email_1': '&ئیمەیڵ=',
    'token': '&تۆکن=',
    'view_owner': 'بینینی خاوەن',
    'manage_contract': 'بەڕێوەبردنی گرێبەست',
    '0_10': '(0–10،',
    'm_1': 'م2',
    'm_2': 'م2',
    'm_3': 'م2',
    'm_4': 'م2',
    'empty_key': '✕',
    'this_apartment_already_has': 'ئەم شوقەیە پێشتر هەیەتی',
    'active_booking_s_for_these_dates': 'حجزکردنی چالاک بۆ ئەم بەروارانە.',
    'levels': 'ئاستەکان',
    'cap': 'کاپ',
    'no_inventory_data': 'هیچ داتایەکی ئینفۆنتۆری نییە',
    'init_units': 'یەکەکانی دەستپێکردن',
    'm_5': 'م2',
    'm_6': 'م2',
    'supports_markdown_placeholders_e_g': 'پشتگیری لە MarkDown & Placeholders دەکات بۆ نموونە.',
    'empty_key_1': '✓',
    'trial_ends_in': 'دادگاییکردنەکە لە...',
    'days_subscribe': 'ڕۆژەکان - سەبسکرایب',
    'new_lease_agreement': 'ڕێکەوتنی نوێی بەکرێدان',
    'tenant_unit_assignment': 'کرێچی و تەرخانکردنی یەکە',
    'please_select_a_building_first': 'تکایە سەرەتا بینایەک هەڵبژێرە',
    'lease_terms_duration': 'مەرجەکانی بەکرێدان و ماوەی بەکرێدان',
    'lease_type': 'جۆری بەکرێدان',
    'fixed_term': 'ماوەی جێگیر',
    'month_to_month': 'مانگ بە مانگ',
    'end_date_optional': 'بەرواری کۆتایی (ئیختیاری)',
    'financial_obligations': 'پابەندبوونە داراییەکان',
    'empty_key_2': ') * .',
    'notes_special_provisions': 'تێبینی / بڕگەی تایبەت',
    'empty_key_3': ': # .',
    'send_for_signature': 'بۆ واژۆ بنێرن',
    'copy_sign_link': 'لینکی واژۆی کۆپی',
    'download_contract_pdf': 'داگرتنی گرێبەستی PDF',
    'contract_summary': 'پوختەی گرێبەست',
    'generated_from_template': 'لە قاڵبەوە دروستکراوە:',
    'digitally_executed': 'بە شێوەیەکی دیجیتاڵی جێبەجێ کراوە',
    'electronic_signatures': 'واژۆی ئەلیکترۆنی',
    'management_office': 'فەرمانگەی بەڕێوەبردن',
    'authorized_signature': 'واژۆی ڕێگەپێدراو',
    'owner_landlord': 'خاوەن / خاوەن خانوو',
    'email_2': 'ئیمەیڵ:',
    'signed': 'واژۆ کراوە:',
    'ip': 'ئایپی:',
    'reason_for_voiding': 'هۆکاری پووچەڵکردنەوە',
    'building_agreement_for': 'ڕێکەوتنی بیناسازی بۆ...',
    'contract_builder_rules': 'یاساکانی دروستکردنی گرێبەست',
    'select_contract_template': 'قاڵبی گرێبەست هەڵبژێرە',
    'no_template_manual_mode': 'بێ قاڵب (دۆخی دەستی)',
    'template_dynamic_variables': 'گۆڕاوە داینامیکییەکانی قاڵب',
    'owner_default_commission': 'کۆمیسیۆنی پێشوەختەی خاوەنکار:',
    'maintenance_threshold': 'ئاستی چاککردنەوە:',
    'unit_1': 'یەکەی',
    'sale_unit_purchase': 'فرۆشتن / کڕینی یەکە',
    'fixed_maintenance_contract': 'گرێبەستی چاککردنەوەی جێگیر',
    'lease_agreement': 'ڕێکەوتنی بەکرێدان',
    'start_date_1': 'بەرواری دەستپێکردن',
    'auto_generate_quarterly': 'چارەگی ئۆتۆماتیکی دروستکردن',
    'add_custom_installment': 'قیستی تایبەت زیاد بکە',
    'plan_total': 'پلان کۆی گشتی',
    'agreement': 'ڕێککەوتن',
    'copy_portal_link': 'لینکی پۆرتاڵ کۆپی بکە',
    'portal_link_copied': 'لینکی دامەزراندنی پۆرتاڵ کۆپی کرا بۆ کلیپبۆرد',
    'failed_generate_invite_link': 'هەڵە لە دروستکردنی لینکی بانگهێشت',
    'ledger': 'کتێبی سەرەکی',
    'empty_key_4': ') â†’',
    'owner_documents': 'بەڵگەنامەکانی خاوەنکار',
    'add_document': 'زیادکردنی بەڵگەنامە',
    'name_1': 'ناو *',
    'tax': 'باج',
    'file_url': 'URLی پەڕگە *',
    'cancel_1': 'هەڵوەشاندنەوە',
    'no_documents_yet': 'هێشتا هیچ بەڵگەنامەیەک نییە',
    'document_added': 'بەڵگەنامە زیادکرا',
    'name_and_url_required': 'ناو و URLـەکە پێویستن',
    'uploaded_by': 'ئەپلۆدکراوە لەلایەن',
    'delete_document': 'سڕینەوەی بەڵگەنامە',
    'document_name_placeholder': 'ناوی بەڵگەنامە',
    '30_days': '(٣٠ ڕۆژ)',
    'view_1': 'بینین',
    'future_scheduled_installments': 'قیستەکانی داهاتوو کە بەرنامە بۆ داڕێژراون',
    'unit_2': '، یەکەی',
    'no_investment_data_available_add_purchas': 'هیچ زانیارییەکی وەبەرهێنان لەبەردەستدا نییە. نرخی کڕین و بەهای ئێستا بۆ شوقەکان زیاد بکە بۆ بینینی پێوەرەکان.',
    'click_the_edit_icon_on_any_unit_to_updat': 'بۆ نوێکردنەوەی بەهای بازاڕی ئێستای یان نرخی کڕینی کلیک لە ئایکۆنی دەستکاریکردن بکە لەسەر هەر یەکەیەک.',
    'unit_3': 'یەکەی',
    'unit_mo': '/یەکە/مۆ',
    'save_16_billed_annually': '16% پاشەکەوت بکە · ساڵانە فەسڵ دەکرێت',
    'reason_for_rejection': 'هۆکاری ڕەتکردنەوە',
    'of_1': 'لە',
    'error_loading_receipt': 'هەڵە لە بار��ردنی پسوڵە',
    'go_back': 'بڕۆ بۆ دواوە',
    'receipt_not_found': 'پسوڵە نەدۆزراوەتەوە',
    'the_requested_payment_receipt_could_not': 'پسوڵەی پارەدانی داواکراو نەدۆزراوەتەوە.',
    'go_back_1': 'بڕۆ بۆ دواوە',
    'payment_receipt': 'پسوڵەی پارەدان',
    'issue_date': 'بەرواری دەرچوون:',
    'from_1': 'لە...',
    'phone_1': 'تەلەفۆن:',
    'to_1': 'بۆ...',
    'phone_2': 'تەلەفۆن:',
    'amount_1': 'بڕی',
    'notes_1': 'تێبینی',
    'thank_you_for_your_payment': 'سوپاس بۆ پارەکەت!',
    'this_receipt_was_generated_automatically': 'ئەم پسوڵەیە بە شێوەیەکی ئۆتۆماتیکی دروست بووە.',
    'delete_template': 'سڕینەوەی قاڵب',
    'cancel_2': 'هەڵوەشاندنەوە',
    'delete_1': 'سڕینەوە',
    'description_optional': 'وەسف (ئیختیاری)',
    'report_type': 'جۆری ڕاپۆرت',
    'choosing_a_report_type_shows_the_relevan': 'هەڵبژاردنی جۆری ڕاپۆرتێک فلتەرە پەیوەندیدارەکانی خوارەوە نیشان دەدات.',
    'saved_filters': 'فلتەرە پاشەکەوتکراوەکان',
    'select_a_report_type_above_to_set_saved': 'جۆرێکی ڕاپۆرت لە سەرەوە هەڵبژێرە بۆ دانانی بەهاکانی فلتەری پاشەکەوتکراو بۆ ئەم قاڵبە.',
    'cancel_3': 'هەڵوەشاندنەوە',
    'saved_filter': 'فلتەری پاشەکەوتکراو',
    'saved_1': 'پاشەکەوت کراوە',
    'favourites': 'دڵخوازەکان',
    'all_templates': 'هەموو قاڵبەکان',
    'load_template': 'قاڵبی بارکردن',
    'favourites_1': 'دڵخوازەکان',
    'no_templates_for_this_report_type': 'هیچ قاڵبێک بۆ ئەم جۆرە ڕاپۆرتە نییە',
    'saved_filter_1': 'فلتەری پاشەکەوتکراو',
    'manage_apartment_sales_and_track_sold_un': 'بەڕێوەبردنی فرۆشتنی شوقە و بەدواداچوون بۆ یەکەکانی فرۆشراو',
    'apartments_1': 'شوقەکان',
    'available': 'بەردەستە',
    'sold_1': 'فرۆشرا',
    'sold_rate': '% ڕێژەی فرۆشراو',
    'floor_4': 'نهۆم',
    'units_1': 'یەکەکان',
    'available_1': 'بەردەستە',
    'sold_2': 'فرۆشرا',
    'unit_4': 'یەکەی',
    'owner_buyer': 'خاوەن / کڕیار',
    'sale_price': 'نرخی فرۆشتن',
    'sale_date': 'بەرواری فرۆشتن',
    'sell_unit_2': 'یەکەی فرۆشتن',
    'search_unit_or_buyer': 'بگەڕێ بۆ یەکە یان کڕیار...',
    'stat_available_to_sell': 'بەردەست بۆ فرۆشتن',
    'stat_sold_units': 'یەکەکانی فرۆشراو',
    'status_all': 'هەموو',
    'status_vacant': 'خاوی',
    'status_available': 'بەردەست',
    'status_occupied': 'داگیرکراو',
    'status_sold': 'فرۆشراو',
    'status_maintenance': 'چاکسازی',
    'view_details_2': 'بینینی وردەکارییەکان',
    'print_1': 'چاپ',
    'apartment_management_system': 'سیستەمی بەڕێوەبردنی شوقە',
    'erbil_kurdistan_region_iraq': 'هەولێر، هەرێمی کوردستان - عێراق',
    'tel_xxx_xxxxxxxx': 'تەلەفۆن: +XXX XXXXXXXX',
    'receipt': 'پسوڵەی #:',
    'name_2': 'ناو:',
    'phone_3': 'تەلەفۆن:',
    'building_1': 'بینا:',
    'payment_details_1': 'وردەکاری پارەدان',
    'amount_2': 'بڕی: ١.',
    'payment_date_1': 'بەرواری پارەدان:',
    'period_1': 'ماوەی:',
    'notes_2': 'تێبینی',
    'thank_you_for_your_payment_1': 'سوپاس بۆ پارەکەت!',
    'tenant_information_1': 'زانیاری کرێچی',
    'name_3': 'ناو:',
    'phone_4': 'تەلەفۆن:',
    'apartment_1': 'شوقە:',
    'building_2': 'بینا:',
    'furnished_1': 'مۆبیلیات:',
    'at_12_00_pm': 'کاتژمێر ١٢:٠٠ی شەو',
    'monthly_rent_1': 'کرێی مانگانە:',
    'insurance_1': 'بیمە:',
    'additional_notes': 'تێبینی زیادە',
    'tenant_signature': 'واژۆی کرێچی',
    'this_receipt_is_electronically_generated': 'ئەم پسوڵەیە بە شێوەی ئەلیکترۆنی دروستکراوە و بەبێ واژۆ کارا دەبێت.',
    'apartment_management_system_all_rights_r': 'سیستەمی بەڕێوەبردنی شوقە. هەموو مافەکان پارێزراوە.',
    'lease_renewal_risk': 'مەترسی نوێکردنەوەی بەکرێدان',
    'expiring_in_30_days': 'لە ٣٠ ڕۆژدا بەسەر دەچێت',
    'expiring_in_60_days': '٦٠ ڕۆژی تر بەسەر دەچێت',
    'expiring_in_90_days': 'لە ٩٠ ڕۆژدا بەسەر دەچێت',
    'expiring_in_180_days': 'دوای ١٨٠ ڕۆژ بەسەر دەچێت',
    'all_risk_levels': 'هەموو ئاستەکانی مەترسی',
    'no_leases_matching_the_selected_filters': 'هیچ بەکرێدانێک کە لەگەڵ فلتەرە هەڵبژێردراوەکاندا بگونجێت.',
    'd_1': 'د',
    'no_documents_uploaded_for_this_tenant': 'هیچ بەڵگەنامەیەک بۆ ئەم کرێچییە بارنەکراوە.',
    'empty_key_5': '✓',
    'empty_key_6': '✕',
    'empty_key_7': '($) *',
    'ai_lease_reader': 'خوێنەری بەکرێدانی AI',
    'upload_a_lease_pdf_to_auto_fill_the_form': 'بۆ پڕکردنەوەی فۆڕمەکە بە شێوەیەکی ئۆتۆماتیکی PDF ی بەکرێدان باربکە',
    'empty_key_8': '●',
    'empty_key_9': '✓',
    '10_1': '10 / 10 .',
    '25_1': '25 / 2019 .',
    '50_1': '50 /',
    '100_1': '100 /',
    'register_as_maintenance_provider_service': 'ناوت تۆمار بکە وەک دابینکەری چاککردنەوە (فرۆشیاری خزمەتگوزاری)',
    'this_will_automatically_create_a_record': 'ئەمەش بە شێوەیەکی ئۆتۆماتیکی تۆمارێک لە ناوەندی چاککردنەوەدا دروست دەکات بۆ ئەوەی بتوانیت فەرمانی کارکردن بۆ ئەم بەکارهێنەرە دیاری بکەیت.',
    'assigned_buildings_portfolio': 'بینا دیاریکراوەکان (پۆرتفۆلیۆ)',
    'select_the_buildings_this_portfolio_mana': 'ئەو بینایانە هەڵبژێرە کە ئەم بەڕێوەبەری پۆرتفۆلیۆیە دەتوانێت دەستیان پێ بگات. ئەوان تەنها داتای ئەم بینایانە دەبینن.',
    'no_buildings_found_please_create_buildin': 'هیچ بینایەک نەدۆزراوەتەوە. تکایە سەرەتا بینا دروست بکەن.',
    'building_3': 'بینا',
    'empty_key_10': '☀️',
    '1_315_333_7884': '+1 (315) 333-7884',
    'sent_sid': '✅ نێردراوە! SID:',
    'iraq_964_is_blocked_by_default_enable_it': '🌍 عێراق (+964) بە دیفۆڵت بلۆک کراوە. چالاک بکە:',
    'twilio_messaging_geo_permissions_iraq_on': 'Twilio → نامە ناردن → جیۆ مۆڵەتەکان → عێراق → داگیرساندن → پاشەکەوتکردن',
    'trial_accounts_can_only_message': '🔒 ئەکاونتی تاقیکاری تەنها دەتوانێت نامە',
    'verified_numbers': 'ژمارە پشتڕاستکراوەکان',
    'apt_1': '· ئاپت',
    'mo_1': '/مۆ',
    'mo_2': '/مۆ',
    'manage_building_amenities_unit_features': 'بەڕێوەبردنی خزمەتگوزارییەکانی بینا و تایبەتمەندییەکانی یەکەکان و شوێنی وەستانی ئۆتۆمبێل',
    'all_buildings_1': 'هەموو بیناکان',
    'add_amenity': 'زیادکردنی ئاسانکاری',
    'no_building_amenities_found': 'هیچ خزمەتگوزارییەکی بیناسازی نەدۆزراوەتەوە',
    'all_buildings_2': 'هەموو بیناکان',
    'all_units': 'هەموو یەکەکان',
    'add_unit_amenity': 'زیادکردنی ئاسانکاری یەکە',
    'no_unit_amenities_found': 'هیچ خزمەتگوزارییەکی یەکە نەدۆزراوەتەوە',

    'unit_amenities': 'خزمەتگوزارییەکانی یەکە',
    'edit_unit_amenity': 'دەستکاریکردنی خزمەتگوزاری یەکە',
    'col_monthly_fee': 'کرێی مانگانە',
    'col_available': 'بەردەستە',
    'col_space': 'شوێن',
    'col_amenity': 'خزمەتگوزاری',
    'all_buildings_3': 'هەموو بیناکان',
    'available_2': 'بەردەستە',
    'reserved': 'تەرخانکراوە',
    'add_space': 'زیادکردنی شوێن',
    'no_parking_spaces_found': 'هیچ شوێنێکی وەستانی ئۆت��مبێل نەدۆزراوەتەوە',
    'assign': 'تەرخان بکە',
    'unassign': 'Unassign',
    'spaces': 'فەزاکان',
    'driveway_area': 'ناوچەی ڕێگای هاتووچۆ',
    'cancel_4': 'هەڵوەشاندنەوە',
    'complete': 'تەواو',
    'confirm_1': 'پشتڕاستی بکەرەوە',
    'cancel_5': 'هەڵو��شاندنەوە',
    'complete_1': 'تەواو',
    'assign_space': 'شوێن دیاری بکە',
    'select_tenant_1': 'کرێچی هەڵبژێرە',
    'choose_tenant': '-- کرێچی هەڵبژێرە --',
    'select_owner': 'Owner هەڵبژێرە',
    'choose_owner': '-- خاوەن هەڵبژێرە --',
    'cancel_6': 'هەڵوەشاندنەوە',
    'assign_1': 'تەرخان بکە',
    'new_amenity_booking': 'حجزکردنی ئاسانکاری نوێ',
    'amenity': 'ئاسانکاری *',
    'select_amenity': 'ئاسانکاری هەڵبژێرە...',
    'tenant_1': 'کرێچی *',
    'select_tenant_2': 'کرێچی هەڵبژێرە...',
    'date_1': 'بەروار *',
    'notes_3': 'تێبینی',
    'cancel_7': 'هەڵوەشاندنەوە',
    'deactivated': 'ناچالاک کراوە',
    'max_uses': 'زۆرترین بەکارهێنان',
    'generate_application_link': 'دروستکردنی بەستەری بەرنامە',
    'building_4': 'بینا *',
    'specific_unit_optional': 'یەکەی تایبەت (ئیختیاری)',
    'any_unit_in_building': 'هەر یەکەیەکی لە بیناسازیدا',
    'unit_5': 'یەکەی',
    'floor_5': '– نهۆم',
    'label': 'لیبێڵ',
    'expires_at': 'بەسەر دەچێت لە کاتژمێر',
    'max_uses_1': 'زۆرترین بەکارهێنان',
    'cancel_8': 'هەڵوەشاندنەوە',
    'label_unit': 'لیبێڵ / یەکە',
    'token_url': 'URL ی نیشانە',
    'uses': 'بەکارهێنان',
    'status_1': 'دۆخ',
    'no_links_yet_click_generate_link_to_crea': 'هێشتا هیچ بەستەرێک نییە. بۆ دروستکردنی یەکێک کلیک لە "Generate Link" بکە.',
    'link_generated': 'بەستەر دروستکرا!',
    'failed_to_generate_link': 'سەرکەوتوو نەبوو لە دروستکردنی بەستەر',
    'failed_to_load_links': 'سەرکەوتوو نەبوو لە بارکردنی بەستەرەکان',
    'link_deactivated': 'بەستەر ناچالاک کرا',
    'search_label_building_token': 'گەڕان بە ناونیشان، بینا، یان تۆکێن…',
    'links_count': '{{count}} بەستەر',
    'untitled': 'بێ ناونیشان',
    'open_form': 'کردنەوەی فۆرم',
    'no_links_match_filters': 'هیچ بەستەرێک لەگەڵ فلتەرەکانت نەگونجاو.',
    'unit_6': '· یەکەی',
    '1_30': '1-30',
    '31_60': '31–60',
    '61_90': '61–90',
    'building_amenity': 'ئاسانکاری بیناسازی',
    'amenity_details': 'وردەکارییەکانی خزمەتگوزارییەکان',
    'building_5': 'بینا *',
    'name_4': 'ناو *',
    'category_1': 'پۆل',
    'monthly_fee': 'نرخی مانگانە ($)',
    'operating_hours': 'کاتی کارکردن',
    'capacity': 'توانا',
    'description_1': 'وەسف',
    'notes_4': 'تێبینی',
    'available_for_booking': 'بەردەستە بۆ حجزکردن',
    'cancel_9': 'هەڵوەشاندنەوە',
    'saving_1': 'پاشەکەوتکردن...',
    'bulk_tenant_import': 'هاوردەکردنی کرێچی بەکۆمەڵ',
    'import_tenants_from_a_csv_file_apartment': 'کرێچیەکان لە فایلێکی CSVەوە گرنگ بکە — شوقەکان بە ناوی بینا + ژمارەی یەکە هاوتا دەکرێن',
    'download_csv_template': 'داگرتنی قاڵبی CSV',
    'use_this_template_to_format_your_data_co': 'ئەم قاڵبە بەکاربهێنە بۆ فۆرماتکردنی داتاکانتان بە دروستی',
    'template': 'قاڵب',
    'required_columns': 'ستوونی پێویست',
    'optional_columns': 'ستوونی ئیختیاری',
    'payment_date_2': 'بەرواری_پارەدان',
    'day_of_month_1_31': '= ڕۆژی مانگ (1–31) ·',
    'contract_start_contract_end': 'دەستپێکردنی_گرێبەست / کۆتایی_گرێبەست',
    'yyyy_mm_dd': '= YYYY-MM-DD ·',
    'en_ar_fr_de_it_sp': '= en, ar, fr, de, it, sp',
    'parsing_csv': 'پارسکردنی CSV...',
    'or_click_to_browse_max_2_mb': 'یان کلیک بکە بۆ گەڕان — زۆرترین 2 مێگابایت',
    'import_preview': 'پێشبینی هاوردەکردن',
    'rows_found_review_before_importing': 'ڕیزەکان دۆزرایەوە — پێداچوونەوە بکە پێش هاوردەکردن',
    'start_over': 'سەرلەنوێ دەستپێبکە',
    'name_5': 'ناو',
    'phone_5': 'تەلەفۆن',
    'building_unit': 'بینا / یەکە',
    'contract_1': 'گرێبەست',
    'status_2': 'دۆخ',
    'empty_key_11': '· # .',
    'ready_to_import': 'ئامادەیە بۆ هاوردەکردن',
    'tenant_2': 'کرێچی',
    'row': 'ڕیز',
    'with_errors_will_be_skipped': 'لەگەڵ هەڵەکان دەپەڕێتەوە',
    'no_valid_rows_to_import': 'هیچ ڕیزێکی دروست نییە بۆ هاوردەکردن',
    'fix_the_errors_in_your_csv_and_try_again': 'هەڵەکانی ناو CSV ـەکەت چاک بکەرەوە و دووبارە هەوڵبدەرەوە',
    'upload_new_file': 'بارکردنی فایلێکی نوێ',
    'import_complete': 'هاوردەکردن تەواو بووە',
    'tenants_successfully_imported': 'کرێچیەکان بە سەرکەوتوویی هاوردەیان کرد',
    'row_1': 'ڕیز',
    'skipped_rows': 'ڕیزەکانی بەجێهێشتووە',
    'row_2': 'ڕیز',
    'import_another_file': 'هاوردەکردنی فایلێکی تر',
    'view_tenants': 'بینینی کرێچییەکان',
    'payout_settings': 'ڕێکخستنەکانی پارەدان',
    'upload_document': 'بەڵگەنامە بارکردن',
    'tenant_3': 'کرێچی *',
    'select_tenant_3': 'کرێچی هەڵبژێرە...',
    'document_name': 'ناوی بەڵگەنامە *',
    'category_2': 'پۆل',
    'file_pdf_image_word_max_5mb': 'فایل * (PDF، وێنە، وشە — زۆرترین 5MB)',
    'upload_document_1': 'بەڵگەنامە بارکردن',
    'document_management': 'بەڕێوەبردنی بەڵگەنامە',
    'document': 'بەڵگەنامە',
    'across_all_tenants': 'لە سەرانسەری هەموو کرێچییەکان',
    'upload': 'بارکردن',
    'all_categories': 'هەموو پۆلەکان',
    'document_1': 'بەڵگەنامە',
    'tenant_4': 'کرێچی',
    'category_3': 'پۆل',
    'status_3': 'دۆخ',
    'uploaded': 'بارکراوە',
    'actions_1': 'کردارەکان',
    'no_documents_found': 'هیچ بەڵگەنامەیەک نەدۆزراوەتەوە',
    'of_2': 'لە',
    'prev': 'پێشتر',
    'next_1': 'دواتر',
    'select_tenant_required': 'کرێچیێک هەڵبژێرە',
    'document_name_required': 'ناوی بەڵگەنامە پێویستە',
    'select_file_required': 'تکایە فایلێک هەڵبژێرە',
    'document_uploaded': 'بەڵگەنامە بارکرا',
    'upload_failed': 'بارکردن سەرکەوتوو نەبوو',
    'failed_to_load_documents': 'سەرکەوتوو نەبوو لە بارکردنی بەڵگەنامەکان',
    'document_status_updated': 'دۆخی بەڵگەنامە نوێکرایەوە',
    'failed_to_update_status': 'سەرکەوتوو نەبوو لە نوێکردنەوەی دۆخ',
    'confirm_delete_doc': 'سڕینەوەی "{{name}}"؟ ئەمە دەتوانرێت لەلایەن بەڕێوەبەرەوە پووچەڵ بکرێتەوە.',
    'failed_to_delete_document': 'سەرکەوتوو نەبوو لە سڕینەوە',
    'documents_count': '{{count}} بەڵگەنامە',
    'search_by_tenant_name': 'گەڕان بە ناوی کرێچی…',
    'doc_results_count': '{{count}} ئەنجام',
    'uploaded_from': 'بارکراو لە',
    'uploaded_to': 'بارکراو بۆ',
    'doc_cat_id': 'ناسنامە',
    'doc_cat_contract': 'گرێبەست',
    'doc_cat_financial': 'دارایی',
    'doc_cat_insurance': 'بیمە',
    'doc_cat_other': 'تر',
    'approved': 'پەسەندکراو',
    'file_1': 'فایل',
    'open_eviction_case': 'دۆسیەی دەرکردنی کراوە',
    'tenant_5': 'کرێچی',
    'tenant_6': 'کرێچی *',
    'building_apartment_auto_filled_from_tena': 'بینا و شوقە بە ئۆتۆماتیکی پڕکراوەتەوە ل�� تۆماری کرێچی',
    'case_details': 'وردەکارییەکانی کەیس',
    'reason': 'هۆکار *',
    'notice_type': 'جۆری ئاگاداری',
    'cancel_10': 'هەڵوەشاندنەوە',
    'open_case': 'کەیسی کراوە',
    'eviction_management': 'بەڕێوەبردنی دەرکردن',
    'track_and_manage_eviction_cases_from_not': 'بەدواداچوون و بەڕێوەبردنی کەیسەکانی دەرکردن لە ئاگادارکردنەوە ت�� تەواوبوون',
    'new_case': 'کەیسی نوێ',
    'pipeline': 'هێڵی بۆری',
    'no_eviction_cases_found': 'هیچ حاڵەتێکی دەرکردن نەدۆزراوەتەوە',
    'advance': 'پێشوەختە →',
    'eviction_case': 'دۆسیەی دەرکردن #',
    'tenant_7': 'کرێچی',
    'unit_7': '· یەکەی # .',
    'reason_1': 'عەقڵ',
    'amount_owed_1': 'بڕی قەرزدار',
    'pipeline_status': 'دۆخی بۆری',
    'notes_5': 'تێبینی',
    'expense_details': 'وردەکاری خەرجییەکان',
    'payment_info': 'زانیاری پارەدان',
    'add_line': '+ هێڵ زیاد بکە',
    'description_2': 'وەسف',
    'no_accounts_posted_yet': 'تا ئێستا هیچ ئەکاونتێک بڵاو نەکراوەتەوە.',
    'total_1': 'کۆی گشتی',
    'assets': 'سەروەت و سامان',
    'liabilities': 'ئیلتزاماتەکان',
    'select_a_date_and_click_run_to_generate': 'بەروارێک هەڵبژێرە و کرتە لە Run بکە بۆ دروستکردنی باڵانس.',
    'from_2': 'لە...',
    'to_2': 'بۆ...',
    'run_1': 'ڕاکردن',
    'operating_activities': 'چالاکییەکانی کارکردن',
    'net_operating_cash_flow': 'ڕۆیشتنی پارەی پاکی کارکردن',
    'financing_activities': 'چالاکییەکانی دارایی',
    'net_financing_cash_flow': 'ڕۆیشتنی پارەی پاکی دارایی',
    'net_change_in_cash': 'گۆڕانکاری پاک لە پارەی کاش',
    'select_a_date_range_and_click_run': 'مەودای بەروارێک هەڵبژێرە و کرتە لە Run بکە.',
    'balance_sheet': 'میزانیەت',
    'cash_flow_statement': 'ڕەوانەی پارە',
    'total_assets': 'کۆی دارایی',
    'total_liabilities': 'کۆی بەرپرسیارێتی',
    'total_equity': 'کۆی مافی خاوەن',
    'bs_balanced_msg': '✓ هاوسەنگ — دارایی = بەرپرسیارێتی + مافی خاوەن',
    'bs_unbalanced_msg': '⚠ نا-هاوسەنگ — تکایە تۆمارەکانی ژۆرنال پشکنیوە',
    'operating_cash_flow': 'ڕەوانەی پارەی کارکردن',
    'financing_cash_flow': 'ڕەوانەی پارەی دارایی',
    'edit_expense': 'دەستکاریکردنی خەرج',
    'expense_updated': 'خەرجەکە نوێکرایەوە',
    'rated': 'ڕیزبەندی کراوە',
    'property_inspections': 'پشکنینی موڵک و ماڵی',
    'move_in_move_out_periodic_20_item_standa': 'گواستنەوە · چوونە دەرەوە · خولیی · لیستی پشکنینی ستانداردکراوی ٢٠ بابەتی',
    'new_inspection': 'پشکنینی نوێ',
    'no_inspections_found': 'هیچ پشکنینێک نەدۆزراوەتەوە.',
    'adjust_the_filters_or_create_a_new_inspe': 'فلتەرەکان ڕێکبخە یان پشکنینی نوێ دروست بکە.',
    'showing_1': 'پیشاندانی',
    'of_3': 'لە',
    'new_inspection_1': 'پشکنینی نوێ',
    'apartment_2': 'شوقە',
    'nothing_found': 'هیچ نەدۆزراوەتەوە.',
    'unit_8': '— یەکە',
    'no_active_tenant_on_this_unit': 'هیچ کرێچییەکی چالاک لەسەر ئەم یەکەیە.',
    'tenant_8': 'کرێچی',
    'no_tenant_vacant': 'بێ کرێچی (بەتاڵ)',
    'inspection_type': 'جۆری پشکنین',
    'overall_condition': 'باری گشتی',
    'a_20_item_standardized_checklist_entranc': 'لیستی پشکنینی ستانداردی ٢٠ بابەتی (دەرگای چوونە ژوورەوە، ژووری میوان، چێشتخانە، حەمام، ژووری نوستن، گشتی) بە شێوەیەکی ئۆتۆماتیکی دروست دەکرێت.',
    'cancel_11': 'هەڵوەشاندنەوە',
    'creating': 'دروستکردنی...',
    'create_inspection': 'دروستکردنی پشکنین',
    'unit_9': '· یەکەی',
    'tenant_9': 'کرێچی:',
    'inspector': 'پشکنەر: ١.',
    'print_2': 'چاپ',
    'checklist_completion': 'تەواوکردنی لیستی پشکنین',
    'overall': 'بە گشتی:',
    'click_a_condition_button_to_rate_each_it': 'بۆ هەڵسەنگاندنی هەر شتێک کلیک لە دوگمەی مەرج بکە. تێبینیەکان بە شێوەیەکی ئۆتۆماتیکی لە کاتی کاڵبوونەوەدا هەڵدەگیرێن.',
    'general_notes_1': 'تێبینی گشتی',
    'close_1': 'دابخە',
    'completing': 'تەواوکردنی...',
    'mark_as_completed': 'وەک تەواوکراو نیشانە بکە',
    'close_2': 'دابخە',
    'signing': 'واژۆکردن...',
    'sign_inspection': 'واژۆکردنی پشکنین',
    'sign_inspection_message': 'دەتەوێت ئەم پشکنینە وەک واژۆکراو دابنێی؟ ئەم کردارە کۆتاییە و ناتوانرێت هەڵبوەشێتەوە.',
    'signing_is_final_and_cannot_be_undone': 'واژۆکردن کۆتاییە و ناتوانرێت هەڵبوەشێتەوە.',
    'delete_draft_inspection': 'سڕینەوەی ڕەشنووسەی پشکنین',
    'delete_draft_confirm': 'دڵنیای کە دەتەوێت ئەم ڕەشنووسەی پشکنینە بسڕیتەوە؟',
    'failed_load_inspections': 'شکستی هێنا بارکردنی پشکنینەکان',
    'inspection_created': 'پشکنین دروستکرا',
    'failed_create_inspection': 'شکستی هێنا دروستکردنی پشکنین',
    'failed_save_checklist': 'شکستی هێنا پاشەکەوتکردنی لیستی پشکنین',
    'inspection_completed': 'پشکنین وەک تەواوبوو دانرا',
    'inspection_signed': 'پشکنین واژۆکرا',
    'failed_sign_inspection': 'شکستی هێنا واژۆکردنی پشکنین',
    'failed_update_condition': 'شکستی هێنا نوێکردنەوەی دۆخ',
    'inspection_deleted': 'پشکنین سڕایەوە',
    'failed_delete_inspection': 'تەنها ڕەشنووسەی پشکنین دەتوانرێت بسڕێتەوە',
    'search_inspections_placeholder': 'بگەڕێ بە یەکە، بینا یان بەندەر...',
    'search_apartment_placeholder': 'بگەڕێ بۆ شوقە...',
    'inspection_notes_placeholder': 'هەر تێبینی یان چاودێریی سەرەتایی...',
    'item_notes_placeholder': 'تێبینی بۆ ئەم بەندە زیاد بکە...',
    'fair': 'مامناوەند',
    'poor': 'خراپ',
    'covered_entity': 'یەکەیەکی داپۆشراو',
    'select': 'هەڵبژێرە',
    'policy_details': 'وردەکاری سیاسەت',
    'insurer_name': 'ناوی بیمەدەر *',
    'start_date_2': 'بەرواری دەستپێکردن',
    'notes_6': 'تێبینی',
    'cancel_12': 'هەڵوەشاندنەوە',
    'manage_tenant_owner_and_building_insuran': 'بەڕێوەبردنی بیمەی کرێچی و خاوەن و بینا',
    'empty_key_12': '✓',
    'new_lease_application': 'داواکاری بەکرێدانی نوێ',
    'applicant_information': 'زانیاری داواکار',
    'full_name_1': 'ناوی تەواو *',
    'email_3': 'ئیمەیڵ',
    'phone_6': 'تەلەفۆن',
    'date_of_birth': 'بەرواری لە دایک بوون',
    'current_address': 'ناونیشانی ئێستا',
    'employment': 'دامەزراندن',
    'employment_status': 'دۆخی دامەزراندن',
    'monthly_income': 'داهاتی مانگانە ($)',
    'employer_name': 'ناوی خاوەنکار',
    'employer_phone': 'تەلەفۆنی خاوەنکار',
    'unit_preferences': 'هەڵبژاردەکانی یەکە',
    'building_6': 'بینا',
    'unit_10': 'یەکەی',
    'desired_move_in': 'گواستنەوەی خوازراو',
    'desired_lease_months': 'بەکرێدانی خوازراو (مانگ)',
    'has_pets': 'ئاژەڵی ماڵی هەیە',
    'pet_details': 'وردەکارییەکانی ئاژەڵە ماڵیەکان',
    'notes_7': 'تێبینی',
    'cancel_13': 'هەڵوەشاندنەوە',
    'submit_application': 'پێشکەشکردنی داواکاری',
    'review_and_approve_prospective_tenant_ap': 'پێداچوونەوە و پەسەندکردنی داواکارییەکانی کرێچی ئایندەیی',
    'all_buildings_4': 'هەموو بیناکان',
    'no_applications_found': 'هیچ بەرنامەیەک نەدۆزراوەتەوە',
    'showing_2': 'پیشاندانی',
    'of_4': 'لە',
    'prev_1': 'پێشتر',
    'next_2': 'دواتر',
    'close_3': 'دابخە',
    'unit_11': '· یەکەی # .',
    'monthly_rent_2': 'کرێی مانگانە *',
    'discount_1': 'داشکاندن',
    'contract_start_1': 'دەستپێکردنی گرێبەست *',
    'contract_end_1': 'کۆتایی گرێبەست *',
    'payment_day_of_month': 'ڕۆژی پارەدان *',
    'application': 'داواکاری',
    'rejection_reason': 'هۆکاری ڕەتکردنەوە',
    'cancel_14': 'هەڵوەشاندنەوە',
    'app_search_placeholder': 'بگەڕێ بە ناو، ئیمەیڵ، تەلەفۆن…',
    'app_status_submitted': 'پێشکەشکراو',
    'app_status_under_review': 'لە پێداچوونەوەدایە',
    'app_status_approved': 'پەسەندکراو',
    'app_status_rejected': 'ڕەتکراوە',
    'app_status_waitlisted': 'لە لیستی چاوەڕوانیدایە',
    'app_status_withdrawn': 'کێشراوەتەوە',
    'app_status_converted': 'گۆڕدراوە',
    'sort_newest': 'نوێترین پێشیوتر',
    'sort_movein_asc': 'کۆچ ↑ نزیکترین',
    'sort_movein_desc': 'کۆچ ↓ دوورترین',
    'sort_income_asc': 'داهات ↑ کەمترین',
    'sort_income_desc': 'داهات ↓ زۆرترین',
    'all_employment': 'هەموو جۆری کار',
    'emp_other': 'تر',
    'move_in_from': 'کۆچ لە',
    'move_in_to': 'کۆچ بۆ',
    'application_results_count': '{{count}} داواکاری',
    'failed_to_load_lease_applications': 'بارکردنی داواکارییەکان سەرنەکەوت',
    'status_updated_to': 'دۆخ نوێکرایەوە بۆ {{status}}',
    'rent_dates_payment_required': 'کرێ، بەرواری دەستپێک و کۆتایی و ڕۆژی پارەدان پێویستن',
    'converted_to_tenant_success': 'گۆڕدرا بۆ کرێچی',
    'conversion_failed': 'گۆڕین سەرنەکەوت',
    'lease_duration_months_label': 'ماوەی بەکرێدان',
    'lease_duration_months': '{{n}} مانگ',
    'details_not_provided': 'وردەکاری پێشکەش نەکراوە',
    'reviewed_by': 'پێداچوونەوە لەلایەن',
    'reviewed_at': 'بەرواری پێداچوونەوە',
    'converting': 'گۆڕین دەکرێت…',
    'applicant_name_required': 'ناوی داواکار پێویستە',
    'failed_to_submit_application': 'پێشکەشکردنی داواکاری سەرنەکەوت',
    'submitting': 'پێشکەشکردن…',
    'update_failed': 'نوێکردنەوە سەرنەکەوت',
    'nightly_scan_flags_leases_expiring_in_90': 'سکانکردنی شەوانە بەکرێدانەکان لە ٩٠ ڕۆژدا بەسەر دەچێت — ڕەشنووسی ئۆفەرەکان بە شێوەیەکی ئۆتۆماتیکی دروست دەکرێن، تۆ بە یەک کلیک دەینێری',
    'send_all_drafts': 'هەموو ڕەشنووسەکان بنێرە (',
    'expiring_within_90_days': 'لە ماوەی ٩٠ ڕۆژدا بەسەر دەچێت',
    'without_an_offer_yet': 'بەبێ ئۆفەر هێشتا',
    'd_2': 'د',
    'offer_sent': 'ئۆفەر نێردراوە',
    'no_offer': 'هیچ ئۆفەرێک نییە',
    'all_statuses_1': 'هەموو دۆخەکان',
    'no_renewals_found': 'هیچ نوێکردنەوەیەک نەدۆزراوەتەوە',
    'd_left': 'د چەپ',
    'convert_lease': 'گۆڕینی بەکرێدان',
    'counter_offer': 'ئۆفەری کەوانتەر',
    'tenant_10': 'کرێچی:',
    'counter_rent_amount': 'بڕی کرێی کەوانتەر *',
    'cancel_15': 'هەڵوەشاندنەوە',
    'send_counter': 'ژمێرەری بنێرە',
    'error_loading_renewals': 'سەرکەوتوو نەبوو لە بارکردنی نوێکردنەوەکان',
    'offer_sent_2': 'پێشنیار نێردرا',
    'error_sending_offer': 'سەرکەوتوو نەبوو لە ناردنی پێشنیار',
    'renewal_accepted': 'نوێکردنەوە قبووڵکرا',
    'error_accepting_renewal': 'سەرکەوتوو نەبوو لە قبووڵکردنی نوێکردنەوە',
    'decline_renewal_title': 'ڕەتکردنەوەی نوێکردنەوە',
    'decline_renewal_msg': 'دڵنیایت دەتەوێت ئەم پێشنیاری نوێکردنەوەیە ڕەت بکەیتەوە؟',
    'renewal_declined': 'نوێکردنەوە ڕەتکرایەوە',
    'error_declining_renewal': 'سەرکەوتوو نەبوو لە ڕەتکردنەوەی نوێکردنەوە',
    'lease_converted_msg': 'بەکرێدان گوێزرایەوە — تۆمارەکەی بەکرێگر نوێکرایەوە!',
    'error_converting_renewal': 'سەرکەوتوو نەبوو لە گوێزاندنەوەی نوێکردنەوە',
    'drafts_created': '{{count}} پێشنووسی پێشنیار دروستکرا!',
    'no_new_drafts_needed': 'پێشنووسی نوێ پێویست نییە — هەموو بەکرێدانە بەسەرچووەکان پێشنیاریان هەیە.',
    'error_generating_drafts': 'سەرکەوتوو نەبوو لە دروستکردنی پێشنووسەکان',
    'no_draft_renewals_to_send': 'هیچ نوێکردنەوەی پێشنووس نییە بۆ ناردن',
    'send_all_draft_offers_title': 'ناردنی هەموو پێشنیارەکانی پێشنووس',
    'send_all_draft_offers_msg': 'پێشنیارەکانی نوێکردنەوە بنێرە بۆ هەموو {{count}} بەکرێگری پێشنووس (ئیمەیڵ + واتساپ)؟',
    'offers_sent': '{{count}} پێشنیار نێردرا!{{failed}}',
    'error_sending_offers': 'سەرکەوتوو نەبوو لە ناردنی پێشنیارەکان',
    'counter_offer_sent': 'پێشنیاری پێچەوانە نێردرا',
    'error_sending_counter': 'سەرکەوتوو نەبوو لە ناردنی پێشنیاری پێچەوانە',
    'search_tenant_unit_building': 'گەڕان بە بەکرێگر، یەکە، بینا…',
    'all_risk': 'هەموو مەترسیەکان',
    'risk_low': 'مەترسی کەم',
    'risk_medium': 'مەترسی ناوەندی',
    'risk_high': 'مەترسی زۆر',
    'renewals_count': '{{count}} نوێکردنەوە',
    'leases_expiring_90d': '{{count}} بەکرێدان لەناو 90 ڕۆژدا بەسەرئەچێت',
    'viewed_1': 'بینراوە',
    'accepted_1': 'قبووڵکراو',
    'counter_offered': 'پێشنیاری پێچەوانە',
    'declined_1': 'ڕەتکراوە',
    'full_lease_lifecycle_create_renew_termin': 'سوڕی ژیانی تەواوی بەکرێدان — دروستکردن، نوێکردنەوە، کۆتاییهێنان، مێژوو',
    'new_lease': 'بەکرێدانی نوێ',
    'all_status_1': 'هەموو دۆخێک',
    'active_1': 'چالاکە',
    'expired_1': 'بەسەرچو��',
    'renewed': 'نوێ کراوەتەوە',
    'all_buildings_5': 'هەموو بیناکان',
    'no_leases_found': 'هیچ بەکرێدانێک نەدۆزراوەتەوە',
    'expired_2': 'بەسەرچوو',
    'd_left_1': 'د چەپ',
    'd_left_2': 'د چەپ',
    'd_3': 'د',
    'renew': 'نوێ بکەرەوە',
    'terminate': 'کۆتایی پێبهێنە',
    'terminate_lease': 'کۆتاییهێنان بە بەکرێدان',
    'this_action_cannot_be_undone_the_lease_w': 'ئەم کارە ناتوانرێت پووچەڵ بکرێتەوە. بەکرێدانەکە بۆ هەمیشە کۆتایی دێت.',
    'cancel_16': 'هەڵوەشاندنەوە',
    'empty_key_13': '— #',
    'new_start_date': 'بەرواری دەستپێکردنی نوێ *',
    'monthly_rent_3': 'کرێی مانگانە ($) *',
    'lease_type_1': 'جۆری بەکرێدان',
    'fixed_term_1': 'ماوەی جێگیر',
    'month_to_month_1': 'مانگ بە مانگ',
    'annual_1': 'ساڵانە',
    'renew_lease_1': 'نوێکردنەوەی بەکرێدان',
    'cancel_17': 'هەڵوەشاندنەوە',
    'expiry_days': '{{days}} ڕۆژ',
    'leases_expiring_within_60d': '{{count}} بەکرێدان لە ماوەی 60 ڕۆژدا بەسەردەچێت',
    'sort_default': 'ڕیزکردن: بنەڕەت',
    'sort_expiry_asc': 'کۆتاییهێنان ↑ نزیکترین',
    'sort_expiry_desc': 'کۆتاییهێنان ↓ دوورترین',
    'sort_rent_asc': 'کرێ ↑ کەمترین',
    'sort_rent_desc': 'کرێ ↓ زۆرترین',
    'sort_name_asc': 'کرێچی ئ → ی',
    'expiring_within': 'بەسەردەچێت لەناو',
    'any_expiry': 'هەر کاتی کۆتایی',
    'days_lte': '≤ {{n}} ڕۆژ',
    'create_tenant_for_lease': 'کرێچیێک زیاد بکە بۆ دروستکردنی تۆمارەکە بە خۆکارى.',
    'terminating': 'کۆتاییهێنان...',
    'enter_termination_reason': 'هۆکاری کۆتاییهێنان بنووسە...',
    'failed_to_load_leases': 'بارکردنی بەکرێدانەکان سەرنەکەوت',
    'renewal_failed': 'نوێکردنەوە سەرنەکەوت',
    'terminate_failed': 'کۆتاییهێنان سەرنەکەوت',
    'start_date_and_rent_required': 'بەرواری دەستپێک و کرێی مانگانە پێویستن',
    'lease_results_count': '{{count}} بەکرێدان',
    'description_3': 'وەسف',
    'tenant_11': 'کرێچی',
    'close_4': 'دابخە',
    'new_maintenance_schedule': 'خشتەی نوێی چاککردنەوە',
    'schedule_details': 'وردەکاری خشتەی کارەکان',
    'building_7': 'بینا',
    'all_buildings_6': 'هەموو بیناکان',
    'frequency': 'فرێکوێنسی *',
    'first_due_date': 'یەکەم بەرواری کۆتایی *',
    'description_4': 'وەسف',
    'cancel_18': 'هەڵوەشاندنەوە',
    'create_schedule': 'دروستکردنی خشتەی کار',
    'maintenance_schedules': 'خشتەی چاککردنەوە',
    'preventive_maintenance_tracking': 'بەدواداچوون بۆ چاککردنەوەی خۆپارێزی',
    'new_schedule': 'خشتەی نوێ',
    'overdue_work_orders_will_be_auto_created': 'دواکەوتووە — ئەمشەو فەرمانەکانی کارکردن بە شێوەیەکی ئۆتۆماتیکی دروست دەکرێن',
    'no_schedules_found': 'هیچ خشتەیەک نەدۆزراوەتەوە',
    'history': 'مێژوو —',
    'no_history_yet': 'هێشتا هیچ مێژوویەک نییە',
    'wo': 'وۆ # .',
    'empty_key_14': '✓',
    'owner_ledger': 'خاوەنی کتێبی سەرەکی',
    'immutable_financial_history': '— مێژووی دارایی نەگۆڕ',
    'refresh_1': 'نوێکردنەوە',
    'add_entry': 'زیادکردنی هاتنە ژوورەوە',
    'income': 'داهات',
    'payouts': 'پارەدان',
    'add_manual_ledger_entry': 'زیادکردنی هاتنە ژوورەوەی کتێبی دەستی دەستی',
    'amount_3': 'بڕی *',
    'description_5': 'وەسف *',
    'cancel_19': 'هەڵوەشاندنەوە',
    'showing_3': 'پیشاندانی',
    'of_5': 'لە',
    'prev_2': 'پێشتر',
    'next_3': 'دواتر',
    'new_parking_space': 'شوێنی نوێی وەستانی ئۆتۆمبێل',
    'creation_mode': 'دۆخی دروستکردن',
    'single_space': 'تاکە فەزای',
    'bulk_generation': 'نەوەی بەکۆمەڵ',
    'building_8': 'بینا *',
    'select_building_1': 'بینا هەڵبژێرە...',
    'prefix': 'پێشگر',
    'start_number': 'ژمارەی دەستپێکردن *',
    'end_number': 'ژمارەی کۆتایی *',
    'pad_with_zeros_e_g_01_02': 'پاد لەگەڵ سفرەکان؟ (بۆ نموونە 01، 02)',
    'space_number': 'ژمارەی شوێن *',
    'level': 'ئاست',
    'type_1': 'جۆر',
    'monthly_fee_1': 'نرخی مانگانە ($)',
    'notes_8': 'تێبینی',
    'cancel_20': 'هەڵوەشاندنەوە',
    'saving_2': 'پاشەکەوتکردن...',
    'create_space': 'دروستکردنی فەزا',
    'tenant_screening': 'سکرینکردنی کرێچی',
    'identity_verification_background_checks': 'پشتڕاستکردنەوەی ناسنامە و پشکنینی پێشینە',
    'unit_12': 'یەکەی',
    'select_a_tenant_to_view_or_start_their_s': 'کرێچییەک هەڵبژێرە بۆ بینین یان دەستپێکردنی سکرینکردنیان',
    'final_decision': 'بڕیاری کۆتایی',
    'set_on': 'دانانی لەسەر',
    'identity_verification': 'پشتڕاستکردنەوەی ناسنامە',
    'document_2': 'بەڵگەنامە:',
    'name_6': 'ناو:',
    'start_identity_verification': 'دەست بە پشتڕاستکردنەوەی ناسنامە بکە',
    'link_was_shared_with_the_tenant_waiting': 'لینکەکە لەگەڵ کرێچیەکەدا هاوبەش بوو — چاوەڕێی ئەوە بوو کە تەواویان بکەن.',
    'background_check_checkr': 'پشکنینی پاشخان (Checkr)',
    'adjudication': 'دادوەری:',
    'checks': 'پشکنینەکان:',
    'start_background_check': 'دەستپێکردنی پشکنینی پاشخان',
    'united_states': 'ئەمریکا',
    'canada': 'کەنەدا',
    'fcra_consent_required': 'ڕەزامەندی FCRA پێویستە',
    'under_the_fair_credit_reporting_act_fcra': 'بەپێی یاسای ڕاپۆرتکردنی قەرزی دادپەروەرانە (FCRA)، پێویستە ڕەزامەندی نووسراوی داواکار بەدەستبهێنیت پێش ئەوەی پشکنینی پێشینە ئەنجام بدەیت. کرێچی ئیمەیڵێک لە چێکرەوە وەردەگرێت بۆ تەواوکردنی پرۆسەکە.',
    'i_confirm_the_applicant_has_provided_wri': 'من پشتڕاستی دەکەمەوە کە داواکار ڕەزامەندی نووسراوی بۆ ئەم پشکنینە پێشینەیە پێشکەش کردووە',
    'cancel_21': 'هەڵوەشاندنەوە',
    'invitation_sent_waiting_for_the_applican': 'بانگهێشتنامە نێردراوە — چاوەڕێی تەواوکردنی داواکارە. Checkr بە شێوەیەکی ئۆتۆماتیکی ئەمە نوێ دەکاتەوە.',
    'set_final_decision': 'بڕیاری کۆتایی دابنێ',
    'final_screening_decision': 'بڕیاری کۆتایی سکرینکردن',
    'manual_review': 'پێداچوونەوەی دەستی',
    'cancel_22': 'هەڵوەشاندنەوە',
    'no_screening_started_for_this_tenant_yet': 'تا ئێستا هیچ سکرینێک بۆ ئەم کرێچییە دەستی پێنەکردووە.',
    'empty_key_15': '($) *',
    'prospect_information': 'زانیاری ئاسۆ',
    'showing_details': 'پیشاندانی وردەکارییەکان',
    'empty_key_16': '· # .',
    'empty_key_17': '· # .',
    'add_unit_amenity_1': 'زیادکردنی ئاسانکاری یەکە',
    'bulk_addition_mode': 'دۆخی زیادکردنی بەکۆمەڵ',
    'add_this_amenity_to_multiple_units_at_on': 'ئەم ئاسانکارییە زیاد بکە بۆ چەندین یەکە بە یەکجار',
    'amenity_details_1': 'وردەکارییەکانی خزمەتگوزارییەکان',
    'clear_all': 'هەمووی پاک بکەرەوە',
    'nothing_found_1': 'هیچ نەدۆزراوەتەوە.',
    'amenity_name': 'ناوی ئاسانکاری *',
    'category_4': 'پۆل',
    'condition': 'مەرج',
    'notes_9': 'تێبینی',
    'cancel_23': 'هەڵوەشاندنەوە',
    'saving_3': 'پاشەکەوتکردن...',
    'add_amenity_1': 'زیادکردنی ئاسانکاری',
    'n_more': '+{{n}} زیاتر',
    'board_view': 'دیمەنی دەستەپان',
    'main_level': 'ئاستی سەرەکی',
    'unassigned_1': 'دابەش نەکراو',
    'unit_cat_appliance': 'ئامێر',
    'unit_cat_climate': 'ئاوهەوا',
    'unit_cat_view': 'دیمەن',
    'unit_cat_layout': 'ڕێکخستن',
    'unit_cat_finish': 'چارەسەرکردن',
    'unit_cat_storage': 'کۆگا',
    'unit_cat_connectivity': 'پەیوەندی',
    'unit_cat_safety': 'ئەمنیەت',
    'unit_cat_other': 'تر',
    'bld_cat_general': 'گشتی',
    'bld_cat_fitness': 'تەندروستی',
    'bld_cat_pool': 'مەلەوانگە',
    'bld_cat_common_area': 'شوێنی هاوبەش',
    'bld_cat_outdoor': 'دەرەوە',
    'bld_cat_security': 'ئەمنیەت',
    'bld_cat_business': 'بازرگانی',
    'bld_cat_parking': 'پارکینگ',
    'bld_cat_pet': 'ئاژەڵی ماڵەوە',
    'bld_cat_laundry': 'جلشۆری',
    'bld_cat_storage': 'کۆگا',
    'all_fields_required': 'هەموو خانەکان پێویستن',
    'booking_failed': 'بوکاپکردن سەرنەکەوت',
    'failed_to_load_amenity': 'بارکردنی ئاسانکاری سەرنەکەوت',
    'name_required': 'ناو پێویستە',
    'amenity_updated': 'ئاسانکاری نوێکرایەوە',
    'amenity_added': 'ئاسانکاری زیادکرا',
    'open_time': 'کردنەوە',
    'close_time': 'داخستن',
    'max_occupancy': 'زۆرترین جێگیرکردن',
    'edit_building_amenity': 'دەستکاریکردنی ئاسانکاری بینا',
    'new_building_amenity': 'ئاسانکاری بینای نوێ',
    'unit_required': 'یەکە پێویستە',
    'at_least_one_unit_required': 'لانیکەم یەک یەکە پێویستە',
    'unit_amenity_updated': 'ئاسانکاری یەکە نوێکرایەوە',
    'amenity_bulk_added': 'ئاسانکاری بۆ {{count}} یەکە زیادکرا',
    'selected_units_label': 'یەکەکانی هەڵبژێردراو *',
    'unit_searchable_label': 'یەکە * (گەڕانپذیر)',
    'search_add_multiple_units': 'گەڕان و زیادکردنی یەکە جیاواز...',
    'search_unit_by_num': 'گەڕان بەدوای یەکە بە ژمارە یان بینا...',
    'cond_new': 'نوێ',
    'cond_excellent': 'نایاب',
    'cond_good': 'باش',
    'cond_fair': 'مامناوەند',
    'cond_needs_repair': 'پێویستی بە چاکسازی',
    'utility_management': 'بەڕێوەبردنی سوودمەندی',
    'meter_accounts_rubs_billing_and_per_tena': 'Meter accounts, RUBS billing, and per-tenant utility charges',
    'option_a_metered': 'بژاردەی A — پێوەرکراو:',
    'add_account_record_reading_generate_bill': 'Add account → record reading → generate bills → charge to ledger',
    'option_c_rubs': 'بژاردەی B — RUBS:',
    'building_level_meter_split_equally_acros': 'پێوەری ئاستی بینا بە یەکسانی دابەش دەکرێت لەنێو هەموو بەرپرسانی چالاک',
    'reading_recorded_for': 'خوێندنەوە تۆمارکراوە بۆ...',
    'utility_accounts': 'ئەژمێری سوودمەندی',
    'no_utility_accounts_yet_add_one_to_start': 'هیچ ئەژمێری سوودمەندییەک نییە — یەکێک زیاد بکە بۆ دەستپێکردن بە فاتووراکردنی پێوەر.',
    'no_bills_yet_generate_from_meter_readings': 'هیچ فاتووراییەک نییە — ئەژمێری پێوەر زیاد بکە، خوێندنەوەکان تۆمار بکە، ئەوان فاتووراکان دروست بکە.',
    'no_readings': 'هیچ خوێندنەوەیەک نییە',
    'shared': 'هاوبەش کراوە',
    'reading': 'خوێندنەوە',
    'utility_bills': 'پڕۆژە یاسای خزمەتگوزارییەکان',
    'all_statuses_2': 'هەموو ستاتۆسەکان',
    'accounts': 'ئەژمێرەکان',
    'bills': 'فاتووراکان',
    'benchmarking': 'Benchmarking',
    'total_bills': 'کۆی فاتووراکان',
    'total_billed': 'کۆی فاتووراکراو',
    'charge': 'بارگاویکردنەوە',
    'add_meter_reading': 'زیادکردنی خوێندنەوەی پێوەر',
    'reading_value': 'بەهای خوێندنەوە *',
    'unit_13': 'یەکەی',
    'reading_date': 'بەرواری خوێندنەوە *',
    'notes_10': 'تێبینی',
    'cancel_24': 'هەڵوەشاندنەوە',
    'loading_1': 'بارکردن...',
    'accounts_tracked': 'ئەکاونتەکان بەدواداچوونیان بۆ کراوە',
    'monthly_consumption_last_6_months': 'بەکارهێنانی مانگانە — ٦ مانگی ڕابردوو',
    'monthly_cost': 'تێچووی مانگانە ($)',
    'no_readings_recorded_yet_for': 'تا ئێستا هیچ خوێندنەوەیەک بۆ...',
    'valuation_details': 'وردەکاری بەهادان',
    'building_9': 'بینا *',
    'market_value': 'بەهای بازاڕ ($) *',
    'valuation_date': 'بەرواری بەهادان *',
    'valuation_method': 'شێوازی بەهادان',
    'notes_11': 'تێبینی',
    'cancel_25': 'هەڵوەشاندنەوە',
    'portal': 'پۆرتاڵ ✓',
    'invite_as_system_user_full_portal_access': 'بانگهێشتکردن وەک بەکارهێنەری سیستەم (دەستگەیشتن بە تەواوی پۆرتاڵ)',
    'this_will_create_a_staff_account_with_th': 'ئەمەش دەبێتە هۆی دروستکردنی ئەکاونتێکی ستاف کە ڕۆڵی \'فرۆشیار\'ی هەبێت. بانگهێشتنامەیەکی ئیمەیڵیان پێدەگات بۆ دانانی وشەی نهێنی خۆیان.',
    'record_violation': 'پێشێلکردنی تۆمارەکان',
    'tenant_unit': 'کرێچی و یەکە',
    'tenant_12': 'کرێچی *',
    'unit_14': '— یەکە',
    'apartment_id': 'ناسنامەی شوقە',
    'auto_filled': 'بە شێوەیەکی ئۆتۆماتیکی پڕ دەکرێتەوە',
    'violation_details': 'وردەکاری سەرپێچی',
    'title_1': 'ناونیشان *',
    'type_2': 'جۆر *',
    'severity': 'توندی *',
    'incident_date': 'بەرواری ڕووداوەکە *',
    'fine_amount_optional': 'بڕی غەرامە (ئیختیاری)',
    'description_6': 'وەسف *',
    'if_a_fine_amount_is_entered_it_will_be_a': 'ئەگەر بڕە پارەیەکی غەرامە داخڵ بکرێت، ئەوا بە شێوەیەکی ئۆتۆماتیکی لە کتێبی سەرەکی کرێچی وەردەگیرێت.',
    'cancel_26': 'هەڵوەشاندنەوە',
    'record_violation_1': 'پێشێلکردنی تۆمارەکان',
    'violations_notices': 'سەرپێچی و ئاگادارییەکان',
    'track_lease_violations_and_issue_formal': 'بەدواداچوون بۆ سەرپێچیەکانی بەکرێدان و دەرکردنی ئاگاداری یاسایی فەرمی',
    'new_violation': 'پێشێلکاری نوێ',
    'how_it_works_1': 'چۆن کاردەکات',
    'all_statuses_3': 'هەموو دۆخەکان',
    'notice': 'ئاگاداری',
    'resolve': 'یەکلایی بکەرەوە',
    'issue_legal_notice': 'ئاگاداری یاسایی دەربکە',
    'cancel_27': 'هەڵوەشاندنەوە',
    'add_webhook_endpoint': 'زیادکردنی Webhook Endpoint',
    'push_events_to_your_external_systems': 'ڕووداوەکان پاڵ بنێن بۆ سیستەمی دەرەکیتان',
    'successfully_created': 'بە سەرکەوتوویی دروستکراوە!',
    'save_your_signing_secret_now_it_won_t_be': 'ئ��ستا نهێنی واژۆکردنەکەت هەڵبگرە — جارێکی تر نیشان نادرێتەوە.',
    'copy_secret': 'نهێنی کۆپی بکە',
    'done_return': 'تەواو و گەڕانەوە',
    'connection_details': 'وردەکاری پەیوەندی',
    'payload_url': 'URL ی باری سوودبەخش',
    'description_7': 'وەسف',
    'event_subscriptions': 'بەشداریکردنی بۆنە و ئاهەنگەکان',
    'you_can_always_add_more_events_later': 'هەمیشە دەتوانیت دواتر ڕووداوی زیاتر زیاد بکەیت.',
    'register_endpoint': 'تۆمارکردنی خاڵی کۆتایی',
    'cancel_28': 'هەڵوەشاندنەوە',
    'assign_a_new_task_to_a_maintenance_provi': 'ئەرکێکی نوێ بدە بە دابینکەری چاککردنەوە',
    'work_order_details': 'وردەکاری فەرمانی کارکردن',
    'work_order_title': 'ناونیشانی فەرمانی کار',
    'task_description': 'وەسفکردنی ئەرک',
    'scheduling_reference': 'خشتەی کار و ئاماژە',
    'maintenance_request_id': 'ناسنامەی داواکاری چاککردنەوە',
    'assignment': 'ئەرکدانان',
    'select_a_maintenance_provider': 'دابینکەرێکی چاککردنەوە هەڵبژێرە',
    'priority_level_level': 'ئاستی ئاستی ئەولەویەت',
    'dispatch_work_order': 'فەرمانی کاری ناردن',
    'discard_changes': 'گۆڕانکارییەکان فڕێ بدە',
    'pro_tip': 'ئامۆژگاری پڕۆ',
    'dispatching_a_work_order_will_immediatel': 'ناردنی فەرمانی کارکردن دەستبەجێ فرۆشیارەکە لە ڕێگەی پۆرتاڵ و ئیمەیڵەکەیانەوە ئاگادار دەکاتەوە ئەگەر چالاک کرابێت.',
    'update_work_order': 'نوێکردنەوەی فەرمانی کارکردن',
    'status_priority': 'دۆخ و ئەولەویەت',
    'status_4': 'دۆخ',
    'completed_date': 'بەرواری تەواوبوون',
    'invoice': 'فاکتورە',
    'invoice_amount': 'بڕی فاکتورە',
    'invoice_status': 'دۆخی فاکتورە',
    'cancel_29': 'هەڵوەشاندنەوە',
    'vendor_work_order_management': 'بەڕێوەبردنی فەرمانی کاری فرۆشیار',
    'refresh_2': 'نوێکردنەوە',
    'new_work_order': 'فەرمانی کاری نوێ',
    'all_statuses_4': 'هەموو دۆخەکان',
    'no_work_orders_found': 'هیچ فەرمانێکی کارکردن نەدۆزراوەتەوە',
    'mr': 'م.',
    'work_order': 'فەرمانی کار # .',
    'priority_1': 'یەکەمایەتی',
    'description_8': 'وەسف',
    'linked_maintenance_request': 'داواکاری چاککردنەوەی بەستراو',
    'unit_15': 'یەکەی',
    'invoice_1': 'فاکتورە',
    'view_invoice_document': 'بینینی بەڵگەنامەی فاکتورە',
    'review_approve_invoice': 'پێداچوونەوە و پەسەندکردنی فاکتورە',
    'edit_work_order': 'دەستکاریکردنی فەرمانی کار',
    'approve_invoice': 'پەسەندکردنی فاکتورە',
    'you_are_approving_a_vendor_invoice_of': 'تۆ فاکتورەیەکی فرۆشیار پەسەند دەکەیت کە...',
    'for': 'بۆ...',
    'charge_to_tenant_ledger': 'پارەدان بۆ کتێبی سەرەکی کرێچی',
    'the_cost_will_be_automatically_added_as': 'تێچوونەکە بە شێوەیەکی ئۆتۆماتیکی وەکو خەرجکردن لەسەر کتێبی سەرەکی کرێچی زیاد دەکرێت بۆ ئەوەی بیدەن.',
    'organization_absorbs_cost': 'ڕێکخراو تێچوون هەڵدەمژێت',
    'the_tenant_will_not_be_charged_this_crea': 'لە کرێچی پارە وەرناگیرێت. ئەمەش هاتنە ژوورەوەی Accounts Payable بۆ ڕێکخراوەکە دروست دەکات.',
    'cancel_30': 'هەڵوەشاندنەوە',
    'loading_2': 'بارکردن...',
    'page_not_found': 'لاپەڕە نەدۆزراوەتەوە',
    'the_page_you_re_looking_for_doesn_t_exis': 'ئەو پەیجەی تۆ بەدوایدا دەگەڕێیت بوونی نییە.',
    'go_to_dashboard': 'بڕۆ بۆ داشبۆرد',
    'clear_signature': 'واژۆی ڕوون',
    'i_consent_to_use_electronic_signatures_a': 'من ڕەزامەندی دەدەم لەسەر بەکارهێنانی واژۆی ئەلیکترۆنی و ڕازیم کە واژۆی ئەلیکترۆنی من',
    'cancel_31': 'هاوتای یاساییە لەگەڵ واژۆی دەستی من لەسەر ئەم گرێبەستە. تێدەگەم',
    'sign_contract_1': 'کە مافی وەرگرتنی کۆپییەکی کاغەزی ئەم بەڵگەنامەیەم هەیە.',
    'by_signing_this_document_electronically': 'هەڵوەشاندنەوە',
    'subscription_locked': 'گرێبەست واژۆ بکە',
    'your_subscription_status_is': 'بە واژۆکردنی ئەم بەڵگەنامەیە بە شێوەی ئەلیکترۆنی، تۆ دان بەوەدا دەنێیت کە واژۆی ئەلیکترۆنیت',
    'please_renew_your_subscription_to_contin': 'لە ڕووی یاساییەوە پابەندکەر و هەمان کاریگەری واژۆی دەستنووسی هەیە. ناونیشانی ئایپی تۆ',
    'payment_options': 'و مۆری کات بۆ مەبەستی پشتڕاستکردنەوە تۆمار دەکرێت.',
    'please_contact_the_administrator_to_proc': 'بەشداریکردن قفڵ کراوە',
    'contact_admin_to_renew': 'دۆخی بەشداریکردنەکەت بریتییە لە',
    'request_sent_pending_approval': '.',
    'need_help_contact_support_at_support_qua': 'تکایە بەشداریکردنەکەت نوێ بکەرەوە بۆ بەردەوامبوون لە بەڕێوەبردنی موڵکەکانت.',
    'sign_out': 'بژاردەی پارەدان',
    'requires_the': 'تکایە پەیوەندی بە بەڕێوەبەرەوە بکە بۆ پرۆسێسکردنی پارەکەت و چالاککردنەوەی بەشداریکردنەکەت.',
    'pro_plan': 'بۆ نوێکردنەوە پەیوەندی بە ئەدمینەوە بکە',
    'is_a_pro_feature': 'داواکاری نێردراوە! چاوەڕوانی پەسەندکردنە.',
    'upgrade_to_pro_to_unlock_ai_powered_inte': 'پێویستت بە یارمەتی هەیە؟ پەیوەندی بە پشتگیرییەوە بکەن لە support@quadcores.com',
    'upgrade_to_pro_1': 'بەرزکردنەوە بۆ Pro',
    'starting_at_3_20_unit_month_no_minimum_u': 'لە 3.20$ / یەکە / مانگەوە دەست پێدەکات · پێویست بە کەمترین یەکە ناکات',
    'our_narrative': 'گێڕانەوەی ئێمە',
    'reimagined': 'دووبارە خەیاڵی کردەوە.',
    'quadcores_properties_is_an_elite_operati': 'کۆمپانیای کوادکۆرس پرۆپرتیس چینێکی کارپێکردنی نوخبەیە بۆ پۆرتفۆلیۆی خانووبەرەی مۆدێرن.',
    'core_capabilities': 'بۆ قەبارە دروستکراوە، بۆ وردبینی دیزاین کراوە، ئەندازی��ری بۆ ئەو کەسانە کراوە کە مەبەستیان بازرگانییە.',
    'our_approach_to': 'توانا سەرەکییەکان',
    'operations': 'ڕێبازی ئێمە بۆ...',
    'we_believe_property_management_should_be': 'ئۆپەراسیۆنەکان.',
    'whether_you_manage_10_units_or_10_000_qu': 'ئێمە پێمان وایە بەڕێوەبردنی موڵک و ماڵی دەبێت کارا و شەفاف و قەبارەدار بێت.',
    'complete_platform': 'هەر بۆیە ئێمە پلاتفۆرمێکمان دروستکرد کە پرۆسەی میراتی دەستی لەناو دەبات،',
    'all_features': 'گۆڕینی بە زیرەکی ئۆتۆماتیکی و کاتی ڕاستەقینە.',
    '35_powerful_features_organized_into_7_co': 'جا تۆ 10 یەکە بەڕێوەببەیت یان 10,000، تایبەتمەندییەکانی کوادکۆرز لەگەڵ ئاڵۆزییەکانتدا قەبارەیان دەگۆڕێت.',
    'link_unavailable': 'ئەرکی ئێمە دابینکردنی بناغەی تەکنیکییە بۆ ئەوەی بتوانن سەرنجتان لەسەر بیناسازی بێت',
    'application_submitted': 'بەها و پەیوەندییەکان، نەک ڕاوەدوونانی کاغەزەکان.',
    'your_application_has_been_received_our_t': 'پلاتفۆرمی تەواو',
    'your_application_id': 'هەموو تایبەتمەندییەکان',
    'successfully_registered': '٣٥ تایبەتمەندی بەهێز ڕێکخراوە بۆ ٧ پۆلی گشتگیر.',
    'track_application_status': 'لینکی بەردەست نییە',
    'rental_application': 'داواکاری پێشکەش کراوە!',
    'unit_16': 'داواکاریەکەت وەرگیراوە. تیمەکەمان پێداچوونەوەی بۆ دەکات و بەم زووانە پەیوەندیتان پێوە دەکەینەوە.',
    'applying_for': 'ناسنامەی داواکارییەکەت',
    'full_name_2': 'بە سەرکەوتوویی تۆمارکرا',
    'email_address': 'شوێنپێی دۆخی داواکاری بگرە',
    'national_id_passport': 'داواکاری کرێ',
    'date_of_birth_1': 'یەکەی',
    'current_address_1': 'داواکاری بۆ...',
    'employment_income': 'ناوی تەواو *',
    'employment_status_1': 'ناونیشانی ئیمەیڵ *',
    'employed': 'ناسنامەی نیشتمانی / پاسپۆرت',
    'self_employed': 'خۆبەخش',
    'retired': 'خانەنشین بووە',
    'student': 'خوێندکار',
    'unemployed': 'بێکار',
    'monthly_income_1': 'داهاتی مانگانە',
    'employer_name_1': 'ناوی خاوەنکار',
    'employer_phone_1': 'تەلەفۆنی خاوەنکار',
    'lease_preferences': 'پەسەندکردنی بەکرێدان',
    'desired_move_in_date': 'بەرواری گواستنەوەی خوازراو',
    'lease_duration_months': 'ماوەی بەکرێدان (مانگەکان)',
    'months_2': 'مانگ',
    'i_have_pets': 'من ئاژەڵی ماڵیم هەیە',
    'emergency_contact': 'پەیوەندی فریاگوزاری',
    'name_7': 'ناو',
    'phone_7': 'تەلەفۆن',
    'relation': 'پەیوەندی',
    'additional_notes_1': 'تێبینی زیادە',
    'your_information_is_kept_private_and_use': 'زانیارییەکانتان بە تایبەتی دەهێڵرێنەوە و تەنها بۆ هەڵسەنگاندنی کرێ بەکاردەهێنرێن.',
    'track_application': 'بەرنامەی تراکی',
    'ref_id': 'ناسنامەی سەرچاوە: #',
    'verification_email': 'ئیمەیڵی پشتڕاستکردنەوە',
    'review': 'پێداچوونەوە',
    'approval': 'پەسەندکردن',
    'notice_from_the_team': 'ئاگاداری لە تیمەوە',
    'applicant': 'داواکار',
    'property_1': 'موڵک و ماڵی',
    'submitted_1': 'پێشکەش کراوە',
    'approved_for_lease': 'پەسەند کراوە بۆ بەکرێدان',
    'next_steps_sign_lease': 'هەنگاوەکانی داهاتوو: واژۆکردنی بەکرێدان',
    'questions_contact': 'پرسیار؟ پەی��ەندی',
    'support': 'پشتگیری',
    'or_call_our_leasing_office': 'یان پەیوەندی بە ئۆفیسی بەکرێدانەکەمانەوە بکەن.',
    'verification_code': 'کۆدی پشتڕاستکردنەوە',
    'verify_code': 'کۆد پشتڕاست بکەرەوە',
    'resend_code': 'کۆدی دووبارە ناردنەوە',
    'back_to_login': 'گەڕانەوە بۆ چوونەژوورەوە',
    'invalid_link': 'لینکی نادروست',
    'go_to_login': 'بڕۆ بۆ چوونە ژوور��وە',
    'welcome_aboard': 'بەخێربێن بۆ ئابۆرد!',
    'secure_onboarding': 'ئۆنبۆردکردنی پارێزراو',
    'welcome_to_the_quadcores_property_manage': 'بەخێربێن بۆ پۆرتاڵی بەڕێوەبردنی موڵک و ماڵی کوادکۆرز. با دانانی ئەکاونتی ناوخۆیی خۆت تەواو بکەین.',
    'account_role': 'ڕۆڵی ئەکاونت',
    'email_address_1': 'ناونیشانی ئیمەیڵ',
    'set_your_password': 'وشەی نهێنی خۆت دابنێ',
    'please_choose_a_secure_password_for_your': 'تکایە وشەی نهێنی پارێزراو بۆ ئەکاونتەکەت هەڵبژێرە.',
    'show_password': 'وشەی نهێنی پیشان بدە',
    'complete_account_setup': 'ڕێکخستنی ئەکاونت تەواو بکە',
    'password_requirement_minimum_8_character': 'پێویستی بە وشەی نهێنی: بەلایەنی کەمەوە ٨ پیت. پێشنیار دەکەین تێکەڵەیەک لە پیت و ژمارە و هێما بەکاربهێنرێت بۆ زۆرترین ئاسایش.',
    'payment_successful': 'پارەدان سەرکەوتوو بوو!',
    'thank_you_for_your_subscription_your_acc': 'سوپاس بۆ بەشداریکردنتان. ئەکاونتەکەت بەرزکراوەتەوە.',
    'go_to_dashboard_1': 'بڕۆ بۆ داشبۆرد',
    'back_to_home': 'گەڕانەوە بۆ ماڵەوە',
    'pricing_plans': 'نرخ + پلان',
    'pay_for_what': 'پارە بدە بۆ چی',
    'you_actually_use': 'لە ڕاستیدا بەکاری دەهێنیت.',
    'annual_2': 'ساڵانە',
    '16_1': '-16%',
    'per_unit_pricing_no_minimum_portfolio_si': 'نرخی هەر یەکەیەک. کەمترین قەبارەی پۆرتفۆلیۆ نییە. لە هەر کاتێکدا هەڵبوەشێنەرەوە.',
    'current_1': 'ئێستا',
    'unit_17': '/ یەکە',
    'from_3': 'لە...',
    'mo_3': '/مۆ',
    'minimum': 'کەمترین',
    '2_months_free_annual_billing': '2 مانگ بەخۆڕاییە · ساڵانە فەسڵکردن',
    'includes': 'لەخۆدەگرێت',
    'enterprise_custom_contract': 'گرێبەستی کۆمپانیا / تایبەتمەند',
    '10_000_units_custom_sla_dedicated_suppor': '10,000+ یەکە، SLA تایبەتمەند، پشتگیری تایبەت، بژاردەی ناوخۆیی.',
    'talk_to_sales': 'قسە لەگەڵ فرۆشتن بکە →',
    'feature_matrix': 'ماتریکسی تایبەتمەندی',
    'full_capability': 'توانای تەواو',
    'breakdown': 'تێکچوون.',
    'starter': 'دەستپێکەر',
    'growth': 'گەشەکردن',
    'pro_2': 'پرۆ',
    'no_minimum_units_no_setup_fees_enterpris': 'کەمترین یەکەکان نییە. بێ پارەی ڕێکخستن. ئاسایشی پلەی کۆمپانیا لەسەر هەموو پلانێک.',
    'legal': 'یاسایی',
    'privacy': 'تایبەتمەندی',
    'policy': 'سیاسەت.',
    'we_are_committed_to_protecting_your_prof': 'ئێمە پابەندین بە پاراستنی زانیارییە پیشەیی و کەسییەکانتان بە هەمان توندی کە بۆ کارەکانی موڵک و ماڵی بەکاری دەهێنین.',
    'principles': 'شەفافیەت بناغەی ئێمەیە.',
    'section_0': 'بنەماکان',
    'legal_and_compliance': 'بەشی 0',
    'inquiries': 'یاسایی و پابەندبوون',
    'if_you_have_questions_about_how_we_handl': 'پرسیارەکان.',
    'info_quadcores_com': 'ئەگەر پرسیارت هەیە سەبارەت بە چۆنیەتی مامەڵەکردن لەگەڵ داتاکانت، یان ئەگەر پێویستت بە بەکارهێنانی مافەکانی نهێنی خۆتە، تکایە پەیوەندی بە تیمی پابەندبوونمانەوە بکە.',
    'please_review_the_full_contract_terms_be': 'ئێمە لێرەین بۆ دڵنیابوون لە ئارامی دەروونیتان.',
    'link_expired_or_invalid': 'info@quadcores.com',
    'we_couldn_t_find_the_contract_associated': 'تکایە پێداچوونەوە بە تەواوی مەرجەکانی گرێبەستەکە بکە لە خوارەوە.',
    'your_signature_has_been_recorded_a_copy': 'بەستەرەکە بەسەرچووە یان نادروستە',
    'setup_your_portal': 'ئێمە نەمانتوانی گرێبەستی پەیوەست بەم بەستەرەوە بدۆزینەوە. تکایە پەیوەندی بە فەرمانگەی بەڕێوەبردنی موڵکەوە بکەن بۆ وەرگرتنی لینکی واژۆی نوێ.',
    'access_your_payments_installments_and_do': 'لە هەر کاتێکدا بە ڕێکخستنی ئەژمێری پۆرتاڵەکەت دەستت بگات بە پارەدان و قیست و بەڵگەنامەکانت.',
    'activate_my_account': 'ئەکاونتی من چالاک بکە',
    'go_to_dashboard_2': 'بڕۆ بۆ داشبۆرد',
    'id_1': 'ناسنامە: #',
    'contract_signature_portal': 'پۆرتاڵی واژۆکردنی گرێبەست',
    'review_sign': 'پێداچوونەوە و واژۆکردن',
    'hello': 'سڵاو',
    'please_review_your_contract_details_for': '، تکایە پێداچوونەوە بە وردەکارییەکانی گرێبەستەکەت بکە بۆ ئەو موڵکە لە خوارەوە.',
    'property_2': 'موڵک و ماڵی',
    'contract_value': 'بەهای گرێبەست',
    'timeline': 'هێڵی کاتی',
    'to_3': 'بۆ...',
    'legal_terms': 'مەرجە یاساییەکان',
    'en_ar': 'EN/AR',
    'legal_disclaimer': 'ڕەتکردنەوەی بەرپرسیارێتی یاسایی',
    'electronic_signatures_are_legally_equiva': 'واژۆی ئەلیکترۆنی لە ڕووی یاساییەوە هاوتایە لەگەڵ واژۆی دەستنووس.',
    'your_ip_address_and_device_information_w': 'ناونیشانی ئایپی و زانیارییەکانی ئامێرەکەت بۆ ئاسایش تۆمار دەکرێن.',
    'you_can_download_the_pdf_anytime_after_c': 'دەتوانیت لە هەر کاتێکدا دوای تەواوبوونی PDF دابەزێنیت.',
    'ready_to_complete': 'ئامادەیت بۆ تەواوکردن؟',
    'continue_to_plans': 'بەردەوام بە لە پلانەکان',
    'next_step': 'هەنگاوی داهاتوو...',
    'complete_registration': 'تەواوکردنی تۆمارکردن',
    'verify_phone_number': 'ژمارەی تەلەفۆنەکەت پشتڕاست بکەرەوە',
    'verification_code_sent_to_phone': 'کۆدی پشتڕاستکردنەوە بۆ تەلەفۆنەکەت ناردرا. تکایە لەوێ بنووسە.',
    'popular': 'بەناوبانگ',
    'mo_4': '/مۆ',
    'up_to': 'تا...',
    'units_2': 'یەکەکان',
    'back_to_info': 'گەڕانەوە بۆ زانیاری',
    'verification_code_1': 'کۆدی پشتڕاستکردنەوە',
    'please_enter_the_6_digit_code_sent_to': 'تکایە ئەو کۆدە ٦ ژمارەییەی کە بۆ...',
    'verify_phone': 'پشتڕاستکردنەوەی تەلەفۆن',
    'guidelines': 'ڕێنماییەکان',
    'terms_of': 'مەرجەکانی...',
    'use': 'بەکارهێنان.',
    'our_terms_are_designed_to_ensure_a_secur': 'مەرجەکانمان بۆ دڵنیابوون لە ژینگەیەکی پارێزراو و متمانەپێکراو و دادپەروەرانە بۆ خاوەنکاران، کرێچییەکان و بەڕێوەبەرانی موڵکەکان بە هەمان شێوە داڕێژراون.',
    'conditions': 'مەرجەکان',
    'clause_0': 'بڕگەی 0',
    'agreement_to': 'ڕێککەوتن بۆ...',
    'arbitration': 'ناوبژیوانی.',
    'by_using_the_platform_you_agree_that_any': 'بە بەکارهێنانی پلاتفۆرمەکە، تۆ ڕەزامەندیت لەسەر ئەوەی کە هەر ناکۆکییەک لە ڕێگەی نێوەندگیری پیشەیی یان ناوبژیوانی پابەندکەرەوە چارەسەر دەکرێت، ئەمەش دڵنیای دەدات لە چارەسەرکردنی کارامەی ململانێی کارکردن.',
    'last_updated_march_2026': 'ئێمە پابەندین بە پاراستنی پەیوەندییەکی هاوبەش لەگەڵ هەموو بەکارهێنەرانمان.',
    'system_architecture': 'دوایین نوێکردنەوە: ئازاری ٢٠٢٦',
    'refined': 'تەلارسازی سیستەم',
    'operations_1': 'پاڵاوتە',
    'a_masterclass_in_property_management_we': 'ئۆپەراسیۆنەکان.',
    'complete_platform_1': 'ماستەرکلاسێک لە بەڕێوەبردنی موڵک و ماڵی. ئێمە ژاوەژاوەکەمان ڕوتکردەوە بۆ ئەوەی تەنها ئەو شتانە بەجێبهێڵین کە پێویستن و بەهێزن و بە شێوەیەکی بێ کەموکوڕی دیزاین کراون.',
    'everything_you_need_to_manage': 'پلاتفۆرمی تەواو',
    'your_properties': 'هەموو شتێک کە پێویستە بەڕێوەی بەریت',
    'a_comprehensive_property_management_syst': 'م��ڵک و ماڵی خۆت.',
    'view_all_24_features': 'سیستەمێکی گشتگیری بەڕێوەبردنی موڵک و ماڵی کە بۆ کارایی و ئۆتۆماتیکی و قەبارە دروستکراوە.',
    'get_started': 'بینینی هەر ٢٤ تایبەتمەندییەکە',
    'take_control_of': 'دەست پێ بکە',
    'your_entire_portfolio': 'کۆنترۆڵی...',
    'hundreds_of_property_managers_have_alrea': 'تەواوی پۆرتفۆلیۆکەت.',
    'start_free_trial': 'سەدان بەڕێوەبەری موڵک پێشتر کارەکانیان گواستۆتە��ە بۆ کوادپرۆپرتیس.',
    'already_have_an_account': 'تاقیکردنەوەی بێبەرامبەرت دەست پێ بکە — پێویست بە کارتی بانکیی ناکات.',
    'quadcores_properties': 'دەستپێکردنی تاقیکردنەوەی بێبەرامبەر',
    'the_apartment_management_platform_built': 'پێشتر ئەکاونتت هەیە؟',
    'quadcores': 'تایبەتمەندیەکانی کوادکۆرس',
    'quadcores_properties_1': 'سەکۆی بەڕێوەبردنی شوقەکان کە بۆ کارەکانی جددی دروستکراوە.',
    'every_property': 'کوادکۆرز',
    'under_control': 'تایبەتمەندیەکانی کوادکۆرس',
    'one_platform_for_leases_rent_collection': 'هەموو موڵکێک.',
    'start_free_trial_1': 'دەستپێکردنی تاقیکردنەوەی بێبەرامبەر',
    'view_dashboard': 'بینینی داشبۆرد',
    'scroll': 'سکڕۆڵ بکە',
    'quadcores_properties_2': 'تایبەتمەندیەکانی کوادکۆرس',
    'tenant_login': 'چوونەژوورەوەی کرێچی',
    'owner_login': 'چوونەژوورەوەی خاوەنکار',
    'sign_in': 'چوونەژوورەوە',
    'get_started_1': 'دەست پێ بکە →',
    'sign_in_1': 'چوونەژوورەوە',
    'menu': 'مێنۆ',
    'get_started_2': 'دەست پێ بکە',
    'tenant_13': 'کرێچی',
    'owner_1': 'خاوەنەکەی',
    'nav_features': 'تایبەتمەندییەکان',
    'nav_pricing': 'نرخەکان',
    'nav_about': 'دەربارەمان',
    'our_tiers': 'قاتەکانمان',
    'choose_the_right': 'ڕاست هەڵبژێرە',
    'plan_for_you': 'پلان بۆ تۆ دابنێ.',
    'monthly_1': 'مانگانە',
    'annual_3': 'ساڵانە',
    'mo_5': '/ مۆ',
    '20_off_annual_billing': '-20% داشکاندن لە فەسڵی ساڵانە',
    'quadcores_properties_3': 'تایبەتمەندیەکانی کوادکۆرس',
    'the_apartment_management_platform_built_1': 'سەکۆی بەڕێوەبردنی شوقەکان کە بۆ کارەکانی جددی دروستکراوە.',
    'quadcores_1': 'کوادکۆرز',
    'solutions': 'چارەسەرەکان',
    'built_for_every_property_professional': 'بۆ هەموو پیشەگەرێکی موڵک و ماڵی دروستکراوە.',
    'empty_key_18': '✦',
    'set_up_your_password': 'وشەی نهێنی خۆت ڕێکبخە',
    'create_a_strong_password_for': 'وشەی نهێنی بەهێز بۆ...',
    'email_address_2': 'ناونیشانی ئیمەیڵ',
    'new_password_1': 'وشەی نهێنی نوێ',
    'confirm_password_1': 'وشەی نهێنی پشتڕاست بکەرەوە',
    'back_to_login_1': 'گەڕانەوە بۆ چوونەژوورەوە',
    'view_all_announcements': 'بینینی هەموو ڕاگەیاندنەکان →',
    'session_expiring_soon': 'بەم زووانە دانیشتنەکە کۆتایی دێت',
    'you_will_be_logged_out_automatically': 'تۆ بە شێوەیەکی ئۆتۆماتیکی دەچیتە دەرەوە',
    'log_out': 'چوونە دەرەوە',
    'stay_logged_in': 'لە چوونەژوورەوە بمێنەرەوە',
    'id_2': 'ناسنامە: #',
    'to_4': 'بۆ...',
    'ip_1': 'ئایپی:',
    'ip_2': 'ئایپی:',
    'contract_already_signed': 'گرێبەستەکە پێشتر واژۆ کراوە',
    'you_have_already_signed_this_contract': 'پێشتر ئەم گرێبەستەت واژۆ کردووە.',
    'review_sign_contract': 'پێداچوونەوە و واژۆکردنی گرێبەست',
    'awaiting_your_signature': 'چاوەڕوانی واژۆی ئێوەین',
    'contract_summary_1': 'پوختەی گرێبەست',
    'property_3': 'موڵک و ماڵی',
    'start_date_3': 'بەرواری دەستپێکردن',
    'end_date_1': 'بەرواری کۆتایی',
    'terms_and_conditions': 'مەرج و ڕێساکان',
    'important_information': 'زانیاری گرنگ',
    'by_signing_you_agree_to_all_terms_and_co': '• بە واژۆکردن، تۆ ڕەزامەندیت لەسەر هەموو ئەو مەرج و ڕێسایانەی کە لە سەرەوە ئاماژەیا�� پێکراوە',
    'your_electronic_signature_is_legally_bin': '• واژۆی ئەلیکترۆنی تۆ لە ڕووی یاساییەوە پابەندکەرە',
    'you_will_receive_a_signed_copy_via_email': '• کۆپییەکی واژۆکراو لە ڕێگەی ئیمەیڵەوە وەردەگریت',
    'you_can_download_the_signed_contract_any': '• دەتوانیت لە هەر کاتێکدا گرێبەستی واژۆکراو لە پۆرتاڵەکەتەوە دابەزێنیت',
    'cancel_32': 'هەڵوەشاندنەوە',
    'sign_contract_2': 'گرێبەست واژۆ بکە',
    'units_3': 'یەکەکان',
    'unit_18': 'یەکەی',
    'tenant_14': 'کرێچی:',
    'empty_key_19': '· $',
    'mo_6': '/مۆ',
    'no_properties_found_in_your_portfolio': 'هیچ موڵکێک لە پۆرتفۆلیۆکەتدا نەدۆزراوەتەوە.',
    'my_ledger': 'کتێبی سەرەکی من',
    'complete_history_of_your_financial_trans': 'مێژووی تەواوی مامەڵە داراییەکانتان',
    'current_balance_1': 'باڵانسی ئێستا',
    'no_ledger_entries_yet_1': 'هێشتا هیچ زانیارییەک لە کتێبی سەرەکیدا نییە',
    'transactions_will_appear_here_once_recor': 'مامەڵەکان لێرە دەردەکەون کاتێک تۆمار دەکرێن.',
    'unit_19': 'یەکەی',
    'bal': 'بال',
    'professional_access': 'دەستڕاگەیشتن بە پیشەیی',
    'owner_2': 'خاوەنەکەی',
    'secure_identify_for_property_executives': 'ناسنامەی پارێزراو بۆ بەڕێوەبەرانی موڵک و بەڕێوەبردنی موڵک.',
    'email_or_phone_number': 'ئیمەیڵ یان ژمارەی تەلەفۆن',
    'secure_password': 'وشەی نهێنی پارێزراو',
    'switch_to_resident_login': 'بگۆڕە بۆ چوونەژوورەوەی نیشتەجێ',
    'institutional_oversight': 'چاودێری دامەزراوەیی.',
    'portfolio_suite': 'سویتی پۆرتفۆلیۆ',
    'full_control_over_your': 'کۆنترۆڵی تەواو بەسەر...',
    'property_assets': 'سەروەت و سامانی موڵک و ماڵی.',
    'audited_secure_compliant': 'وردبینی کراوە. پارێزراو. پابەندە.',
    'empty_key_20': ': $',
    'per_unit_p_l_last_12_months': 'P&L بۆ هەر یەکەیەک — 12 مانگی ڕابردوو',
    'loading_report': 'بارکردنی ڕاپۆرت...',
    'no_properties_found': 'هیچ موڵکێک نەدۆزراوەتەوە',
    'unit_20': '· یەکەی # .',
    'mo_lease_ends': '/mo · بەکرێدان کۆتایی دێت',
    '12_mo_noi': '12 مانگی NOI',
    'empty_key_21': '▾',
    'monthly_collections_last_6_months': 'کۆکردنەوەی مانگانە (٦ مانگی ڕابردوو)',
    'tax_documents': 'بەڵگەنامەکانی باج',
    'annual_payment_summary_for_tax_reporting': 'پوختەی پارەدانی ساڵانە بۆ ڕاپۆرتکردنی باج (1099-NEC)',
    'total_paid_1': 'کۆی گشتی پارەدار',
    'this_is_your_personal_payment_summary_fo': 'ئەمە پوختەی پارەدانی کەسی تۆیە. بۆ فۆڕمی فەرمی 1099-NEC، تکایە پەیوەندی بە بەڕێوەبەری موڵکەکەتەوە بکەن. تەنها پارەدان بە بڕی ٦٠٠ دۆلار یان زیاتر لە ساڵێکی ڕۆژمێریدا ڕاپۆرت دەکرێت بۆ IRS.',
    'unit_21': 'یەکەی',
    'no_payments_recorded_for': 'هیچ پارەیەک بۆ تۆمار نەکراوە بۆ...',
    'select_a_different_year_to_view_your_pay': 'ساڵێکی جیاواز هەڵبژێرە بۆ بینینی مێژووی پارەدانەکەت.',
    'browse_facilities_and_book_time_slots': 'گەڕان بە ئاسانکارییەکان و حجزکردنی کاتەکان',
    'no_amenities_available_in_your_building': 'هیچ خزمەتگوزارییەک لە بیناکەتدا بەردەست نییە',
    'mo_7': '/مۆ',
    'capacity_1': 'توانای:',
    'book_time_slot': 'شوێنی کاتی حجزکردن',
    'book_an_amenity': 'حجزکردنی ئاسانکارییەک',
    'amenity_1': 'ئاسانکاری *',
    'select_amenity_1': 'ئاسانکاری هەڵبژێرە',
    'date_2': 'بەروار *',
    'start_time_1': 'کاتی دەستپێکردن *',
    'end_time_1': 'کاتی کۆتایی *',
    'notes_optional_1': 'تێبینی (ئیختیاری)',
    'cancel_33': 'هەڵوەشاندنەوە',
    'no_upcoming_bookings': 'هیچ حجزێکی داهاتوو نییە',
    'browse_amenities': 'گەڕان بەناو خزمەتگوزارییەکان',
    'cancel_34': 'هەڵوەشاندنەوە',
    'history_1': 'مێژوو',
    'property_assistant': 'یاریدەدەری موڵک و ماڵی',
    'ask_about_your_account': 'دەربارەی ئەکاونتەکەت بپرسە',
    'lease_history': 'مێژووی بەکرێدان',
    'your_current_and_past_lease_agreements': 'گرێبەستی بەکرێدانی ئێستا و ڕابردووت',
    'active_lease': 'بەکرێدانی چالاک',
    'unit_22': 'یەکەی',
    'building_10': 'بینا',
    'monthly_rent_4': 'کرێی مانگانە',
    'expires_1': 'بەسەر دەچێت',
    'open_ended': 'کۆتایی کراوە',
    'start_date_4': 'بەرواری دەستپێکردن',
    'security_deposit_1': 'پارەی زەمانەت',
    'type_3': 'جۆر',
    'no_active_lease_on_file': 'هیچ بەکرێدانی چالاک لە فایلدا نییە',
    'history_2': 'مێژوو',
    'mo_8': '/مۆ',
    'no_lease_records_found': 'هیچ تۆمارێکی بەکرێدان نەدۆزراوەتەوە',
    'secure_access': 'دەستڕاگەیشتن بە پارێزراو',
    'hello_1': 'سڵاو',
    'again': 'دیسانەوە.',
    'enter_your_details_to_manage_your_home_a': 'وردەکارییەکانتان بنووسن بۆ بەڕێوەبردنی ماڵ و پارەدانەکانتان.',
    'your_email': 'ئیمەیڵەکەت',
    'your_password': 'پاسۆردەکەت',
    'switch_to_owner_login': 'بگۆڕە بۆ چوونەژوورەوەی خاوەنکار',
    'everything_in_one_place': 'هەموو شتێک لە یەک شوێن.',
    'tools_for_you': 'ئامرازەکان بۆ تۆ',
    'everything_you_need': 'هەموو شتێک کە پێویستت پێیەتی',
    'to_manage_your_home': 'بۆ بەڕێوەبردنی ماڵەکەت.',
    'safe_private_reliable': 'سەلامەت. تایبەت. جێ متمانە.',
    'we_use_professional_grade_encryption_to': 'ئێمە کۆدکردنی پلەی پیشەیی بەکاردەهێنین بۆ دڵنیابوون لەوەی کە هەمیشە داتا و پارەدانەکانت پارێزراون.',
    'empty_key_22': ': # .',
    'auto_pay_is_on': 'Auto-Pay ON ە',
    'your_rent_is_charged_automatically_on_th': '· کرێی خانووەکەت لە بەرواری دیاریکراودا بە شێوەیەکی ئۆتۆماتیکی وەردەگیرێت.',
    'enable_auto_pay': 'Auto-Pay چالاک بکە',
    'save_a_card_or_bank_account_and_never_mi': 'کارتێک یان ئەژمێری بانکی پاشەکەوت بکە و جارێکی تر هەرگیز پارەی کرێ لەدەست مەدە.',

    'autopay_enabled_toast': 'پاڕەدانی ئۆتۆماتیکی چالاک کرا.',
    'autopay_setup_canceled': 'ڕێکخستنی پاڕەدانی ئۆتۆماتیکی هەڵوەشایەوە.',
    'autopay_setup_failed': 'نەتوانرا ڕێکخستنی پاڕەدانی ئۆتۆماتیکی بەڕێوبچێت.',
    'autopay_start_failed': 'ڕێکخستنی پاڕەدانی ئۆتۆماتیکی سەرکەوتوو نەبوو.',
    'confirm_disable_autopay': 'دڵنیایت دەتەوێت پاڕەدانی ئۆتۆماتیکی ناچالاک بکەیت؟ شێوازی پاڕەدان پاشکەوتراو دەسێتەوە.',
    'autopay_disabled_success': 'پاڕەدانی ئۆتۆماتیکی ناچالاک کرا.',
    'autopay_disable_failed': 'ناچالاک کردنی پاڕەدانی ئۆتۆماتیکی سەرکەوتوو نەبوو.',
    'card_ending_label': '{{brand}} کۆتایی پێدێت بە ••••{{last4}}',
    'payment_method_saved': 'شێوازی پاڕەدان پاشکەوت کرا',
    'disable_auto_pay': 'ناچالاک کردنی پاڕەدانی ئۆتۆماتیکی',
    'set_up_auto_pay': 'ڕێکخستنی پاڕەدانی ئۆتۆماتیکی',
    'due_colon': 'مەودا:',
    'disabling': 'ناچالاک دەکرێت…',
    'renewal_offers': 'ئۆفەری نوێکردنەوە',
    'review_and_respond_to_lease_renewal_offe': 'پێداچوونەوە و وەڵامدانەوەی ئۆفەرەکانی نوێکردنەوەی بەکرێدان لەلایەن خاوەن خانووەکەتەوە',
    'no_renewal_offers_yet': 'هێشتا هیچ ئۆفەرێکی نوێکردنەوە نییە',
    'your_property_manager_will_send_a_renewa': 'بەڕێوەبەری موڵکەکەت ئۆفەری نوێکردنەوە لێرە دەنێرێت کاتێک بەکرێدانەکەت لە بەرواری کۆتایی نزیک دەبێتەوە.',
    'unit_23': 'یەکەی',
    'offer_sent_1': 'ئۆفەر نێردراوە',
    'per_month': 'لە مانگێکدا',
    'offered_rent': 'کرێی پێشکەشکراو',
    'per_month_1': 'لە مانگێکدا',
    'new_term': 'زاراوەی نوێ:',
    'note_from_management': 'تێبینی لە بەڕێوەبەرایەتییەوە',
    'decline': 'دابەزین',
    'past_offers': 'ئۆفەرەکانی ڕابردوو',
    'unit_24': 'یەکەی',
    'mo_9': '/مۆ',
    'responded': 'وەڵامی دایەوە',
    'share_feedback': 'فیدباک بەشی بکە',
    'your_opinion_helps_us_improve': 'بۆچوونی ئێوە یارمەتیدەرمانە بۆ باشتربوون',
    'thank_you': 'دەست خۆش!',
    'your_feedback_has_been_submitted': 'فیدباکەکانتان پێشکەش کراوە.',
    'submit_another': 'یەکێکی تر پێشکەش بکە',
    'category_5': 'پۆل',
    'your_rating': 'ڕیتینگەکەت',
    'comment_optional': 'کۆمێنت (ئیختیاری)',
    'your_past_feedback': 'فیدباکەکانی ڕابردووت',

    'general': 'گشتی',
    'submit_feedback': 'ناردنی هەڵسەنگاندن',
    'please_select_rating': 'تکایە ستێرەکانت هەڵبژێرە',
    'submission_failed': 'ناردن سەرکەوتوو نەبوو',
    'tell_us_placeholder': 'بیرت لێمان بگۆرە…',
    'rating_very_poor': 'زۆر خراپ',
    'rating_poor': 'خراپ',
    'rating_okay': 'باشە',
    'rating_good': 'باش',
    'rating_excellent': 'نایاب',
    'utility_bills_1': 'پڕۆژە یاسای خزمەتگوزارییەکان',
    'electricity_water_gas_and_other_utility': 'پارەی کارەبا و ئاو و غاز و خزمەتگوزارییەکانی تر',
    'paid_on_time': 'لە کاتی خۆیدا پارەی دراوە',
    'monthly_utility_spend': 'خەرجکردنی مانگانەی خزمەتگوزاری',
    'no_utility_bills_yet': 'هێشتا هیچ پارەیەکی خزمەتگوزارییەکان نییە',
    'bills_will_appear_here_once_issued_by_ma': 'پڕۆژە یاساکان لێرە دەردەکەون کاتێک لەلایەن بەڕێوەبەرایەتییەوە دەرچوون.',
    'due_now': 'ئێستا بڕیارە (',
    'history_3': 'مێژوو (',
    'due_1': 'بەهۆی...',
    'violations_notices_1': 'سەرپێچی و ئاگادارییەکان',
    'view_violations_and_official_notices_iss': 'سەیری سەرپێچی و ئاگادارییە فەرمییەکان بکە کە بۆت دەرچووە',
    'no_violations_on_record': 'هیچ سەرپێچییەک لە تۆماردا نییە',
    'you_have_a_clean_record_keep_it_up': 'تۆ تۆمارێکی پاکت هەیە — بەردەوام بە!',
    'fine': 'غەرامە:',
    'resolution': 'بڕیارنامە',
    'unit_25': 'یەکەی',
    'no_notices': 'هیچ ئاگادارییەک',
    'no_official_notices_have_been_issued_to': 'هیچ ئاگادارییەکی فەرمی بۆ ئێوە دەرنەچووە.',
    'here_s_an_overview_of_your_operations_to': 'لێرەدا تێڕوانینێکی گشتی لەسەر ئۆپەراسیۆنەکانی ئەمڕۆتان دەخەینەڕوو.',
    'system_live': 'سیستەم لایڤ',
    'active_operations': 'ئۆپەراسیۆنە چالاکەکان',
    'priority_task_queue': 'نزیکی ئەرکی یەکەمایەتی',
    'no_active_tasks_in_your_queue': 'هیچ ئەرکێکی چالاک لە ڕیزەکەتدا نییە.',
    'compliance_alert': 'ئاگادارکردنەوەی پابەندبوون',
    'insurance_expires_in_12_days_please_uplo': 'بیمە لە ١٢ ڕۆژدا بەسەر دەچێت. تکایە بەڵگەنامەی نوێکراو باربکەن.',
    'upgrade_1': 'بەرزکردنەوە',
    'service_score': 'نمرەی خزمەتگوزاری',
    'detailed_analysis': 'شیکاری ورد',
    'system_activity': 'چالاکیی سیستەم',
    'profile_load_error': 'هەڵەی بارکردنی پڕۆفایلی',
    'the_registry_could_not_verify_your_ident': 'تۆمارەکە نەیتوانی ناسنامەکەت پشتڕاست بکاتەوە. پەیوەندی بە بەڕێوەبەرانی سیستەمەوە بکە.',
    'operator': 'ئۆپەراتۆر',
    'tier_platinum': 'پلە: پلاتینیۆم',
    'identity_matrix': 'ماتریکسی ناسنامە',
    'logistical_data': 'داتا لۆجستیکییەکان',
    'verified_credentials': 'بڕوانامەی پشتڕاستکراوە',
    'profile_modifications_are_managed_by_ins': 'گۆڕانکارییەکانی پڕۆفایلی بە پرۆتۆکۆڵەکانی ئاسایشی دامەزراوەیی بەڕێوەدەبرێن. داوای نوێکردنەوە بکە لە ڕێگەی مێزی کۆنترۆڵەوە بۆ یەکپارچەیی تۆڕەکە.',
    'invalid_or_expired_link': 'لینکی نادروست یان بەسەرچوو',
    'security_established': 'ئاسایش دامەزرا',
    'your_portal_access_key_has_been_successf': 'کلیلی دەستگەیشتن بە پۆرتاڵەکەت بە سەرکەوتوویی دروست کراوە.',
    'proceed_to_login': 'بڕۆ بۆ چوونە ژوورەوە',
    'access_setup': 'ڕێکخستنی دەستڕاگەیشتن',
    'finalize_your_credentials_for': 'کۆتایی پێهێنانی بڕوانامەکانت بۆ...',
    'new_access_key': 'کلیلی دەستگەیشتنێکی نوێ',
    'confirm_authorization': 'ڕێگەپێدان پشتڕاست بکەرەوە',
    'finalize_connection': 'کۆتایی هێنان بە پەیوەندی',
    'w_9_tax_form': 'فۆڕمی باجی W-9',
    'request_for_taxpayer_identification_numb': 'داواکاری بۆ ژمارەی ناسنامەی باجد��ر — پێویستە بۆ تۆمارکردنی 1099-NEC',
    'w_9_on_file': 'W-9 لەسەر فایل',
    'certified_on': 'بڕوانامەی لەسەر...',
    'you_can_update_and_re_certify_at_any_tim': '. دەتوانیت لە هەر کاتێکدا نوێکاری بکەیتەوە و دووبارە بڕوانامە بدەیتەوە.',
    'this_form_is_required_by_the_irs_if_you': 'ئەم فۆڕمە لەلایەن IRS داواکراوە. ئەگەر لە ساڵێکی ڕۆژمێریدا ٦٠٠ دۆلار یان زیاترت وەرگرت، ئەوا بە بەکارهێنانی ئەم زانیاریانە 1099-NEC دەردەچێت. SSNی تەواوت هەرگیز هەڵناگیرێت — تەنها 4 ژمارەی کۆتایی ئەگەر دابینکرابێت.',
    '1_legal_name_as_shown_on_income_tax_retu': '1. ناوی یاسایی (وەک لە فۆڕمی باجی داهاتدا دیارە) *',
    '3_federal_tax_classification': '3. پۆلێنکردنی باجی فیدراڵی *',
    'employer_id_number_ein': 'ژمارەی ناسنامەی خاوەنکار (EIN)',
    'ssn_last_4_digits_only': 'SSN — تەنها 4 ژمارەی کۆتایی',
    'we_only_store_the_last_4_for_your_privac': 'ئێمە تەنها ٤ی کۆتایی هەڵدەگرین بۆ پاراستنی نهێنی ئێوە',
    '5_address': '5. ناونیشان',
    'city': 'شار',
    'state': 'دەوڵەت',
    'certification': 'بڕوانامەدان',
    'under_penalties_of_perjury_i_certify_tha': 'بەپێی سزاکانی سوێندی درۆ، من بڕوانامە دەدەم کە: (١) ئەو ژمارەیەی کە نیشان دراوە ژمارەی ناسنامەی باجدەری دروستی منە؛ (2) من تووشی ڕاگرتنی پاشەکەوت نیم؛ (3) من هاووڵاتییەکی ئەمریکیم یان کەسێکی دیکەی ئەمریکیم؛ (4) من لە ڕاپۆرتکردنی FATCA بەخشراوم (ئەگەر پێویست بێت).',
    'by_clicking': 'بە کلیک کردن',
    'save_certify': 'پاشەکەوتکردن و بڕوانامەدان',
    'you_are_electronically_signing_this_w_9': 'تۆ بە شێوەیەکی ئەلیکترۆنی ئەم W-9 واژۆ دەکەیت. ناونیشانی ئایپی و مۆری کاتەکەت تۆمار دەکرێت.',
    'core_operations': 'ئۆپەراسیۆنە سەرەکییەکان',
    'work_orders_1': 'فەرمانی کارکردن',
    'execute_your_assignments_with_efficiency': 'ئەرکەکانت بە کارایی و وردبینی جێبەجێ بکە.',
    'all_assignments': 'هەموو ئەرکەکان',
    'assigned_tasks': 'ئەرکە دیاریکراوەکان',
    'currently_active': 'لە ئێستادا چالاکە',
    'completed_history': 'مێژووی تەواو',
    'no_assignments_found': 'هیچ ئەرکێک نەدۆزراوەتەوە',
    'your_current_view_filters_haven_t_matche': 'فلتەرەکانی بینینی ئێستات هیچ تۆمارێکیان نەگونجاندووە.',
    'unit_26': 'یەکەی',
    'task_description_1': 'وەسفکردنی ئەرک',
    'completion_evidence': 'بەڵگەی تەواوکردن',
    'logistics_control': 'کۆنترۆڵی لۆجستی',
    'start_mission': 'دەستپێکردنی ئەرک',
    'mark_finished': 'مارک تەواو بووە',
    'submit_invoice': 'پێشکەشکردنی فاکتورە',
    'view_brief': 'بینینی کورتەیەک',
    'notice_1': 'ئاگاداری',
    'safety_protocols_are_active_wear_authori': 'پرۆتۆکۆڵەکانی سەلامەتی چالاکن. لە هەموو کاتێکدا PPE ڕێگەپێدراو لەبەر بکە.',
    'page_1': 'پەیج',
    'of_6': 'لە',
    'next_4': 'دواتر',
    'submit_settlement': 'پێشکەشکردنی یەکلاییکردنەوە',
    'claim_amount_for': 'بڕی داواکاری بۆ...',
    'cancel_35': 'هەڵوەشاندنەوە',
    'live': 'ڕاستەوخۆ',
    'sign_out_1': 'چوونە دەرەوە',
    'sign_out_2': 'چوونە دەرەوە',

    // Missing translations added
    'account_number_label': 'ژمارەی ئەکاونت',
    'action_required_onboarding': 'کردارێک پێویستە: چوونە ژوورەوەی چاوەڕوانکراو',
    'active_agreements': 'ڕێکەوتنامەکانی چالاک',
    'active_holds': 'دانراوە چالاکەکان',
    'add_utility_account_subtitle': 'تۆمارکردنی عدادێک یان خزمەتگوزاریی نوێ',
    'all_service_payments': 'هەموو پارەدانەکانی خزمەتگوزاری',
    'amount_due': 'بڕی ئێستای مانەوە',
    'apartment_available': 'ئەپارتمانەکە بۆ ئەم بەروارانە بەردەستە!',
    'apartment_element': 'تەکەی ئەپارتمان',
    'apartment_unit_display': 'ئەپارتمان {{number}} - نهۆمی {{floor}}',
    'application_links': 'بەستەرەکانی داواکاری',
    'appraisal': 'هەڵسەنگاندن',
    'appraised_value': 'نرخی هەڵسەنگێندراو',
    'ask_ai': 'داواکاری لە هۆشی دەستکرد بکە',
    'asset': 'دارایی',
    'at_12_pm': 'لە کاتژمێر 12:00 نیوەڕۆ',
    'available_now': 'ئێستا بەردەستە',
    'avg_hold_time': 'تاکو کاتی دانراو',
    'balanced': 'هاوسەنگ',
    'before_conversion_cancel': 'پێش گۆڕان/هەڵوەشاندنەوە',
    'bill_charged': 'پسوڵە لەسەر ئەکاونتی کرێکار تۆمارکرا',
    'billing_day': 'ڕۆژی پسوڵەدانی مانگ',
    'booking_analytics': 'شیکاری حجزەکان',
    'booking_cancelled': 'حجزەکە هەڵوەشایەوە',
    'booking_confirmed': 'حجزەکە پشتڕاستکرایەوە',
    'booking_converted': 'حجزەکە بە سەرکەوتویی بە کرێکار گۆڕدرا!',
    'booking_details': 'وردەکاری حجز',
    'booking_management': 'بەڕێوەبردنی حجزەکان',
    'booking_number': 'حجزی #{{id}}',
    'booking_timeline': 'هێڵی کاتی حجز',
    'booking_updated': 'حجزەکە بە سەرکەوتویی نوێکرایەوە',
    'booking_window': 'پەنجەرەی کاتی حجز',
    'broker_opinion': 'بۆچوونی دەلاڵ',
    'building_meter_hint': 'عدادی بینا — RUBS بەکاربهێنە بۆ دابەشکردنی تێچوو لەنێو هەموو کرێکارەکان',
    'calculating': 'ژمارەدان دەکرێت…',
    'calendar_view': 'بینینی ئەلبووم',
    'cancel_booking': 'هەڵوەشاندنەوەی حجز',
    'cancel_booking_question': 'ئایا دڵنیایت کە دەتەوێت ئەم حجزە هەڵبوەشێیتەوە؟',
    'cancellation_rate': 'ڕێژەی هەڵوەشاندنەوە',
    'cancellation_reason': 'هۆکاری هەڵوەشاندنەوە',
    'cancelled_holds': '{{count}} دانراوی هەڵوەشاوەوە',
    'charge_all': 'هەموویان وەرگرە',
    'charge_all_success_msg': '{{count}} پسوڵە وەرگیرا{{failed_msg}}',
    'generate_bills_btn': 'دروستکردنی پسوڵەکان',
    'generate_from_meters': 'دروستکردن لە مەترەکان',
    'charge_all_btn': 'وەرگرتنی هەمووی ({{count}})',
    'bills_generated_msg': '{{count}} پسوڵەی کارەبا دروستکرا',
    'rubs_failed': 'هەڵەی لەژمێرکردنی RUBS',
    'failed_to_update_account': 'نەتوانرا ئەکاونت نوێ بکرێتەوە',
    'charge_tenant': 'کرێکار وەرگرە',
    'charging': 'وەرگرتن دەکرێت…',
    'check_availability': 'پشکنینی بەردەستی',
    'checking_availability': 'بەردەستی پشکێنراودەکرێت...',
    'complete_signing': 'تەواوکردنی واژووکردن',
    'confirm_booking': 'پشتڕاستکردنەوەی حجز',
    'confirm_booking_question': 'تەواوکردنی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'confirm_booking_question_ar': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'confirm_booking_question_ku': 'پشتڕاستکردنەوەی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'confirm_charge_all_bills': 'پسوڵە {{count}} ی چاوەڕوانکراو لەسەر ئەکاونتی کرێکارەکان تۆمار بکرێت؟',
    'confirm_charge_all_bills_title': 'هەموو پسوڵەکانی چاوەڕوانکراو تۆمار بکە',
    'confirm_conflict_booking': 'کێشەی کاتی هەیە. ئایا دڵنیایت کە بدەیتە پێش؟',
    'confirm_convert': 'پشتڕاستکردنەوە و گۆڕانکاری',
    'confirmation_statement': '"من {{name}}، بەم وتارەوە پشتڕاست دەکەمەوە کە هەموو مەرجەکانی گرێبەستی کرێی بینای {{building}}، یەکەی {{unit}} خوێندمەوە و ڕازیم."',
    'confirmed_hold': 'دانراوی پشتڕاستکراو',
    'conflict_detected': 'کێشەی بەرپێچبوون دۆزرایەوە',
    'connect_stripe_desc': 'ئەکاونتی Stripe بکەیلەوە بۆ ئەوەی کرێکارەکان بتوانن کرێ ڕاستەوخۆ لەپێرستگا بدەن.',
    'contract_end': 'کۆتایی گرێبەست',
    'contract_progress': 'پێشکەوتنی گرێبەست',
    'contract_start': 'دەستپێکردنی گرێبەست',
    'conversion_rate': 'ڕێژەی گۆڕانکاری',
    'convert_to_active_tenant': 'گۆڕانکاری بۆ کرێکاری چالاک',
    'convert_to_tenant': 'گۆڕانکاری بۆ کرێکار',
    'converted_to_tenants': '{{count}} گۆڕاون بۆ کرێکار',
    'cost': 'تێچوو',
    'create_booking': 'دروستکردنی حجز',
    'created_source': 'دروستکراو ({{source}})',
    'currently_occupied': 'ئێستا داگیرکراوە',
    'custom': 'تایبەت',
    'date': 'بەروار',
    'day_number': 'ڕۆژی {{number}}',
    'digital_trace': 'شوێنکەوتنی دیجیتاڵ',
    'digital_verification_required': 'پشتڕاستکردنەوەی واژووی دیجیتاڵ پێویستە',
    'edit_booking': 'دەستکاری حجز',
    'effective_rent': 'کرێی کارامە',
    'electronic_lease_signing': 'واژووکردنی ئەلکترۆنیکی گرێبەستی کرێ',
    'electronic_signature_recorded': 'واژووی ئەلکترۆنیکی تۆمارکرا',
    'email_templates_desc': 'ئیمەیڵی ئۆتۆماتیکی بۆ کرێکارەکان و خاوەنەکانت دیزاین بکە',
    'enable_service_fee_reminder': 'چالاككردنی بیرکردنەوەی کرێی خزمەتگوزاری',
    'ends_in_days': 'لە {{count}} ڕۆژدا کۆتایی دێت',
    'ent_f1': 'یەکە و ئادمینی نامحدود',
    'ent_f10': 'دەستگەیشتن بە API و Webhook',
    'ent_f11': '2FA لەڕێگەی WhatsApp OTP',
    'ent_f2': 'پەڕتووکخانەکانی کرێکار و خاوەن',
    'ent_f3': 'پەیامدانی ئاسایشی دوو ئاراستەیی',
    'ent_f4': 'پارەدانی کرێ لەڕێگەی Stripe',
    'ent_f5': 'سیستەمی ئیمەیڵی ئۆتۆماتیکی',
    'ent_f6': 'واژووی دیجیتاڵی گرێبەستەکان',
    'ent_f7': 'پشتیوانی لە دەستەی پرشپڕ',
    'ent_f8': 'قاڵبی ڕاپۆرتی تایبەت',
    'ent_f9': 'تۆمارەکانی چالاکی پێشکەوتوو',
    'enterprise_desc': 'کۆنترۆڵی ئامادەیی دامەزراوەیی لەگەڵ پەڕتووکخانەی خزمەتی خۆت تەواو.',
    'enterprise_plan': 'پلانی دامەزراوەیی',
    'error_checking_availability': 'هەڵە لە پشکنینی بەردەستی',
    'error_loading_data': 'شکستهێنا لە بارکردنی داتا',
    'error_saving_booking': 'هەڵە لە پاشەکەوتکردنی حجز',
    'errors': 'هەڵەکان',
    'et_basic_info': 'زانیاری بنچینەیی',
    'et_create_btn': 'دروستکردنی قاڵب',
    'et_description': 'وەسف',
    'et_description_placeholder': 'تێبینی ناوخۆیی ئیختیاری',
    'et_editor': 'دەستکاریکەر',
    'et_html_body': 'جەستەی HTML',
    'et_preview': 'پێشبینی',
    'et_quick_insert': 'گۆڕاوەکانی دانانی خێرا',
    'et_subject_line': 'هێڵی بابەت *',
    'et_subject_placeholder': 'وەک نمونە: کرێی ${{rent_amount}} ی تۆ لە {{due_date}} دەبێت بدەیت',
    'et_template_name': 'ناوی قاڵب *',
    'et_template_name_placeholder': 'وەک نمونە: بیرکردنەوەی کرێی مانگانە',
    'et_trigger_event': 'ئیشی دەستپێككەر',
    'et_update_btn': 'نوێکردنەوەی قاڵب',
    'expense': 'خەرجی',
    'expense_description_placeholder': 'وەک نمونە: خزمەتگوزاری مانگانەی دژ بە ئاژەڵی بچووک',
    'extending': 'درێژکردن دەکرێت...',
    'failed_to_assess': 'شکستهێنا لە هەڵسەنگاندن',
    'failed_to_load_settings': 'شکستهێنا لە بارکردنی ڕێکخستنەکان',
    'failed_to_save': 'شکستهێنا لە پاشەکەوتکردن',
    'failed_to_send': 'شکستهێنا لە ناردن',
    'finance': 'دارایی',
    'first_payment_date': 'بەرواری یەکەم پارەدان',
    'first_payment_message': 'مێژووی پارەدانی تۆ لێرە دەردەکەوێت کاتێک یەکەم پارەدانەکەت ئەنجام دەدەیت.',
    'fri': 'هەینی',
    'full_payment_form': 'فۆرمی پارەدانی تەواو',
    'future_tenant_upcoming_move_in': 'کرێکاری داهاتوو (چوونە ژوورەوەی داهاتوو)',
    'generate_bills': 'دروستکردنی پسوڵەکان',
    'generate_bills_now': 'ئێستا پسوڵەکان دروست بکە',
    'hold_duration': 'ماوەی دانراو',
    'hold_expiration': 'کۆتایی دانراو',
    'hold_expires': 'دانراو دەکوێتەسەر',
    'hold_hours': 'کاتژمێرەکانی دانراو',
    'hours': 'کاتژمێر',
    'in_n_days': 'لە {{count}} ڕۆژدا',
    'in_n_days_plural': 'لە {{count}} ڕۆژدا',
    'in_selected_period': 'لە ماوەی هەڵبژێردراودا',
    'indefinite': 'نامحدود',
    'individual_meter_hint': 'عدادی تاکەکەسی — پسوڵەیەک بۆ ئەم یەکەیە دروست بکە',
    'installment_details': 'وردەکاری قیستەکان',
    'installment_plan': 'پلانی قیست',
    'keep_it': 'بیپارێزە',
    'last_90_days': '90 ڕۆژی دواجار',
    'lease_details': 'وردەکاری گرێبەستی کرێ',
    'lease_details_move_in_instruction': 'وردەکاری گرێبەستی کرێ تەواو بکە بۆ گۆڕانکاری {{name}} بۆ یەکەی {{unit}}.',
    'lease_ended_short': 'گرێبەستی کرێ کۆتایی هێنا',
    'lease_ending_soon': 'گرێبەستی کرێ بەم زووانە کۆتایی دێت',
    'lease_not_found_subtitle': 'پەیوەندی بکە بە بەڕێوەبەریەتیەوە ئەگەر پێتوایە ئەمە هەڵەیە.',
    'leases': 'گرێبەستەکانی کرێ',
    'liability': 'بەرپرسیاریەتی دارایی',
    'management_agreements': 'ڕێکەوتنامەکانی بەڕێوەبردن',
    'management_fees_subtitle': 'پێشبینی کۆی گشتی دەرئامدی بەڕێوەبردنی خاوەن و خشتەکانی کرێی خزمەتگوزاری.',
    'mark_as_read': 'دیاریکردن وەک خوێندراو',
    'market': 'بازار',
    'meter_number_label': 'ژمارەی عداد',
    'method_bank_transfer': 'گواستنەوەی بانکی',
    'method_cash': 'نەقد',
    'method_check': 'چێک',
    'method_credit_card': 'کارتی ئەقڵی',
    'method_other': 'جووری تر',
    'method_stripe': 'Stripe',
    'method_wire': 'گواستنەوەی ئەلکترۆنیکی',
    'mon': 'دووشەممە',
    'monthly_pay_date': 'بەرواری پارەدانی مانگانە',
    'monthly_view_holds': 'بینینی مانگانەی دانراوەکانی ئەپارتمانی چالاک',
    'months': 'مانگ',
    'more': 'زیاتر',
    'move_in_date': 'بەرواری چوونە ژوورەوە',
    'move_out_date': 'بەرواری چوونە دەرەوە',
    'net': 'کۆی خاڵص',
    'new_booking_hold': 'دانراوی حجزی نوێ',
    'new_expense_subtitle': 'تۆمارکردنی خەرجیی کارگێڕی',
    'new_hold': 'دانراوی نوێ',
    'next_installment': 'قیستی داهاتوو',
    'no_active_tenant_error': 'هیچ کرێکاری چالاکی نییە — پارەدان ناتوانرێت لێرە تۆمار بکرێت.',
    'no_active_tenant_found': 'هیچ کرێکاری چالاکی بۆ ئەم یەکەیە نەدۆزرایەوە',
    'no_bills_found_msg': 'هیچ پسوڵەیەک نەدۆزرایەوە — پسوڵەکان دروست بکە پاش تۆمارکردنی خوێندنەوەکان',
    'no_bookings_found': 'هیچ حجزێک نەدۆزرایەوە',
    'no_pending_bills_to_charge': 'هیچ پسوڵەی چاوەڕوانکراوی بۆ وەرگرتن نییە',
    'no_status_data': 'هیچ داتای دۆخی بەردەست نییە',
    'no_trend_data': 'هیچ داتای ئاراستەی بەردەست نییە',
    'no_utility_accounts': 'هیچ ئەکاونتی کارەبایی نییە — کلیک بکە لەسەر زیادکردنی ئەکاونت بۆ دەستپێکردن',
    'not_found': 'نەدۆزرایەوە',
    'optional': 'ئیختیاری',
    'owner_message_template': 'قاڵبی پەیامی خاوەن',
    'owner_reminder_sub': 'ئاگادارکردنەوەی خاوەنەکان کاتێک کرێکارەکانیان پارەدانی دواخراو هەیە',
    'payment_confirmation_sub': 'ئۆتۆماتیکی ناردراو بۆ کرێکار کاتێک پارەدانێک تۆمارکرا',
    'payment_confirmation_template': 'قاڵبی پەیامی پشتڕاستکردنەوە',
    'payments_subtitle': 'بەڕێوەبردنی پارەدانەکانی کرێ و بینینی مێژووی مامکردەکان.',
    'pending_move_in': 'چوونە ژوورەوەی چاوەڕوانکراو',
    'pending_payment': 'پارەدانی چاوەڕوانکراو',
    'period': 'ماوە',
    'pro_desc': 'بۆ فەرمی پسپۆڕ لەگەڵ هەڵکەوتی بەڕێوەبردنی ئۆتۆماتیکی.',
    'pro_f1': 'تا 150 یەکە',
    'pro_f10': 'پشتیوانی ئەولەویەتی ستانداردی',
    'pro_f2': '5 کورسی ئادمین',
    'pro_f3': 'ناوەندی چاکسازی گشتی',
    'pro_f4': 'پابەندبوون بە مەرجی مانەوەی دەستنیشانکراو',
    'pro_f5': 'ڕایەڵەکانی مانگانەی ئۆتۆماتیکی',
    'pro_f6': 'بیرکردنەوەکانی WhatsApp',
    'pro_f7': 'بەڕێوەبردنی خاوەن و فەرمانی کار',
    'pro_f8': 'شیکاری ئەستەمکردن',
    'pro_f9': 'حجز، لیستی چاوەڕوان و گواستنەوەکان',
    'process_waitlist_success': 'بە سەرکەوتویی گۆڕدرا بۆ حجزی چاوەڕوانکراو!',
    'property_info': 'زانیاری تەلار',
    'provider': 'دابینکەر',
    'purchase_agreement': 'گرێبەستی کڕین',
    'ready': 'ئامادەیە',
    'reason_optional': 'تکایە هۆکارێک بێنە (ئیختیاری):',
    'recent_bookings': 'حجزەکان و دانراوەکانی دواجار',
    'record': 'تۆمار',
    'record_payment_btn': 'تۆمارکردنی پارەدانی {{amount}}',
    'record_reading': 'تۆمارکردنی خوێندنەوە',
    'record_valuation_subtitle': 'تۆمارکردنی نرخی بازاری ئێستا بۆ بینا',
    'recording': 'تۆمارکردن دەکرێت...',
    'redirecting_to_payment': 'دەگوازرێیتەوە بۆ بەرپایەی پارەدانی ئاسایش...',
    'rejected': 'ڕەتکرایەوە',
    'remaining_balance': 'ماوەی مانەوە',
    'remaining_time': 'کاتی ماوە',
    'reminder_message_template': 'قاڵبی پەیام',
    'renewing': 'نوێکردنەوە دەکرێت...',
    'rent_status': 'دۆخی کرێ',
    'requested_dates': 'بەروارەکانی داواکراو',
    'rubs_complete_msg': 'RUBS تەواو بوو — {{count}} کرێکار هەر {{amount_each}} ی وەرگرت (کۆی گشتی {{total}})',
    'run_rubs_btn': 'بەستنی دابەشکردنی RUBS',
    'sat': 'شەممە',
    'save_20_annual': '20% خەزن بکە · ${{amount}}/ساڵ بە پارەدانی ساڵانە',
    'search_unit': 'گەڕان بۆ ئەپارتمان...',
    'select_apartment_move_in_date_error': 'تکایە ئەپارتمان و بەرواری چوونە ژوورەوە دیاری بکە بۆ پشکنینی بەردەستی',
    'select_unit': 'هەڵبژاردنی یەکە',
    'send_on_payment': 'ناردنی پشتڕاستکردنەوە کاتێک پارەدانێک تۆمارکرا',
    'send_reminders_now': 'ئێستا بیرکردنەوەکان بنێرە',
    'send_reminders_now_description': 'ڕاستەوخۆ بیرکردنەوەکان بنێرە بۆ هەموو کرێکاران و خاوەنانی کە ئێستا پێویستیان هەیە.',
    'send_test_message': 'ناردنی پەیامی تاقیکردنەوە',
    'sent': 'نێردرا',
    'server_error': 'هەڵەی پەیوەندی سێرڤەر',
    'service_agreement': 'ڕێکەوتنامەی خزمەتگوزاری',
    'service_fee_reminder_sub': 'ئاگادارکردنەوەی کرێکاران دەربارەی پارەدانەکانی کرێی خزمەتگوزاری داهاتوو',
    'settings_subtitle': 'بەڕێوەبردنی ئەکاونت و ئامادەکارییەکانی سیستەم',
    'shared_meter': 'عدادی هاوبەش (دابەشکراو لەنێو یەکەکان)',
    'size_unit_sqm': 'قەبارەی یەکە بە مەتری چوارگۆشەیی',
    'skipped': 'تێپەڕدرا',
    'standard_plan': 'پلانی ستانداردی',
    'starter_desc': 'بۆ خاوەن خانەی سەربەخۆ کە تۆمارەکانی ناوخۆیی بەڕێوەدەبات.',
    'starter_f1': 'تا 100 یەکە',
    'starter_f2': '2 کورسی ئادمین',
    'starter_f3': 'بەڕێوەبردنی بیناکان و یەکەکان',
    'starter_f4': 'دەفتەری کۆنترۆڵی دووجانبە',
    'starter_f5': 'شوێنکردنی کرێی دەستی',
    'starter_f6': 'ڕاپۆرتە دارایی بنچینەیەکان',
    'starter_f7': 'ئاگادارکردنەوەی ئیمەیڵ',
    'starter_plan': 'دەستپێکەر',
    'status_breakdown': 'داڕشتنی دۆخ',
    'status_held': 'دانراو',
    'status_not_collected': 'کۆنەکراو نییە',
    'sun': 'یەکشەممە',
    'target_property': 'تەلاری ئامانج',
    'tenant_email': 'ئیمەیڵ',
    'tenant_name': 'ناو',
    'tenant_phone': 'تەلەفۆن',
    'tenant_rent_reminder': 'بیرکردنەوەی کرێی کرێکار',
    'tenant_rent_reminder_sub': 'بیرکردنەوە بنێرە بۆ کرێکاران پێش یان پاش بەرواری پارەدان',
    'test_email_address': 'ئادرەسی ئیمەیڵی تاقیکردنەوە',
    'test_message': 'پەیام',
    'thu': 'پێنجشەممە',
    'total_bookings': 'کۆی گشتی حجزەکان',
    'total_contract_value': 'کۆی گشتی نرخی گرێبەست',
    'total_holds': 'کۆی گشتی دانراوەکان',
    'total_service_fees': 'کۆی گشتی کرێی خزمەتگوزاری',
    'track_conversion_and_holds': 'شوێنکردنی ڕێژەی گۆڕانکاری و ماوەی دانراو',
    'tue': 'سێشەممە',
    'type_full_name': 'ناوی تەواو بنووسە بۆ واژووکردن',
    'unknown': 'نەناسراو',
    'usage': 'بەکارهێنان',
    'utility_account_created': 'ئەکاونتی خزمەتگوزاری دروستکرا',
    'utility_step1': 'ئەکاونتی مرۆڤی زیاد بکە (کارەبا، ئاو، گاز…)',
    'utility_step2': 'خوێندنەوەی عداد تۆمار بکە',
    'utility_step3': 'پسوڵەکان لە خوێندنەوەکانەوە دروست بکە',
    'utility_step4': 'پسوڵەکان ڕاستەوخۆ لەسەر ئەکاونتی کرێکار بنێرە',
    'utility_subtitle': 'عدادەکان شوێن بکەوە، پسوڵەکان دروست بکە، و کرێکاران وەرگرە',
    'view_all': 'هەموویان ببینە',
    'view_application': 'داواکاری ببینە',
    'view_full_ledger': 'دەفتەری تەواوی {{name}} ببینە',
    'view_tenant_profile': 'پرۆفایلی کرێکار ببینە',
    'volume_trends': 'ئاراستەکانی قەبارە',
    'wed': 'چوارشەممە',
    'whatsapp_enable': 'چالاككردنی ئاگادارکردنەوەکانی WhatsApp',
    'whatsapp_enable_sub': 'هەموو پەیامەکانی WhatsApp ی ئۆتۆماتیکی چالاک یان ناچالاک بکە',
    'whatsapp_must_be_enabled': 'دەبێت یەکەم WhatsApp چالاک بکرێت',
    'whatsapp_settings': 'ڕێکخستنەکانی WhatsApp',
    'whatsapp_settings_description': 'ئاگادارکردنەوەکانی ئۆتۆماتیکی WhatsApp بۆ کرێکاران و خاوەنەکان',
    'whatsapp_test_default_message': 'پەیامی تاقیکردنەوە لە سیستەمی بەڕێوەبردنی تەلار',
    'whatsapp_test_send': 'ناردنی پەیامی تاقیکردنەوە',
    'whatsapp_test_sent': 'پەیامی تاقیکردنەوە نێردرا!',
    'wire_transfer': 'گواستنەوەی ئەلکترۆنیکی',
    'yes_cancel': 'بەڵێ، هەڵوەشاندنەوە',

    'confirm_charge_bill': 'ئایا دەتەوێت ئەم پسوڵەی مرۆڤییە بنێیتە ئەکاونتی کرێکار؟',

    'all_tenants_compliant_desc': 'هەموو کرێکارەکان ئێستا پابەندی یاسان',
    'audit_compliance': 'پشکنینی پابەندبوون',
    'compliant': 'پابەند',
    'confirm_delete_policy': 'ئەم پالیسییە بسڕیتەوە؟',
    'entity_name': 'ناوی دامەزراوە',
    'error_loading_insurance': 'شکستهێنا لە بارکردنی بیمەنامەکان',
    'expiration': 'کۆتایی بەروار',
    'no_insurance_records': 'هیچ تۆماری بیمەیەک نەدۆزرایەوە',
    'non_compliant': 'نەپابەند',
    'policy_added': 'پالیسی زیادکرا',
    'policy_updated': 'پالیسی نوێکرایەوە',
    'send_notice': 'ناردنی ئاگادارکردنەوە',
    'view_policy': 'سیاسەت ببینە',

    'generate_drafts': 'ئێستا پێشنووسەکان دروست بکە',

    // Evictions
    'ev_initiated': 'دەستپێکراو',
    'ev_notice_served': 'ئاگادارکردنەوە گەیشت',
    'ev_court_filed': 'دادگا داواکراو',
    'ev_court_ruling': 'بڕیاری دادگا',
    'ev_completed': 'تەواوبوو',
    'ev_dismissed': 'رەتکراوەتەوە',
    'ev_notice_pay_or_quit': 'بدە یان بچە',
    'ev_notice_cure_or_quit': 'چارەسەر بکە یان بچە',
    'ev_notice_unconditional': 'چونەدەرەوەی بێ مەرج',
    'ev_active_cases': 'کیسە چالاکەکان',
    'ev_notice_served': 'ئاگادارکردنەوە گەیشت',
    'ev_court_filed': 'دادگا داواکراو',
    'ev_total_owed': 'کۆی پارەی دەستیپێدەکرێت',
    'ev_notice_type': 'جۆری ئاگادارکردنەوە',
    'ev_amount_owed': 'بڕی پارەی دەستیپێدەکرێت',
    'ev_status_updated': 'دۆخ نوێکراوەتەوە',
    'ev_dismiss_case': 'رەتکردنەوەی کیسە',
    'ev_dismiss_confirm': 'دڵنیایت دەتەوێت ئەم کیسەی دانپێدانە رەت بکەیتەوە؟ ئەمە گەڕاندنەوەی نییە.',
    'ev_case_dismissed': 'کیسەی دانپێدان رەتکراوەتەوە',
    'ev_dismiss_failed': 'هەڵە لە رەتکردنەوەی کیسە',
    'ev_case_timeline': 'کاتژمێری کیسە',
    'ev_notice_served_date': 'بەرواری گەیاندنی ئاگادارکردنەوە',
    'ev_court_filing_date': 'بەرواری داخلکردنی دادگا',
    'ev_court_date': 'بەرواری دانیشتنی دادگا',
    'ev_ruling': 'بڕیار',
    'ev_ruling_date': 'بەرواری بڕیار',
    'ev_vacate_date': 'چوونەدەرەوە لەمەوبەر',
    'ev_edit_notes': 'دەستکاری تێبینییەکان',
    'ev_save_notes': 'پاشەکەوتکردنی تێبینییەکان',
    'ev_add_notes': 'زیادکردنی تێبینی',
    'ev_notes_saved': 'تێبینییەکان پاشەکەوتکران',
    'ev_save_failed': 'هەڵە لە پاشەکەوتکردن',
    'filed': 'تۆمارکراو',

    // Inspections
    'insp_move_in': 'چوونەژوورەوە',
    'insp_move_out': 'چوونەدەرەوە',
    'insp_periodic': 'سەردانی دەوری',
    'insp_maintenance': 'پاراستن',
    'total': 'کۆی گشتی',
    'draft': 'پێشنووس',
    'completed': 'تەواوبوو',
    'signed': 'واژووکراو',
    'all_types': 'هەموو جۆرەکان',
    'all_status': 'هەموو دۆخەکان',
    'unit_building': 'یەکە / بینا',
    'checklist_progress': 'پێشکەوتنی لیستی پشکنین',
    'condition_1': 'دۆخ',
    'date': 'بەروار',

    // Violations
    'tenant_unit': 'کرێچی / یەکە',
    'title': 'ناونیشان',
    'severity': 'گرنگی',
    'fine': 'سەرپێچی',

    // Leases
    'start': 'دەستپێکردن',
    'end': 'کۆتایی',
    'expiry': 'بەسەرچوون',
    'rent_mo': 'کرێ/مانگ',
    'deposit': 'پارەی مانەوە',
    'open_ended': 'کۆتاینەبوو',

    // Renewals
    'current_rent': 'کرێی ئێستا',
    'offered_rent': 'کرێی پێشکەشکراو',
    'risk': 'مەترسی',
    'offer_expires': 'کۆتایی پێشکەش',

    // Lease Applications
    'applicant': 'داواکار',
    'contact': 'پەیوەندی',
    'move_in': 'چوونەژوورەوە',
    'income': 'داهات',
    'employment': 'کارمەندی',

    // Application Links
    'total_links': 'کۆی بەستەرەکان',
    'active_links': 'بەستەرە چالاکەکان',
    'total_uses': 'کۆی بەکارهێنان',
    'generating': 'دروستکردن...',
    'generate_link': 'دروستکردنی بەستەر',
    'deactivate_link': 'ناچالاककردنی بەستەر',
    'deactivate_link_confirm': 'دەتەوێت بەستەری "{{label}}" ناچالاک بکەیتەوە؟ دیگر داواکاریەکان قبوڵ ناکات.',
    'deactivate': 'ناچالاككردن',

    // Sales Wizard
    'sw_step_buyer': 'کڕیار',
    'sw_step_terms': 'مەرجەکان',
    'sw_step_schedule': 'خشتە',
    'sw_step_confirm': 'پشتڕاستکردنەوە',
    'back': 'گەڕانەوە',
    'creating': 'دروستکردن...',
    'create_sale_contract': 'دروستکردنی گرێبەستی فرۆشتن',
    'hash': '#',
    'due_date': 'بەرواری دانەوە',
    'payment': 'پارەدان',
    'principal': 'سەرمایە',
    'interest': 'سوود',
    'balance': 'ماوەی پارە',
    'monthly_payment': 'پارەدانی مانگانە',
    'total_interest': 'کۆی سوود',
    'total_cost': 'تێچووی گشتی',
    'down_payment': 'پارەدانی یەکەم',
    'sale_price': 'نرخی فرۆشتن',
    'financed_amount': 'بڕی دابینکراو',
    'interest_rate': 'ڕێژەی سوود',
    'term': 'ماوە',

    // Validation errors
    'val_first_name_min': 'ناوی یەکەم دەبێت لانی کەم ٢ پیت بێت',
    'val_first_name_max': 'ناوی یەکەم ناتوانێت زیاتر لە ٥٠ پیت بێت',
    'val_last_name_min': 'ناوی خێزانی دەبێت لانی کەم ٢ پیت بێت',
    'val_last_name_max': 'ناوی خێزانی ناتوانێت زیاتر لە ٥٠ پیت بێت',
    'val_username_min': 'ناوی بەکارهێنەر دەبێت لانی کەم ٣ پیت بێت',
    'val_username_max': 'ناوی بەکارهێنەر ناتوانێت زیاتر لە ٣٠ پیت بێت',
    'val_username_no_spaces': 'ناوی بەکارهێنەر ناتوانێت بۆشایی تێدا بێت',
    'val_email_invalid': 'تکایە ئیمەیڵێکی دروست بنووسە',
    'val_company_name_min': 'ناوی کۆمپانیا دەبێت لانی کەم ٢ پیت بێت',
    'val_password_min': 'وشەی نهێنی دەبێت لانی کەم ٨ پیت بێت',
    'val_password_max': 'وشەی نهێنی ناتوانێت زیاتر لە ١٢٨ پیت بێت',
    'val_name_max_100': 'ناو ناتوانێت زیاتر لە ١٠٠ پیت بێت',
    'val_close_time_required': 'تکایە کاتی داخستن دیاری بکە',
    'val_open_time_required': 'تکایە کاتی کردنەوە دیاری بکە',
    'val_close_after_open': 'کاتی داخستن دەبێت دوای کاتی کردنەوە بێت',
    'val_title_max_200': 'سەردێڕ ناتوانێت زیاتر لە ٢٠٠ پیت بێت',
    'val_description_max_2000': 'وەسف ناتوانێت زیاتر لە ٢٠٠٠ پیت بێت',
    'val_fine_non_negative': 'بڕی سزا دەبێت سفر یان زیاتر بێت',
    'val_prospect_name_max': 'ناوی کڕیارە مەرەکە ناتوانێت زیاتر لە ٢٠٠ پیت بێت',
    'val_end_after_start': 'کاتی کۆتایی دەبێت دوای کاتی دەستپێکردن بێت',
    'val_notes_max_2000': 'تێبینییەکان ناتوانن زیاتر لە ٢٠٠٠ پیت بن',
    'val_expiry_after_start': 'بەرواری بەسەرچوون دەبێت دوای بەرواری دەستپێکردن بێت',
    'val_url_invalid': 'بەستەر دەبێت بە http:// یان https:// دەست پێبکات',
    'val_notes_max_1000': 'تێبینییەکان ناتوانن زیاتر لە ١٠٠٠ پیت بن',
    'val_webhook_url_https': 'بەستەری Webhook دەبێت بە https:// دەست پێبکات',
  
    // Added missing translations
    'default_messaging_language': 'زمانی نامەی بنەڕەتی',
    'default_language_help': 'بەکاردێت ئەگەر کرێچی زمانێکی پەسەندکراوی دیاریکراوی نەبێت.',
    'enable_tenant_rent_reminders': 'چالاککردنی بیرخستنەوەکان',
    'extend_lease_confirm': 'ئایا دڵنیایت کە دەتەوێت گرێبەستی کرێ درێژ بکەیتەوە؟',

    'error_loading_violations': 'هەڵە لە بارکردنی سەرپێچییەکان',
    'marked_as_resolved': 'وەک چارەسەرکراو نیشانەکرا',
    'error_updating_violation': 'هەڵە لە نوێکردنەوەی سەرپێچی',
    'title_and_notice_body_required': 'ناونیشان و ناوەرۆکی ئاگاداری پێویستن',
    'notice_issued': 'ئاگاداری دەرکرا',
    'error_issuing_notice': 'هەڵە لە دەرکردنی ئاگاداری',
    'search_violations': 'گەڕان بە کرێچی، ناونیشان، یان وەسف...',
    'loading_violations': 'بارکردنی سەرپێچییەکان...',
    'no_violations_recorded': 'هیچ سەرپێچییەک تۆمار نەکراوە',
    'no_status_violations': 'هیچ سەرپێچی {{status}} نییە',
    'notice_type_required': 'جۆری ئاگاداری *',
    'delivery_method_required': 'شێوازی گەیاندن *',
    'notice_title_required': 'ناونیشانی ئاگاداری *',
    'notice_deadline_optional': 'کۆتایی ماوەی پابەندبوون (ئارەزوومەندانە)',
    'notice_body_required': 'دەقی ئاگاداری *',
    'issuing': 'دەرکردن...',
    'issue_notice_btn': 'دەرکردنی ئاگاداری',
    'violations_count': '{{count}} سەرپێچی',
    'open_tickets': 'تیکێتی کراوە',
    'has_balance': 'باڵانسی هەیە',
    'perfect_payments': 'پارەدانی کامل',
    'risk_score': 'خاڵی مەترسی',

    'failed_to_load_evictions': 'هەڵە لە بارکردنی پەڕەی دانپێدانەکان',
    'failed_to_update_status': 'هەڵە لە نوێکردنەوەی دۆخ',
    'please_select_a_tenant': 'تکایە کرێچییەک هەڵبژێرە',
    'tenant_must_have_apartment': 'کرێچی هەڵبژێردراو دەبێت خانووبەرەیەکی دیاریکراوی هەبێت بۆ ئەنجامدانی دانپێدانەکە.',
    'reason_is_required': 'هۆکار پێویستە',
    'eviction_case_opened': 'کیسەی دانپێدان کرایەوە',
    'failed_to_create_eviction': 'هەڵە لە دروستکردنی کیسەی دانپێدان',

    'wo_stat_total': 'کۆی گشتی',
    'wo_stat_assigned': 'دیاریکراو',
    'wo_stat_in_progress': 'لەناو کارەوە',
    'wo_stat_completed': 'تەواوبوو',
    'wo_col_title': 'ناونیشان',
    'wo_col_vendor': 'فرۆشیار',
    'wo_col_priority': 'پێشینە',
    'wo_col_status': 'دۆخ',
    'wo_col_scheduled': 'خشتەبەندکراو',
    'wo_col_invoice': 'فاکتوورە',
    'wo_col_assigned_by': 'دیاریکراوە لەلایەن',
    'wo_detail_scheduled': 'خشتەبەندکراو',
    'wo_detail_completed': 'تەواوبوو',
    'wo_detail_created': 'دروستکراوە',
    'wo_failed_to_load': 'بارکردنی فەرمانی کار سەرکەوتوو نەبوو',
    'wo_invoice_approved': 'فاکتوورەکە بە سەرکەوتوویی مەرجبەستراو!',
    'wo_confirm_approval': 'دووپاتکردنەوەی مەرجبەستن',
    'wo_status_assigned': 'دیاریکراو',
    'wo_status_in_progress': 'لە کارکردنداە',
    'wo_status_on_hold': 'دواخراوە',
    'inv_status_received': 'وەرگیراوە',
    'view_detail': 'بینینی وردەکاری',
    'wo_failed_approve': 'مەرجبەستنی فاکتووری سەرکەوتوو نەبوو',
    'wo_failed_load_vendors': 'بارکردنی لیستی فرۆشەران سەرکەوتوو نەبوو',
    'wo_vendor_required': 'فرۆشەر پێویستە',
    'wo_title_required': 'ناونیشان پێویستە',
    'wo_created': 'فەرمانی کار بە سەرکەوتوویی دروستکراو',
    'wo_failed_to_create': 'دروستکردنی فەرمانی کار سەرکەوتوو نەبوو',
    'wo_title_placeholder': 'نمونە: چاکسازی بۆری لێکخوازی لە بینای A یەکە 302',
    'wo_description_placeholder': 'ڕێنمایییە وردەکارەکان بۆ فرۆشەر پیشکەش بکە...',
    'wo_linked_id_placeholder': 'ناسنامەی پەیوەندیدار (ئارەزووی)',
    'wo_nothing_to_update': 'هیچ شتێک نییە بۆ نوێکردنەوە',
    'wo_updated': 'فەرمانی کار نوێکرایەوە',
    'wo_update_failed': 'نوێکردنەوە سەرکەوتوو نەبوو',
    'sch_col_title': 'ناونیشان',
    'sch_col_building': 'بینا',
    'sch_col_frequency': 'دووبارەبوونەوە',
    'sch_col_next_due': 'ئەوەی داهاتوو',
    'sch_col_est_cost': 'تاقیکردنەوەی تێچوون',
    'sch_col_status': 'دۆخ',
    'sch_col_actions': 'کردارەکان',
    'sch_error_loading': 'هەڵە لە بارکردنی خشتەکان',
    'sch_mark_complete_success': 'بەتەواوی نیشاندراوە، بەرواری داهاتوو پێشکەشکراوە',
    'sch_error_complete': 'هەڵە لە تەواوکردنی خشتەکە',
    'sch_confirm_remove': 'ئایا دەتەوێت ئەم خشتەیە لادەبەیت؟',
    'sch_removed': 'خشتەکە لادراوە',
    'sch_error_remove': 'هەڵە لە لادانی خشتەکە',
    'sch_error_history': 'هەڵە لە بارکردنی مێژوو',
    'sch_search_placeholder': 'گەڕان لە خشتەکان...',
    'sch_status_active': 'چالاک',
    'sch_status_inactive': 'ناچالاک',
    'sch_edit_success': 'خشتەکە نوێ کرایەوە',
    'sch_error_edit': 'هەڵە لە نوێکردنەوەی خشتەکە',
    'sch_edit_schedule': 'دەستکاریکردنی خشتە',
    'sch_title_freq_due_required': 'ناونیشان، دووبارەبوونەوە و بەرواری دوای یەکەم پێویستن',
    'schedule_created': 'خشتە دروستکرا',
    'sch_failed_to_create': 'دروستکردنی خشتە سەرنەکەوت',
    'sch_history_title': 'مێژوو',
    'sch_remove_title': 'لابردن',
    'describe_task_placeholder': 'وەسفکردنی کارەکەی چاکسازی...',
    'vendor_instructions_placeholder': 'ڕێنمایی تایبەت بۆ دابینکەر...',
    'freq_daily': 'ڕۆژانە',
    'freq_weekly': 'هەفتانە',
    'freq_biweekly': 'هەر دوو هەفتەیەک',
    'freq_monthly': 'مانگانە',
    'freq_quarterly': 'سێ مانگەیەک',
    'freq_semiannual': 'شەش مانگەیەک',
    'freq_biannual': 'شەش مانگەیەک',
    'freq_annual': 'ساڵانە',

    'search_conversations': 'گەڕان لە گفتوگۆکاندا...',
    'load_more': 'زیاتر بار بکە',
    'no_results': 'هیچ ئەنجامێک نەدۆزرایەوە',
    'failed_to_update_document_status': 'نەتوانرا باری بەڵگەنامەکە نوێ بکرێتەوە',

    // Auto injected missing keys
    'hw_record_violation': '1. تۆمارکردنی سەرپێچی',
    'hw_record_violation_desc': 'سەرپێچییەک تۆمار بکە بە جۆر، گرنگی، و جریمەی ئارەزوومەندانە. جریمە بە خۆکاری لە حسابی بەرکرێدەر دەکرێتەوە.',
    'hw_issue_notice': '2. دەرکردنی ئاگادارکردنەوەی فەرمی',
    'hw_issue_notice_desc': 'ئاگادارکردنەوەیەکی یاسایی هاوپێچ بکە و بە ئیمەیڵ یان واتساپ بنێرە.',
    'hw_track_resolution': '3. شوێنکەوتنی چارەسەر',
    'hw_track_resolution_desc': 'باری نوێ بکەرەوە: پەسەندکرا ← بەرزکراوەتەوە ← چارەسەرکرا. تەواوی ریکۆردی پشکنین دەمێنێتەوە.',
    'hw_escalate': '4. بەرزکردنەوە لە کاتی پێویست',
    'hw_escalate_desc': 'سەرپێچیە بەرزکراوەکان دەتوانن بەشی کارپێکراوی داواکاری دەرکردن بن.',
    'notice_title_placeholder': 'نموونە: ئاگادارکردنەوەی دانی کرێ یان جێبەجێکردن — کرێ دەوین',
    'notice_body_placeholder': 'تێکستی تەواوی ئاگادارکردنەوەی یاسایی بنووسە...',
    'failed_to_load_tenants': 'بارکردنی کرێچییەکان سەرنەکەوت. تکایە پەیوەندیت بپشکنە.',
    'please_select_tenant': 'تکایە یەکێک لە کرێچییەکان هەڵبژێرە',
    'title_is_required': 'ناونیشان پێویستە',
    'violation_recorded_notice_sent': 'سەرپێچی تۆمارکرا — ئاگادارکردنەوە بە خۆکاری بۆ کرێچی نێردرا',
    'violation_recorded': 'سەرپێچی تۆمارکرا',
    'error_creating_violation': 'هەڵە لە دروستکردنی سەرپێچی',
    'select_tenant_placeholder': 'کرێچی هەڵبژێرە...',
    'violation_title_placeholder': 'نموونە: گلەیی دەنگی بەرز — موزیکی بەرز دوای نیوەشەو',
    'violation_desc_placeholder': 'سەرپێچییەکە بە وردی شی بکەوە...',
    'saving_ellipsis': 'پاشەکەوتکردن...',
    'violation_status_open': 'کراوە',
    'violation_status_acknowledged': 'پەسەندکراوە',
    'violation_status_resolved': 'چارەسەرکراوە',
    'violation_status_escalated': 'بەرزکراوەتەوە',
    'violation_status_closed': 'داخراوە',
    'violation_type_noise': 'دەنگی بەرز',
    'violation_type_pets': 'ئاژەڵی ماڵەوە',
    'violation_type_damage': 'زیان',
    'violation_type_unauthorized_occupant': 'دانیشتوانی بەبێ مۆڵەت',
    'violation_type_parking': 'پارکینگ',
    'violation_type_smoking': 'جگەرە کێشان',
    'violation_type_cleanliness': 'پاکیزەیی',
    'violation_type_lease_breach': 'مێشکخستنی گرێبەست',
    'violation_type_late_payment': 'دانی دواخراو',
    'violation_type_general': 'گشتی',
    'violation_severity_warning': 'ئاگاداری',
    'violation_severity_minor': 'بچووک',
    'violation_severity_major': 'گەورە',
    'violation_severity_critical': 'کریتیکی',
    'notice_type_pay_or_quit': 'بدە یان دەربچو',
    'notice_type_cure_or_quit': 'سەرئەنجام بدەرە یان دەربچو',
    'notice_type_unconditional_quit': 'دەرچوونی بەبێ مەرج',
    'notice_type_entry_notice': 'ئاگادارکردنەوەی چوونەژوورەوە',
    'notice_type_non_renewal': 'نەنوێکردنەوە',
    'notice_type_eviction_filing': 'پێشکەشکردنی داوای دەرکردن',
    'notice_type_lease_termination': 'بەسەرهێنانی گرێبەستی کرێ',
    'notice_type_rent_increase': 'زیادکردنی کرێ',
    'notice_type_general': 'گشتی',
    'delivery_method_email': 'ئیمەیڵ',
    'delivery_method_whatsapp': 'واتساپ',
    'delivery_method_hand_delivered': 'دەستی گەیاندن',
    'delivery_method_certified_mail': 'پۆستی پشتڕاستکراو',
    'delivery_method_posted_on_door': 'لەسەر دەرگا دانراوە',
    'delivery_method_sms': 'پەیامی کورت',
    'ev_reason_placeholder': 'نەدانی کرێ، مێشکخستنی گرێبەست، هتد.',
    'select_placeholder': 'هەڵبژێرە...',
    'opening_ellipsis': 'بکردنەوە...',
    'err_loading_tenants': 'هەڵە لە بارکردنی کرێچییەکان',
    'identity_link_opened': 'بەستەری پشتڕاستکردنەوەی ناسنامە کرایەوە — بیبەخشە بە کرێچی',
    'failed_identity_verification': 'دەستپێکردنی پشتڕاستکردنەوەی ناسنامە سەرنەکەوت',
    'fcra_consent_required_toast': 'دەبێت پەسەندکردنی FCRA پشتڕاست بکەیتەوە پێش کردنی پشکنینی پێشینە',
    'bg_invitation_sent': 'بانگهێشتنامەی پشکنینی پێشینە بۆ ئیمەیڵی کرێچی نێردرا',
    'failed_bg_check': 'دەستپێکردنی پشکنینی پێشینە سەرنەکەوت',
    'screening_decision_set': 'بڕیاری پشکنین دانرا بۆ: ',
    'failed_to_save_decision': 'پاشەکەوتکردنی بڕیار سەرنەکەوت',
    'search_tenants_placeholder': 'گەڕان بەدوای کرێچییەکاندا...',
    'loading_ellipsis': 'بارکردن...',
    'loading_screening_data': 'بارکردنی داتای پشکنین...',
    'dob_optional': 'بەرواری لەدایکبوون (دڵخواز)',
    'zipcode_optional': 'کۆدی ZIP (دڵخواز)',
    'state_optional': 'ووڵات (دڵخواز)',
    'country_label': 'وڵات',
    'sending_ellipsis': 'ناردن...',
    'send_to_tenant': 'ناردن بۆ کرێچی',
    'decision_label': 'بڕیار',
    'add_notes_decision_placeholder': 'هەر تێبینییەک دەربارەی ئەم بڕیارە زیاد بکە...',
    'save_decision': 'پاشەکەوتکردنی بڕیار',
    'badge_not_started': 'دەستیپێنەکراو',
    'badge_verified': 'پشتڕاستکراوە',
    'badge_action_needed': 'کردار پێویستە',
    'badge_canceled': 'هەستکراوە',
    'badge_clear': 'ئازاد',
    'badge_consider': 'بۆ لێکۆڵینەوە',
    'badge_dispute': 'مەترسیدار',
    'badge_suspended': 'ڕاگیراو',
    'badge_approved': 'پەسەندکراو',
    'badge_rejected': 'ڕەتکراوەیە',
    'badge_manual_review': 'پێداچوونەوەی دەستی',
}
};
